import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  Upload: any;
};

export type Account = {
  __typename?: 'Account';
  name: Scalars['String'];
  schoolAddress?: Maybe<Scalars['String']>;
  schoolCity?: Maybe<Scalars['String']>;
  schoolState?: Maybe<Scalars['String']>;
  schoolZip?: Maybe<Scalars['String']>;
  subscriptionActive: Scalars['Boolean'];
  subscriptionCancelled: Scalars['Boolean'];
  subscriptionCustomInterval?: Maybe<Scalars['String']>;
  subscriptionCustomPrice?: Maybe<Scalars['Int']>;
  subscriptionEndDate?: Maybe<Scalars['ISO8601Date']>;
  subscriptionMaxActivities?: Maybe<Scalars['Int']>;
  subscriptionMaxCourses?: Maybe<Scalars['Int']>;
  subscriptionMaxInstructors?: Maybe<Scalars['Int']>;
  subscriptionMaxStudents?: Maybe<Scalars['Int']>;
  subscriptionPastDue: Scalars['Boolean'];
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  subscriptionTotalActivities: Scalars['Int'];
  subscriptionTotalCourses: Scalars['Int'];
  subscriptionTotalInstructors: Scalars['Int'];
  subscriptionTotalStudents: Scalars['Int'];
  subscriptionTrialEndDate?: Maybe<Scalars['ISO8601Date']>;
  timeZone?: Maybe<Scalars['String']>;
  users?: Maybe<Array<User>>;
};

export type AccountRole = {
  __typename?: 'AccountRole';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  roleType?: Maybe<Scalars['String']>;
  users?: Maybe<Array<User>>;
};

/** Autogenerated return type of AccountUsersCancelEmailChange. */
export type AccountUsersCancelEmailChangePayload = {
  __typename?: 'AccountUsersCancelEmailChangePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of AccountUsersClearOauth. */
export type AccountUsersClearOauthPayload = {
  __typename?: 'AccountUsersClearOauthPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of AccountUsersCreate. */
export type AccountUsersCreatePayload = {
  __typename?: 'AccountUsersCreatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of AccountUsersDelete. */
export type AccountUsersDeletePayload = {
  __typename?: 'AccountUsersDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AccountUsersResendEmailChange. */
export type AccountUsersResendEmailChangePayload = {
  __typename?: 'AccountUsersResendEmailChangePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of AccountUsersResendEmailConfirmation. */
export type AccountUsersResendEmailConfirmationPayload = {
  __typename?: 'AccountUsersResendEmailConfirmationPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AccountUsersUpdate. */
export type AccountUsersUpdatePayload = {
  __typename?: 'AccountUsersUpdatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of AccountsCreate. */
export type AccountsCreatePayload = {
  __typename?: 'AccountsCreatePayload';
  account?: Maybe<Account>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AccountsUpdate. */
export type AccountsUpdatePayload = {
  __typename?: 'AccountsUpdatePayload';
  account?: Maybe<Account>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Activity = CommentedItem & {
  __typename?: 'Activity';
  activityBlock?: Maybe<ActivityBlock>;
  activityGroup?: Maybe<ActivityGroup>;
  assignDate?: Maybe<Scalars['ISO8601DateTime']>;
  comments?: Maybe<Array<Comment>>;
  createdAt: Scalars['ISO8601DateTime'];
  dueDate?: Maybe<Scalars['ISO8601DateTime']>;
  dueTimeSignificant?: Maybe<Scalars['Boolean']>;
  graded?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  item: ActivityItem;
  lockAfterDueDate?: Maybe<Scalars['Boolean']>;
  lockBeforeAssignDate?: Maybe<Scalars['Boolean']>;
  lockedAfterDueDate?: Maybe<Scalars['Boolean']>;
  lockedBeforeAssignDate?: Maybe<Scalars['Boolean']>;
  markLate?: Maybe<Scalars['Boolean']>;
  optional?: Maybe<Scalars['Boolean']>;
  parentCanGrade?: Maybe<Scalars['Boolean']>;
  parentCanGradeOverride?: Maybe<Scalars['Boolean']>;
  points: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  secondaryUnits: Array<Unit>;
  similarityReportsEnabled?: Maybe<Scalars['Boolean']>;
  studentSubmissions: Array<StudentSubmission>;
  submissions: Array<Submission>;
  type: CommentableObject;
  unit: Unit;
  updatedAt: Scalars['ISO8601DateTime'];
  visible?: Maybe<Scalars['Boolean']>;
};


export type ActivityStudentSubmissionsArgs = {
  enrollmentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type ActivitySubmissionsArgs = {
  enrollmentIds?: InputMaybe<Array<Scalars['ID']>>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  includePast?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ActivityAttributes = {
  activityBlockId?: InputMaybe<Scalars['ID']>;
  activityGroupId?: InputMaybe<Scalars['ID']>;
  assignDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  assignmentItem?: InputMaybe<AssignmentAttributes>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueTimeSignificant?: InputMaybe<Scalars['Boolean']>;
  /** Required for update only */
  id?: InputMaybe<Scalars['ID']>;
  lockAfterDueDate?: InputMaybe<Scalars['Boolean']>;
  lockBeforeAssignDate?: InputMaybe<Scalars['Boolean']>;
  markLate?: InputMaybe<Scalars['Boolean']>;
  operation: BatchOperation;
  optional?: InputMaybe<Scalars['Boolean']>;
  parentCanGrade?: InputMaybe<Scalars['Boolean']>;
  parentCanGradeOverride?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  quizItem?: InputMaybe<QuizAttributes>;
  secondaryUnitIds?: InputMaybe<Array<Scalars['ID']>>;
  similarityReportsEnabled?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  unitId?: InputMaybe<Scalars['ID']>;
  updateTimestamp?: InputMaybe<Scalars['ISO8601DateTime']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ActivityBatch = {
  __typename?: 'ActivityBatch';
  baseItem?: Maybe<ActivityItem>;
  /** Quiz or Assignment */
  baseItemType: Scalars['String'];
  course: Course;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  items: Array<Scalars['JSON']>;
  title: Scalars['String'];
};

/** Autogenerated return type of ActivityBatchCreate. */
export type ActivityBatchCreatePayload = {
  __typename?: 'ActivityBatchCreatePayload';
  activityBatch?: Maybe<ActivityBatch>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ActivityBatchOverrideAttributes = {
  enrollmentId: Scalars['ID'];
  id: Scalars['ID'];
  /** Pass null explicitly to reset the field */
  points?: InputMaybe<Scalars['Float']>;
  /** Pass null explicitly to reset the field */
  status?: InputMaybe<ActivityStatusOverride>;
};

/** Autogenerated return type of ActivityBatchUpdate. */
export type ActivityBatchUpdatePayload = {
  __typename?: 'ActivityBatchUpdatePayload';
  activityBatch?: Maybe<ActivityBatch>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityBatchesDelete. */
export type ActivityBatchesDeletePayload = {
  __typename?: 'ActivityBatchesDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ActivityBlock = {
  __typename?: 'ActivityBlock';
  activities: Array<Activity>;
  assignDate?: Maybe<Scalars['ISO8601Date']>;
  createdAt: Scalars['ISO8601DateTime'];
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  published?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  unit: Unit;
  visible?: Maybe<Scalars['Boolean']>;
};

export type ActivityBlockAttributes = {
  assignDate?: InputMaybe<Scalars['ISO8601Date']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** Required for update only */
  id?: InputMaybe<Scalars['ID']>;
  operation: BatchOperation;
  title: Scalars['String'];
  unitId: Scalars['ID'];
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ActivityBlockCreate. */
export type ActivityBlockCreatePayload = {
  __typename?: 'ActivityBlockCreatePayload';
  activityBlock?: Maybe<ActivityBlock>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityBlockDelete. */
export type ActivityBlockDeletePayload = {
  __typename?: 'ActivityBlockDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityBlockUpdate. */
export type ActivityBlockUpdatePayload = {
  __typename?: 'ActivityBlockUpdatePayload';
  activityBlock?: Maybe<ActivityBlock>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityCreate. */
export type ActivityCreatePayload = {
  __typename?: 'ActivityCreatePayload';
  activity?: Maybe<Activity>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityDelete. */
export type ActivityDeletePayload = {
  __typename?: 'ActivityDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityDuplicate. */
export type ActivityDuplicatePayload = {
  __typename?: 'ActivityDuplicatePayload';
  activity?: Maybe<Activity>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityGradeOverride. */
export type ActivityGradeOverridePayload = {
  __typename?: 'ActivityGradeOverridePayload';
  activity?: Maybe<Activity>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ActivityGroup = {
  __typename?: 'ActivityGroup';
  activities: Array<Activity>;
  course: Course;
  createdAt: Scalars['ISO8601DateTime'];
  defaultSettings: Scalars['JSON'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

export type ActivityGroupArguments = {
  /** For create only, required */
  courseId?: InputMaybe<Scalars['ID']>;
  defaultSettings?: InputMaybe<ActivityGroupSettingsAttributes>;
  description?: InputMaybe<Scalars['String']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  operation: BatchOperation;
  position?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  /** If blank, activity group is ungraded */
  weight?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ActivityGroupCreate. */
export type ActivityGroupCreatePayload = {
  __typename?: 'ActivityGroupCreatePayload';
  activityGroup?: Maybe<ActivityGroup>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityGroupDelete. */
export type ActivityGroupDeletePayload = {
  __typename?: 'ActivityGroupDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ActivityGroupGrade = {
  __typename?: 'ActivityGroupGrade';
  activityGroup?: Maybe<ActivityGroup>;
  grade?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of ActivityGroupReorder. */
export type ActivityGroupReorderPayload = {
  __typename?: 'ActivityGroupReorderPayload';
  activityGroups?: Maybe<Array<ActivityGroup>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ActivityGroupSettingsAttributes = {
  assignmentSettings?: InputMaybe<Scalars['JSON']>;
  quizSettings?: InputMaybe<Scalars['JSON']>;
};

/** Autogenerated return type of ActivityGroupUpdate. */
export type ActivityGroupUpdatePayload = {
  __typename?: 'ActivityGroupUpdatePayload';
  activityGroup?: Maybe<ActivityGroup>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Base activity item type */
export type ActivityItem = {
  attemptsAllowed?: Maybe<Scalars['Int']>;
  /** Only non-null for active students in the course */
  attemptsRemaining?: Maybe<Scalars['Int']>;
  copyableBy: Visibility;
  createdAt: Scalars['ISO8601DateTime'];
  curriculum: Array<Scalars['String']>;
  gradeLevels: Array<Scalars['String']>;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  subjects: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
  visibleTo: Visibility;
};

export enum ActivityStatusOverride {
  Absent = 'absent',
  Dropped = 'dropped',
  Excused = 'excused',
  MarkedDone = 'marked_done',
  Reassigned = 'reassigned',
  Skipped = 'skipped'
}

/** Autogenerated return type of ActivityStatusOverride. */
export type ActivityStatusOverridePayload = {
  __typename?: 'ActivityStatusOverridePayload';
  activity?: Maybe<Activity>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ActivityUpdate. */
export type ActivityUpdatePayload = {
  __typename?: 'ActivityUpdatePayload';
  activity?: Maybe<Activity>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Assignment = ActivityItem & {
  __typename?: 'Assignment';
  attemptsAllowed?: Maybe<Scalars['Int']>;
  /** Only non-null for active students in the course */
  attemptsRemaining?: Maybe<Scalars['Int']>;
  contentBlocks: Array<AssignmentContentBlock>;
  copyableBy: Visibility;
  createdAt: Scalars['ISO8601DateTime'];
  curriculum: Array<Scalars['String']>;
  gradeLevels: Array<Scalars['String']>;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  maxPoints?: Maybe<Scalars['Int']>;
  onlineSubmissionAccepted?: Maybe<Scalars['Boolean']>;
  onlineSubmissionRequired?: Maybe<Scalars['Boolean']>;
  parentTemplate?: Maybe<AssignmentTemplate>;
  sourceAttribution?: Maybe<SourceAttribution>;
  subjects: Array<Scalars['String']>;
  submissionKind?: Maybe<SubmissionKind>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
  visibleTo: Visibility;
};

export type AssignmentAttributes = {
  attemptsAllowed?: InputMaybe<Scalars['Int']>;
  /** If passed, will replace current content_blocks */
  contentBlocks?: InputMaybe<Array<AssignmentContentBlockAttributes>>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  instructions?: InputMaybe<Scalars['String']>;
  maxPoints?: InputMaybe<Scalars['Int']>;
  onlineSubmissionAccepted?: InputMaybe<Scalars['Boolean']>;
  onlineSubmissionRequired?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  submissionKind?: InputMaybe<SubmissionKind>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type AssignmentContentBlock = {
  __typename?: 'AssignmentContentBlock';
  attachments: Array<FileEntry>;
  backgroundColor?: Maybe<Scalars['String']>;
  blockType: ContentBlock;
  content: Scalars['JSON'];
  itemId?: Maybe<Scalars['Int']>;
  itemType?: Maybe<ContentItem>;
  position?: Maybe<Scalars['Int']>;
  publish?: Maybe<Scalars['Boolean']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  topLine?: Maybe<Scalars['Boolean']>;
  uid: Scalars['String'];
};

export type AssignmentContentBlockAttributes = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  blockType: ContentBlock;
  /** Put main content into body key, any other keys allowed */
  content?: InputMaybe<Scalars['JSON']>;
  itemId?: InputMaybe<Scalars['Int']>;
  itemType?: InputMaybe<ContentItem>;
  position?: InputMaybe<Scalars['Int']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  topLine?: InputMaybe<Scalars['Boolean']>;
  uid: Scalars['String'];
};

export type AssignmentSubmission = {
  __typename?: 'AssignmentSubmission';
  text?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AssignmentSubmissionStart. */
export type AssignmentSubmissionStartPayload = {
  __typename?: 'AssignmentSubmissionStartPayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AssignmentSubmissionSubmit. */
export type AssignmentSubmissionSubmitPayload = {
  __typename?: 'AssignmentSubmissionSubmitPayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AssignmentSubmissionUpdate. */
export type AssignmentSubmissionUpdatePayload = {
  __typename?: 'AssignmentSubmissionUpdatePayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

export type AssignmentTemplate = {
  __typename?: 'AssignmentTemplate';
  attemptsAllowed?: Maybe<Scalars['Int']>;
  author: User;
  contentBlocks: Array<AssignmentContentBlock>;
  copyableBy?: Maybe<Visibility>;
  createdAt: Scalars['ISO8601DateTime'];
  curriculum: Array<Scalars['String']>;
  gradeLevels: Array<Scalars['String']>;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  onlineSubmissionAccepted?: Maybe<Scalars['Boolean']>;
  onlineSubmissionRequired?: Maybe<Scalars['Boolean']>;
  parentTemplate?: Maybe<CourseTemplate>;
  sourceAttribution?: Maybe<SourceAttribution>;
  subjects: Array<Scalars['String']>;
  submissionKind?: Maybe<SubmissionKind>;
  tags: Array<Scalars['String']>;
  templateInCourse?: Maybe<Course>;
  templateOptions: Scalars['JSON'];
  title: Scalars['String'];
  visibleTo: Visibility;
};

/** Autogenerated return type of AssignmentTemplatesCreate. */
export type AssignmentTemplatesCreatePayload = {
  __typename?: 'AssignmentTemplatesCreatePayload';
  assignmentTemplate?: Maybe<AssignmentTemplate>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AssignmentTemplatesDelete. */
export type AssignmentTemplatesDeletePayload = {
  __typename?: 'AssignmentTemplatesDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AssignmentTemplatesUpdate. */
export type AssignmentTemplatesUpdatePayload = {
  __typename?: 'AssignmentTemplatesUpdatePayload';
  assignmentTemplate?: Maybe<AssignmentTemplate>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AssignmentTemplatesUse. */
export type AssignmentTemplatesUsePayload = {
  __typename?: 'AssignmentTemplatesUsePayload';
  activity?: Maybe<Activity>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum AttributionLicense {
  /** Creative Commons Attribution 4.0 International */
  CcBy = 'cc_by',
  /** Creative Commons Attribution Non-Commercial */
  CcNc = 'cc_nc',
  /** Creative Commons Attribution Non-Commercial No Derivatives */
  CcNcNd = 'cc_nc_nd',
  /** Creative Commons Attribution Non-Commercial Share Alike */
  CcNcSa = 'cc_nc_sa',
  /** Creative Commons Attribution No Derivatives */
  CcNd = 'cc_nd',
  /** Creative Commons Attribution Share Alike */
  CcSa = 'cc_sa',
  /** Other */
  Other = 'other',
  /** Pixabay License */
  Pixabay = 'pixabay',
  /** Public Domain */
  Public = 'public',
  /** Unsplash License */
  Unsplash = 'unsplash',
  /** YouTube License */
  Youtube = 'youtube'
}

/** Form error */
export type BaseError = {
  __typename?: 'BaseError';
  /** Field of the error */
  field: Scalars['String'];
  /** Error message */
  message: Scalars['String'];
};

/** Autogenerated return type of BatchActivities. */
export type BatchActivitiesPayload = {
  __typename?: 'BatchActivitiesPayload';
  activities?: Maybe<Array<Activity>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchActivityBlocks. */
export type BatchActivityBlocksPayload = {
  __typename?: 'BatchActivityBlocksPayload';
  activityBlocks?: Maybe<Array<ActivityBlock>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchActivityGroup. */
export type BatchActivityGroupPayload = {
  __typename?: 'BatchActivityGroupPayload';
  activityGroups?: Maybe<Array<ActivityGroup>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchActivityOverrides. */
export type BatchActivityOverridesPayload = {
  __typename?: 'BatchActivityOverridesPayload';
  activities?: Maybe<Array<Activity>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchCourseMaterial. */
export type BatchCourseMaterialPayload = {
  __typename?: 'BatchCourseMaterialPayload';
  errors: Array<Scalars['String']>;
  materials?: Maybe<Array<CourseMaterial>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchCourseTerm. */
export type BatchCourseTermPayload = {
  __typename?: 'BatchCourseTermPayload';
  courseTerms?: Maybe<Array<CourseTerm>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchGradingSchemeUpdate. */
export type BatchGradingSchemeUpdatePayload = {
  __typename?: 'BatchGradingSchemeUpdatePayload';
  errors: Array<Scalars['String']>;
  gradingSchemes?: Maybe<Array<GradingScheme>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchMaterialBook. */
export type BatchMaterialBookPayload = {
  __typename?: 'BatchMaterialBookPayload';
  errors: Array<Scalars['String']>;
  materialBooks?: Maybe<Array<MaterialBook>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchMaterialCode. */
export type BatchMaterialCodePayload = {
  __typename?: 'BatchMaterialCodePayload';
  errors: Array<Scalars['String']>;
  materialCodes?: Maybe<Array<MaterialCode>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchMaterialLink. */
export type BatchMaterialLinkPayload = {
  __typename?: 'BatchMaterialLinkPayload';
  errors: Array<Scalars['String']>;
  materialLinks?: Maybe<Array<MaterialLink>>;
  success: Scalars['Boolean'];
};

export enum BatchOperation {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

/** Autogenerated return type of BatchSourceAttribution. */
export type BatchSourceAttributionPayload = {
  __typename?: 'BatchSourceAttributionPayload';
  errors: Array<Scalars['String']>;
  sourceAttributions?: Maybe<Array<SourceAttribution>>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of BatchUnitsCreate. */
export type BatchUnitsCreatePayload = {
  __typename?: 'BatchUnitsCreatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  units?: Maybe<Array<Unit>>;
};

/** Autogenerated return type of BatchUnits. */
export type BatchUnitsPayload = {
  __typename?: 'BatchUnitsPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  units?: Maybe<Array<Unit>>;
};

export type Calendar = {
  __typename?: 'Calendar';
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  events?: Maybe<Array<Event>>;
  familyAccount?: Maybe<Account>;
  id: Scalars['ID'];
  owner?: Maybe<User>;
  readOnly?: Maybe<Scalars['Boolean']>;
  syncUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  users?: Maybe<Array<User>>;
};

/** Autogenerated return type of CalendarCreate. */
export type CalendarCreatePayload = {
  __typename?: 'CalendarCreatePayload';
  calendar?: Maybe<Calendar>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CalendarDelete. */
export type CalendarDeletePayload = {
  __typename?: 'CalendarDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CalendarEventCreate. */
export type CalendarEventCreatePayload = {
  __typename?: 'CalendarEventCreatePayload';
  errors: Array<Scalars['String']>;
  event?: Maybe<Event>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CalendarEventDelete. */
export type CalendarEventDeletePayload = {
  __typename?: 'CalendarEventDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CalendarEventUpdate. */
export type CalendarEventUpdatePayload = {
  __typename?: 'CalendarEventUpdatePayload';
  errors: Array<Scalars['String']>;
  event?: Maybe<Event>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CalendarUpdate. */
export type CalendarUpdatePayload = {
  __typename?: 'CalendarUpdatePayload';
  calendar?: Maybe<Calendar>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Cohort = {
  __typename?: 'Cohort';
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** Autogenerated return type of CohortCreate. */
export type CohortCreatePayload = {
  __typename?: 'CohortCreatePayload';
  cohort?: Maybe<Cohort>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CohortDelete. */
export type CohortDeletePayload = {
  __typename?: 'CohortDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CohortUpdate. */
export type CohortUpdatePayload = {
  __typename?: 'CohortUpdatePayload';
  cohort?: Maybe<Cohort>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Comment = {
  __typename?: 'Comment';
  author?: Maybe<User>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  fileEntry?: Maybe<FileEntry>;
  id: Scalars['ID'];
  isViewed: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of CommentCreate. */
export type CommentCreatePayload = {
  __typename?: 'CommentCreatePayload';
  comment?: Maybe<Comment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CommentMarkReadAll. */
export type CommentMarkReadAllPayload = {
  __typename?: 'CommentMarkReadAllPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CommentToggleRead. */
export type CommentToggleReadPayload = {
  __typename?: 'CommentToggleReadPayload';
  comment?: Maybe<Comment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum CommentableObject {
  Activity = 'Activity',
  Event = 'Event',
  PrivateDiscussion = 'PrivateDiscussion'
}

export type CommentedItem = {
  comments?: Maybe<Array<Comment>>;
  id: Scalars['ID'];
  type: CommentableObject;
};

export enum ContentBlock {
  Book = 'book',
  Embed = 'embed',
  File = 'file',
  Guide = 'guide',
  Image = 'image',
  Link = 'link',
  List = 'list',
  Text = 'text'
}

export enum ContentItem {
  FileEntry = 'FileEntry',
  MaterialBook = 'MaterialBook',
  MaterialCode = 'MaterialCode',
  MaterialLink = 'MaterialLink'
}

export type Conversation = {
  __typename?: 'Conversation';
  courseParticipantEnrollments: Array<Enrollment>;
  createdAt: Scalars['ISO8601DateTime'];
  iconFileEntry?: Maybe<FileEntry>;
  id: Scalars['ID'];
  isClosed: Scalars['Boolean'];
  isMuted: Scalars['Boolean'];
  isViewed: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  leftParticipants: Array<User>;
  messages: Array<Message>;
  moderators: Array<User>;
  owner: User;
  participants: Array<User>;
  participatingCourseMemberGroups: Array<CourseMemberGroup>;
  participatingUsers: Array<User>;
  /** Permissions granted to the current user: participate, manage, read */
  permissions: Array<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of ConversationCreate. */
export type ConversationCreatePayload = {
  __typename?: 'ConversationCreatePayload';
  conversation?: Maybe<Conversation>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ConversationHide. */
export type ConversationHidePayload = {
  __typename?: 'ConversationHidePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ConversationLeave. */
export type ConversationLeavePayload = {
  __typename?: 'ConversationLeavePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ConversationParticipatingCourseAttributes = {
  courseId: Scalars['ID'];
  memberGroupTypes: Array<CourseMemberGroupEnum>;
};

/** Autogenerated return type of ConversationReopen. */
export type ConversationReopenPayload = {
  __typename?: 'ConversationReopenPayload';
  conversation?: Maybe<Conversation>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ConversationToggleMute. */
export type ConversationToggleMutePayload = {
  __typename?: 'ConversationToggleMutePayload';
  conversation?: Maybe<Conversation>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ConversationToggleView. */
export type ConversationToggleViewPayload = {
  __typename?: 'ConversationToggleViewPayload';
  conversation?: Maybe<Conversation>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ConversationUpdate. */
export type ConversationUpdatePayload = {
  __typename?: 'ConversationUpdatePayload';
  conversation?: Maybe<Conversation>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Course = {
  __typename?: 'Course';
  activityBatches?: Maybe<Array<ActivityBatch>>;
  activityGroups?: Maybe<Array<ActivityGroup>>;
  autoRegenerateInviteCode?: Maybe<Scalars['Boolean']>;
  cohorts?: Maybe<Array<Cohort>>;
  courseCredits?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentEnrollment?: Maybe<Enrollment>;
  currentTerm?: Maybe<CourseTerm>;
  curriculum?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  enrollments?: Maybe<Array<Enrollment>>;
  gradeLevels?: Maybe<Array<Scalars['String']>>;
  graded?: Maybe<Scalars['Boolean']>;
  gradingScheme?: Maybe<GradingScheme>;
  iconClass?: Maybe<Scalars['String']>;
  iconColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageFileEntry?: Maybe<FileEntry>;
  inviteCode?: Maybe<Scalars['String']>;
  inviteCodeExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  isSameAccount?: Maybe<Scalars['Boolean']>;
  materials?: Maybe<Array<CourseMaterial>>;
  originalCourseTemplate?: Maybe<CourseTemplate>;
  published?: Maybe<Scalars['Boolean']>;
  requireJoinConfirmation?: Maybe<Scalars['Boolean']>;
  restricted?: Maybe<Scalars['Boolean']>;
  roles?: Maybe<Array<CourseRole>>;
  scheduledDaysOff?: Maybe<Array<Scalars['ISO8601Date']>>;
  scheduledWeekdays?: Maybe<Array<DayOfWeek>>;
  schedulingMode?: Maybe<CourseSchedulingMode>;
  similarityReportsEnabled?: Maybe<Scalars['Boolean']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  subjects?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  terms?: Maybe<Array<CourseTerm>>;
  thumbnailFileEntry?: Maybe<FileEntry>;
  timeZone: Scalars['String'];
  title: Scalars['String'];
  uid: Scalars['String'];
  units?: Maybe<Array<Unit>>;
  videoFileEntry?: Maybe<FileEntry>;
  welcome?: Maybe<Scalars['String']>;
  welcomeMediaType?: Maybe<CourseWelcomeMedia>;
};


export type CourseEnrollmentsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type CourseUnitsArgs = {
  courseTermId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CourseCreate. */
export type CourseCreatePayload = {
  __typename?: 'CourseCreatePayload';
  course?: Maybe<Course>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseDelete. */
export type CourseDeletePayload = {
  __typename?: 'CourseDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CourseMaterial = {
  __typename?: 'CourseMaterial';
  course?: Maybe<Course>;
  description?: Maybe<Scalars['String']>;
  fileEntry?: Maybe<FileEntry>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type CourseMaterialArguments = {
  /** For create only, required */
  courseId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  fileEntryId?: InputMaybe<Scalars['ID']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  operation: BatchOperation;
  position?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CourseMemberGroup = {
  __typename?: 'CourseMemberGroup';
  course: Course;
  memberGroupTypes: Array<CourseMemberGroupEnum>;
};

export enum CourseMemberGroupEnum {
  Leader = 'leader',
  Parent = 'parent',
  Student = 'student'
}

export type CourseRole = {
  __typename?: 'CourseRole';
  course: Course;
  createdAt: Scalars['ISO8601DateTime'];
  enrollments: Array<Enrollment>;
  fixed?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions: Scalars['JSON'];
  type: Role;
};


export type CourseRoleEnrollmentsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CourseRoleCreate. */
export type CourseRoleCreatePayload = {
  __typename?: 'CourseRoleCreatePayload';
  courseRole?: Maybe<CourseRole>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseRoleDelete. */
export type CourseRoleDeletePayload = {
  __typename?: 'CourseRoleDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseRoleUpdate. */
export type CourseRoleUpdatePayload = {
  __typename?: 'CourseRoleUpdatePayload';
  courseRole?: Maybe<CourseRole>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum CourseSchedulingMode {
  /** Drip auto-scheduling */
  Drip = 'drip',
  /** Manual due dates */
  DueDate = 'due_date',
  /** Flexible rolling */
  FlexibleRolling = 'flexible_rolling',
  /** Self-paced */
  Full = 'full'
}

export type CourseTemplate = {
  __typename?: 'CourseTemplate';
  activitiesCount: Scalars['Int'];
  author: User;
  content: Scalars['JSON'];
  copyableBy?: Maybe<Visibility>;
  courseCredits?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  curriculum: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  gradeLevels: Array<Scalars['String']>;
  iconColor: Scalars['String'];
  id: Scalars['ID'];
  imageFileEntry?: Maybe<FileEntry>;
  originalCourse?: Maybe<Course>;
  parentTemplate?: Maybe<CourseTemplate>;
  sourceAttribution?: Maybe<SourceAttribution>;
  subjects: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  thumbnailFileEntry?: Maybe<FileEntry>;
  title: Scalars['String'];
  uid: Scalars['String'];
  visibleTo: Visibility;
};

/** Autogenerated return type of CourseTemplatesCreate. */
export type CourseTemplatesCreatePayload = {
  __typename?: 'CourseTemplatesCreatePayload';
  courseTemplate?: Maybe<CourseTemplate>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseTemplatesDelete. */
export type CourseTemplatesDeletePayload = {
  __typename?: 'CourseTemplatesDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseTemplatesUpdate. */
export type CourseTemplatesUpdatePayload = {
  __typename?: 'CourseTemplatesUpdatePayload';
  courseTemplate?: Maybe<CourseTemplate>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseTemplatesUse. */
export type CourseTemplatesUsePayload = {
  __typename?: 'CourseTemplatesUsePayload';
  course?: Maybe<Course>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CourseTerm = {
  __typename?: 'CourseTerm';
  accessible?: Maybe<Scalars['Boolean']>;
  course: Course;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  forGradebook?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  publishable?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  units: Array<Unit>;
  weight?: Maybe<Scalars['Float']>;
};

export type CourseTermArguments = {
  /** For create only, required */
  courseId?: InputMaybe<Scalars['ID']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  operation: BatchOperation;
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  unitIds?: InputMaybe<Array<Scalars['ID']>>;
  weight?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of CourseTermCreate. */
export type CourseTermCreatePayload = {
  __typename?: 'CourseTermCreatePayload';
  courseTerm?: Maybe<CourseTerm>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseTermDelete. */
export type CourseTermDeletePayload = {
  __typename?: 'CourseTermDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CourseTermGrade = {
  __typename?: 'CourseTermGrade';
  courseTerm?: Maybe<CourseTerm>;
  grade?: Maybe<Scalars['Float']>;
  gradeOverridden?: Maybe<Scalars['Boolean']>;
  originalGrade?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of CourseTermUpdate. */
export type CourseTermUpdatePayload = {
  __typename?: 'CourseTermUpdatePayload';
  courseTerm?: Maybe<CourseTerm>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CourseUpdate. */
export type CourseUpdatePayload = {
  __typename?: 'CourseUpdatePayload';
  course?: Maybe<Course>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum CourseWelcomeMedia {
  /** Image welcome content has priority */
  Image = 'image',
  /** None */
  None = 'none',
  /** Video welcome content has priority */
  Video = 'video'
}

/** Autogenerated return type of CreateSubscription. */
export type CreateSubscriptionPayload = {
  __typename?: 'CreateSubscriptionPayload';
  errors: Array<Scalars['String']>;
  invoicePreview?: Maybe<Scalars['JSON']>;
  redirectUrl?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  success: Scalars['Boolean'];
};

export type CropAttributes = {
  fileCropH: Scalars['Int'];
  fileCropW: Scalars['Int'];
  fileCropX: Scalars['Int'];
  fileCropY: Scalars['Int'];
};

export enum DayOfWeek {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed'
}

export type Enrollment = {
  __typename?: 'Enrollment';
  activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Student average grade (current term or overall course) */
  averageGrade?: Maybe<Scalars['Int']>;
  certificateFileEntry?: Maybe<FileEntry>;
  children: Array<Enrollment>;
  cohort?: Maybe<Cohort>;
  concludeLabel?: Maybe<EnrollmentConcludedLabel>;
  concluded?: Maybe<Scalars['Boolean']>;
  concludedState: Scalars['JSON'];
  course: Course;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy?: Maybe<User>;
  creditsAwarded?: Maybe<Scalars['Float']>;
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  default?: Maybe<Scalars['Boolean']>;
  dropped?: Maybe<Scalars['Boolean']>;
  favorite?: Maybe<Scalars['Boolean']>;
  finalGrade?: Maybe<Scalars['Int']>;
  gpaAwarded?: Maybe<Scalars['Float']>;
  gradeOverrides: Scalars['JSON'];
  id: Scalars['ID'];
  lastActivityAt?: Maybe<Scalars['ISO8601DateTime']>;
  manualGradeEntries: Array<ManualGradeEntry>;
  needsConfirmJoin?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  officialNotes?: Maybe<Scalars['String']>;
  parent?: Maybe<Enrollment>;
  role: CourseRole;
  status: EnrollmentStatus;
  user: User;
};


export type EnrollmentFinalGradeArgs = {
  includeCalculated?: InputMaybe<Scalars['Boolean']>;
};

export enum EnrollmentConcludedLabel {
  Audit = 'audit',
  Completed = 'completed',
  Failed = 'failed',
  Incomplete = 'incomplete',
  Passed = 'passed'
}

export enum EnrollmentStatus {
  Active = 'active',
  Concluded = 'concluded',
  Dropped = 'dropped',
  PendingAccept = 'pending_accept',
  PendingConfirm = 'pending_confirm',
  Rejected = 'rejected'
}

/** Autogenerated return type of EnrollmentsAcademicRecordsDownload. */
export type EnrollmentsAcademicRecordsDownloadPayload = {
  __typename?: 'EnrollmentsAcademicRecordsDownloadPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of EnrollmentsAccept. */
export type EnrollmentsAcceptPayload = {
  __typename?: 'EnrollmentsAcceptPayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnrollmentsConcludeAll. */
export type EnrollmentsConcludeAllPayload = {
  __typename?: 'EnrollmentsConcludeAllPayload';
  enrollments?: Maybe<Array<Enrollment>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnrollmentsConclude. */
export type EnrollmentsConcludePayload = {
  __typename?: 'EnrollmentsConcludePayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnrollmentsCreate. */
export type EnrollmentsCreatePayload = {
  __typename?: 'EnrollmentsCreatePayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnrollmentsDrop. */
export type EnrollmentsDropPayload = {
  __typename?: 'EnrollmentsDropPayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnrollmentsGradeOverride. */
export type EnrollmentsGradeOverridePayload = {
  __typename?: 'EnrollmentsGradeOverridePayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnrollmentsResendInvite. */
export type EnrollmentsResendInvitePayload = {
  __typename?: 'EnrollmentsResendInvitePayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum EnrollmentsSortOrder {
  FirstNameAsc = 'first_name_asc',
  FirstNameDesc = 'first_name_desc',
  LastNameAsc = 'last_name_asc',
  LastNameDesc = 'last_name_desc'
}

/** Autogenerated return type of EnrollmentsSwitch. */
export type EnrollmentsSwitchPayload = {
  __typename?: 'EnrollmentsSwitchPayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnrollmentsUpdate. */
export type EnrollmentsUpdatePayload = {
  __typename?: 'EnrollmentsUpdatePayload';
  enrollment?: Maybe<Enrollment>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Event = CommentedItem & {
  __typename?: 'Event';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  calendar?: Maybe<Calendar>;
  comments?: Maybe<Array<Comment>>;
  course?: Maybe<Course>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdBy?: Maybe<User>;
  date: Scalars['ISO8601Date'];
  details?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notifyUnit?: Maybe<EventNotifyUnit>;
  notifyValue?: Maybe<Scalars['Int']>;
  repeatCount?: Maybe<Scalars['Int']>;
  repeatDays?: Maybe<Array<EventRepeatDay>>;
  repeatEnd?: Maybe<EventRepeatEnd>;
  repeatMonthlyDayOfWeek?: Maybe<EventRepeatDay>;
  /** eg. 2 means every 2nd <day of week> */
  repeatMonthlyEveryDayOfWeek?: Maybe<Scalars['Int']>;
  repeatUnit?: Maybe<EventRepeatUnit>;
  repeatUntil?: Maybe<Scalars['ISO8601Date']>;
  repeatValue?: Maybe<Scalars['Int']>;
  timeEnd?: Maybe<Scalars['ISO8601DateTime']>;
  timeStart?: Maybe<Scalars['ISO8601DateTime']>;
  title?: Maybe<Scalars['String']>;
  type: CommentableObject;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export enum EventNotifyUnit {
  Days = 'days',
  Hours = 'hours',
  Minutes = 'minutes',
  Months = 'months',
  Seconds = 'seconds',
  Weeks = 'weeks',
  Years = 'years'
}

export enum EventRepeatDay {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed'
}

export enum EventRepeatEnd {
  Count = 'count',
  Date = 'date'
}

export enum EventRepeatUnit {
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type ExternalImage = {
  __typename?: 'ExternalImage';
  author?: Maybe<Scalars['String']>;
  authorUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  originalHeight?: Maybe<Scalars['Int']>;
  originalWidth?: Maybe<Scalars['Int']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum ExternalImageProvider {
  Flickr = 'flickr',
  Pinterest = 'pinterest',
  Pixabay = 'pixabay',
  Unsplash = 'unsplash'
}

export type ExternalVideo = {
  __typename?: 'ExternalVideo';
  author?: Maybe<Scalars['String']>;
  authorUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  originalHeight?: Maybe<Scalars['Int']>;
  originalWidth?: Maybe<Scalars['Int']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum ExternalVideoProvider {
  Pixabay = 'pixabay',
  Vimeo = 'vimeo',
  Youtube = 'youtube'
}

export type FileEntry = {
  __typename?: 'FileEntry';
  annotatable?: Maybe<Scalars['Boolean']>;
  annotation?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  croppedUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  links?: Maybe<Array<FileEntry>>;
  linksTo?: Maybe<FileEntry>;
  originalFileContentType?: Maybe<Scalars['String']>;
  originalFileName?: Maybe<Scalars['String']>;
  originalFileSize?: Maybe<Scalars['Int']>;
  skipperPaperContent?: Maybe<Scalars['String']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  uploadedBy: User;
  url?: Maybe<Scalars['String']>;
  viewedBy?: Maybe<Scalars['JSON']>;
};

/** Autogenerated return type of FileEntryCreate. */
export type FileEntryCreatePayload = {
  __typename?: 'FileEntryCreatePayload';
  errors: Array<Scalars['String']>;
  fileEntry?: Maybe<FileEntry>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of FileEntryDelete. */
export type FileEntryDeletePayload = {
  __typename?: 'FileEntryDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of FileEntryFinishCreate. */
export type FileEntryFinishCreatePayload = {
  __typename?: 'FileEntryFinishCreatePayload';
  errors: Array<Scalars['String']>;
  fileEntry?: Maybe<FileEntry>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of FileEntryPresignCreate. */
export type FileEntryPresignCreatePayload = {
  __typename?: 'FileEntryPresignCreatePayload';
  errors: Array<Scalars['String']>;
  fileEntryId?: Maybe<Scalars['ID']>;
  parts?: Maybe<Array<FileUploadPart>>;
  success: Scalars['Boolean'];
  uploadId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of FileEntryStartUploadSession. */
export type FileEntryStartUploadSessionPayload = {
  __typename?: 'FileEntryStartUploadSessionPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  uploadSession?: Maybe<UploadSession>;
};

/** Autogenerated return type of FileEntryUpdate. */
export type FileEntryUpdatePayload = {
  __typename?: 'FileEntryUpdatePayload';
  errors: Array<Scalars['String']>;
  fileEntry?: Maybe<FileEntry>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of FileEntryView. */
export type FileEntryViewPayload = {
  __typename?: 'FileEntryViewPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type FileUploadPart = {
  __typename?: 'FileUploadPart';
  offset: Scalars['Int'];
  partNumber: Scalars['Int'];
  size: Scalars['Int'];
  url: Scalars['String'];
};

/** Autogenerated return type of ForgotPassword. */
export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  errors: Array<BaseError>;
  /** Always true for security reasons */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of GenerateCumulativeGradebookUrl. */
export type GenerateCumulativeGradebookUrlPayload = {
  __typename?: 'GenerateCumulativeGradebookUrlPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type GenericData = {
  __typename?: 'GenericData';
  data?: Maybe<Scalars['JSON']>;
};

export type GoodreadsBook = {
  __typename?: 'GoodreadsBook';
  author?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GradebookData = {
  __typename?: 'GradebookData';
  activities?: Maybe<Array<Activity>>;
  activitiesLimit?: Maybe<Scalars['Int']>;
  activitiesOffset?: Maybe<Scalars['Int']>;
  activitiesTotal?: Maybe<Scalars['Int']>;
  students?: Maybe<Array<GradebookStudentData>>;
  studentsLimit?: Maybe<Scalars['Int']>;
  studentsOffset?: Maybe<Scalars['Int']>;
  studentsTotal?: Maybe<Scalars['Int']>;
};

export type GradebookStudentData = {
  __typename?: 'GradebookStudentData';
  activityGroupGrades?: Maybe<Array<ActivityGroupGrade>>;
  courseGrade?: Maybe<Scalars['Float']>;
  courseGradeOverridden?: Maybe<Scalars['Boolean']>;
  courseOriginalGrade?: Maybe<Scalars['Float']>;
  courseTermGrades?: Maybe<Array<CourseTermGrade>>;
  enrollment?: Maybe<Enrollment>;
  needsGradingCounter?: Maybe<Scalars['Int']>;
  submissions?: Maybe<Array<StudentSubmission>>;
};

export type GradingScheme = {
  __typename?: 'GradingScheme';
  courses: Array<Course>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  percentageGrade?: Maybe<Scalars['Boolean']>;
  ranges: Scalars['JSON'];
  showLetterGrade?: Maybe<Scalars['Boolean']>;
  showNumericGrade?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type GradingSchemeArguments = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  percentageGrade?: InputMaybe<Scalars['Boolean']>;
  ranges?: InputMaybe<Scalars['JSON']>;
  showLetterGrade?: InputMaybe<Scalars['Boolean']>;
  showNumericGrade?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of GradingSchemeCreate. */
export type GradingSchemeCreatePayload = {
  __typename?: 'GradingSchemeCreatePayload';
  errors: Array<Scalars['String']>;
  gradingScheme?: Maybe<GradingScheme>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of GradingSchemeDelete. */
export type GradingSchemeDeletePayload = {
  __typename?: 'GradingSchemeDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of GradingSchemeUpdate. */
export type GradingSchemeUpdatePayload = {
  __typename?: 'GradingSchemeUpdatePayload';
  errors: Array<Scalars['String']>;
  gradingScheme?: Maybe<GradingScheme>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of Impersonate. */
export type ImpersonatePayload = {
  __typename?: 'ImpersonatePayload';
  errors: Array<BaseError>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type ManualGradeEntry = {
  __typename?: 'ManualGradeEntry';
  activityGroup?: Maybe<ActivityGroup>;
  attachment?: Maybe<FileEntry>;
  createdAt: Scalars['ISO8601DateTime'];
  enrollment: Enrollment;
  id: Scalars['ID'];
  isExtraCredit: Scalars['Boolean'];
  maxPoints?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  submittedOn?: Maybe<Scalars['ISO8601DateTime']>;
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ManualGradeEntryCreate. */
export type ManualGradeEntryCreatePayload = {
  __typename?: 'ManualGradeEntryCreatePayload';
  errors: Array<Scalars['String']>;
  manualGradeEntry?: Maybe<ManualGradeEntry>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ManualGradeEntryDelete. */
export type ManualGradeEntryDeletePayload = {
  __typename?: 'ManualGradeEntryDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ManualGradeEntryUpdate. */
export type ManualGradeEntryUpdatePayload = {
  __typename?: 'ManualGradeEntryUpdatePayload';
  errors: Array<Scalars['String']>;
  manualGradeEntry?: Maybe<ManualGradeEntry>;
  success: Scalars['Boolean'];
};

export type MaterialBook = {
  __typename?: 'MaterialBook';
  author?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  isbn?: Maybe<Scalars['String']>;
  libraryButton?: Maybe<Array<MaterialButtonPermission>>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  websiteButton?: Maybe<Array<MaterialButtonPermission>>;
};

export type MaterialBookArguments = {
  author?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  goodreadsId?: InputMaybe<Scalars['String']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['Upload']>;
  isbn?: InputMaybe<Scalars['String']>;
  libraryButton?: InputMaybe<Array<MaterialButtonPermission>>;
  operation: BatchOperation;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  websiteButton?: InputMaybe<Array<MaterialButtonPermission>>;
};

export enum MaterialButtonPermission {
  Instructor = 'instructor',
  Student = 'student'
}

export type MaterialCode = {
  __typename?: 'MaterialCode';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type MaterialCodeArguments = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  operation: BatchOperation;
  title?: InputMaybe<Scalars['String']>;
};

export type MaterialLink = {
  __typename?: 'MaterialLink';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  imageMaxWidth?: Maybe<Scalars['Int']>;
  otherImages?: Maybe<Array<Scalars['String']>>;
  showImage?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MaterialLinkArguments = {
  description?: InputMaybe<Scalars['String']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['String']>;
  imageMaxWidth?: InputMaybe<Scalars['Int']>;
  operation: BatchOperation;
  otherImages?: InputMaybe<Array<Scalars['String']>>;
  showImage?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  author?: Maybe<User>;
  content?: Maybe<Scalars['String']>;
  conversation?: Maybe<Conversation>;
  createdAt: Scalars['ISO8601DateTime'];
  fileEntry?: Maybe<FileEntry>;
  id: Scalars['ID'];
  subject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of MessageCreate. */
export type MessageCreatePayload = {
  __typename?: 'MessageCreatePayload';
  errors: Array<Scalars['String']>;
  message?: Maybe<Message>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of MessageDelete. */
export type MessageDeletePayload = {
  __typename?: 'MessageDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MultiSubmission = StudentSubmission & {
  __typename?: 'MultiSubmission';
  activity: Activity;
  dueStatus?: Maybe<SubmissionDueStatus>;
  enrollment: Enrollment;
  grade?: Maybe<Scalars['Float']>;
  gradedAt?: Maybe<Scalars['ISO8601DateTime']>;
  gradedBy?: Maybe<Enrollment>;
  mainStatus?: Maybe<SubmissionMainStatus>;
  privateDiscussionId?: Maybe<Scalars['ID']>;
  status?: Maybe<SubmissionStatus>;
  statusOverriddenAt?: Maybe<Scalars['ISO8601DateTime']>;
  statusOverriddenBy?: Maybe<Enrollment>;
  subStatus?: Maybe<SubmissionSubStatus>;
  submissions: Array<Submission>;
};


export type MultiSubmissionSubmissionsArgs = {
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  includePast?: InputMaybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  academicRecordsDownloadUrl?: Maybe<EnrollmentsAcademicRecordsDownloadPayload>;
  acceptEnrollment?: Maybe<EnrollmentsAcceptPayload>;
  annotateSubmission?: Maybe<SubmissionAnnotatePayload>;
  batchActivities?: Maybe<BatchActivitiesPayload>;
  batchActivityBlocks?: Maybe<BatchActivityBlocksPayload>;
  batchActivityGroups?: Maybe<BatchActivityGroupPayload>;
  batchActivityOverrides?: Maybe<BatchActivityOverridesPayload>;
  batchCourseMaterials?: Maybe<BatchCourseMaterialPayload>;
  batchCourseTerms?: Maybe<BatchCourseTermPayload>;
  batchCreateUnits?: Maybe<BatchUnitsCreatePayload>;
  batchMaterialBooks?: Maybe<BatchMaterialBookPayload>;
  batchMaterialCodes?: Maybe<BatchMaterialCodePayload>;
  batchMaterialLinks?: Maybe<BatchMaterialLinkPayload>;
  batchSourceAttributions?: Maybe<BatchSourceAttributionPayload>;
  batchUnits?: Maybe<BatchUnitsPayload>;
  batchUpdateGradingScheme?: Maybe<BatchGradingSchemeUpdatePayload>;
  cancelEmailChangeAccountUser?: Maybe<AccountUsersCancelEmailChangePayload>;
  clearOauthAccountUser?: Maybe<AccountUsersClearOauthPayload>;
  concludeAllEnrollments?: Maybe<EnrollmentsConcludeAllPayload>;
  concludeEnrollment?: Maybe<EnrollmentsConcludePayload>;
  createAccount?: Maybe<AccountsCreatePayload>;
  createAccountUser?: Maybe<AccountUsersCreatePayload>;
  createActivity?: Maybe<ActivityCreatePayload>;
  createActivityBatch?: Maybe<ActivityBatchCreatePayload>;
  createActivityBlock?: Maybe<ActivityBlockCreatePayload>;
  createActivityGroup?: Maybe<ActivityGroupCreatePayload>;
  createAssignmentTemplate?: Maybe<AssignmentTemplatesCreatePayload>;
  createCalendar?: Maybe<CalendarCreatePayload>;
  createCohort?: Maybe<CohortCreatePayload>;
  createComment?: Maybe<CommentCreatePayload>;
  createConversation?: Maybe<ConversationCreatePayload>;
  createCourse?: Maybe<CourseCreatePayload>;
  createCourseRole?: Maybe<CourseRoleCreatePayload>;
  createCourseTemplate?: Maybe<CourseTemplatesCreatePayload>;
  createCourseTerm?: Maybe<CourseTermCreatePayload>;
  createEnrollment?: Maybe<EnrollmentsCreatePayload>;
  createEvent?: Maybe<CalendarEventCreatePayload>;
  createFile?: Maybe<FileEntryCreatePayload>;
  createGradingScheme?: Maybe<GradingSchemeCreatePayload>;
  createManualGradeEntries?: Maybe<ManualGradeEntryCreatePayload>;
  createMessage?: Maybe<MessageCreatePayload>;
  createPermissionLevel?: Maybe<PermissionLevelsCreatePayload>;
  createQuizTemplate?: Maybe<QuizTemplatesCreatePayload>;
  createStripeDeepLink?: Maybe<StripeDeepLinkPayload>;
  createSubscription?: Maybe<CreateSubscriptionPayload>;
  createUnit?: Maybe<UnitCreatePayload>;
  createUnitTemplate?: Maybe<UnitTemplatesCreatePayload>;
  deleteAccountUser?: Maybe<AccountUsersDeletePayload>;
  deleteActivity?: Maybe<ActivityDeletePayload>;
  deleteActivityBatch?: Maybe<ActivityBatchesDeletePayload>;
  deleteActivityBlock?: Maybe<ActivityBlockDeletePayload>;
  deleteActivityGroup?: Maybe<ActivityGroupDeletePayload>;
  deleteAssignmentTemplate?: Maybe<AssignmentTemplatesDeletePayload>;
  deleteCalendar?: Maybe<CalendarDeletePayload>;
  deleteCohort?: Maybe<CohortDeletePayload>;
  deleteCourse?: Maybe<CourseDeletePayload>;
  deleteCourseRole?: Maybe<CourseRoleDeletePayload>;
  deleteCourseTemplate?: Maybe<CourseTemplatesDeletePayload>;
  deleteCourseTerm?: Maybe<CourseTermDeletePayload>;
  deleteEvent?: Maybe<CalendarEventDeletePayload>;
  deleteFile?: Maybe<FileEntryDeletePayload>;
  deleteGradingScheme?: Maybe<GradingSchemeDeletePayload>;
  deleteManualGradeEntries?: Maybe<ManualGradeEntryDeletePayload>;
  deleteMessage?: Maybe<MessageDeletePayload>;
  deletePermissionLevel?: Maybe<PermissionLevelsDeletePayload>;
  deleteQuizTemplate?: Maybe<QuizTemplatesDeletePayload>;
  deleteSubmission?: Maybe<SubmissionDeletePayload>;
  deleteUnit?: Maybe<UnitDeletePayload>;
  deleteUnitTemplate?: Maybe<UnitTemplatesDeletePayload>;
  dropEnrollment?: Maybe<EnrollmentsDropPayload>;
  duplicateActivity?: Maybe<ActivityDuplicatePayload>;
  duplicateUnit?: Maybe<UnitDuplicatePayload>;
  finishCreateFile?: Maybe<FileEntryFinishCreatePayload>;
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  generateCumulativeGradebookUrl?: Maybe<GenerateCumulativeGradebookUrlPayload>;
  generateSubmissionSimilarityReportUrl?: Maybe<SubmissionGenerateSimilarityReportUrlPayload>;
  gradeSubmission?: Maybe<SubmissionGradePayload>;
  hideConversation?: Maybe<ConversationHidePayload>;
  impersonate?: Maybe<ImpersonatePayload>;
  leaveConversation?: Maybe<ConversationLeavePayload>;
  makeFinalSubmission?: Maybe<SubmissionMakeFinalPayload>;
  markReadAllComments?: Maybe<CommentMarkReadAllPayload>;
  markReadAllNotifications?: Maybe<NotificationsMarkReadAllPayload>;
  overrideActivityGrade?: Maybe<ActivityGradeOverridePayload>;
  overrideActivityStatus?: Maybe<ActivityStatusOverridePayload>;
  overrideEnrollmentGrade?: Maybe<EnrollmentsGradeOverridePayload>;
  presignCreateFile?: Maybe<FileEntryPresignCreatePayload>;
  reopenConversation?: Maybe<ConversationReopenPayload>;
  reorderActivityGroups?: Maybe<ActivityGroupReorderPayload>;
  reorderUnitItems?: Maybe<UnitsReorderItemsPayload>;
  reorderUnits?: Maybe<UnitsReorderPayload>;
  resendEmailChangeAccountUser?: Maybe<AccountUsersResendEmailChangePayload>;
  resendEmailConfirmationAccountUser?: Maybe<AccountUsersResendEmailConfirmationPayload>;
  resendEnrollmentInvite?: Maybe<EnrollmentsResendInvitePayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  signIn?: Maybe<SignInPayload>;
  signInOauth?: Maybe<SignInOauthPayload>;
  startAssignmentSubmission?: Maybe<AssignmentSubmissionStartPayload>;
  startQuizSubmission?: Maybe<QuizSubmissionStartPayload>;
  startUploadSession?: Maybe<FileEntryStartUploadSessionPayload>;
  submitAssignmentSubmission?: Maybe<AssignmentSubmissionSubmitPayload>;
  submitQuizSubmission?: Maybe<QuizSubmissionSubmitPayload>;
  switchEnrollment?: Maybe<EnrollmentsSwitchPayload>;
  toggleMuteConversation?: Maybe<ConversationToggleMutePayload>;
  toggleReadComment?: Maybe<CommentToggleReadPayload>;
  toggleReadNotification?: Maybe<NotificationToggleReadPayload>;
  toggleViewConversation?: Maybe<ConversationToggleViewPayload>;
  updateAccount?: Maybe<AccountsUpdatePayload>;
  updateAccountUser?: Maybe<AccountUsersUpdatePayload>;
  updateActivity?: Maybe<ActivityUpdatePayload>;
  updateActivityBatch?: Maybe<ActivityBatchUpdatePayload>;
  updateActivityBlock?: Maybe<ActivityBlockUpdatePayload>;
  updateActivityGroup?: Maybe<ActivityGroupUpdatePayload>;
  updateAssignmentSubmission?: Maybe<AssignmentSubmissionUpdatePayload>;
  updateAssignmentTemplate?: Maybe<AssignmentTemplatesUpdatePayload>;
  updateCalendar?: Maybe<CalendarUpdatePayload>;
  updateCohort?: Maybe<CohortUpdatePayload>;
  updateConversation?: Maybe<ConversationUpdatePayload>;
  updateCourse?: Maybe<CourseUpdatePayload>;
  updateCourseRole?: Maybe<CourseRoleUpdatePayload>;
  updateCourseTemplate?: Maybe<CourseTemplatesUpdatePayload>;
  updateCourseTerm?: Maybe<CourseTermUpdatePayload>;
  updateEnrollment?: Maybe<EnrollmentsUpdatePayload>;
  updateEvent?: Maybe<CalendarEventUpdatePayload>;
  updateFile?: Maybe<FileEntryUpdatePayload>;
  updateGradingScheme?: Maybe<GradingSchemeUpdatePayload>;
  updateManualGradeEntries?: Maybe<ManualGradeEntryUpdatePayload>;
  updatePermissionLevel?: Maybe<PermissionLevelsUpdatePayload>;
  updateQuizSubmission?: Maybe<QuizSubmissionUpdatePayload>;
  updateQuizTemplate?: Maybe<QuizTemplatesUpdatePayload>;
  updateUnit?: Maybe<UnitUpdatePayload>;
  updateUnitTemplate?: Maybe<UnitTemplatesUpdatePayload>;
  useAssignmentTemplate?: Maybe<AssignmentTemplatesUsePayload>;
  useCourseTemplate?: Maybe<CourseTemplatesUsePayload>;
  useQuizTemplate?: Maybe<QuizTemplatesUsePayload>;
  useUnitTemplate?: Maybe<UnitTemplatesUsePayload>;
  validateToken?: Maybe<ValidateTokenPayload>;
  viewFile?: Maybe<FileEntryViewPayload>;
};


export type MutationAcademicRecordsDownloadUrlArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  scope: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationAcceptEnrollmentArgs = {
  id: Scalars['ID'];
};


export type MutationAnnotateSubmissionArgs = {
  annotation?: InputMaybe<Scalars['String']>;
  submissionId: Scalars['ID'];
};


export type MutationBatchActivitiesArgs = {
  batchItems: Array<ActivityAttributes>;
};


export type MutationBatchActivityBlocksArgs = {
  batchItems: Array<ActivityBlockAttributes>;
};


export type MutationBatchActivityGroupsArgs = {
  batchItems: Array<ActivityGroupArguments>;
};


export type MutationBatchActivityOverridesArgs = {
  overrides: Array<ActivityBatchOverrideAttributes>;
};


export type MutationBatchCourseMaterialsArgs = {
  batchItems: Array<CourseMaterialArguments>;
};


export type MutationBatchCourseTermsArgs = {
  batchItems: Array<CourseTermArguments>;
};


export type MutationBatchCreateUnitsArgs = {
  batchItems: Array<UnitArguments>;
};


export type MutationBatchMaterialBooksArgs = {
  batchItems: Array<MaterialBookArguments>;
};


export type MutationBatchMaterialCodesArgs = {
  batchItems: Array<MaterialCodeArguments>;
};


export type MutationBatchMaterialLinksArgs = {
  batchItems: Array<MaterialLinkArguments>;
};


export type MutationBatchSourceAttributionsArgs = {
  batchItems: Array<SourceAttributionArguments>;
};


export type MutationBatchUnitsArgs = {
  batchItems: Array<UnitArguments>;
};


export type MutationBatchUpdateGradingSchemeArgs = {
  batchItems: Array<GradingSchemeArguments>;
};


export type MutationCancelEmailChangeAccountUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationClearOauthAccountUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  provider: OauthProvider;
};


export type MutationConcludeAllEnrollmentsArgs = {
  concludeLabel?: InputMaybe<EnrollmentConcludedLabel>;
  courseId: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationConcludeEnrollmentArgs = {
  certificateFileEntryId?: InputMaybe<Scalars['Int']>;
  concludeLabel?: InputMaybe<EnrollmentConcludedLabel>;
  creditsAwarded?: InputMaybe<Scalars['Float']>;
  finalGrade?: InputMaybe<Scalars['Int']>;
  gpaAwarded?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  officialNotes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateAccountArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateAccountUserArgs = {
  accountRoleId: Scalars['ID'];
  birthDate?: InputMaybe<Scalars['ISO8601Date']>;
  calendarColor?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  minGradeNotificationThreshold?: InputMaybe<Scalars['JSON']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  password: Scalars['String'];
  pauseNotifications?: InputMaybe<Scalars['Boolean']>;
  permissionLevelId?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationCreateActivityArgs = {
  activityBlockId?: InputMaybe<Scalars['ID']>;
  activityGroupId?: InputMaybe<Scalars['ID']>;
  assignDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  assignmentItem?: InputMaybe<AssignmentAttributes>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueTimeSignificant?: InputMaybe<Scalars['Boolean']>;
  lockAfterDueDate?: InputMaybe<Scalars['Boolean']>;
  lockBeforeAssignDate?: InputMaybe<Scalars['Boolean']>;
  markLate?: InputMaybe<Scalars['Boolean']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  parentCanGrade?: InputMaybe<Scalars['Boolean']>;
  parentCanGradeOverride?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  quizItem?: InputMaybe<QuizAttributes>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  unitId: Scalars['ID'];
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateActivityBatchArgs = {
  baseItemId?: InputMaybe<Scalars['ID']>;
  baseItemType: Scalars['String'];
  courseId: Scalars['ID'];
  items?: InputMaybe<Array<Scalars['JSON']>>;
  title: Scalars['String'];
};


export type MutationCreateActivityBlockArgs = {
  assignDate?: InputMaybe<Scalars['ISO8601Date']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
  unitId: Scalars['ID'];
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateActivityGroupArgs = {
  courseId: Scalars['ID'];
  defaultSettings?: InputMaybe<ActivityGroupSettingsAttributes>;
  description?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  weight?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateAssignmentTemplateArgs = {
  attemptsAllowed?: InputMaybe<Scalars['Int']>;
  contentBlocks?: InputMaybe<Array<AssignmentContentBlockAttributes>>;
  copyableBy?: InputMaybe<Visibility>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  instructions?: InputMaybe<Scalars['String']>;
  maxPoints?: InputMaybe<Scalars['Int']>;
  onlineSubmissionAccepted?: InputMaybe<Scalars['Boolean']>;
  onlineSubmissionRequired?: InputMaybe<Scalars['Boolean']>;
  originalAssignmentId?: InputMaybe<Scalars['ID']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  submissionKind?: InputMaybe<SubmissionKind>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateOptions?: InputMaybe<Scalars['JSON']>;
  title: Scalars['String'];
  visibleTo?: InputMaybe<Visibility>;
};


export type MutationCreateCalendarArgs = {
  color?: InputMaybe<Scalars['String']>;
  syncUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCreateCohortArgs = {
  courseId: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationCreateCommentArgs = {
  content?: InputMaybe<Scalars['String']>;
  fileEntryId?: InputMaybe<Scalars['ID']>;
  objectId: Scalars['ID'];
  objectType?: InputMaybe<CommentableObject>;
};


export type MutationCreateConversationArgs = {
  iconFileEntryId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  messageSubject?: InputMaybe<Scalars['String']>;
  participatingCourses?: InputMaybe<Array<ConversationParticipatingCourseAttributes>>;
  participatingUserIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCourseArgs = {
  courseCredits?: InputMaybe<Scalars['Float']>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  graded?: InputMaybe<Scalars['Boolean']>;
  gradingSchemeId?: InputMaybe<Scalars['ID']>;
  iconClass?: InputMaybe<Scalars['String']>;
  iconColor?: InputMaybe<Scalars['String']>;
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  inviteCode?: InputMaybe<Scalars['String']>;
  inviteCodeExpiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  originalCourseTemplateId?: InputMaybe<Scalars['ID']>;
  requireJoinConfirmation?: InputMaybe<Scalars['Boolean']>;
  scheduledDaysOff?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  scheduledWeekdays?: InputMaybe<Array<DayOfWeek>>;
  schedulingMode?: InputMaybe<CourseSchedulingMode>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  thumbnailFileEntryId?: InputMaybe<Scalars['ID']>;
  timeZone?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  videoFileEntryId?: InputMaybe<Scalars['ID']>;
  welcome?: InputMaybe<Scalars['String']>;
  welcomeMediaType?: InputMaybe<CourseWelcomeMedia>;
};


export type MutationCreateCourseRoleArgs = {
  courseId: Scalars['ID'];
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationCreateCourseTemplateArgs = {
  copyableBy?: InputMaybe<Visibility>;
  courseCredits?: InputMaybe<Scalars['Float']>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  iconColor?: InputMaybe<Scalars['String']>;
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  keepDates: Scalars['Boolean'];
  keepRolesPermissions: Scalars['Boolean'];
  originalCourseId: Scalars['ID'];
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  thumbnailFileEntryId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  visibleTo?: InputMaybe<Visibility>;
};


export type MutationCreateCourseTermArgs = {
  courseId: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  unitIds?: InputMaybe<Array<Scalars['ID']>>;
  weight?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateEnrollmentArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  courseRoleId?: InputMaybe<Scalars['ID']>;
  default?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['ID']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  inviteCode?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateEventArgs = {
  calendarId?: InputMaybe<Scalars['ID']>;
  courseId?: InputMaybe<Scalars['ID']>;
  date: Scalars['ISO8601Date'];
  details?: InputMaybe<Scalars['String']>;
  notifyUnit?: InputMaybe<EventNotifyUnit>;
  notifyValue?: InputMaybe<Scalars['Int']>;
  repeatCount?: InputMaybe<Scalars['Int']>;
  repeatDays?: InputMaybe<Array<EventRepeatDay>>;
  repeatEnd?: InputMaybe<EventRepeatEnd>;
  repeatMonthlyDayOfWeek?: InputMaybe<EventRepeatDay>;
  repeatMonthlyEveryDayOfWeek?: InputMaybe<EventRepeatDay>;
  repeatUnit?: InputMaybe<EventRepeatUnit>;
  repeatUntil?: InputMaybe<Scalars['ISO8601Date']>;
  repeatValue?: InputMaybe<Scalars['Int']>;
  timeEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  timeStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};


export type MutationCreateFileArgs = {
  authorizerItem?: InputMaybe<PolymorphicItemId>;
  cropAttributes?: InputMaybe<CropAttributes>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  skipperPaperContent?: InputMaybe<Scalars['String']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  srcUrl?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  uploadSessionId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateGradingSchemeArgs = {
  description?: InputMaybe<Scalars['String']>;
  percentageGrade?: InputMaybe<Scalars['Boolean']>;
  ranges: Scalars['JSON'];
  showLetterGrade?: InputMaybe<Scalars['Boolean']>;
  showNumericGrade?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};


export type MutationCreateManualGradeEntriesArgs = {
  activityGroupId: Scalars['ID'];
  attachmentId?: InputMaybe<Scalars['ID']>;
  enrollmentId: Scalars['ID'];
  maxPoints?: InputMaybe<Scalars['Int']>;
  points: Scalars['Int'];
  submittedOn: Scalars['ISO8601Date'];
  title: Scalars['String'];
  unitId: Scalars['ID'];
};


export type MutationCreateMessageArgs = {
  content?: InputMaybe<Scalars['String']>;
  conversationId: Scalars['ID'];
  fileEntryId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
};


export type MutationCreatePermissionLevelArgs = {
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationCreateQuizTemplateArgs = {
  copyableBy?: InputMaybe<Visibility>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  hideGradePendingSubmission?: InputMaybe<Scalars['Boolean']>;
  instructions?: InputMaybe<Scalars['String']>;
  originalQuizId?: InputMaybe<Scalars['ID']>;
  pageBreaks?: InputMaybe<QuizPageBreaks>;
  questionIds?: InputMaybe<Array<Scalars['ID']>>;
  questionNumbering?: InputMaybe<QuizQuestionNumbering>;
  questions?: InputMaybe<Array<QuizQuestionAttributes>>;
  resumable?: InputMaybe<Scalars['Boolean']>;
  showResults?: InputMaybe<Scalars['Boolean']>;
  shuffleOrder?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateOptions?: InputMaybe<Scalars['JSON']>;
  timeLimit?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  visibleTo?: InputMaybe<Visibility>;
};


export type MutationCreateStripeDeepLinkArgs = {
  type: Scalars['String'];
};


export type MutationCreateSubscriptionArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  priceId?: InputMaybe<Scalars['String']>;
  subscriptionPlanId: Scalars['ID'];
};


export type MutationCreateUnitArgs = {
  backgroundFileEntryId?: InputMaybe<Scalars['ID']>;
  courseId: Scalars['ID'];
  courseTermId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateUnitTemplateArgs = {
  copyableBy?: InputMaybe<Visibility>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  originalUnitId: Scalars['ID'];
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  visibleTo?: InputMaybe<Visibility>;
};


export type MutationDeleteAccountUserArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteActivityArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationDeleteActivityBatchArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteActivityBlockArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteActivityGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssignmentTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCalendarArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCohortArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCourseArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCourseRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCourseTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCourseTermArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEventArgs = {
  chain?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGradingSchemeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteManualGradeEntriesArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMessageArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePermissionLevelArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteQuizTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteSubmissionArgs = {
  submissionId: Scalars['ID'];
};


export type MutationDeleteUnitArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUnitTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDropEnrollmentArgs = {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  officialNotes?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDuplicateActivityArgs = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationDuplicateUnitArgs = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationFinishCreateFileArgs = {
  cropAttributes?: InputMaybe<CropAttributes>;
  etags: Array<Scalars['String']>;
  fileEntryId: Scalars['ID'];
  skipperPaperContent?: InputMaybe<Scalars['String']>;
  uploadId?: InputMaybe<Scalars['String']>;
  uploadSessionId?: InputMaybe<Scalars['String']>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateCumulativeGradebookUrlArgs = {
  courseId: Scalars['ID'];
  courseTermId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  enrollmentIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  type: Scalars['String'];
};


export type MutationGenerateSubmissionSimilarityReportUrlArgs = {
  submissionId: Scalars['ID'];
};


export type MutationGradeSubmissionArgs = {
  bonus?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Scalars['Float']>;
  quizQuestionId?: InputMaybe<Scalars['ID']>;
  submissionId: Scalars['ID'];
};


export type MutationHideConversationArgs = {
  id: Scalars['ID'];
};


export type MutationImpersonateArgs = {
  id: Scalars['ID'];
};


export type MutationLeaveConversationArgs = {
  id: Scalars['ID'];
};


export type MutationMakeFinalSubmissionArgs = {
  submissionId: Scalars['ID'];
};


export type MutationMarkReadAllCommentsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationMarkReadAllNotificationsArgs = {
  types?: InputMaybe<Array<NotificationType>>;
};


export type MutationOverrideActivityGradeArgs = {
  enrollmentId: Scalars['ID'];
  id: Scalars['ID'];
  points?: InputMaybe<Scalars['Float']>;
};


export type MutationOverrideActivityStatusArgs = {
  enrollmentId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  status?: InputMaybe<ActivityStatusOverride>;
};


export type MutationOverrideEnrollmentGradeArgs = {
  courseTermId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  percentageGrade?: InputMaybe<Scalars['Float']>;
};


export type MutationPresignCreateFileArgs = {
  authorizerItem?: InputMaybe<PolymorphicItemId>;
  contentType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  uploadSessionId?: InputMaybe<Scalars['String']>;
};


export type MutationReopenConversationArgs = {
  id: Scalars['ID'];
};


export type MutationReorderActivityGroupsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationReorderUnitItemsArgs = {
  activityIds: Array<PolymorphicItemId>;
  unitId: Scalars['ID'];
};


export type MutationReorderUnitsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationResendEmailChangeAccountUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationResendEmailConfirmationAccountUserArgs = {
  email: Scalars['String'];
};


export type MutationResendEnrollmentInviteArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationSignInArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSignInOauthArgs = {
  idToken?: InputMaybe<Scalars['String']>;
  provider: OauthProvider;
  uid: Scalars['String'];
  verifier: Scalars['String'];
};


export type MutationStartAssignmentSubmissionArgs = {
  activityId: Scalars['ID'];
  attachmentIds?: InputMaybe<Array<Scalars['ID']>>;
  studentEnrollmentId?: InputMaybe<Scalars['ID']>;
  submit?: InputMaybe<Scalars['Boolean']>;
};


export type MutationStartQuizSubmissionArgs = {
  activityId: Scalars['ID'];
};


export type MutationStartUploadSessionArgs = {
  authorizerItem: PolymorphicItemId;
};


export type MutationSubmitAssignmentSubmissionArgs = {
  addAttachmentIds?: InputMaybe<Array<Scalars['ID']>>;
  removeAttachmentIds?: InputMaybe<Array<Scalars['ID']>>;
  submissionId: Scalars['ID'];
};


export type MutationSubmitQuizSubmissionArgs = {
  answers?: InputMaybe<Array<Scalars['JSON']>>;
  bookmarks?: InputMaybe<Array<Scalars['ID']>>;
  saveForLater?: InputMaybe<Scalars['Boolean']>;
  sessionId?: InputMaybe<Scalars['String']>;
  submissionId: Scalars['ID'];
};


export type MutationSwitchEnrollmentArgs = {
  enrollmentId: Scalars['ID'];
};


export type MutationToggleMuteConversationArgs = {
  id: Scalars['ID'];
};


export type MutationToggleReadCommentArgs = {
  id: Scalars['ID'];
};


export type MutationToggleReadNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationToggleViewConversationArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAccountArgs = {
  name?: InputMaybe<Scalars['String']>;
  schoolAddress?: InputMaybe<Scalars['String']>;
  schoolCity?: InputMaybe<Scalars['String']>;
  schoolState?: InputMaybe<Scalars['String']>;
  schoolZip?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAccountUserArgs = {
  accountRoleId?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  birthDate?: InputMaybe<Scalars['ISO8601Date']>;
  calendarColor?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  minGradeNotificationThreshold?: InputMaybe<Scalars['JSON']>;
  newPassword?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  pauseNotifications?: InputMaybe<Scalars['Boolean']>;
  permissionLevelId?: InputMaybe<Scalars['ID']>;
  turnitinEulaAcceptedVersion?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateActivityArgs = {
  activityBlockId?: InputMaybe<Scalars['ID']>;
  activityGroupId?: InputMaybe<Scalars['ID']>;
  assignDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  assignmentItem?: InputMaybe<AssignmentAttributes>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueTimeSignificant?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lockAfterDueDate?: InputMaybe<Scalars['Boolean']>;
  lockBeforeAssignDate?: InputMaybe<Scalars['Boolean']>;
  markLate?: InputMaybe<Scalars['Boolean']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  parentCanGrade?: InputMaybe<Scalars['Boolean']>;
  parentCanGradeOverride?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  quizItem?: InputMaybe<QuizAttributes>;
  secondaryUnitIds?: InputMaybe<Array<Scalars['ID']>>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  unitId?: InputMaybe<Scalars['ID']>;
  updateTimestamp?: InputMaybe<Scalars['ISO8601DateTime']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateActivityBatchArgs = {
  id: Scalars['ID'];
  items?: InputMaybe<Array<Scalars['JSON']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateActivityBlockArgs = {
  assignDate?: InputMaybe<Scalars['ISO8601Date']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['ID']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateActivityGroupArgs = {
  defaultSettings?: InputMaybe<ActivityGroupSettingsAttributes>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateAssignmentSubmissionArgs = {
  addAttachmentIds?: InputMaybe<Array<Scalars['ID']>>;
  removeAttachmentIds?: InputMaybe<Array<Scalars['ID']>>;
  submissionId: Scalars['ID'];
};


export type MutationUpdateAssignmentTemplateArgs = {
  attemptsAllowed?: InputMaybe<Scalars['Int']>;
  contentBlocks?: InputMaybe<Array<AssignmentContentBlockAttributes>>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  instructions?: InputMaybe<Scalars['String']>;
  onlineSubmissionAccepted?: InputMaybe<Scalars['Boolean']>;
  onlineSubmissionRequired?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  submissionKind?: InputMaybe<SubmissionKind>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateOptions?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCalendarArgs = {
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  syncUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdateCohortArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationUpdateConversationArgs = {
  iconFileEntryId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  participatingCourses?: InputMaybe<Array<ConversationParticipatingCourseAttributes>>;
  participatingUserIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCourseArgs = {
  autoRegenerateInviteCode?: InputMaybe<Scalars['Boolean']>;
  courseCredits?: InputMaybe<Scalars['Float']>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  defaultCourseTermId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  graded?: InputMaybe<Scalars['Boolean']>;
  gradingSchemeId?: InputMaybe<Scalars['ID']>;
  iconClass?: InputMaybe<Scalars['String']>;
  iconColor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  inviteCode?: InputMaybe<Scalars['String']>;
  inviteCodeExpiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  originalCourseTemplateId?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  requireJoinConfirmation?: InputMaybe<Scalars['Boolean']>;
  scheduledDaysOff?: InputMaybe<Array<Scalars['ISO8601Date']>>;
  scheduledWeekdays?: InputMaybe<Array<DayOfWeek>>;
  schedulingMode?: InputMaybe<CourseSchedulingMode>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  thumbnailFileEntryId?: InputMaybe<Scalars['ID']>;
  timeZone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  videoFileEntryId?: InputMaybe<Scalars['ID']>;
  welcome?: InputMaybe<Scalars['String']>;
  welcomeMediaType?: InputMaybe<CourseWelcomeMedia>;
};


export type MutationUpdateCourseRoleArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateCourseTemplateArgs = {
  courseCredits?: InputMaybe<Scalars['Float']>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  iconColor?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  thumbnailFileEntryId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCourseTermArgs = {
  id: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  unitIds?: InputMaybe<Array<Scalars['ID']>>;
  weight?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateEnrollmentArgs = {
  certificateFileEntryId?: InputMaybe<Scalars['Int']>;
  cohortId?: InputMaybe<Scalars['ID']>;
  concludeLabel?: InputMaybe<EnrollmentConcludedLabel>;
  courseRoleId?: InputMaybe<Scalars['ID']>;
  creditsAwarded?: InputMaybe<Scalars['Float']>;
  default?: InputMaybe<Scalars['Boolean']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  gpaAwarded?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  officialNotes?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateEventArgs = {
  calendarId?: InputMaybe<Scalars['ID']>;
  courseId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  details?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notifyUnit?: InputMaybe<EventNotifyUnit>;
  notifyValue?: InputMaybe<Scalars['Int']>;
  repeatCount?: InputMaybe<Scalars['Int']>;
  repeatDays?: InputMaybe<Array<EventRepeatDay>>;
  repeatEnd?: InputMaybe<EventRepeatEnd>;
  repeatMonthlyDayOfWeek?: InputMaybe<EventRepeatDay>;
  repeatMonthlyEveryDayOfWeek?: InputMaybe<EventRepeatDay>;
  repeatUnit?: InputMaybe<EventRepeatUnit>;
  repeatUntil?: InputMaybe<Scalars['ISO8601Date']>;
  repeatValue?: InputMaybe<Scalars['Int']>;
  timeEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  timeStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFileArgs = {
  annotation?: InputMaybe<Scalars['String']>;
  cropAttributes?: InputMaybe<CropAttributes>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  skipperPaperContent?: InputMaybe<Scalars['String']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateGradingSchemeArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  percentageGrade?: InputMaybe<Scalars['Boolean']>;
  ranges?: InputMaybe<Scalars['JSON']>;
  showLetterGrade?: InputMaybe<Scalars['Boolean']>;
  showNumericGrade?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateManualGradeEntriesArgs = {
  activityGroupId?: InputMaybe<Scalars['ID']>;
  attachmentId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  maxPoints?: InputMaybe<Scalars['Int']>;
  points?: InputMaybe<Scalars['Int']>;
  submittedOn?: InputMaybe<Scalars['ISO8601Date']>;
  title?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdatePermissionLevelArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateQuizSubmissionArgs = {
  answers?: InputMaybe<Array<Scalars['JSON']>>;
  bookmarks?: InputMaybe<Array<Scalars['ID']>>;
  saveForLater?: InputMaybe<Scalars['Boolean']>;
  sessionId?: InputMaybe<Scalars['String']>;
  submissionId: Scalars['ID'];
};


export type MutationUpdateQuizTemplateArgs = {
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  hideGradePendingSubmission?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  instructions?: InputMaybe<Scalars['String']>;
  pageBreaks?: InputMaybe<QuizPageBreaks>;
  questionNumbering?: InputMaybe<QuizQuestionNumbering>;
  questions?: InputMaybe<Array<QuizQuestionAttributes>>;
  resumable?: InputMaybe<Scalars['Boolean']>;
  showResults?: InputMaybe<Scalars['Boolean']>;
  shuffleOrder?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateOptions?: InputMaybe<Scalars['JSON']>;
  timeLimit?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};


export type MutationUpdateUnitArgs = {
  backgroundFileEntryId?: InputMaybe<Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  resetDates?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateUnitTemplateArgs = {
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUseAssignmentTemplateArgs = {
  id: Scalars['Int'];
  unitId: Scalars['ID'];
};


export type MutationUseCourseTemplateArgs = {
  graded?: InputMaybe<Scalars['Boolean']>;
  iconColor?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  keepDates: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
};


export type MutationUseQuizTemplateArgs = {
  id: Scalars['Int'];
  unitId: Scalars['ID'];
};


export type MutationUseUnitTemplateArgs = {
  addAfterUnitId?: InputMaybe<Scalars['Int']>;
  courseId: Scalars['ID'];
  id: Scalars['Int'];
  keepDates: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
};


export type MutationViewFileArgs = {
  id: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['ISO8601DateTime'];
  dotColor?: Maybe<Scalars['String']>;
  dotTitle?: Maybe<Scalars['String']>;
  iconType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isViewed: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  notificationType: NotificationType;
  originUser?: Maybe<User>;
  targetUser?: Maybe<User>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of NotificationToggleRead. */
export type NotificationToggleReadPayload = {
  __typename?: 'NotificationToggleReadPayload';
  errors: Array<Scalars['String']>;
  notification?: Maybe<Notification>;
  success: Scalars['Boolean'];
};

export enum NotificationType {
  ActivityDueDateChanged = 'activity_due_date_changed',
  ActivityDueDateMissed = 'activity_due_date_missed',
  ActivityHelpNeeded = 'activity_help_needed',
  ActivityMarkedDone = 'activity_marked_done',
  ActivityNeedsGrading = 'activity_needs_grading',
  ActivityPastDue = 'activity_past_due',
  ActivityQuizSubmissionAutoGraded = 'activity_quiz_submission_auto_graded',
  ActivityQuizSubmissionNonGraded = 'activity_quiz_submission_non_graded',
  ActivityReassigned = 'activity_reassigned',
  ActivityReassignedParent = 'activity_reassigned_parent',
  ActivityStarted = 'activity_started',
  ActivitySubmitted = 'activity_submitted',
  ChildAvgGradeBelowThreshold = 'child_avg_grade_below_threshold',
  CommentActivity = 'comment_activity',
  CommentEvent = 'comment_event',
  CommentToChild = 'comment_to_child',
  CourseChildConcluded = 'course_child_concluded',
  CourseChildDropped = 'course_child_dropped',
  CourseChildEnrolled = 'course_child_enrolled',
  CourseCompleted = 'course_completed',
  CourseConcluded = 'course_concluded',
  CourseDropped = 'course_dropped',
  CourseEnrollment = 'course_enrollment',
  CourseLeaderConcluded = 'course_leader_concluded',
  CourseMemberEnrollment = 'course_member_enrollment',
  CourseMemberEnrollmentRequest = 'course_member_enrollment_request',
  CourseWithdrawn = 'course_withdrawn',
  EventAdded = 'event_added',
  EventCancelled = 'event_cancelled',
  EventDateChanged = 'event_date_changed',
  EventReminder = 'event_reminder',
  InstructorPostedInCourseChat = 'instructor_posted_in_course_chat',
  MemberPostedInCourseChat = 'member_posted_in_course_chat',
  NewGradebookEntry = 'new_gradebook_entry',
  NewMention = 'new_mention',
  NewMessage = 'new_message',
  PersonalAvgGradeBelowThreshold = 'personal_avg_grade_below_threshold',
  StudentAvgGradeBelowThreshold = 'student_avg_grade_below_threshold',
  SubmissionAnnotated = 'submission_annotated'
}

/** Autogenerated return type of NotificationsMarkReadAll. */
export type NotificationsMarkReadAllPayload = {
  __typename?: 'NotificationsMarkReadAllPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum OauthProvider {
  Dropbox = 'dropbox',
  Facebook = 'facebook',
  Google = 'google',
  Snapchat = 'snapchat'
}

export type PaginatedCourses = {
  __typename?: 'PaginatedCourses';
  items: Array<Course>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginatedEnrollments = {
  __typename?: 'PaginatedEnrollments';
  items: Array<Enrollment>;
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PermissionLevel = {
  __typename?: 'PermissionLevel';
  fixed?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  users?: Maybe<Array<User>>;
};

/** Autogenerated return type of PermissionLevelsCreate. */
export type PermissionLevelsCreatePayload = {
  __typename?: 'PermissionLevelsCreatePayload';
  errors: Array<Scalars['String']>;
  permissionLevel?: Maybe<PermissionLevel>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PermissionLevelsDelete. */
export type PermissionLevelsDeletePayload = {
  __typename?: 'PermissionLevelsDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PermissionLevelsUpdate. */
export type PermissionLevelsUpdatePayload = {
  __typename?: 'PermissionLevelsUpdatePayload';
  errors: Array<Scalars['String']>;
  permissionLevel?: Maybe<PermissionLevel>;
  success: Scalars['Boolean'];
};

export type PolymorphicItemId = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

export enum PrintSchedule {
  Combined = 'combined',
  Individual = 'individual',
  Simple = 'simple'
}

export enum PrintShowOption {
  /** Include activities */
  Activities = 'activities',
  /** If enabled exclusively, activities will be shown on end date */
  ActivitiesByEndDate = 'activities_by_end_date',
  /** If enabled exclusively, activities will be shown on start date */
  ActivitiesByStartDate = 'activities_by_start_date',
  /** Include events */
  Events = 'events',
  /** Include holidays */
  Holidays = 'holidays',
  /** Include late activities */
  LateActivities = 'late_activities',
  /** Include weekends */
  Weekends = 'weekends'
}

export type PrivateDiscussion = CommentedItem & {
  __typename?: 'PrivateDiscussion';
  author: User;
  comments?: Maybe<Array<Comment>>;
  enrollments: Array<Enrollment>;
  id: Scalars['ID'];
  targetItem?: Maybe<CommentedItem>;
  type: CommentableObject;
  users: Array<User>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountCourses?: Maybe<PaginatedCourses>;
  accountEnrollments?: Maybe<PaginatedEnrollments>;
  accountRoles?: Maybe<Array<AccountRole>>;
  accountRolesById?: Maybe<Array<AccountRole>>;
  accountUsers?: Maybe<Array<User>>;
  activities?: Maybe<Array<Activity>>;
  activityBatches?: Maybe<Array<ActivityBatch>>;
  activityBlocks?: Maybe<Array<ActivityBlock>>;
  activityGroups?: Maybe<Array<ActivityGroup>>;
  assignmentTemplates: Array<AssignmentTemplate>;
  assignments?: Maybe<Array<Assignment>>;
  autocompleteData?: Maybe<GenericData>;
  calendarEvents?: Maybe<Array<Event>>;
  calendars?: Maybe<Array<Calendar>>;
  cohorts?: Maybe<Array<Cohort>>;
  commentedItems?: Maybe<Array<CommentedItem>>;
  comments?: Maybe<Array<Comment>>;
  contactableCourseMemberGroupTypes?: Maybe<Array<CourseMemberGroup>>;
  contactableUsers?: Maybe<Array<User>>;
  conversationMessages?: Maybe<Array<Message>>;
  conversations?: Maybe<Array<Conversation>>;
  courseActivities?: Maybe<Array<Activity>>;
  courseByInvite?: Maybe<Course>;
  courseMaterials?: Maybe<Array<CourseMaterial>>;
  courseRoles?: Maybe<Array<CourseRole>>;
  courseTemplates: Array<CourseTemplate>;
  courseTerms?: Maybe<Array<CourseTerm>>;
  courses?: Maybe<Array<Course>>;
  downloadGradebook: Scalars['JSON'];
  enrollments?: Maybe<Array<Enrollment>>;
  externalImages: Array<ExternalImage>;
  externalVideos: Array<ExternalVideo>;
  fileEntries: Array<FileEntry>;
  getUploadSession?: Maybe<UploadSession>;
  gradebookData?: Maybe<GradebookData>;
  gradingSchemes?: Maybe<Array<GradingScheme>>;
  icalFeedUrl?: Maybe<Scalars['String']>;
  manualGradeEntries?: Maybe<Array<ManualGradeEntry>>;
  materialBooks?: Maybe<Array<MaterialBook>>;
  materialCodes?: Maybe<Array<MaterialCode>>;
  materialLinks?: Maybe<Array<MaterialLink>>;
  me?: Maybe<User>;
  notifications?: Maybe<Array<Notification>>;
  permissionLevels?: Maybe<Array<PermissionLevel>>;
  permissionLevelsById?: Maybe<Array<PermissionLevel>>;
  printedSchedule?: Maybe<Scalars['String']>;
  quizTemplates: Array<QuizTemplate>;
  quizzes?: Maybe<Array<Quiz>>;
  realMe?: Maybe<User>;
  searchBooks?: Maybe<Array<GoodreadsBook>>;
  sourceAttributions?: Maybe<Array<SourceAttribution>>;
  stripeUpcomingInvoice?: Maybe<Scalars['JSON']>;
  studentSubmissions?: Maybe<Array<StudentSubmission>>;
  submissions?: Maybe<Array<Submission>>;
  subscriptionPlans: Array<SubscriptionPlan>;
  unitTemplates: Array<UnitTemplate>;
  units?: Maybe<Array<Unit>>;
  users?: Maybe<Array<User>>;
};


export type QueryAccountCoursesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchKey?: InputMaybe<Scalars['String']>;
};


export type QueryAccountEnrollmentsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  rolePrefix?: InputMaybe<Scalars['String']>;
  searchKey?: InputMaybe<Scalars['String']>;
};


export type QueryAccountRolesByIdArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryAccountUsersArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryActivitiesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryActivityBatchesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryActivityBlocksArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryActivityGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryAssignmentTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryAssignmentsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryAutocompleteDataArgs = {
  key: Scalars['String'];
};


export type QueryCalendarEventsArgs = {
  calendarIds?: InputMaybe<Array<Scalars['ID']>>;
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  keyword?: InputMaybe<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
};


export type QueryCohortsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCommentsArgs = {
  markRead?: InputMaybe<Scalars['Boolean']>;
  objectId: Scalars['ID'];
  objectType: CommentableObject;
};


export type QueryContactableUsersArgs = {
  conversationId?: InputMaybe<Scalars['ID']>;
};


export type QueryConversationMessagesArgs = {
  conversationId: Scalars['ID'];
};


export type QueryCourseActivitiesArgs = {
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  includeMissed?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
};


export type QueryCourseByInviteArgs = {
  inviteCode: Scalars['String'];
};


export type QueryCourseMaterialsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCourseRolesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCourseTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCourseTermsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCoursesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryDownloadGradebookArgs = {
  activityGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  courseId: Scalars['ID'];
  courseTermId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  enrollmentIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryEnrollmentsArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includePast?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  namePrefix?: InputMaybe<Scalars['String']>;
  rolePrefix?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryExternalImagesArgs = {
  provider: ExternalImageProvider;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryExternalVideosArgs = {
  provider: ExternalVideoProvider;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryFileEntriesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetUploadSessionArgs = {
  uploadSessionId: Scalars['String'];
};


export type QueryGradebookDataArgs = {
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  activityIds?: InputMaybe<Array<Scalars['ID']>>;
  courseId: Scalars['ID'];
  courseTermId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']>>;
  studentsLimit?: InputMaybe<Scalars['Int']>;
  studentsOffset?: InputMaybe<Scalars['Int']>;
  studentsSort?: InputMaybe<EnrollmentsSortOrder>;
};


export type QueryIcalFeedUrlArgs = {
  calendarIds?: InputMaybe<Array<Scalars['ID']>>;
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryManualGradeEntriesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryMaterialBooksArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryMaterialCodesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryMaterialLinksArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryPermissionLevelsByIdArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryPrintedScheduleArgs = {
  calendarIds?: InputMaybe<Array<Scalars['ID']>>;
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['ISO8601Date'];
  keyword?: InputMaybe<Scalars['String']>;
  scheduleType?: PrintSchedule;
  startDate: Scalars['ISO8601Date'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  viewOptions?: InputMaybe<Array<PrintShowOption>>;
};


export type QueryQuizTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryQuizzesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySearchBooksArgs = {
  query: Scalars['String'];
};


export type QuerySourceAttributionsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryStudentSubmissionsArgs = {
  activityIds: Array<Scalars['ID']>;
  enrollmentIds: Array<Scalars['ID']>;
};


export type QuerySubmissionsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryUnitTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryUnitsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryUsersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type Quiz = ActivityItem & {
  __typename?: 'Quiz';
  attemptsAllowed?: Maybe<Scalars['Int']>;
  /** Only non-null for active students in the course */
  attemptsRemaining?: Maybe<Scalars['Int']>;
  copyableBy: Visibility;
  createdAt: Scalars['ISO8601DateTime'];
  curriculum: Array<Scalars['String']>;
  downloadable?: Maybe<Scalars['Boolean']>;
  gradeLevels: Array<Scalars['String']>;
  hideGradePendingSubmission?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  pageBreaks?: Maybe<QuizPageBreaks>;
  parentTemplate?: Maybe<QuizTemplate>;
  questionNumbering: QuizQuestionNumbering;
  questions: Array<QuizQuestion>;
  resumable?: Maybe<Scalars['Boolean']>;
  showResults?: Maybe<Scalars['Boolean']>;
  shuffleOrder?: Maybe<Scalars['Boolean']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  subjects: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  timeLimit?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  type: Scalars['String'];
  visibleTo: Visibility;
};


export type QuizQuestionsArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

export type QuizAttributes = {
  attemptsAllowed?: InputMaybe<Scalars['Int']>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  hideGradePendingSubmission?: InputMaybe<Scalars['Boolean']>;
  instructions?: InputMaybe<Scalars['String']>;
  pageBreaks?: InputMaybe<QuizPageBreaks>;
  questionNumbering?: InputMaybe<QuizQuestionNumbering>;
  questions?: InputMaybe<Array<QuizQuestionAttributes>>;
  resumable?: InputMaybe<Scalars['Boolean']>;
  showResults?: InputMaybe<Scalars['Boolean']>;
  shuffleOrder?: InputMaybe<Scalars['Boolean']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  timeLimit?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum QuizPageBreaks {
  Section = 'section'
}

export type QuizQuestion = {
  __typename?: 'QuizQuestion';
  acceptPartialAnswers?: Maybe<Scalars['Boolean']>;
  caseSensitive?: Maybe<Scalars['Boolean']>;
  content: Scalars['JSON'];
  createdAt: Scalars['ISO8601DateTime'];
  displayNumber?: Maybe<Scalars['String']>;
  extraCredit?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  partialMatch?: Maybe<Scalars['Boolean']>;
  points: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  questionType: QuizQuestionKind;
  quiz: Quiz;
  requireOrder?: Maybe<Scalars['Boolean']>;
  section?: Maybe<Scalars['Boolean']>;
  shuffleAnswers?: Maybe<Scalars['Boolean']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  tags: Array<Scalars['String']>;
  uid: Scalars['String'];
};

export type QuizQuestionAttributes = {
  attemptsAllowed?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['JSON']>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  delete?: InputMaybe<Scalars['Boolean']>;
  displayNumber?: InputMaybe<Scalars['String']>;
  extraCredit?: InputMaybe<Scalars['Boolean']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']>>;
  instructions?: InputMaybe<Scalars['String']>;
  points?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  questionType?: InputMaybe<QuizQuestionKind>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  subjects?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  uid: Scalars['String'];
};

export enum QuizQuestionKind {
  Choice = 'choice',
  Drag = 'drag',
  Essay = 'essay',
  Fill = 'fill',
  Matching = 'matching',
  Section = 'section',
  Sequence = 'sequence',
  Short = 'short',
  Tf = 'tf',
  Word = 'word'
}

export enum QuizQuestionNumbering {
  /** Auto-Number */
  Auto = 'auto',
  /** Auto-Number per Section */
  AutoSection = 'auto_section',
  /** Manually Entered */
  Manual = 'manual',
  /** No Numbering */
  None = 'none'
}

export type QuizSubmission = {
  __typename?: 'QuizSubmission';
  answers: Scalars['JSON'];
  /** List of bookmarked quiz questions (when taking quiz) */
  bookmarks: Array<Scalars['ID']>;
  questionGrades: Scalars['JSON'];
  timeElapsed: Scalars['Int'];
  timeLeft?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of QuizSubmissionStart. */
export type QuizSubmissionStartPayload = {
  __typename?: 'QuizSubmissionStartPayload';
  errors: Array<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of QuizSubmissionSubmit. */
export type QuizSubmissionSubmitPayload = {
  __typename?: 'QuizSubmissionSubmitPayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of QuizSubmissionUpdate. */
export type QuizSubmissionUpdatePayload = {
  __typename?: 'QuizSubmissionUpdatePayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

export type QuizTemplate = {
  __typename?: 'QuizTemplate';
  author: User;
  copyableBy?: Maybe<Visibility>;
  createdAt: Scalars['ISO8601DateTime'];
  curriculum: Array<Scalars['String']>;
  downloadable?: Maybe<Scalars['Boolean']>;
  gradeLevels: Array<Scalars['String']>;
  hideGradePendingSubmission?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  instructions?: Maybe<Scalars['String']>;
  pageBreaks?: Maybe<QuizPageBreaks>;
  parentTemplate?: Maybe<CourseTemplate>;
  questionNumbering: QuizQuestionNumbering;
  questions: Array<QuizQuestion>;
  resumable?: Maybe<Scalars['Boolean']>;
  showResults?: Maybe<Scalars['Boolean']>;
  shuffleOrder?: Maybe<Scalars['Boolean']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  subjects: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  templateInCourse?: Maybe<Course>;
  templateOptions: Scalars['JSON'];
  timeLimit?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  visibleTo: Visibility;
};

/** Autogenerated return type of QuizTemplatesCreate. */
export type QuizTemplatesCreatePayload = {
  __typename?: 'QuizTemplatesCreatePayload';
  errors: Array<Scalars['String']>;
  quizTemplate?: Maybe<QuizTemplate>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of QuizTemplatesDelete. */
export type QuizTemplatesDeletePayload = {
  __typename?: 'QuizTemplatesDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of QuizTemplatesUpdate. */
export type QuizTemplatesUpdatePayload = {
  __typename?: 'QuizTemplatesUpdatePayload';
  errors: Array<Scalars['String']>;
  quizTemplate?: Maybe<QuizTemplate>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of QuizTemplatesUse. */
export type QuizTemplatesUsePayload = {
  __typename?: 'QuizTemplatesUsePayload';
  activity?: Maybe<Activity>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ResetPassword. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  errors: Array<BaseError>;
  success: Scalars['Boolean'];
};

export enum Role {
  Leader = 'leader',
  Parent = 'parent',
  Student = 'student'
}

/** Autogenerated return type of SignInOauth. */
export type SignInOauthPayload = {
  __typename?: 'SignInOauthPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** Autogenerated return type of SignIn. */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  errors: Array<BaseError>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type SingleSubmission = StudentSubmission & {
  __typename?: 'SingleSubmission';
  activity: Activity;
  dueStatus?: Maybe<SubmissionDueStatus>;
  enrollment: Enrollment;
  grade?: Maybe<Scalars['Float']>;
  gradedAt?: Maybe<Scalars['ISO8601DateTime']>;
  gradedBy?: Maybe<Enrollment>;
  mainStatus?: Maybe<SubmissionMainStatus>;
  privateDiscussionId?: Maybe<Scalars['ID']>;
  status?: Maybe<SubmissionStatus>;
  statusOverriddenAt?: Maybe<Scalars['ISO8601DateTime']>;
  statusOverriddenBy?: Maybe<Enrollment>;
  subStatus?: Maybe<SubmissionSubStatus>;
  submission?: Maybe<Submission>;
};


export type SingleSubmissionSubmissionArgs = {
  includeDraft?: InputMaybe<Scalars['Boolean']>;
};

export type SourceAttribution = {
  __typename?: 'SourceAttribution';
  author?: Maybe<Scalars['String']>;
  authorUrl?: Maybe<Scalars['String']>;
  byCompany?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  licenseOther?: Maybe<Scalars['String']>;
  licenseType?: Maybe<AttributionLicense>;
  notes?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SourceAttributionArguments = {
  author?: InputMaybe<Scalars['String']>;
  authorUrl?: InputMaybe<Scalars['String']>;
  byCompany?: InputMaybe<Scalars['String']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  licenseOther?: InputMaybe<Scalars['String']>;
  licenseType?: InputMaybe<AttributionLicense>;
  notes?: InputMaybe<Scalars['String']>;
  operation: BatchOperation;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of StripeDeepLink. */
export type StripeDeepLinkPayload = {
  __typename?: 'StripeDeepLinkPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type StudentSubmission = {
  activity: Activity;
  dueStatus?: Maybe<SubmissionDueStatus>;
  enrollment: Enrollment;
  grade?: Maybe<Scalars['Float']>;
  gradedAt?: Maybe<Scalars['ISO8601DateTime']>;
  gradedBy?: Maybe<Enrollment>;
  mainStatus?: Maybe<SubmissionMainStatus>;
  privateDiscussionId?: Maybe<Scalars['ID']>;
  status?: Maybe<SubmissionStatus>;
  statusOverriddenAt?: Maybe<Scalars['ISO8601DateTime']>;
  statusOverriddenBy?: Maybe<Enrollment>;
  subStatus?: Maybe<SubmissionSubStatus>;
};

export type Submission = {
  __typename?: 'Submission';
  activity: Activity;
  annotatedPdf?: Maybe<FileEntry>;
  annotationStatus?: Maybe<Scalars['String']>;
  annotationSubmittedBy?: Maybe<Enrollment>;
  annotationsSubmittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  attachments: Array<FileEntry>;
  content: SubmissionContent;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdBy?: Maybe<Enrollment>;
  deletableAttachments: Array<FileEntry>;
  enrollment: Enrollment;
  finalOverride?: Maybe<Scalars['Boolean']>;
  grade?: Maybe<Scalars['Float']>;
  gradedAt?: Maybe<Scalars['ISO8601DateTime']>;
  gradedBy?: Maybe<Enrollment>;
  hasContent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  isFinal?: Maybe<Scalars['Boolean']>;
  isSubmitted?: Maybe<Scalars['Boolean']>;
  isViewed?: Maybe<Scalars['Boolean']>;
  percentageGrade?: Maybe<Scalars['Float']>;
  similarityReportResults?: Maybe<Scalars['JSON']>;
  sticker?: Maybe<Scalars['String']>;
  submissionType: SubmissionEntry;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  textPdf?: Maybe<FileEntry>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of SubmissionAnnotate. */
export type SubmissionAnnotatePayload = {
  __typename?: 'SubmissionAnnotatePayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

export type SubmissionContent = AssignmentSubmission | QuizSubmission;

/** Autogenerated return type of SubmissionDelete. */
export type SubmissionDeletePayload = {
  __typename?: 'SubmissionDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum SubmissionDueStatus {
  Late = 'late',
  Missed = 'missed',
  Overdue = 'overdue'
}

export enum SubmissionEntry {
  /** Auto-submission */
  Auto = 'auto',
  /** Forced done submission */
  ForcedDone = 'forced_done',
  /** Mark as Done submission */
  MarkAsDone = 'mark_as_done',
  /** Quiz submission */
  Quiz = 'quiz',
  /** Skipped submission */
  Skipped = 'skipped',
  /** Text submission (Skipper Paper) */
  Text = 'text'
}

/** Autogenerated return type of SubmissionGenerateSimilarityReportUrl. */
export type SubmissionGenerateSimilarityReportUrlPayload = {
  __typename?: 'SubmissionGenerateSimilarityReportUrlPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SubmissionGrade. */
export type SubmissionGradePayload = {
  __typename?: 'SubmissionGradePayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

export enum SubmissionKind {
  Digital = 'digital',
  InPerson = 'in_person',
  NoSubmission = 'no_submission',
  OnPaper = 'on_paper',
  Online = 'online'
}

export enum SubmissionMainStatus {
  Assigned = 'assigned',
  Done = 'done',
  Upcoming = 'upcoming'
}

/** Autogenerated return type of SubmissionMakeFinal. */
export type SubmissionMakeFinalPayload = {
  __typename?: 'SubmissionMakeFinalPayload';
  errors: Array<Scalars['String']>;
  submission?: Maybe<Submission>;
  success: Scalars['Boolean'];
};

export enum SubmissionStatus {
  Absent = 'absent',
  Completed = 'completed',
  Dropped = 'dropped',
  Excused = 'excused',
  MarkedDone = 'marked_done',
  Missed = 'missed',
  NeedsGrading = 'needs_grading',
  Reassigned = 'reassigned',
  Skipped = 'skipped'
}

export enum SubmissionSubStatus {
  Assigned = 'assigned',
  InProgress = 'in_progress',
  Late = 'late',
  Missed = 'missed',
  NeedsGrading = 'needs_grading',
  NeedsReview = 'needs_review',
  Overdue = 'overdue',
  Upcoming = 'upcoming'
}

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  annualPriceId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  maxActivities?: Maybe<Scalars['Int']>;
  maxCourses?: Maybe<Scalars['Int']>;
  maxInstructors?: Maybe<Scalars['Int']>;
  maxStudents?: Maybe<Scalars['Int']>;
  monthlyPriceId?: Maybe<Scalars['String']>;
  priceAnnual: Scalars['Int'];
  priceMonthly: Scalars['Int'];
  productId: Scalars['String'];
  title: Scalars['String'];
};

export type Unit = {
  __typename?: 'Unit';
  activities: Array<Activity>;
  activityBlocks: Array<ActivityBlock>;
  backgroundFileEntry?: Maybe<FileEntry>;
  course: Course;
  courseTerm?: Maybe<CourseTerm>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  imageFileEntry?: Maybe<FileEntry>;
  position?: Maybe<Scalars['Int']>;
  sourceAttribution?: Maybe<SourceAttribution>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  title: Scalars['String'];
  visible?: Maybe<Scalars['Boolean']>;
};


export type UnitActivitiesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  includeInBlocks?: InputMaybe<Scalars['Boolean']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
};


export type UnitActivityBlocksArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
};

export type UnitArguments = {
  backgroundFileEntryId?: InputMaybe<Scalars['ID']>;
  courseId?: InputMaybe<Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** For update only, required */
  id?: InputMaybe<Scalars['ID']>;
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  operation: BatchOperation;
  position?: InputMaybe<Scalars['Int']>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  title?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UnitCreate. */
export type UnitCreatePayload = {
  __typename?: 'UnitCreatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  unit?: Maybe<Unit>;
};

/** Autogenerated return type of UnitDelete. */
export type UnitDeletePayload = {
  __typename?: 'UnitDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of UnitDuplicate. */
export type UnitDuplicatePayload = {
  __typename?: 'UnitDuplicatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  unit?: Maybe<Unit>;
};

export type UnitTemplate = {
  __typename?: 'UnitTemplate';
  activitiesCount: Scalars['Int'];
  author: User;
  content: Scalars['JSON'];
  copyableBy?: Maybe<Visibility>;
  createdAt: Scalars['ISO8601DateTime'];
  curriculum: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  gradeLevels: Array<Scalars['String']>;
  id: Scalars['ID'];
  originalCourse?: Maybe<Course>;
  parentTemplate?: Maybe<UnitTemplate>;
  sourceAttribution?: Maybe<SourceAttribution>;
  subjects: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  visibleTo: Visibility;
};

/** Autogenerated return type of UnitTemplatesCreate. */
export type UnitTemplatesCreatePayload = {
  __typename?: 'UnitTemplatesCreatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  unitTemplate?: Maybe<UnitTemplate>;
};

/** Autogenerated return type of UnitTemplatesDelete. */
export type UnitTemplatesDeletePayload = {
  __typename?: 'UnitTemplatesDeletePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of UnitTemplatesUpdate. */
export type UnitTemplatesUpdatePayload = {
  __typename?: 'UnitTemplatesUpdatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  unitTemplate?: Maybe<UnitTemplate>;
};

/** Autogenerated return type of UnitTemplatesUse. */
export type UnitTemplatesUsePayload = {
  __typename?: 'UnitTemplatesUsePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  unit?: Maybe<Unit>;
};

/** Autogenerated return type of UnitUpdate. */
export type UnitUpdatePayload = {
  __typename?: 'UnitUpdatePayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  unit?: Maybe<Unit>;
};

/** Autogenerated return type of UnitsReorderItems. */
export type UnitsReorderItemsPayload = {
  __typename?: 'UnitsReorderItemsPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of UnitsReorder. */
export type UnitsReorderPayload = {
  __typename?: 'UnitsReorderPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  units?: Maybe<Array<Unit>>;
};

export type UploadSession = {
  __typename?: 'UploadSession';
  authorizerItem: Scalars['JSON'];
  expiresAt: Scalars['ISO8601DateTime'];
  id: Scalars['String'];
  uploadedFiles: Array<FileEntry>;
  userId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  accountRole?: Maybe<AccountRole>;
  active?: Maybe<Scalars['Boolean']>;
  birthDate?: Maybe<Scalars['ISO8601Date']>;
  calendarColor?: Maybe<Scalars['String']>;
  children?: Maybe<Array<User>>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageFileEntry?: Maybe<FileEntry>;
  initials?: Maybe<Scalars['String']>;
  intercomHash?: Maybe<Scalars['String']>;
  joinedCalendars?: Maybe<Array<Calendar>>;
  lastActiveAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  minGradeNotificationThreshold?: Maybe<Scalars['JSON']>;
  notificationSettings?: Maybe<Scalars['JSON']>;
  oauthConnections: Array<OauthProvider>;
  ownCalendars?: Maybe<Array<Calendar>>;
  parent?: Maybe<User>;
  pauseNotifications?: Maybe<Scalars['Boolean']>;
  permissionLevel?: Maybe<PermissionLevel>;
  primaryAccount?: Maybe<Account>;
  systemAdmin?: Maybe<Scalars['Boolean']>;
  turnitinEulaAcceptedAt?: Maybe<Scalars['ISO8601DateTime']>;
  turnitinEulaAcceptedVersion?: Maybe<Scalars['String']>;
  turnitinEulaLatestVersion?: Maybe<Scalars['String']>;
  uid: Scalars['String'];
  unconfirmedEmail?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ValidateToken. */
export type ValidateTokenPayload = {
  __typename?: 'ValidateTokenPayload';
  errors: Array<BaseError>;
  success: Scalars['Boolean'];
  user?: Maybe<User>;
  valid: Scalars['Boolean'];
};

export enum Visibility {
  Collaborators = 'collaborators',
  Everyone = 'everyone',
  Me = 'me'
}

export type UserFragmentFragment = { __typename?: 'User', id: string, fullName?: string | null };

export type UnitDetailsFragment = { __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null };

export type CourseFragmentFragment = { __typename?: 'Course', id: string, graded?: boolean | null, courseCredits?: number | null, timeZone: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, startDate?: any | null, published?: boolean | null, tags?: Array<string> | null, gradeLevels?: Array<string> | null, subjects?: Array<string> | null, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, curriculum?: Array<string> | null, similarityReportsEnabled?: boolean | null, restricted?: boolean | null, isSameAccount?: boolean | null, currentTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null, terms?: Array<{ __typename?: 'CourseTerm', id: string, published?: boolean | null, forGradebook?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null }> | null, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, type: Role, name: string, permissions: any } } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, originalCourseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, visibleTo: Visibility, copyableBy?: Visibility | null, author: { __typename?: 'User', id: string } } | null };

export type CourseGradingSchemaFragment = { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string };

export type CourseActivityGroupsFragment = { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null };

export type FileEntryDefaultFragment = { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } };

export type ActivitiesDetailsFragment = { __typename?: 'Activity', id: string, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, graded?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, similarityReportsEnabled?: boolean | null, published?: boolean | null, visible?: boolean | null, points: number, updatedAt: any, position?: number | null, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null };

type ActivityItemFragment_Assignment_Fragment = { __typename?: 'Assignment', id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility };

type ActivityItemFragment_Quiz_Fragment = { __typename?: 'Quiz', id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility };

export type ActivityItemFragmentFragment = ActivityItemFragment_Assignment_Fragment | ActivityItemFragment_Quiz_Fragment;

export type ActivityBatchDefaultFragment = { __typename?: 'ActivityBatch', id: string, items: Array<any>, title: string, createdAt: any, baseItemType: string, baseItem?: { __typename?: 'Assignment', id: string, title: string, type: string, instructions?: string | null, attemptsAllowed?: number | null, createdAt: any, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }> } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string } | null };

export type AssignmentFragmentFragment = { __typename?: 'Assignment', attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null };

export type QuizFragmentFragment = { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, parentTemplate?: { __typename?: 'QuizTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null };

export type QuizQuestionFragmentFragment = { __typename?: 'QuizQuestion', id: string, uid: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string>, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null };

export type SubmissionFragmentFragment = { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, hasContent?: boolean | null, similarityReportResults?: any | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } };

export type ConversationMessageFragmentFragment = { __typename?: 'Message', id: string, content?: string | null, subject?: string | null, createdAt: any, author?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null };

export type CommentFragmentFragment = { __typename?: 'Comment', id: string, content?: string | null, isViewed: boolean, createdAt: any, author?: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null };

export type CreateAccountUserMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  accountRoleId: Scalars['ID'];
  birthDate: Scalars['ISO8601Date'];
  calendarColor?: InputMaybe<Scalars['String']>;
}>;


export type CreateAccountUserMutation = { __typename?: 'Mutation', createAccountUser?: { __typename?: 'AccountUsersCreatePayload', success: boolean, errors: Array<string>, user?: { __typename?: 'User', id: string, initials?: string | null, birthDate?: any | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, username?: string | null, email?: string | null, calendarColor?: string | null, unconfirmedEmail?: string | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, permissionLevel?: { __typename?: 'PermissionLevel', id: string, fixed?: boolean | null, name?: string | null, permissions?: Array<string> | null } | null } | null } | null };

export type DeleteAccountUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAccountUserMutation = { __typename?: 'Mutation', deleteAccountUser?: { __typename?: 'AccountUsersDeletePayload', success: boolean, errors: Array<string> } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['Int'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  calendarColor?: InputMaybe<Scalars['String']>;
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  minGradeNotificationThreshold?: InputMaybe<Scalars['JSON']>;
  permissionLevelId?: InputMaybe<Scalars['ID']>;
  birthDate?: InputMaybe<Scalars['ISO8601Date']>;
  turnItInEulaVersion?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateAccountUser?: { __typename?: 'AccountUsersUpdatePayload', errors: Array<string>, success: boolean, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, birthDate?: any | null, calendarColor?: string | null, email?: string | null, fullName?: string | null, id: string, initials?: string | null, unconfirmedEmail?: string | null, notificationSettings?: any | null, minGradeNotificationThreshold?: any | null } | null } | null };

export type UpdateAccountMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  schoolAddress?: InputMaybe<Scalars['String']>;
  schoolCity?: InputMaybe<Scalars['String']>;
  schoolState?: InputMaybe<Scalars['String']>;
  schoolZip?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'AccountsUpdatePayload', success: boolean, errors: Array<string>, account?: { __typename?: 'Account', name: string, schoolAddress?: string | null, schoolCity?: string | null, schoolState?: string | null, schoolZip?: string | null, timeZone?: string | null } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordToken: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordPayload', success: boolean, errors: Array<{ __typename?: 'BaseError', field: string, message: string }> } | null };

export type ResendEmailChangeAccountUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ResendEmailChangeAccountUserMutation = { __typename?: 'Mutation', resendEmailChangeAccountUser?: { __typename?: 'AccountUsersResendEmailChangePayload', success: boolean, errors: Array<string> } | null };

export type ResendEmailConfirmationAccountUserMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendEmailConfirmationAccountUserMutation = { __typename?: 'Mutation', resendEmailConfirmationAccountUser?: { __typename?: 'AccountUsersResendEmailConfirmationPayload', success: boolean, errors: Array<string> } | null };

export type CancelEmailChangeAccountUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CancelEmailChangeAccountUserMutation = { __typename?: 'Mutation', cancelEmailChangeAccountUser?: { __typename?: 'AccountUsersCancelEmailChangePayload', success: boolean, errors: Array<string> } | null };

export type CreateAccountMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'AccountsCreatePayload', success: boolean, errors: Array<string>, account?: { __typename?: 'Account', users?: Array<{ __typename?: 'User', id: string, email?: string | null }> | null } | null } | null };

export type CreateSubscriptionMutationVariables = Exact<{
  subscriptionPlanId: Scalars['ID'];
  priceId?: InputMaybe<Scalars['String']>;
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription?: { __typename?: 'CreateSubscriptionPayload', success: boolean, errors: Array<string>, redirectUrl?: string | null, invoicePreview?: any | null, subscriptionPlan?: { __typename?: 'SubscriptionPlan', title: string, description?: string | null, features?: Array<string> | null, productId: string, priceAnnual: number, priceMonthly: number } | null } | null };

export type CreateStripeDeepLinkMutationVariables = Exact<{
  type: Scalars['String'];
}>;


export type CreateStripeDeepLinkMutation = { __typename?: 'Mutation', createStripeDeepLink?: { __typename?: 'StripeDeepLinkPayload', success: boolean, errors: Array<string>, url?: string | null } | null };

export type CreateActivityMutationVariables = Exact<{
  unitId: Scalars['ID'];
  activityBlockId?: InputMaybe<Scalars['ID']>;
  activityGroupId?: InputMaybe<Scalars['ID']>;
  assignmentItem?: InputMaybe<AssignmentAttributes>;
  quizItem?: InputMaybe<QuizAttributes>;
  assignDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueTimeSignificant?: InputMaybe<Scalars['Boolean']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  parentCanGrade?: InputMaybe<Scalars['Boolean']>;
  parentCanGradeOverride?: InputMaybe<Scalars['Boolean']>;
  markLate?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
  lockAfterDueDate?: InputMaybe<Scalars['Boolean']>;
  lockBeforeAssignDate?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateActivityMutation = { __typename?: 'Mutation', createActivity?: { __typename?: 'ActivityCreatePayload', success: boolean, errors: Array<string>, activity?: { __typename?: 'Activity', id: string, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, points: number, position?: number | null, published?: boolean | null, visible?: boolean | null, graded?: boolean | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, createdAt: any, assignDate?: any | null, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, description?: string | null, weight?: number | null } | null, item: { __typename?: 'Assignment', submissionKind?: SubmissionKind | null, id: string, title: string, type: string, instructions?: string | null, attemptsAllowed?: number | null, createdAt: any, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }> } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, questions: Array<{ __typename?: 'QuizQuestion', id: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string> }> } } | null } | null };

export type UpdateActivityMutationVariables = Exact<{
  id: Scalars['ID'];
  unitId?: InputMaybe<Scalars['ID']>;
  activityBlockId?: InputMaybe<Scalars['ID']>;
  activityGroupId?: InputMaybe<Scalars['ID']>;
  assignmentItem?: InputMaybe<AssignmentAttributes>;
  quizItem?: InputMaybe<QuizAttributes>;
  assignDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  dueTimeSignificant?: InputMaybe<Scalars['Boolean']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  parentCanGrade?: InputMaybe<Scalars['Boolean']>;
  parentCanGradeOverride?: InputMaybe<Scalars['Boolean']>;
  markLate?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
  lockAfterDueDate?: InputMaybe<Scalars['Boolean']>;
  lockBeforeAssignDate?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateActivityMutation = { __typename?: 'Mutation', updateActivity?: { __typename?: 'ActivityUpdatePayload', success: boolean, errors: Array<string>, activity?: { __typename?: 'Activity', id: string, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, points: number, position?: number | null, published?: boolean | null, visible?: boolean | null, graded?: boolean | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, createdAt: any, assignDate?: any | null, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, description?: string | null, weight?: number | null } | null, item: { __typename?: 'Assignment', id: string, title: string, type: string, instructions?: string | null, attemptsAllowed?: number | null, createdAt: any, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', backgroundColor?: string | null, uid: string, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }> } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, questions: Array<{ __typename?: 'QuizQuestion', id: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string> }> } } | null } | null };

export type CreateActivityBlockMutationVariables = Exact<{
  unitId: Scalars['ID'];
  title: Scalars['String'];
  assignDate?: InputMaybe<Scalars['ISO8601Date']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']>;
  visible?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateActivityBlockMutation = { __typename?: 'Mutation', createActivityBlock?: { __typename?: 'ActivityBlockCreatePayload', success: boolean, errors: Array<string> } | null };

export type DeleteActivityMutationVariables = Exact<{
  id: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteActivityMutation = { __typename?: 'Mutation', deleteActivity?: { __typename?: 'ActivityDeletePayload', success: boolean, errors: Array<string> } | null };

export type CreateActivityBatchMutationVariables = Exact<{
  courseId: Scalars['ID'];
  title: Scalars['String'];
  items?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
  baseItemType: Scalars['String'];
  baseItemId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateActivityBatchMutation = { __typename?: 'Mutation', createActivityBatch?: { __typename?: 'ActivityBatchCreatePayload', success: boolean, errors: Array<string>, activityBatch?: { __typename?: 'ActivityBatch', id: string, items: Array<any>, title: string, createdAt: any, baseItemType: string, baseItem?: { __typename?: 'Assignment', id: string, title: string, type: string, instructions?: string | null, attemptsAllowed?: number | null, createdAt: any, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }> } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string } | null } | null } | null };

export type DeleteActivityBatchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteActivityBatchMutation = { __typename?: 'Mutation', deleteActivityBatch?: { __typename?: 'ActivityBatchesDeletePayload', success: boolean, errors: Array<string> } | null };

export type UpdateActivityBatchMutationVariables = Exact<{
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
}>;


export type UpdateActivityBatchMutation = { __typename?: 'Mutation', updateActivityBatch?: { __typename?: 'ActivityBatchUpdatePayload', success: boolean, errors: Array<string>, activityBatch?: { __typename?: 'ActivityBatch', id: string, items: Array<any>, title: string, createdAt: any, baseItemType: string, baseItem?: { __typename?: 'Assignment', id: string, title: string, type: string, instructions?: string | null, attemptsAllowed?: number | null, createdAt: any, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }> } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string } | null } | null } | null };

export type BatchActivitiesMutationVariables = Exact<{
  batchItems: Array<ActivityAttributes> | ActivityAttributes;
}>;


export type BatchActivitiesMutation = { __typename?: 'Mutation', batchActivities?: { __typename?: 'BatchActivitiesPayload', success: boolean, errors: Array<string>, activities?: Array<{ __typename?: 'Activity', id: string, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, points: number, position?: number | null, published?: boolean | null, visible?: boolean | null, graded?: boolean | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, createdAt: any, assignDate?: any | null, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, description?: string | null, weight?: number | null } | null, item: { __typename?: 'Assignment', id: string, title: string, type: string, instructions?: string | null, attemptsAllowed?: number | null, createdAt: any, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }> } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, questions: Array<{ __typename?: 'QuizQuestion', id: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string> }> } }> | null } | null };

export type CreateActivityGroupMutationVariables = Exact<{
  courseId: Scalars['ID'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
}>;


export type CreateActivityGroupMutation = { __typename?: 'Mutation', createActivityGroup?: { __typename?: 'ActivityGroupCreatePayload', success: boolean, errors: Array<string>, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null, createdAt: any } | null } | null };

export type DeleteActivityGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteActivityGroupMutation = { __typename?: 'Mutation', deleteActivityGroup?: { __typename?: 'ActivityGroupDeletePayload', success: boolean, errors: Array<string> } | null };

export type UpdateActivityGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateActivityGroupMutation = { __typename?: 'Mutation', updateActivityGroup?: { __typename?: 'ActivityGroupUpdatePayload', success: boolean, errors: Array<string>, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null, createdAt: any } | null } | null };

export type BatchActivityGroupsMutationVariables = Exact<{
  batchItems: Array<ActivityGroupArguments> | ActivityGroupArguments;
}>;


export type BatchActivityGroupsMutation = { __typename?: 'Mutation', batchActivityGroups?: { __typename?: 'BatchActivityGroupPayload', success: boolean, errors: Array<string> } | null };

export type CreateAssignmentTemplateMutationVariables = Exact<{
  originalAssignmentId: Scalars['ID'];
  title: Scalars['String'];
  visibleTo?: InputMaybe<Visibility>;
  copyableBy?: InputMaybe<Visibility>;
  maxPoints?: InputMaybe<Scalars['Int']>;
}>;


export type CreateAssignmentTemplateMutation = { __typename?: 'Mutation', createAssignmentTemplate?: { __typename?: 'AssignmentTemplatesCreatePayload', errors: Array<string>, success: boolean, assignmentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string } | null } | null };

export type CreateQuizTemplateMutationVariables = Exact<{
  originalQuizId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  visibleTo?: InputMaybe<Visibility>;
  copyableBy?: InputMaybe<Visibility>;
}>;


export type CreateQuizTemplateMutation = { __typename?: 'Mutation', createQuizTemplate?: { __typename?: 'QuizTemplatesCreatePayload', errors: Array<string>, success: boolean, quizTemplate?: { __typename?: 'QuizTemplate', id: string, title: string } | null } | null };

export type UseAssignmentTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  unitId: Scalars['ID'];
}>;


export type UseAssignmentTemplateMutation = { __typename?: 'Mutation', useAssignmentTemplate?: { __typename?: 'AssignmentTemplatesUsePayload', errors: Array<string>, success: boolean, activity?: { __typename?: 'Activity', id: string, item: { __typename?: 'Assignment', title: string, id: string } | { __typename?: 'Quiz', title: string, id: string } } | null } | null };

export type UseQuizTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  unitId: Scalars['ID'];
}>;


export type UseQuizTemplateMutation = { __typename?: 'Mutation', useQuizTemplate?: { __typename?: 'QuizTemplatesUsePayload', errors: Array<string>, success: boolean, activity?: { __typename?: 'Activity', id: string, item: { __typename?: 'Assignment', title: string, id: string } | { __typename?: 'Quiz', title: string, id: string } } | null } | null };

export type DeleteAssignmentTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAssignmentTemplateMutation = { __typename?: 'Mutation', deleteAssignmentTemplate?: { __typename?: 'AssignmentTemplatesDeletePayload', errors: Array<string>, success: boolean } | null };

export type DeleteQuizTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteQuizTemplateMutation = { __typename?: 'Mutation', deleteQuizTemplate?: { __typename?: 'QuizTemplatesDeletePayload', errors: Array<string>, success: boolean } | null };

export type CreateEventMutationVariables = Exact<{
  title: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  timeStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  timeEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  courseId?: InputMaybe<Scalars['ID']>;
  calendarId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent?: { __typename?: 'CalendarEventCreatePayload', success: boolean, errors: Array<string>, event?: { __typename?: 'Event', id: string, title?: string | null, date: any, timeStart?: any | null, timeEnd?: any | null, url?: string | null, details?: string | null, calendar?: { __typename?: 'Calendar', id: string } | null, course?: { __typename?: 'Course', id: string } | null, createdBy?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null } | null } | null } | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  details?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  timeStart?: InputMaybe<Scalars['ISO8601DateTime']>;
  timeEnd?: InputMaybe<Scalars['ISO8601DateTime']>;
  courseId?: InputMaybe<Scalars['ID']>;
  calendarId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent?: { __typename?: 'CalendarEventUpdatePayload', success: boolean, errors: Array<string>, event?: { __typename?: 'Event', id: string, title?: string | null, date: any, timeStart?: any | null, timeEnd?: any | null, url?: string | null, details?: string | null, calendar?: { __typename?: 'Calendar', id: string } | null, course?: { __typename?: 'Course', id: string } | null, createdBy?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null } | null } | null } | null };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['ID'];
  chain?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent?: { __typename?: 'CalendarEventDeletePayload', success: boolean, errors: Array<string> } | null };

export type CreateCommentMutationVariables = Exact<{
  objectId: Scalars['ID'];
  objectType: CommentableObject;
  content: Scalars['String'];
  fileEntryId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment?: { __typename?: 'CommentCreatePayload', comment?: { __typename?: 'Comment', id: string, content?: string | null, isViewed: boolean, createdAt: any, author?: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } | null } | null };

export type ToggleReadCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
}>;


export type ToggleReadCommentMutation = { __typename?: 'Mutation', toggleReadComment?: { __typename?: 'CommentToggleReadPayload', success: boolean, errors: Array<string> } | null };

export type MarkReadAllCommentsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkReadAllCommentsMutation = { __typename?: 'Mutation', markReadAllComments?: { __typename?: 'CommentMarkReadAllPayload', success: boolean, errors: Array<string> } | null };

export type CreateConversationMutationVariables = Exact<{
  participatingUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  participatingCourses?: InputMaybe<Array<ConversationParticipatingCourseAttributes> | ConversationParticipatingCourseAttributes>;
  title?: InputMaybe<Scalars['String']>;
  iconFileEntryId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  messageSubject?: InputMaybe<Scalars['String']>;
}>;


export type CreateConversationMutation = { __typename?: 'Mutation', createConversation?: { __typename?: 'ConversationCreatePayload', conversation?: { __typename?: 'Conversation', id: string, title?: string | null, createdAt: any, leftParticipants: Array<{ __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }>, participatingCourseMemberGroups: Array<{ __typename?: 'CourseMemberGroup', course: { __typename?: 'Course', id: string, title: string } }>, owner: { __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } } | null } | null };

export type HideConversationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HideConversationMutation = { __typename?: 'Mutation', hideConversation?: { __typename?: 'ConversationHidePayload', success: boolean, errors: Array<string> } | null };

export type LeaveConversationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LeaveConversationMutation = { __typename?: 'Mutation', leaveConversation?: { __typename?: 'ConversationLeavePayload', success: boolean, errors: Array<string> } | null };

export type ToggleMuteConversationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleMuteConversationMutation = { __typename?: 'Mutation', toggleMuteConversation?: { __typename?: 'ConversationToggleMutePayload', success: boolean, errors: Array<string>, conversation?: { __typename?: 'Conversation', id: string, isMuted: boolean } | null } | null };

export type ToggleViewConversationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleViewConversationMutation = { __typename?: 'Mutation', toggleViewConversation?: { __typename?: 'ConversationToggleViewPayload', success: boolean, errors: Array<string>, conversation?: { __typename?: 'Conversation', id: string, isMuted: boolean } | null } | null };

export type ReopenConversationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReopenConversationMutation = { __typename?: 'Mutation', reopenConversation?: { __typename?: 'ConversationReopenPayload', success: boolean, errors: Array<string> } | null };

export type CreateConversationMessageMutationVariables = Exact<{
  conversationId: Scalars['ID'];
  content?: InputMaybe<Scalars['String']>;
  fileEntryId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
}>;


export type CreateConversationMessageMutation = { __typename?: 'Mutation', createMessage?: { __typename?: 'MessageCreatePayload', success: boolean, errors: Array<string>, message?: { __typename?: 'Message', id: string, content?: string | null, subject?: string | null, createdAt: any, author?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } | null } | null };

export type DeleteConversationMessageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteConversationMessageMutation = { __typename?: 'Mutation', deleteMessage?: { __typename?: 'MessageDeletePayload', success: boolean, errors: Array<string> } | null };

export type UpdateConversationMutationVariables = Exact<{
  id: Scalars['ID'];
  participatingUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  participatingCourses?: InputMaybe<Array<ConversationParticipatingCourseAttributes> | ConversationParticipatingCourseAttributes>;
  title?: InputMaybe<Scalars['String']>;
  iconFileEntryId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateConversationMutation = { __typename?: 'Mutation', updateConversation?: { __typename?: 'ConversationUpdatePayload', conversation?: { __typename?: 'Conversation', id: string, title?: string | null, createdAt: any, leftParticipants: Array<{ __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }>, participatingCourseMemberGroups: Array<{ __typename?: 'CourseMemberGroup', course: { __typename?: 'Course', id: string, title: string } }>, participants: Array<{ __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null }>, owner: { __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } } | null } | null };

export type CreateCourseMutationVariables = Exact<{
  title: Scalars['String'];
  graded?: InputMaybe<Scalars['Boolean']>;
  iconColor?: InputMaybe<Scalars['String']>;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', createCourse?: { __typename?: 'CourseCreatePayload', success: boolean, errors: Array<string>, course?: { __typename?: 'Course', id: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, published?: boolean | null, graded?: boolean | null, courseCredits?: number | null } | null } | null };

export type UpdateCourseMutationVariables = Exact<{
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  gradingSchemeId?: InputMaybe<Scalars['ID']>;
  iconColor?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  graded?: InputMaybe<Scalars['Boolean']>;
  timeZone?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  courseCredits?: InputMaybe<Scalars['Float']>;
  scheduledDaysOff?: InputMaybe<Array<Scalars['ISO8601Date']> | Scalars['ISO8601Date']>;
  scheduledWeekdays?: InputMaybe<Array<DayOfWeek> | DayOfWeek>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  schedulingMode?: InputMaybe<CourseSchedulingMode>;
  gradeLevels?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subjects?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  curriculum?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  welcome?: InputMaybe<Scalars['String']>;
  thumbnailFileEntryId?: InputMaybe<Scalars['ID']>;
  videoFileEntryId?: InputMaybe<Scalars['ID']>;
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  inviteCode?: InputMaybe<Scalars['String']>;
  autoRegenerateInviteCode?: InputMaybe<Scalars['Boolean']>;
  inviteCodeExpiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  requireJoinConfirmation?: InputMaybe<Scalars['Boolean']>;
  welcomeMediaType?: InputMaybe<CourseWelcomeMedia>;
  defaultCourseTermId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse?: { __typename?: 'CourseUpdatePayload', success: boolean, errors: Array<string>, course?: { __typename?: 'Course', id: string, description?: string | null, iconColor?: string | null, title: string, uid: string, published?: boolean | null, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, graded?: boolean | null, timeZone: string, courseCredits?: number | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, inviteCode?: string | null, autoRegenerateInviteCode?: boolean | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, startDate?: any | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } | null } | null };

export type DeleteCourseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCourseMutation = { __typename?: 'Mutation', deleteCourse?: { __typename?: 'CourseDeletePayload', errors: Array<string>, success: boolean } | null };

export type CreateCourseRoleMutationVariables = Exact<{
  name: Scalars['String'];
  courseId: Scalars['ID'];
}>;


export type CreateCourseRoleMutation = { __typename?: 'Mutation', createCourseRole?: { __typename?: 'CourseRoleCreatePayload', success: boolean, errors: Array<string>, courseRole?: { __typename?: 'CourseRole', id: string, name: string, permissions: any, fixed?: boolean | null, type: Role, enrollments: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null } }> } | null } | null };

export type UpdateCourseRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateCourseRoleMutation = { __typename?: 'Mutation', updateCourseRole?: { __typename?: 'CourseRoleUpdatePayload', success: boolean, errors: Array<string>, courseRole?: { __typename?: 'CourseRole', id: string, name: string, permissions: any, fixed?: boolean | null, type: Role, enrollments: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null } }> } | null } | null };

export type DeleteCourseRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCourseRoleMutation = { __typename?: 'Mutation', deleteCourseRole?: { __typename?: 'CourseRoleDeletePayload', success: boolean, errors: Array<string> } | null };

export type CreateUnitMutationVariables = Exact<{
  courseId: Scalars['ID'];
  title: Scalars['String'];
  courseTermId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateUnitMutation = { __typename?: 'Mutation', createUnit?: { __typename?: 'UnitCreatePayload', success: boolean, errors: Array<string>, unit?: { __typename?: 'Unit', id: string, title: string } | null } | null };

export type BatchCreateUnitsMutationVariables = Exact<{
  batchItems: Array<UnitArguments> | UnitArguments;
}>;


export type BatchCreateUnitsMutation = { __typename?: 'Mutation', batchCreateUnits?: { __typename?: 'BatchUnitsCreatePayload', success: boolean, errors: Array<string> } | null };

export type DeleteUnitMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUnitMutation = { __typename?: 'Mutation', deleteUnit?: { __typename?: 'UnitDeletePayload', success: boolean, errors: Array<string> } | null };

export type UpdateUnitMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  visible?: InputMaybe<Scalars['Boolean']>;
  imageFileEntryId?: InputMaybe<Scalars['ID']>;
  backgroundFileEntryId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateUnitMutation = { __typename?: 'Mutation', updateUnit?: { __typename?: 'UnitUpdatePayload', success: boolean, errors: Array<string>, unit?: { __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } | null } | null };

export type BatchUnitsMutationVariables = Exact<{
  batchItems: Array<UnitArguments> | UnitArguments;
}>;


export type BatchUnitsMutation = { __typename?: 'Mutation', batchUnits?: { __typename?: 'BatchUnitsPayload', success: boolean, errors: Array<string> } | null };

export type CreateCourseTermMutationVariables = Exact<{
  courseId: Scalars['ID'];
  title: Scalars['String'];
  weight?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CreateCourseTermMutation = { __typename?: 'Mutation', createCourseTerm?: { __typename?: 'CourseTermCreatePayload', success: boolean, errors: Array<string>, courseTerm?: { __typename?: 'CourseTerm', id: string, title: string, weight?: number | null, published?: boolean | null, publishable?: boolean | null, units: Array<{ __typename?: 'Unit', id: string, title: string }> } | null } | null };

export type UpdateCourseTermMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  weight?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateCourseTermMutation = { __typename?: 'Mutation', updateCourseTerm?: { __typename?: 'CourseTermUpdatePayload', success: boolean, errors: Array<string> } | null };

export type BatchCourseTermsMutationVariables = Exact<{
  batchItems: Array<CourseTermArguments> | CourseTermArguments;
}>;


export type BatchCourseTermsMutation = { __typename?: 'Mutation', batchCourseTerms?: { __typename?: 'BatchCourseTermPayload', success: boolean, errors: Array<string>, courseTerms?: Array<{ __typename?: 'CourseTerm', accessible?: boolean | null, id: string, published?: boolean | null, title: string, weight?: number | null, publishable?: boolean | null, forGradebook?: boolean | null, units: Array<{ __typename?: 'Unit', id: string, title: string }> }> | null } | null };

export type DeleteCourseTermMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCourseTermMutation = { __typename?: 'Mutation', deleteCourseTerm?: { __typename?: 'CourseTermDeletePayload', success: boolean, errors: Array<string> } | null };

export type BatchCourseMaterialsMutationVariables = Exact<{
  batchItems: Array<CourseMaterialArguments> | CourseMaterialArguments;
}>;


export type BatchCourseMaterialsMutation = { __typename?: 'Mutation', batchCourseMaterials?: { __typename?: 'BatchCourseMaterialPayload', success: boolean, errors: Array<string>, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null } | null };

export type ReorderUnitItemsMutationVariables = Exact<{
  unitId: Scalars['ID'];
  activityIds: Array<PolymorphicItemId> | PolymorphicItemId;
}>;


export type ReorderUnitItemsMutation = { __typename?: 'Mutation', reorderUnitItems?: { __typename?: 'UnitsReorderItemsPayload', success: boolean, errors: Array<string> } | null };

export type ReorderUnitsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReorderUnitsMutation = { __typename?: 'Mutation', reorderUnits?: { __typename?: 'UnitsReorderPayload', success: boolean, errors: Array<string> } | null };

export type DuplicateActivityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateActivityMutation = { __typename?: 'Mutation', duplicateActivity?: { __typename?: 'ActivityDuplicatePayload', success: boolean, errors: Array<string>, activity?: { __typename?: 'Activity', id: string } | null } | null };

export type DuplicateUnitMutationVariables = Exact<{
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
}>;


export type DuplicateUnitMutation = { __typename?: 'Mutation', duplicateUnit?: { __typename?: 'UnitDuplicatePayload', success: boolean, errors: Array<string>, unit?: { __typename?: 'Unit', id: string } | null } | null };

export type StartUploadSessionMutationVariables = Exact<{
  authorizerItem: PolymorphicItemId;
}>;


export type StartUploadSessionMutation = { __typename?: 'Mutation', startUploadSession?: { __typename?: 'FileEntryStartUploadSessionPayload', errors: Array<string>, success: boolean, uploadSession?: { __typename?: 'UploadSession', expiresAt: any, id: string, authorizerItem: any } | null } | null };

export type GetUploadSessionQueryVariables = Exact<{
  uploadSessionId: Scalars['String'];
}>;


export type GetUploadSessionQuery = { __typename?: 'Query', getUploadSession?: { __typename?: 'UploadSession', expiresAt: any, id: string, authorizerItem: any, userId: string, uploadedFiles: Array<{ __typename?: 'FileEntry', createdAt?: any | null, croppedUrl?: string | null, description?: string | null, fileType?: string | null, id: string, originalFileName?: string | null, originalFileSize?: number | null, tags: Array<string>, title: string, updatedAt?: any | null, url?: string | null }> } | null };

export type GenerateCumulativeGradebookUrlMutationVariables = Exact<{
  courseId: Scalars['ID'];
  enrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
}>;


export type GenerateCumulativeGradebookUrlMutation = { __typename?: 'Mutation', generateCumulativeGradebookUrl?: { __typename?: 'GenerateCumulativeGradebookUrlPayload', success: boolean, errors: Array<string>, url?: string | null } | null };

export type GenerateGridGradebookUrlMutationVariables = Exact<{
  courseId: Scalars['ID'];
  enrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
}>;


export type GenerateGridGradebookUrlMutation = { __typename?: 'Mutation', generateCumulativeGradebookUrl?: { __typename?: 'GenerateCumulativeGradebookUrlPayload', success: boolean, errors: Array<string>, url?: string | null } | null };

export type CreateCourseTemplateMutationVariables = Exact<{
  courseId: Scalars['ID'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  visibleTo?: InputMaybe<Visibility>;
  copyableBy?: InputMaybe<Visibility>;
  keepDates: Scalars['Boolean'];
  keepRoles: Scalars['Boolean'];
  gradeLevels?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subjects?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  curriculum?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  courseCredits?: InputMaybe<Scalars['Float']>;
  thumbnailFileEntryId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateCourseTemplateMutation = { __typename?: 'Mutation', createCourseTemplate?: { __typename?: 'CourseTemplatesCreatePayload', errors: Array<string>, success: boolean, courseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, description?: string | null, uid: string, subjects: Array<string>, curriculum: Array<string>, gradeLevels: Array<string>, tags: Array<string>, courseCredits?: number | null, iconColor: string, visibleTo: Visibility, copyableBy?: Visibility | null, thumbnailFileEntry?: { __typename?: 'FileEntry', id: string } | null, imageFileEntry?: { __typename?: 'FileEntry', id: string } | null, originalCourse?: { __typename?: 'Course', id: string } | null, parentTemplate?: { __typename?: 'CourseTemplate', id: string } | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null } | null } | null };

export type DeleteCourseTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCourseTemplateMutation = { __typename?: 'Mutation', deleteCourseTemplate?: { __typename?: 'CourseTemplatesDeletePayload', errors: Array<string>, success: boolean } | null };

export type UpdateCourseTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCourseTemplateMutation = { __typename?: 'Mutation', updateCourseTemplate?: { __typename?: 'CourseTemplatesUpdatePayload', errors: Array<string>, success: boolean, courseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, description?: string | null, uid: string, subjects: Array<string>, curriculum: Array<string>, gradeLevels: Array<string>, tags: Array<string>, courseCredits?: number | null, iconColor: string, visibleTo: Visibility, copyableBy?: Visibility | null, thumbnailFileEntry?: { __typename?: 'FileEntry', id: string } | null, imageFileEntry?: { __typename?: 'FileEntry', id: string } | null, originalCourse?: { __typename?: 'Course', id: string } | null, parentTemplate?: { __typename?: 'CourseTemplate', id: string } | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null } | null } | null };

export type UseCourseTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  keepDates: Scalars['Boolean'];
  title: Scalars['String'];
  graded?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  iconColor?: InputMaybe<Scalars['String']>;
}>;


export type UseCourseTemplateMutation = { __typename?: 'Mutation', useCourseTemplate?: { __typename?: 'CourseTemplatesUsePayload', errors: Array<string>, success: boolean, course?: { __typename?: 'Course', id: string, title: string } | null } | null };

export type EnrollmentFragmentFragment = { __typename?: 'Enrollment', id: string, concluded?: boolean | null, dropped?: boolean | null, createdAt: any, finalGrade?: number | null, activatedAt?: any | null, deactivatedAt?: any | null, lastActivityAt?: any | null, needsConfirmJoin?: boolean | null, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null }, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role } };

export type CreateEnrollmentMutationVariables = Exact<{
  courseId?: InputMaybe<Scalars['ID']>;
  inviteCode?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['ID']>;
  courseRoleId?: InputMaybe<Scalars['ID']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateEnrollmentMutation = { __typename?: 'Mutation', createEnrollment?: { __typename?: 'EnrollmentsCreatePayload', success: boolean, errors: Array<string>, enrollment?: { __typename?: 'Enrollment', id: string, concluded?: boolean | null, dropped?: boolean | null, createdAt: any, finalGrade?: number | null, activatedAt?: any | null, deactivatedAt?: any | null, lastActivityAt?: any | null, needsConfirmJoin?: boolean | null, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null }, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role } } | null } | null };

export type SwitchEnrollmentMutationVariables = Exact<{
  enrollmentId: Scalars['ID'];
}>;


export type SwitchEnrollmentMutation = { __typename?: 'Mutation', switchEnrollment?: { __typename?: 'EnrollmentsSwitchPayload', success: boolean, errors: Array<string>, enrollment?: { __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null } } | null } | null };

export type ConcludeEnrollmentMutationVariables = Exact<{
  id: Scalars['ID'];
  finalGrade?: InputMaybe<Scalars['Int']>;
  silent?: InputMaybe<Scalars['Boolean']>;
}>;


export type ConcludeEnrollmentMutation = { __typename?: 'Mutation', concludeEnrollment?: { __typename?: 'EnrollmentsConcludePayload', success: boolean, errors: Array<string> } | null };

export type ConcludeAllEnrollmentsMutationVariables = Exact<{
  courseId: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
}>;


export type ConcludeAllEnrollmentsMutation = { __typename?: 'Mutation', concludeAllEnrollments?: { __typename?: 'EnrollmentsConcludeAllPayload', success: boolean, errors: Array<string>, enrollments?: Array<{ __typename?: 'Enrollment', id: string }> | null } | null };

export type AcademicRecordsDownloadUrlMutationVariables = Exact<{
  scope: Scalars['String'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type AcademicRecordsDownloadUrlMutation = { __typename?: 'Mutation', academicRecordsDownloadUrl?: { __typename?: 'EnrollmentsAcademicRecordsDownloadPayload', success: boolean, errors: Array<string>, url?: string | null } | null };

export type DropEnrollmentMutationVariables = Exact<{
  id: Scalars['ID'];
  silent?: InputMaybe<Scalars['Boolean']>;
}>;


export type DropEnrollmentMutation = { __typename?: 'Mutation', dropEnrollment?: { __typename?: 'EnrollmentsDropPayload', success: boolean, errors: Array<string> } | null };

export type UpdateEnrollmentMutationVariables = Exact<{
  id: Scalars['ID'];
  courseRoleId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateEnrollmentMutation = { __typename?: 'Mutation', updateEnrollment?: { __typename?: 'EnrollmentsUpdatePayload', success: boolean, errors: Array<string> } | null };

export type AcceptEnrollmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AcceptEnrollmentMutation = { __typename?: 'Mutation', acceptEnrollment?: { __typename?: 'EnrollmentsAcceptPayload', success: boolean, errors: Array<string>, enrollment?: { __typename?: 'Enrollment', id: string, course: { __typename?: 'Course', id: string } } | null } | null };

export type ResendEnrollmentInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendEnrollmentInviteMutation = { __typename?: 'Mutation', resendEnrollmentInvite?: { __typename?: 'EnrollmentsResendInvitePayload', success: boolean, errors: Array<string> } | null };

export type CreateFileMutationVariables = Exact<{
  title: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  srcUrl?: InputMaybe<Scalars['String']>;
  skipperPaperContent?: InputMaybe<Scalars['String']>;
  authorizerItem?: InputMaybe<PolymorphicItemId>;
  cropAttributes?: InputMaybe<CropAttributes>;
  uploadSessionId?: InputMaybe<Scalars['String']>;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile?: { __typename?: 'FileEntryCreatePayload', success: boolean, errors: Array<string>, fileEntry?: { __typename?: 'FileEntry', croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, skipperPaperContent?: string | null, title: string, description?: string | null, url?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } | null };

export type PresignCreateFileMutationVariables = Exact<{
  title: Scalars['String'];
  contentType?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  authorizerItem?: InputMaybe<PolymorphicItemId>;
  uploadSessionId?: InputMaybe<Scalars['String']>;
}>;


export type PresignCreateFileMutation = { __typename?: 'Mutation', presignCreateFile?: { __typename?: 'FileEntryPresignCreatePayload', success: boolean, errors: Array<string>, fileEntryId?: string | null, uploadId?: string | null, parts?: Array<{ __typename?: 'FileUploadPart', partNumber: number, offset: number, size: number, url: string }> | null } | null };

export type FinishCreateFileMutationVariables = Exact<{
  fileEntryId: Scalars['ID'];
  uploadId?: InputMaybe<Scalars['String']>;
  etags: Array<Scalars['String']> | Scalars['String'];
  cropAttributes?: InputMaybe<CropAttributes>;
  uploadSessionId?: InputMaybe<Scalars['String']>;
  skipperPaperContent?: InputMaybe<Scalars['String']>;
}>;


export type FinishCreateFileMutation = { __typename?: 'Mutation', finishCreateFile?: { __typename?: 'FileEntryFinishCreatePayload', success: boolean, errors: Array<string>, fileEntry?: { __typename?: 'FileEntry', croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, skipperPaperContent?: string | null, title: string, description?: string | null, url?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } | null };

export type UpdateFileMutationVariables = Exact<{
  id: Scalars['ID'];
  skipperPaperContent?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  cropAttributes?: InputMaybe<CropAttributes>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
  annotation?: InputMaybe<Scalars['String']>;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateFile?: { __typename?: 'FileEntryUpdatePayload', success: boolean, errors: Array<string>, fileEntry?: { __typename?: 'FileEntry', annotation?: string | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null } | null } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile?: { __typename?: 'FileEntryDeletePayload', success: boolean, errors: Array<string> } | null };

export type ViewFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ViewFileMutation = { __typename?: 'Mutation', viewFile?: { __typename?: 'FileEntryViewPayload', success: boolean, errors: Array<string> } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'ForgotPasswordPayload', success: boolean, errors: Array<{ __typename?: 'BaseError', field: string, message: string }> } | null };

export type CreateGradingSchemeMutationVariables = Exact<{
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  ranges: Scalars['JSON'];
  percentageGrade?: InputMaybe<Scalars['Boolean']>;
  showNumericGrade?: InputMaybe<Scalars['Boolean']>;
  showLetterGrade?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateGradingSchemeMutation = { __typename?: 'Mutation', createGradingScheme?: { __typename?: 'GradingSchemeCreatePayload', success: boolean, errors: Array<string>, gradingScheme?: { __typename?: 'GradingScheme', id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string, description?: string | null } | null } | null };

export type DeleteGradingSchemeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGradingSchemeMutation = { __typename?: 'Mutation', deleteGradingScheme?: { __typename?: 'GradingSchemeDeletePayload', success: boolean, errors: Array<string> } | null };

export type UpdateGradingSchemeMutationVariables = Exact<{
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  ranges?: InputMaybe<Scalars['JSON']>;
  percentageGrade?: InputMaybe<Scalars['Boolean']>;
  showNumericGrade?: InputMaybe<Scalars['Boolean']>;
  showLetterGrade?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateGradingSchemeMutation = { __typename?: 'Mutation', updateGradingScheme?: { __typename?: 'GradingSchemeUpdatePayload', success: boolean, errors: Array<string>, gradingScheme?: { __typename?: 'GradingScheme', id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string, description?: string | null } | null } | null };

export type ImpersonateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImpersonateMutation = { __typename?: 'Mutation', impersonate?: { __typename?: 'ImpersonatePayload', success: boolean, errors: Array<{ __typename?: 'BaseError', field: string, message: string }>, user?: { __typename?: 'User', id: string, initials?: string | null, birthDate?: any | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type BatchMaterialBooksMutationVariables = Exact<{
  batchItems: Array<MaterialBookArguments> | MaterialBookArguments;
}>;


export type BatchMaterialBooksMutation = { __typename?: 'Mutation', batchMaterialBooks?: { __typename?: 'BatchMaterialBookPayload', success: boolean, errors: Array<string>, materialBooks?: Array<{ __typename?: 'MaterialBook', author?: string | null, createdAt?: any | null, description?: string | null, id?: string | null, imageUrl?: string | null, isbn?: string | null, libraryButton?: Array<MaterialButtonPermission> | null, title?: string | null, url?: string | null, websiteButton?: Array<MaterialButtonPermission> | null }> | null } | null };

export type BatchMaterialCodesMutationVariables = Exact<{
  batchItems: Array<MaterialCodeArguments> | MaterialCodeArguments;
}>;


export type BatchMaterialCodesMutation = { __typename?: 'Mutation', batchMaterialCodes?: { __typename?: 'BatchMaterialCodePayload', success: boolean, errors: Array<string>, materialCodes?: Array<{ __typename?: 'MaterialCode', code?: string | null, createdAt?: any | null, description?: string | null, id?: string | null, title?: string | null }> | null } | null };

export type BatchMaterialLinksMutationVariables = Exact<{
  batchItems: Array<MaterialLinkArguments> | MaterialLinkArguments;
}>;


export type BatchMaterialLinksMutation = { __typename?: 'Mutation', batchMaterialLinks?: { __typename?: 'BatchMaterialLinkPayload', success: boolean, errors: Array<string>, materialLinks?: Array<{ __typename?: 'MaterialLink', id?: string | null, createdAt?: any | null, description?: string | null, image?: string | null, title?: string | null, otherImages?: Array<string> | null, showImage?: boolean | null, imageMaxWidth?: number | null, url?: string | null }> | null } | null };

export type BatchSourceAttributionsMutationVariables = Exact<{
  batchItems: Array<SourceAttributionArguments> | SourceAttributionArguments;
}>;


export type BatchSourceAttributionsMutation = { __typename?: 'Mutation', batchSourceAttributions?: { __typename?: 'BatchSourceAttributionPayload', success: boolean, errors: Array<string>, sourceAttributions?: Array<{ __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null }> | null } | null };

export type ToggleReadNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleReadNotificationMutation = { __typename?: 'Mutation', toggleReadNotification?: { __typename?: 'NotificationToggleReadPayload', success: boolean, errors: Array<string>, notification?: { __typename?: 'Notification', id: string, isViewed: boolean } | null } | null };

export type MarkReadAllNotificationsMutationVariables = Exact<{
  types?: InputMaybe<Array<NotificationType> | NotificationType>;
}>;


export type MarkReadAllNotificationsMutation = { __typename?: 'Mutation', markReadAllNotifications?: { __typename?: 'NotificationsMarkReadAllPayload', success: boolean, errors: Array<string> } | null };

export type UpdatePermissionLevelMutationVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdatePermissionLevelMutation = { __typename?: 'Mutation', updatePermissionLevel?: { __typename?: 'PermissionLevelsUpdatePayload', success: boolean, errors: Array<string> } | null };

export type CreatePermissionLevelMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreatePermissionLevelMutation = { __typename?: 'Mutation', createPermissionLevel?: { __typename?: 'PermissionLevelsCreatePayload', success: boolean, errors: Array<string> } | null };

export type DeletePermissionLevelMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePermissionLevelMutation = { __typename?: 'Mutation', deletePermissionLevel?: { __typename?: 'PermissionLevelsDeletePayload', success: boolean, errors: Array<string> } | null };

export type SigninUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SigninUserMutation = { __typename?: 'Mutation', signIn?: { __typename?: 'SignInPayload', success: boolean, user?: { __typename?: 'User', id: string, email?: string | null, initials?: string | null } | null, errors: Array<{ __typename?: 'BaseError', field: string, message: string }> } | null };

export type SignInOauthMutationVariables = Exact<{
  provider: OauthProvider;
  uid: Scalars['String'];
  verifier: Scalars['String'];
  idToken?: InputMaybe<Scalars['String']>;
}>;


export type SignInOauthMutation = { __typename?: 'Mutation', signInOauth?: { __typename?: 'SignInOauthPayload', success: boolean, errors: Array<string>, user?: { __typename?: 'User', id: string } | null } | null };

export type ClearOauthAccountUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  provider: OauthProvider;
}>;


export type ClearOauthAccountUserMutation = { __typename?: 'Mutation', clearOauthAccountUser?: { __typename?: 'AccountUsersClearOauthPayload', success: boolean, errors: Array<string>, user?: { __typename?: 'User', id: string } | null } | null };

export type StartQuizSubmissionMutationVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type StartQuizSubmissionMutation = { __typename?: 'Mutation', startQuizSubmission?: { __typename?: 'QuizSubmissionStartPayload', success: boolean, sessionId?: string | null, errors: Array<string>, submission?: { __typename?: 'Submission', id: string } | null } | null };

export type UpdateQuizSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
  answers?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
  bookmarks?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sessionId: Scalars['String'];
  saveForLater?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateQuizSubmissionMutation = { __typename?: 'Mutation', updateQuizSubmission?: { __typename?: 'QuizSubmissionUpdatePayload', success: boolean, errors: Array<string>, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, hasContent?: boolean | null, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null } | null };

export type SubmitQuizSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
  answers?: InputMaybe<Array<Scalars['JSON']> | Scalars['JSON']>;
  bookmarks?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sessionId: Scalars['String'];
}>;


export type SubmitQuizSubmissionMutation = { __typename?: 'Mutation', submitQuizSubmission?: { __typename?: 'QuizSubmissionSubmitPayload', success: boolean, errors: Array<string>, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, hasContent?: boolean | null, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null } | null };

export type GradeSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
  points?: InputMaybe<Scalars['Float']>;
  quizQuestionId?: InputMaybe<Scalars['ID']>;
  bonus?: InputMaybe<Scalars['Boolean']>;
}>;


export type GradeSubmissionMutation = { __typename?: 'Mutation', gradeSubmission?: { __typename?: 'SubmissionGradePayload', success: boolean, errors: Array<string>, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, percentageGrade?: number | null, hasContent?: boolean | null, enrollment: { __typename?: 'Enrollment', id: string }, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null } | null };

export type StartAssignmentSubmissionMutationVariables = Exact<{
  activityId: Scalars['ID'];
  attachmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  studentEnrollmentId?: InputMaybe<Scalars['ID']>;
}>;


export type StartAssignmentSubmissionMutation = { __typename?: 'Mutation', startAssignmentSubmission?: { __typename?: 'AssignmentSubmissionStartPayload', success: boolean, errors: Array<string>, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, hasContent?: boolean | null, similarityReportResults?: any | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null } | null };

export type SubmitAssignmentSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
  addAttachmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  removeAttachmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SubmitAssignmentSubmissionMutation = { __typename?: 'Mutation', submitAssignmentSubmission?: { __typename?: 'AssignmentSubmissionSubmitPayload', success: boolean, errors: Array<string>, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, hasContent?: boolean | null, similarityReportResults?: any | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null } | null };

export type UpdateAssignmentSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
  addAttachmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  removeAttachmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateAssignmentSubmissionMutation = { __typename?: 'Mutation', updateAssignmentSubmission?: { __typename?: 'AssignmentSubmissionUpdatePayload', success: boolean, errors: Array<string>, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, hasContent?: boolean | null, similarityReportResults?: any | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null } | null };

export type DeleteSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type DeleteSubmissionMutation = { __typename?: 'Mutation', deleteSubmission?: { __typename?: 'SubmissionDeletePayload', success: boolean, errors: Array<string> } | null };

export type OverrideActivityStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  enrollmentId: Scalars['ID'];
  status?: InputMaybe<ActivityStatusOverride>;
}>;


export type OverrideActivityStatusMutation = { __typename?: 'Mutation', overrideActivityStatus?: { __typename?: 'ActivityStatusOverridePayload', success: boolean, errors: Array<string> } | null };

export type OverrideActivityGradeMutationVariables = Exact<{
  id: Scalars['ID'];
  enrollmentId: Scalars['ID'];
  points?: InputMaybe<Scalars['Float']>;
}>;


export type OverrideActivityGradeMutation = { __typename?: 'Mutation', overrideActivityGrade?: { __typename?: 'ActivityGradeOverridePayload', success: boolean, errors: Array<string> } | null };

export type BatchActivityOverridesMutationVariables = Exact<{
  overrides: Array<ActivityBatchOverrideAttributes> | ActivityBatchOverrideAttributes;
}>;


export type BatchActivityOverridesMutation = { __typename?: 'Mutation', batchActivityOverrides?: { __typename?: 'BatchActivityOverridesPayload', success: boolean, errors: Array<string> } | null };

export type AnnotateSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
  annotation?: InputMaybe<Scalars['String']>;
}>;


export type AnnotateSubmissionMutation = { __typename?: 'Mutation', annotateSubmission?: { __typename?: 'SubmissionAnnotatePayload', success: boolean, errors: Array<string> } | null };

export type OverrideEnrollmentGradeMutationVariables = Exact<{
  id: Scalars['ID'];
  courseTermId?: InputMaybe<Scalars['ID']>;
  percentageGrade?: InputMaybe<Scalars['Float']>;
}>;


export type OverrideEnrollmentGradeMutation = { __typename?: 'Mutation', overrideEnrollmentGrade?: { __typename?: 'EnrollmentsGradeOverridePayload', success: boolean, errors: Array<string> } | null };

export type GenerateSubmissionSimilarityReportUrlMutationVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type GenerateSubmissionSimilarityReportUrlMutation = { __typename?: 'Mutation', generateSubmissionSimilarityReportUrl?: { __typename?: 'SubmissionGenerateSimilarityReportUrlPayload', success: boolean, url?: string | null, errors: Array<string> } | null };

export type CreateUnitTemplateMutationVariables = Exact<{
  originalUnitId: Scalars['ID'];
  title: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  subjects?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  curriculum?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  gradeLevels?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  visibleTo?: InputMaybe<Visibility>;
  copyableBy?: InputMaybe<Visibility>;
  sourceAttributionId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateUnitTemplateMutation = { __typename?: 'Mutation', createUnitTemplate?: { __typename?: 'UnitTemplatesCreatePayload', errors: Array<string>, success: boolean, unitTemplate?: { __typename?: 'UnitTemplate', id: string, title: string } | null } | null };

export type UseUnitTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  title: Scalars['String'];
  courseId: Scalars['ID'];
  keepDates: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  addAfterUnitId?: InputMaybe<Scalars['Int']>;
}>;


export type UseUnitTemplateMutation = { __typename?: 'Mutation', useUnitTemplate?: { __typename?: 'UnitTemplatesUsePayload', errors: Array<string>, success: boolean, unit?: { __typename?: 'Unit', id: string, course: { __typename?: 'Course', id: string } } | null } | null };

export type DeleteUnitTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteUnitTemplateMutation = { __typename?: 'Mutation', deleteUnitTemplate?: { __typename?: 'UnitTemplatesDeletePayload', errors: Array<string>, success: boolean } | null };

export type ValidateTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type ValidateTokenMutation = { __typename?: 'Mutation', validateToken?: { __typename?: 'ValidateTokenPayload', success: boolean, valid: boolean, errors: Array<{ __typename?: 'BaseError', field: string, message: string }> } | null };

export type AccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountDetailsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', name: string, schoolAddress?: string | null, schoolCity?: string | null, schoolState?: string | null, schoolZip?: string | null, timeZone?: string | null, subscriptionActive: boolean, subscriptionPastDue: boolean, subscriptionCancelled: boolean, subscriptionCustomPrice?: number | null, subscriptionCustomInterval?: string | null, subscriptionEndDate?: any | null, subscriptionTrialEndDate?: any | null, subscriptionMaxActivities?: number | null, subscriptionMaxCourses?: number | null, subscriptionMaxInstructors?: number | null, subscriptionMaxStudents?: number | null, subscriptionTotalActivities: number, subscriptionTotalCourses: number, subscriptionTotalInstructors: number, subscriptionTotalStudents: number, subscriptionPlan?: { __typename?: 'SubscriptionPlan', title: string, description?: string | null, features?: Array<string> | null, productId: string, priceAnnual: number, priceMonthly: number } | null } | null };

export type AccountRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountRolesQuery = { __typename?: 'Query', accountRoles?: Array<{ __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null }> | null };

export type AccountUsersQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type AccountUsersQuery = { __typename?: 'Query', accountUsers?: Array<{ __typename?: 'User', id: string, active?: boolean | null, initials?: string | null, birthDate?: any | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, username?: string | null, calendarColor?: string | null, email?: string | null, oauthConnections: Array<OauthProvider>, systemAdmin?: boolean | null, unconfirmedEmail?: string | null, confirmedAt?: any | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, permissionLevel?: { __typename?: 'PermissionLevel', id: string, fixed?: boolean | null, name?: string | null, permissions?: Array<string> | null } | null }> | null };

export type AccountUsersNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountUsersNotificationsQuery = { __typename?: 'Query', accountUsers?: Array<{ __typename?: 'User', id: string, fullName?: string | null, firstName?: string | null, lastName?: string | null, initials?: string | null, minGradeNotificationThreshold?: any | null, notificationSettings?: any | null, pauseNotifications?: boolean | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, title: string, description?: string | null, features?: Array<string> | null, productId: string, priceAnnual: number, priceMonthly: number, annualPriceId?: string | null, monthlyPriceId?: string | null, maxCourses?: number | null, maxActivities?: number | null, maxInstructors?: number | null, maxStudents?: number | null }> };

export type StripeUpcomingInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeUpcomingInvoiceQuery = { __typename?: 'Query', stripeUpcomingInvoice?: any | null };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, fullName?: string | null, email?: string | null, initials?: string | null, username?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null } | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, primaryAccount?: { __typename?: 'Account', name: string } | null }> | null };

export type CourseActivitiesCalendarDataQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type CourseActivitiesCalendarDataQuery = { __typename?: 'Query', courseActivities?: Array<{ __typename?: 'Activity', id: string, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, unit: { __typename?: 'Unit', id: string, title: string, course: { __typename?: 'Course', id: string, iconColor?: string | null, title: string } } }> | null };

export type CalendarPrintedScheduleQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  courseIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  scheduleType: PrintSchedule;
  viewOptions?: InputMaybe<Array<PrintShowOption> | PrintShowOption>;
}>;


export type CalendarPrintedScheduleQuery = { __typename?: 'Query', printedSchedule?: string | null };

export type CalendarEventsQueryVariables = Exact<{
  startDate: Scalars['ISO8601Date'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  calendarIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type CalendarEventsQuery = { __typename?: 'Query', calendarEvents?: Array<{ __typename?: 'Event', id: string, title?: string | null, details?: string | null, url?: string | null, date: any, timeStart?: any | null, timeEnd?: any | null, calendar?: { __typename?: 'Calendar', id: string, title?: string | null, color?: string | null } | null, course?: { __typename?: 'Course', id: string, title: string, iconColor?: string | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, type: Role, name: string, permissions: any } } | null } | null, createdBy?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null } | null }> | null };

export type CalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarsQuery = { __typename?: 'Query', calendars?: Array<{ __typename?: 'Calendar', id: string, title?: string | null, color?: string | null, readOnly?: boolean | null, familyAccount?: { __typename?: 'Account', name: string } | null, owner?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null } | null, users?: Array<{ __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null }> | null }> | null };

export type IcalFeedUrlQueryVariables = Exact<{
  calendarIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type IcalFeedUrlQuery = { __typename?: 'Query', icalFeedUrl?: string | null };

export type CommentsQueryVariables = Exact<{
  objectId: Scalars['ID'];
  objectType: CommentableObject;
  markRead?: InputMaybe<Scalars['Boolean']>;
}>;


export type CommentsQuery = { __typename?: 'Query', comments?: Array<{ __typename?: 'Comment', id: string, content?: string | null, isViewed: boolean, createdAt: any, author?: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null };

export type CommentedItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommentedItemsQuery = { __typename?: 'Query', commentedItems?: Array<{ __typename?: 'Activity', id: string, type: CommentableObject, item: { __typename?: 'Assignment', id: string, title: string } | { __typename?: 'Quiz', id: string, title: string }, unit: { __typename?: 'Unit', id: string, title: string, course: { __typename?: 'Course', id: string, title: string } }, comments?: Array<{ __typename?: 'Comment', id: string, content?: string | null, isViewed: boolean, createdAt: any, author?: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null } | { __typename?: 'Event', id: string, type: CommentableObject, comments?: Array<{ __typename?: 'Comment', id: string, content?: string | null, isViewed: boolean, createdAt: any, author?: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null } | { __typename?: 'PrivateDiscussion', id: string, type: CommentableObject, users: Array<{ __typename?: 'User', id: string }>, enrollments: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null }, role: { __typename?: 'CourseRole', id: string, type: Role, name: string } }>, targetItem?: { __typename?: 'Activity', id: string, type: CommentableObject, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, unit: { __typename?: 'Unit', id: string, title: string, course: { __typename?: 'Course', id: string, title: string, iconColor?: string | null } } } | { __typename?: 'Event', id: string, type: CommentableObject } | { __typename?: 'PrivateDiscussion', id: string, type: CommentableObject } | null, comments?: Array<{ __typename?: 'Comment', id: string, content?: string | null, isViewed: boolean, createdAt: any, author?: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null }> | null };

export type ContactableUsersQueryVariables = Exact<{
  conversationId?: InputMaybe<Scalars['ID']>;
}>;


export type ContactableUsersQuery = { __typename?: 'Query', contactableUsers?: Array<{ __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }> | null };

export type ContactableCourseMemberGroupTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactableCourseMemberGroupTypesQuery = { __typename?: 'Query', contactableCourseMemberGroupTypes?: Array<{ __typename?: 'CourseMemberGroup', memberGroupTypes: Array<CourseMemberGroupEnum>, course: { __typename?: 'Course', id: string, title: string, iconColor?: string | null } }> | null };

export type ConversationsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ConversationsListQuery = { __typename?: 'Query', conversations?: Array<{ __typename?: 'Conversation', id: string, title?: string | null, isMuted: boolean, isClosed: boolean, isViewed: boolean, permissions: Array<string>, createdAt: any, updatedAt: any, iconFileEntry?: { __typename?: 'FileEntry', id: string, title: string, url?: string | null, croppedUrl?: string | null } | null, moderators: Array<{ __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }>, participants: Array<{ __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }>, courseParticipantEnrollments: Array<{ __typename?: 'Enrollment', id: string, course: { __typename?: 'Course', id: string, title: string }, user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }, role: { __typename?: 'CourseRole', id: string, type: Role, name: string } }>, owner: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }, lastMessage?: { __typename?: 'Message', id: string, content?: string | null, subject?: string | null, createdAt: any, author?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } | null, participatingCourseMemberGroups: Array<{ __typename?: 'CourseMemberGroup', memberGroupTypes: Array<CourseMemberGroupEnum>, course: { __typename?: 'Course', id: string, title: string, iconColor?: string | null } }>, participatingUsers: Array<{ __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }> }> | null };

export type ConversationMessagesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConversationMessagesQuery = { __typename?: 'Query', conversationMessages?: Array<{ __typename?: 'Message', id: string, content?: string | null, subject?: string | null, createdAt: any, author?: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null };

export type CoursesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeGrading: Scalars['Boolean'];
  includeActivityGroups: Scalars['Boolean'];
  courseTermId?: InputMaybe<Scalars['ID']>;
  includeHiddenUnits?: InputMaybe<Scalars['Boolean']>;
}>;


export type CoursesQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, graded?: boolean | null, courseCredits?: number | null, timeZone: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, startDate?: any | null, published?: boolean | null, tags?: Array<string> | null, gradeLevels?: Array<string> | null, subjects?: Array<string> | null, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, curriculum?: Array<string> | null, similarityReportsEnabled?: boolean | null, restricted?: boolean | null, isSameAccount?: boolean | null, activityGroups?: Array<{ __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null }> | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null, currentTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null, terms?: Array<{ __typename?: 'CourseTerm', id: string, published?: boolean | null, forGradebook?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null }> | null, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, type: Role, name: string, permissions: any } } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, originalCourseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, visibleTo: Visibility, copyableBy?: Visibility | null, author: { __typename?: 'User', id: string } } | null }> | null };

export type CoursesWithActivitiesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId: Scalars['ID'];
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  includeHiddenUnits?: InputMaybe<Scalars['Boolean']>;
}>;


export type CoursesWithActivitiesQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, graded?: boolean | null, courseCredits?: number | null, timeZone: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, startDate?: any | null, published?: boolean | null, tags?: Array<string> | null, gradeLevels?: Array<string> | null, subjects?: Array<string> | null, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, curriculum?: Array<string> | null, similarityReportsEnabled?: boolean | null, restricted?: boolean | null, isSameAccount?: boolean | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, status: EnrollmentStatus, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role, permissions: any } } | null, enrollments?: Array<{ __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role } }> | null, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, activities: Array<{ __typename?: 'Activity', id: string, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, graded?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, similarityReportsEnabled?: boolean | null, published?: boolean | null, visible?: boolean | null, points: number, updatedAt: any, position?: number | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null }>, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null, currentTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null, terms?: Array<{ __typename?: 'CourseTerm', id: string, published?: boolean | null, forGradebook?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null }> | null, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, originalCourseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, visibleTo: Visibility, copyableBy?: Visibility | null, author: { __typename?: 'User', id: string } } | null }> | null };

export type CoursesWithActivitiyItemsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  includeHiddenUnits?: InputMaybe<Scalars['Boolean']>;
  includeHiddenQuestions?: InputMaybe<Scalars['Boolean']>;
}>;


export type CoursesWithActivitiyItemsQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, graded?: boolean | null, courseCredits?: number | null, timeZone: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, startDate?: any | null, published?: boolean | null, tags?: Array<string> | null, gradeLevels?: Array<string> | null, subjects?: Array<string> | null, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, curriculum?: Array<string> | null, similarityReportsEnabled?: boolean | null, restricted?: boolean | null, isSameAccount?: boolean | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, activityGroups?: Array<{ __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null }> | null, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, activities: Array<{ __typename?: 'Activity', id: string, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, graded?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, similarityReportsEnabled?: boolean | null, published?: boolean | null, visible?: boolean | null, points: number, updatedAt: any, position?: number | null, item: { __typename?: 'Assignment', attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, questions: Array<{ __typename?: 'QuizQuestion', id: string, uid: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string>, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null }>, parentTemplate?: { __typename?: 'QuizTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null }>, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null, currentTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null, terms?: Array<{ __typename?: 'CourseTerm', id: string, published?: boolean | null, forGradebook?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null }> | null, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, type: Role, name: string, permissions: any } } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, originalCourseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, visibleTo: Visibility, copyableBy?: Visibility | null, author: { __typename?: 'User', id: string } } | null }> | null };

export type CoursesRolesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CoursesRolesQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, schedulingMode?: CourseSchedulingMode | null, graded?: boolean | null, roles?: Array<{ __typename?: 'CourseRole', id: string, name: string, permissions: any, fixed?: boolean | null, type: Role, enrollments: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } }> }> | null }> | null };

export type CoursesInviteCodesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CoursesInviteCodesQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, title: string, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, timeZone: string, requireJoinConfirmation?: boolean | null, autoRegenerateInviteCode?: boolean | null }> | null };

export type CourseNotificationsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CourseNotificationsQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, title: string }> | null };

export type CourseTermsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CourseTermsQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, title: string, terms?: Array<{ __typename?: 'CourseTerm', id: string, title: string, weight?: number | null, accessible?: boolean | null, published?: boolean | null, publishable?: boolean | null, forGradebook?: boolean | null, units: Array<{ __typename?: 'Unit', id: string, title: string }> }> | null }> | null };

export type CourseByInviteQueryVariables = Exact<{
  inviteCode: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CourseByInviteQuery = { __typename?: 'Query', courseByInvite?: { __typename?: 'Course', id: string, title: string, enrollments?: Array<{ __typename?: 'Enrollment', id: string, needsConfirmJoin?: boolean | null, user: { __typename?: 'User', id: string } }> | null } | null };

export type CourseActivityBatchesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
}>;


export type CourseActivityBatchesQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, title: string, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, graded?: boolean | null, activityGroups?: Array<{ __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null }> | null, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null, activityBatches?: Array<{ __typename?: 'ActivityBatch', id: string, items: Array<any>, title: string, createdAt: any, baseItemType: string, baseItem?: { __typename?: 'Assignment', id: string, title: string, type: string, instructions?: string | null, attemptsAllowed?: number | null, createdAt: any, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }> } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string } | null }> | null }> | null };

export type CourseMetaDataQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId: Scalars['ID'];
}>;


export type CourseMetaDataQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, graded?: boolean | null, courseCredits?: number | null, timeZone: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, startDate?: any | null, published?: boolean | null, tags?: Array<string> | null, gradeLevels?: Array<string> | null, subjects?: Array<string> | null, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, curriculum?: Array<string> | null, similarityReportsEnabled?: boolean | null, restricted?: boolean | null, isSameAccount?: boolean | null, activityGroups?: Array<{ __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null }> | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, status: EnrollmentStatus, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role, permissions: any } } | null, enrollments?: Array<{ __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role } }> | null, currentTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null, terms?: Array<{ __typename?: 'CourseTerm', id: string, published?: boolean | null, forGradebook?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null }> | null, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, originalCourseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, visibleTo: Visibility, copyableBy?: Visibility | null, author: { __typename?: 'User', id: string } } | null }> | null };

export type CourseUnitsDataQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId: Scalars['ID'];
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  includeActivities: Scalars['Boolean'];
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
}>;


export type CourseUnitsDataQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', title: string, id: string, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, activities?: Array<{ __typename?: 'Activity', id: string, visible?: boolean | null, published?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string } }>, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null }> | null };

export type CourseUnitsDataStudentsDataQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId: Scalars['ID'];
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  includeActivities: Scalars['Boolean'];
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
}>;


export type CourseUnitsDataStudentsDataQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', title: string, id: string, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, activities?: Array<{ __typename?: 'Activity', id: string, visible?: boolean | null, published?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, studentSubmissions: Array<{ __typename?: 'MultiSubmission', mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, dueStatus?: SubmissionDueStatus | null } | { __typename?: 'SingleSubmission', mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, dueStatus?: SubmissionDueStatus | null }> }>, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null }> | null };

export type CourseUnitActivitiesDataQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId: Scalars['ID'];
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  includeHiddenQuestions?: InputMaybe<Scalars['Boolean']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
}>;


export type CourseUnitActivitiesDataQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, activities: Array<{ __typename?: 'Activity', id: string, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, graded?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, similarityReportsEnabled?: boolean | null, published?: boolean | null, visible?: boolean | null, points: number, updatedAt: any, position?: number | null, item: { __typename?: 'Assignment', attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, questions: Array<{ __typename?: 'QuizQuestion', id: string, uid: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string>, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null }>, parentTemplate?: { __typename?: 'QuizTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null }, studentSubmissions: Array<{ __typename?: 'MultiSubmission', mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, dueStatus?: SubmissionDueStatus | null, status?: SubmissionStatus | null } | { __typename?: 'SingleSubmission', mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, dueStatus?: SubmissionDueStatus | null, status?: SubmissionStatus | null }>, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null }>, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null }> | null };

export type CourseTermsDataQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CourseTermsDataQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, title: string, terms?: Array<{ __typename?: 'CourseTerm', id: string, title: string, weight?: number | null, accessible?: boolean | null, published?: boolean | null, publishable?: boolean | null, units: Array<{ __typename?: 'Unit', id: string, title: string }> }> | null }> | null };

export type CoursesRolesDataQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CoursesRolesDataQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, currentEnrollment?: { __typename?: 'Enrollment', id: string, status: EnrollmentStatus, role: { __typename?: 'CourseRole', id: string, type: Role, permissions: any } } | null, roles?: Array<{ __typename?: 'CourseRole', id: string, name: string, permissions: any, fixed?: boolean | null, type: Role, enrollments: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, calendarColor?: string | null, initials?: string | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } }> }> | null }> | null };

export type StudentCurrentAverageQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId: Scalars['ID'];
}>;


export type StudentCurrentAverageQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, graded?: boolean | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, currentTerm?: { __typename?: 'CourseTerm', title: string } | null, enrollments?: Array<{ __typename?: 'Enrollment', id: string, averageGrade?: number | null, role: { __typename?: 'CourseRole', name: string, type: Role } }> | null }> | null };

export type AccountCoursesQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  searchKey?: InputMaybe<Scalars['String']>;
}>;


export type AccountCoursesQuery = { __typename?: 'Query', accountCourses?: { __typename?: 'PaginatedCourses', totalCount: number, totalPages: number, items: Array<{ __typename?: 'Course', id: string, title: string, iconColor?: string | null, createdAt?: any | null, enrollments?: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }, role: { __typename?: 'CourseRole', id: string, name: string, type: Role } }> | null }> } | null };

export type AccountEnrollmentsQueryVariables = Exact<{
  includePast?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  searchKey?: InputMaybe<Scalars['String']>;
  rolePrefix?: InputMaybe<Scalars['String']>;
}>;


export type AccountEnrollmentsQuery = { __typename?: 'Query', accountEnrollments?: { __typename?: 'PaginatedEnrollments', totalCount: number, totalPages: number, items: Array<{ __typename?: 'Enrollment', averageGrade?: number | null, createdAt: any, id: string, lastActivityAt?: any | null, children: Array<{ __typename?: 'Enrollment', user: { __typename?: 'User', id: string, birthDate?: any | null, email?: string | null, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } }>, course: { __typename?: 'Course', id: string, title: string, iconColor?: string | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, currentTerm?: { __typename?: 'CourseTerm', title: string } | null }, user: { __typename?: 'User', birthDate?: any | null, id: string, initials?: string | null, calendarColor?: string | null, email?: string | null, createdAt?: any | null, fullName?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null, parent?: { __typename?: 'User', id: string, initials?: string | null, calendarColor?: string | null, email?: string | null, createdAt?: any | null, fullName?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } | null }, parent?: { __typename?: 'Enrollment', user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } } | null, role: { __typename?: 'CourseRole', id: string, name: string, type: Role } }> } | null };

export type CourseEnrollmentsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includePast?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  calculateFinalGrade?: InputMaybe<Scalars['Boolean']>;
}>;


export type CourseEnrollmentsQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, title: string, graded?: boolean | null, roles?: Array<{ __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, permissions: any, type: Role }> | null, enrollments?: Array<{ __typename?: 'Enrollment', id: string, concluded?: boolean | null, dropped?: boolean | null, createdAt: any, finalGrade?: number | null, activatedAt?: any | null, deactivatedAt?: any | null, lastActivityAt?: any | null, needsConfirmJoin?: boolean | null, status: EnrollmentStatus, createdBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, email?: string | null, birthDate?: any | null, createdAt?: any | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, children?: Array<{ __typename?: 'User', id: string, fullName?: string | null, birthDate?: any | null, email?: string | null, initials?: string | null, active?: boolean | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, parent?: { __typename?: 'User', id: string, initials?: string | null, calendarColor?: string | null, email?: string | null, createdAt?: any | null, fullName?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null } | null }, parent?: { __typename?: 'Enrollment', id: string, lastActivityAt?: any | null, user: { __typename?: 'User', id: string, fullName?: string | null, createdAt?: any | null, birthDate?: any | null, email?: string | null, initials?: string | null, active?: boolean | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, children?: Array<{ __typename?: 'User', id: string, fullName?: string | null, birthDate?: any | null, email?: string | null, initials?: string | null, active?: boolean | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null } } | null, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role } }> | null }> | null };

export type EnrollmentsOnlyQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  includePast?: InputMaybe<Scalars['Boolean']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  includeChildren: Scalars['Boolean'];
  calculateFinalGrade?: InputMaybe<Scalars['Boolean']>;
}>;


export type EnrollmentsOnlyQuery = { __typename?: 'Query', enrollments?: Array<{ __typename?: 'Enrollment', id: string, concluded?: boolean | null, dropped?: boolean | null, createdAt: any, finalGrade?: number | null, activatedAt?: any | null, deactivatedAt?: any | null, lastActivityAt?: any | null, needsConfirmJoin?: boolean | null, status: EnrollmentStatus, createdBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, children?: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, active?: boolean | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } }>, role: { __typename?: 'CourseRole', id: string, fixed?: boolean | null, name: string, type: Role, permissions: any }, course: { __typename?: 'Course', id: string, title: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, published?: boolean | null, iconColor?: string | null, schedulingMode?: CourseSchedulingMode | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null } }> | null };

export type ExternalImagesQueryVariables = Exact<{
  provider: ExternalImageProvider;
  query?: InputMaybe<Scalars['String']>;
}>;


export type ExternalImagesQuery = { __typename?: 'Query', externalImages: Array<{ __typename?: 'ExternalImage', author?: string | null, authorUrl?: string | null, description?: string | null, thumbnailUrl?: string | null, title?: string | null, url: string, originalHeight?: number | null, originalWidth?: number | null }> };

export type FileEntriesQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type FileEntriesQuery = { __typename?: 'Query', fileEntries: Array<{ __typename?: 'FileEntry', fileType?: string | null, id: string, originalFileSize?: number | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, annotation?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type GradingSchemaFragmentFragment = { __typename?: 'GradingScheme', id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, title: string, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, description?: string | null };

export type GradingSchemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GradingSchemesQuery = { __typename?: 'Query', gradingSchemes?: Array<{ __typename?: 'GradingScheme', id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, title: string, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, description?: string | null }> | null };

export type SearchBooksQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchBooksQuery = { __typename?: 'Query', searchBooks?: Array<{ __typename?: 'GoodreadsBook', author?: string | null, id?: string | null, image?: string | null, isbn?: string | null, title?: string | null }> | null };

export type MaterialBooksQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type MaterialBooksQuery = { __typename?: 'Query', materialBooks?: Array<{ __typename?: 'MaterialBook', author?: string | null, createdAt?: any | null, description?: string | null, id?: string | null, imageUrl?: string | null, isbn?: string | null, libraryButton?: Array<MaterialButtonPermission> | null, title?: string | null, url?: string | null, websiteButton?: Array<MaterialButtonPermission> | null }> | null };

export type MaterialCodesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type MaterialCodesQuery = { __typename?: 'Query', materialCodes?: Array<{ __typename?: 'MaterialCode', code?: string | null, createdAt?: any | null, description?: string | null, id?: string | null, title?: string | null }> | null };

export type MaterialLinksQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type MaterialLinksQuery = { __typename?: 'Query', materialLinks?: Array<{ __typename?: 'MaterialLink', id?: string | null, createdAt?: any | null, description?: string | null, image?: string | null, title?: string | null, otherImages?: Array<string> | null, showImage?: boolean | null, imageMaxWidth?: number | null, url?: string | null }> | null };

export type SourceAttributionsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SourceAttributionsQuery = { __typename?: 'Query', sourceAttributions?: Array<{ __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null }> | null };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', createdAt: any, id: string, isViewed: boolean, message?: string | null, notificationType: NotificationType, updatedAt: any, url?: string | null, dotColor?: string | null, dotTitle?: string | null, iconType?: string | null, title?: string | null, originUser?: { __typename?: 'User', id: string, fullName?: string | null } | null, targetUser?: { __typename?: 'User', id: string, fullName?: string | null } | null }> | null };

export type PermissionLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionLevelsQuery = { __typename?: 'Query', permissionLevels?: Array<{ __typename?: 'PermissionLevel', fixed?: boolean | null, id: string, name?: string | null, permissions?: Array<string> | null }> | null };

export type PermissionsWithUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsWithUsersQuery = { __typename?: 'Query', permissionLevels?: Array<{ __typename?: 'PermissionLevel', fixed?: boolean | null, id: string, name?: string | null, permissions?: Array<string> | null, users?: Array<{ __typename?: 'User', id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null }> | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, uid: string, fullName?: string | null, firstName?: string | null, birthDate?: any | null, lastName?: string | null, initials?: string | null, email?: string | null, calendarColor?: string | null, unconfirmedEmail?: string | null, confirmedAt?: any | null, username?: string | null, active?: boolean | null, oauthConnections: Array<OauthProvider>, turnitinEulaAcceptedAt?: any | null, turnitinEulaAcceptedVersion?: string | null, turnitinEulaLatestVersion?: string | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, permissionLevel?: { __typename?: 'PermissionLevel', id: string, name?: string | null, permissions?: Array<string> | null } | null } | null };

export type RealUserQueryVariables = Exact<{ [key: string]: never; }>;


export type RealUserQuery = { __typename?: 'Query', realMe?: { __typename?: 'User', id: string, uid: string, intercomHash?: string | null, fullName?: string | null, firstName?: string | null, birthDate?: any | null, lastName?: string | null, initials?: string | null, email?: string | null, calendarColor?: string | null, unconfirmedEmail?: string | null, confirmedAt?: any | null, username?: string | null, active?: boolean | null, systemAdmin?: boolean | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, accountRole?: { __typename?: 'AccountRole', id: string, name?: string | null, roleType?: string | null } | null, permissionLevel?: { __typename?: 'PermissionLevel', id: string, name?: string | null, permissions?: Array<string> | null } | null } | null };

export type SubmissionsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SubmissionsQuery = { __typename?: 'Query', submissions?: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isFinal?: boolean | null, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, activity: { __typename?: 'Activity', id: string, dueDate?: any | null, dueTimeSignificant?: boolean | null, graded?: boolean | null, points: number, optional?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, course: { __typename?: 'Course', id: string, title: string } } | null, unit: { __typename?: 'Unit', id: string, title: string } }, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, enrollment: { __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, initials?: string | null, fullName?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null } | null } }, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } }> | null };

export type CoursesWithActivitiesAndSubmissionsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  enrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includePastSubmissions?: InputMaybe<Scalars['Boolean']>;
  includeDraftSubmissions?: InputMaybe<Scalars['Boolean']>;
  includeHiddenQuestions?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CoursesWithActivitiesAndSubmissionsQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, graded?: boolean | null, courseCredits?: number | null, timeZone: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, startDate?: any | null, published?: boolean | null, tags?: Array<string> | null, gradeLevels?: Array<string> | null, subjects?: Array<string> | null, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, curriculum?: Array<string> | null, similarityReportsEnabled?: boolean | null, restricted?: boolean | null, isSameAccount?: boolean | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, activityGroups?: Array<{ __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null }> | null, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, activities: Array<{ __typename?: 'Activity', id: string, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, graded?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, similarityReportsEnabled?: boolean | null, published?: boolean | null, visible?: boolean | null, points: number, updatedAt: any, position?: number | null, item: { __typename?: 'Assignment', attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, questions: Array<{ __typename?: 'QuizQuestion', id: string, uid: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string>, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null }>, parentTemplate?: { __typename?: 'QuizTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null }, submissions: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, isFinal?: boolean | null, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, enrollment: { __typename?: 'Enrollment', id: string, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } }, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } }>, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null }>, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null, currentTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null, terms?: Array<{ __typename?: 'CourseTerm', id: string, published?: boolean | null, forGradebook?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null }> | null, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, type: Role, name: string, permissions: any } } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, originalCourseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, visibleTo: Visibility, copyableBy?: Visibility | null, author: { __typename?: 'User', id: string } } | null }> | null };

export type CoursesActivitySubmissionsByEnrollmentsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  unitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  includePastSubmissions?: InputMaybe<Scalars['Boolean']>;
  includeDraftSubmissions?: InputMaybe<Scalars['Boolean']>;
  includeHiddenQuestions?: InputMaybe<Scalars['Boolean']>;
}>;


export type CoursesActivitySubmissionsByEnrollmentsQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, graded?: boolean | null, courseCredits?: number | null, timeZone: string, description?: string | null, iconColor?: string | null, title: string, uid: string, welcome?: string | null, welcomeMediaType?: CourseWelcomeMedia | null, scheduledDaysOff?: Array<any> | null, scheduledWeekdays?: Array<DayOfWeek> | null, schedulingMode?: CourseSchedulingMode | null, startDate?: any | null, published?: boolean | null, tags?: Array<string> | null, gradeLevels?: Array<string> | null, subjects?: Array<string> | null, inviteCode?: string | null, inviteCodeExpiresAt?: any | null, requireJoinConfirmation?: boolean | null, curriculum?: Array<string> | null, similarityReportsEnabled?: boolean | null, restricted?: boolean | null, isSameAccount?: boolean | null, gradingScheme?: { __typename?: 'GradingScheme', description?: string | null, id: string, isDefault?: boolean | null, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null, title: string } | null, activityGroups?: Array<{ __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null, description?: string | null }> | null, units?: Array<{ __typename?: 'Unit', id: string, title: string, visible?: boolean | null, description?: string | null, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, backgroundFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null, activities: Array<{ __typename?: 'Activity', id: string, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, lockAfterDueDate?: boolean | null, lockBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, lockedBeforeAssignDate?: boolean | null, markLate?: boolean | null, optional?: boolean | null, graded?: boolean | null, parentCanGrade?: boolean | null, parentCanGradeOverride?: boolean | null, similarityReportsEnabled?: boolean | null, published?: boolean | null, visible?: boolean | null, points: number, updatedAt: any, position?: number | null, item: { __typename?: 'Assignment', attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, questions: Array<{ __typename?: 'QuizQuestion', id: string, uid: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string>, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null }>, parentTemplate?: { __typename?: 'QuizTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null }, unit: { __typename?: 'Unit', id: string, title: string }, studentSubmissions: Array<{ __typename: 'MultiSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, mainStatus?: SubmissionMainStatus | null, statusOverriddenAt?: any | null, privateDiscussionId?: string | null, submissions: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, percentageGrade?: number | null, hasContent?: boolean | null, isDraft: boolean, isFinal?: boolean | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, deletableAttachments: Array<{ __typename?: 'FileEntry', id: string }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } }>, enrollment: { __typename?: 'Enrollment', id: string, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } } } | { __typename: 'SingleSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, mainStatus?: SubmissionMainStatus | null, statusOverriddenAt?: any | null, privateDiscussionId?: string | null, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, deletableAttachments: Array<{ __typename?: 'FileEntry', id: string }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null, enrollment: { __typename?: 'Enrollment', id: string, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } } }>, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null }>, courseTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null }> | null, currentTerm?: { __typename?: 'CourseTerm', id: string, published?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null } | null, terms?: Array<{ __typename?: 'CourseTerm', id: string, published?: boolean | null, forGradebook?: boolean | null, title: string, accessible?: boolean | null, weight?: number | null }> | null, materials?: Array<{ __typename?: 'CourseMaterial', id: string, description?: string | null, title: string, url?: string | null, published: boolean, position?: number | null, fileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null }> | null, currentEnrollment?: { __typename?: 'Enrollment', id: string, role: { __typename?: 'CourseRole', id: string, type: Role, name: string, permissions: any } } | null, imageFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, videoFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } } | null, originalCourseTemplate?: { __typename?: 'CourseTemplate', id: string, title: string, visibleTo: Visibility, copyableBy?: Visibility | null, author: { __typename?: 'User', id: string } } | null }> | null };

export type GradebookActivitiesDataQueryVariables = Exact<{
  courseId: Scalars['ID'];
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type GradebookActivitiesDataQuery = { __typename?: 'Query', gradebookData?: { __typename?: 'GradebookData', activitiesTotal?: number | null, activities?: Array<{ __typename?: 'Activity', id: string, dueDate?: any | null, dueTimeSignificant?: boolean | null, lockedBeforeAssignDate?: boolean | null, graded?: boolean | null, points: number, optional?: boolean | null, item: { __typename?: 'Assignment', submissionKind?: SubmissionKind | null, onlineSubmissionRequired?: boolean | null, onlineSubmissionAccepted?: boolean | null, id: string, title: string, type: string } | { __typename?: 'Quiz', attemptsAllowed?: number | null, attemptsRemaining?: number | null, resumable?: boolean | null, id: string, title: string, type: string, questions: Array<{ __typename?: 'QuizQuestion', id: string }> }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string }, studentSubmissions: Array<{ __typename: 'MultiSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, submissions: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, percentageGrade?: number | null, hasContent?: boolean | null, isDraft: boolean, isFinal?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }> }>, activity: { __typename?: 'Activity', id: string }, enrollment: { __typename?: 'Enrollment', id: string } } | { __typename: 'SingleSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }> } | null, activity: { __typename?: 'Activity', id: string }, enrollment: { __typename?: 'Enrollment', id: string } }> }> | null } | null };

export type GradebookActivitiesUpdatedDataQueryVariables = Exact<{
  courseId: Scalars['ID'];
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type GradebookActivitiesUpdatedDataQuery = { __typename?: 'Query', gradebookData?: { __typename?: 'GradebookData', activitiesTotal?: number | null, activities?: Array<{ __typename?: 'Activity', id: string, dueDate?: any | null, dueTimeSignificant?: boolean | null, graded?: boolean | null, points: number, optional?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string }, studentSubmissions: Array<{ __typename: 'MultiSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, submissions: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, percentageGrade?: number | null, hasContent?: boolean | null, isDraft: boolean, isFinal?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } }>, activity: { __typename?: 'Activity', id: string }, enrollment: { __typename?: 'Enrollment', id: string } } | { __typename: 'SingleSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, mainStatus?: SubmissionMainStatus | null, subStatus?: SubmissionSubStatus | null, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null, activity: { __typename?: 'Activity', id: string }, enrollment: { __typename?: 'Enrollment', id: string } }> }> | null } | null };

export type GradebookStudentsDataQueryVariables = Exact<{
  courseId: Scalars['ID'];
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  studentsLimit?: InputMaybe<Scalars['Int']>;
  studentsOffset?: InputMaybe<Scalars['Int']>;
  studentsSort?: InputMaybe<EnrollmentsSortOrder>;
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type GradebookStudentsDataQuery = { __typename?: 'Query', gradebookData?: { __typename?: 'GradebookData', students?: Array<{ __typename?: 'GradebookStudentData', enrollment?: { __typename?: 'Enrollment', id: string, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } } | null }> | null } | null };

export type GradebookStudentsAvgDataQueryVariables = Exact<{
  courseId: Scalars['ID'];
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  studentsLimit?: InputMaybe<Scalars['Int']>;
  studentsOffset?: InputMaybe<Scalars['Int']>;
  studentsSort?: InputMaybe<EnrollmentsSortOrder>;
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type GradebookStudentsAvgDataQuery = { __typename?: 'Query', gradebookData?: { __typename?: 'GradebookData', students?: Array<{ __typename?: 'GradebookStudentData', courseGrade?: number | null, courseGradeOverridden?: boolean | null, courseOriginalGrade?: number | null, activityGroupGrades?: Array<{ __typename?: 'ActivityGroupGrade', grade?: number | null, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null }> | null, courseTermGrades?: Array<{ __typename?: 'CourseTermGrade', grade?: number | null, gradeOverridden?: boolean | null, originalGrade?: number | null, courseTerm?: { __typename?: 'CourseTerm', id: string, title: string } | null }> | null, enrollment?: { __typename?: 'Enrollment', id: string } | null }> | null } | null };

export type GradebookDataQueryVariables = Exact<{
  courseId: Scalars['ID'];
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  studentsLimit?: InputMaybe<Scalars['Int']>;
  studentsOffset?: InputMaybe<Scalars['Int']>;
  studentsSort?: InputMaybe<EnrollmentsSortOrder>;
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type GradebookDataQuery = { __typename?: 'Query', gradebookData?: { __typename?: 'GradebookData', activities?: Array<{ __typename?: 'Activity', id: string, dueDate?: any | null, dueTimeSignificant?: boolean | null, graded?: boolean | null, points: number, optional?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }> | null, students?: Array<{ __typename?: 'GradebookStudentData', courseGrade?: number | null, courseGradeOverridden?: boolean | null, courseOriginalGrade?: number | null, needsGradingCounter?: number | null, submissions?: Array<{ __typename: 'MultiSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, statusOverriddenAt?: any | null, submissions: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, percentageGrade?: number | null, hasContent?: boolean | null, isDraft: boolean, isFinal?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } }>, activity: { __typename?: 'Activity', id: string, points: number, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, optional?: boolean | null, lockedBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string, attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, instructions?: string | null, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', id: string, title: string, type: string, instructions?: string | null, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }, enrollment: { __typename?: 'Enrollment', id: string } } | { __typename: 'SingleSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, statusOverriddenAt?: any | null, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null, activity: { __typename?: 'Activity', id: string, points: number, assignDate?: any | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, optional?: boolean | null, lockedBeforeAssignDate?: boolean | null, lockedAfterDueDate?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string, attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, instructions?: string | null, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', id: string, title: string, type: string, instructions?: string | null, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }, enrollment: { __typename?: 'Enrollment', id: string } }> | null, activityGroupGrades?: Array<{ __typename?: 'ActivityGroupGrade', grade?: number | null, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null }> | null, courseTermGrades?: Array<{ __typename?: 'CourseTermGrade', grade?: number | null, gradeOverridden?: boolean | null, originalGrade?: number | null, courseTerm?: { __typename?: 'CourseTerm', id: string, title: string } | null }> | null, enrollment?: { __typename?: 'Enrollment', id: string, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } } | null }> | null } | null };

export type GetStudentEnrollmentsQueryVariables = Exact<{
  courseIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  roleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetStudentEnrollmentsQuery = { __typename?: 'Query', courses?: Array<{ __typename?: 'Course', id: string, enrollments?: Array<{ __typename?: 'Enrollment', id: string, user: { __typename?: 'User', id: string, fullName?: string | null } }> | null }> | null };

export type GradebookStudentsQueryVariables = Exact<{
  courseId: Scalars['ID'];
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  studentsLimit?: InputMaybe<Scalars['Int']>;
  studentsOffset?: InputMaybe<Scalars['Int']>;
  studentsSort?: InputMaybe<EnrollmentsSortOrder>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type GradebookStudentsQuery = { __typename?: 'Query', gradebookData?: { __typename?: 'GradebookData', students?: Array<{ __typename?: 'GradebookStudentData', needsGradingCounter?: number | null, submissions?: Array<{ __typename: 'MultiSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, statusOverriddenAt?: any | null, submissions: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, percentageGrade?: number | null, hasContent?: boolean | null, isDraft: boolean, isFinal?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } }>, activity: { __typename?: 'Activity', id: string, points: number, optional?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }, enrollment: { __typename?: 'Enrollment', id: string, course: { __typename?: 'Course', id: string, gradingScheme?: { __typename?: 'GradingScheme', id: string, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null } | null } } } | { __typename: 'SingleSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, statusOverriddenAt?: any | null, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null, activity: { __typename?: 'Activity', id: string, points: number, optional?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }, enrollment: { __typename?: 'Enrollment', id: string, course: { __typename?: 'Course', id: string, gradingScheme?: { __typename?: 'GradingScheme', id: string, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null } | null } } }> | null, enrollment?: { __typename?: 'Enrollment', id: string, course: { __typename?: 'Course', id: string, gradingScheme?: { __typename?: 'GradingScheme', id: string, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null } | null }, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } } | null }> | null } | null };

export type StudentSubmissionsQueryVariables = Exact<{
  enrollmentIds: Array<Scalars['ID']> | Scalars['ID'];
  activityIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type StudentSubmissionsQuery = { __typename?: 'Query', studentSubmissions?: Array<{ __typename: 'MultiSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, statusOverriddenAt?: any | null, privateDiscussionId?: string | null, submissions: Array<{ __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, percentageGrade?: number | null, hasContent?: boolean | null, isDraft: boolean, isFinal?: boolean | null, annotationStatus?: string | null, similarityReportResults?: any | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } }>, activity: { __typename?: 'Activity', id: string, points: number, optional?: boolean | null, graded?: boolean | null, similarityReportsEnabled?: boolean | null, item: { __typename?: 'Assignment', attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, questions: Array<{ __typename?: 'QuizQuestion', id: string, uid: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string>, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null }>, parentTemplate?: { __typename?: 'QuizTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }, enrollment: { __typename?: 'Enrollment', id: string, course: { __typename?: 'Course', id: string, graded?: boolean | null, gradingScheme?: { __typename?: 'GradingScheme', id: string, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null } | null }, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } } } | { __typename: 'SingleSubmission', dueStatus?: SubmissionDueStatus | null, grade?: number | null, gradedAt?: any | null, status?: SubmissionStatus | null, statusOverriddenAt?: any | null, privateDiscussionId?: string | null, submission?: { __typename?: 'Submission', id: string, isSubmitted?: boolean | null, isViewed?: boolean | null, submissionType: SubmissionEntry, createdAt?: any | null, submittedAt?: any | null, updatedAt?: any | null, grade?: number | null, gradedAt?: any | null, isDraft: boolean, percentageGrade?: number | null, hasContent?: boolean | null, annotationStatus?: string | null, similarityReportResults?: any | null, annotatedPdf?: { __typename?: 'FileEntry', id: string, annotation?: string | null, fileType?: string | null, url?: string | null, title: string } | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, content: { __typename?: 'AssignmentSubmission', text?: string | null } | { __typename?: 'QuizSubmission', answers: any, bookmarks: Array<string>, questionGrades: any, timeElapsed: number, timeLeft?: number | null } } | null, activity: { __typename?: 'Activity', id: string, points: number, optional?: boolean | null, graded?: boolean | null, similarityReportsEnabled?: boolean | null, item: { __typename?: 'Assignment', attemptsAllowed?: number | null, maxPoints?: number | null, submissionKind?: SubmissionKind | null, onlineSubmissionAccepted?: boolean | null, onlineSubmissionRequired?: boolean | null, id: string, instructions?: string | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', uid: string, backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, authorUrl?: string | null, byCompany?: string | null, id?: string | null, licenseOther?: string | null, licenseType?: AttributionLicense | null, notes?: string | null, title?: string | null, url?: string | null } | null }>, parentTemplate?: { __typename?: 'AssignmentTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null } | { __typename?: 'Quiz', attemptsAllowed?: number | null, createdAt: any, curriculum: Array<string>, downloadable?: boolean | null, gradeLevels: Array<string>, id: string, instructions?: string | null, pageBreaks?: QuizPageBreaks | null, questionNumbering: QuizQuestionNumbering, resumable?: boolean | null, showResults?: boolean | null, shuffleOrder?: boolean | null, subjects: Array<string>, tags: Array<string>, timeLimit?: number | null, title: string, type: string, attemptsRemaining?: number | null, copyableBy: Visibility, visibleTo: Visibility, questions: Array<{ __typename?: 'QuizQuestion', id: string, uid: string, acceptPartialAnswers?: boolean | null, caseSensitive?: boolean | null, content: any, createdAt: any, displayNumber?: string | null, extraCredit?: boolean | null, points: number, position?: number | null, published?: boolean | null, questionType: QuizQuestionKind, requireOrder?: boolean | null, section?: boolean | null, shuffleAnswers?: boolean | null, tags: Array<string>, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null }>, parentTemplate?: { __typename?: 'QuizTemplate', id: string, title: string, author: { __typename?: 'User', id: string } } | null }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }, enrollment: { __typename?: 'Enrollment', id: string, course: { __typename?: 'Course', id: string, graded?: boolean | null, gradingScheme?: { __typename?: 'GradingScheme', id: string, percentageGrade?: boolean | null, ranges: any, showLetterGrade?: boolean | null, showNumericGrade?: boolean | null } | null }, user: { __typename?: 'User', active?: boolean | null, id: string, fullName?: string | null, initials?: string | null, calendarColor?: string | null, oauthConnections: Array<OauthProvider>, imageFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, croppedUrl?: string | null, title: string, fileType?: string | null } | null } } }> | null };

export type GradebookActivitiesQueryVariables = Exact<{
  courseId: Scalars['ID'];
  studentEnrollmentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  studentsLimit?: InputMaybe<Scalars['Int']>;
  studentsOffset?: InputMaybe<Scalars['Int']>;
  studentsSort?: InputMaybe<EnrollmentsSortOrder>;
  activityIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activitiesLimit?: InputMaybe<Scalars['Int']>;
  activitiesOffset?: InputMaybe<Scalars['Int']>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  courseTermId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type GradebookActivitiesQuery = { __typename?: 'Query', gradebookData?: { __typename?: 'GradebookData', activities?: Array<{ __typename?: 'Activity', id: string, points: number, optional?: boolean | null, dueDate?: any | null, dueTimeSignificant?: boolean | null, item: { __typename?: 'Assignment', id: string, title: string, type: string } | { __typename?: 'Quiz', id: string, title: string, type: string }, activityGroup?: { __typename?: 'ActivityGroup', id: string, title: string, weight?: number | null } | null, unit: { __typename?: 'Unit', id: string, title: string } }> | null } | null };

export type MakeFinalSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type MakeFinalSubmissionMutation = { __typename?: 'Mutation', makeFinalSubmission?: { __typename?: 'SubmissionMakeFinalPayload', errors: Array<string>, success: boolean } | null };

export type AutocompleteDataQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type AutocompleteDataQuery = { __typename?: 'Query', autocompleteData?: { __typename?: 'GenericData', data?: any | null } | null };

export type CourseTemplatesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CourseTemplatesQuery = { __typename?: 'Query', courseTemplates: Array<{ __typename: 'CourseTemplate', activitiesCount: number, content: any, copyableBy?: Visibility | null, createdAt: any, courseCredits?: number | null, curriculum: Array<string>, description?: string | null, gradeLevels: Array<string>, iconColor: string, id: string, subjects: Array<string>, tags: Array<string>, title: string, uid: string, visibleTo: Visibility, author: { __typename?: 'User', fullName?: string | null, initials?: string | null, id: string, username?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }, imageFileEntry?: { __typename?: 'FileEntry', croppedUrl?: string | null, fileType?: string | null, id: string, url?: string | null } | null, originalCourse?: { __typename?: 'Course', id: string, title: string, iconColor?: string | null, graded?: boolean | null } | null, parentTemplate?: { __typename?: 'CourseTemplate', id: string, title: string } | null, thumbnailFileEntry?: { __typename?: 'FileEntry', id: string, url?: string | null, title: string } | null }> };

export type AssignmentTemplatesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type AssignmentTemplatesQuery = { __typename?: 'Query', assignmentTemplates: Array<{ __typename: 'AssignmentTemplate', gradeLevels: Array<string>, curriculum: Array<string>, subjects: Array<string>, copyableBy?: Visibility | null, createdAt: any, instructions?: string | null, templateOptions: any, title: string, id: string, tags: Array<string>, visibleTo: Visibility, author: { __typename?: 'User', fullName?: string | null, id: string, username?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }, contentBlocks: Array<{ __typename?: 'AssignmentContentBlock', backgroundColor?: string | null, blockType: ContentBlock, content: any, itemId?: number | null, itemType?: ContentItem | null, position?: number | null, publish?: boolean | null, topLine?: boolean | null, attachments: Array<{ __typename?: 'FileEntry', annotatable?: boolean | null, croppedUrl?: string | null, fileType?: string | null, id: string, originalFileSize?: number | null, originalFileName?: string | null, originalFileContentType?: string | null, title: string, description?: string | null, url?: string | null, skipperPaperContent?: string | null, createdAt?: any | null, updatedAt?: any | null, sourceAttribution?: { __typename?: 'SourceAttribution', id?: string | null } | null, uploadedBy: { __typename?: 'User', id: string, fullName?: string | null, username?: string | null } }>, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, licenseType?: AttributionLicense | null, title?: string | null, url?: string | null } | null }>, sourceAttribution?: { __typename?: 'SourceAttribution', author?: string | null, licenseType?: AttributionLicense | null, title?: string | null, url?: string | null } | null, templateInCourse?: { __typename?: 'Course', id: string, title: string } | null, parentTemplate?: { __typename?: 'CourseTemplate', id: string, title: string } | null }> };

export type QuizTemplatesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type QuizTemplatesQuery = { __typename?: 'Query', quizTemplates: Array<{ __typename: 'QuizTemplate', copyableBy?: Visibility | null, createdAt: any, instructions?: string | null, templateOptions: any, title: string, id: string, tags: Array<string>, visibleTo: Visibility, author: { __typename?: 'User', fullName?: string | null, id: string, username?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }, templateInCourse?: { __typename?: 'Course', id: string, title: string } | null, parentTemplate?: { __typename?: 'CourseTemplate', id: string, title: string } | null, questions: Array<{ __typename?: 'QuizQuestion', id: string, questionType: QuizQuestionKind, content: any, uid: string }> }> };

export type UnitTemplatesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UnitTemplatesQuery = { __typename?: 'Query', unitTemplates: Array<{ __typename: 'UnitTemplate', activitiesCount: number, content: any, copyableBy?: Visibility | null, createdAt: any, description?: string | null, title: string, id: string, subjects: Array<string>, curriculum: Array<string>, gradeLevels: Array<string>, tags: Array<string>, visibleTo: Visibility, author: { __typename?: 'User', fullName?: string | null, id: string, username?: string | null, initials?: string | null, calendarColor?: string | null, imageFileEntry?: { __typename?: 'FileEntry', url?: string | null } | null }, parentTemplate?: { __typename?: 'UnitTemplate', id: string, title: string } | null, originalCourse?: { __typename?: 'Course', id: string, title: string } | null }> };

export const UserFragmentFragmentDoc = `
    fragment UserFragment on User {
  id
  fullName
}
    `;
export const UnitDetailsFragmentDoc = `
    fragment UnitDetails on Unit {
  id
  title
  visible
  description
  courseTerm {
    id
    published
    title
    accessible
    weight
  }
}
    `;
export const FileEntryDefaultFragmentDoc = `
    fragment FileEntryDefault on FileEntry {
  annotatable
  croppedUrl
  fileType
  id
  originalFileSize
  originalFileName
  originalFileContentType
  sourceAttribution {
    id
  }
  title
  description
  url
  skipperPaperContent
  createdAt
  updatedAt
  uploadedBy {
    id
    fullName
    username
  }
}
    `;
export const CourseFragmentFragmentDoc = `
    fragment CourseFragment on Course {
  id
  graded
  courseCredits
  timeZone
  currentTerm {
    id
    published
    title
    accessible
    weight
  }
  terms {
    id
    published
    forGradebook
    title
    accessible
    weight
  }
  materials {
    id
    description
    title
    url
    published
    position
    fileEntry {
      ...FileEntryDefault
    }
  }
  currentEnrollment {
    id
    role {
      id
      type
      name
      permissions
    }
  }
  description
  iconColor
  title
  uid
  welcome
  welcomeMediaType
  scheduledDaysOff
  scheduledWeekdays
  schedulingMode
  startDate
  published
  tags
  gradeLevels
  subjects
  inviteCode
  inviteCodeExpiresAt
  requireJoinConfirmation
  curriculum
  similarityReportsEnabled
  restricted
  isSameAccount
  imageFileEntry {
    ...FileEntryDefault
  }
  videoFileEntry {
    ...FileEntryDefault
  }
  thumbnailFileEntry {
    ...FileEntryDefault
  }
  originalCourseTemplate {
    id
    title
    visibleTo
    copyableBy
    author {
      id
    }
  }
}
    `;
export const CourseGradingSchemaFragmentDoc = `
    fragment CourseGradingSchema on GradingScheme {
  description
  id
  isDefault
  percentageGrade
  ranges
  showLetterGrade
  showNumericGrade
  title
}
    `;
export const CourseActivityGroupsFragmentDoc = `
    fragment CourseActivityGroups on ActivityGroup {
  id
  title
  weight
  description
}
    `;
export const ActivitiesDetailsFragmentDoc = `
    fragment ActivitiesDetails on Activity {
  id
  assignDate
  dueDate
  dueTimeSignificant
  lockAfterDueDate
  lockBeforeAssignDate
  lockedAfterDueDate
  lockedBeforeAssignDate
  markLate
  optional
  graded
  parentCanGrade
  parentCanGradeOverride
  parentCanGradeOverride
  similarityReportsEnabled
  published
  visible
  points
  updatedAt
  position
  activityGroup {
    id
    title
    weight
  }
}
    `;
export const ActivityItemFragmentFragmentDoc = `
    fragment ActivityItemFragment on ActivityItem {
  id
  instructions
  title
  type
  attemptsRemaining
  copyableBy
  visibleTo
}
    `;
export const ActivityBatchDefaultFragmentDoc = `
    fragment ActivityBatchDefault on ActivityBatch {
  id
  items
  title
  createdAt
  baseItemType
  baseItem {
    id
    title
    type
    instructions
    attemptsAllowed
    createdAt
    ... on Assignment {
      contentBlocks {
        uid
        backgroundColor
        blockType
        content
        itemId
        itemType
        position
        publish
        topLine
        sourceAttribution {
          author
          authorUrl
          byCompany
          id
          licenseOther
          licenseType
          notes
          title
          url
        }
      }
    }
    ... on Quiz {
      attemptsAllowed
      createdAt
      curriculum
      downloadable
      gradeLevels
      id
      instructions
      pageBreaks
      questionNumbering
      resumable
      showResults
      shuffleOrder
      subjects
      tags
      timeLimit
      title
      type
    }
  }
}
    `;
export const AssignmentFragmentFragmentDoc = `
    fragment AssignmentFragment on Assignment {
  attemptsAllowed
  contentBlocks {
    uid
    backgroundColor
    blockType
    content
    itemId
    itemType
    position
    publish
    topLine
    sourceAttribution {
      author
      authorUrl
      byCompany
      id
      licenseOther
      licenseType
      notes
      title
      url
    }
  }
  maxPoints
  submissionKind
  onlineSubmissionAccepted
  onlineSubmissionRequired
  parentTemplate {
    id
    title
    author {
      id
    }
  }
}
    `;
export const QuizFragmentFragmentDoc = `
    fragment QuizFragment on Quiz {
  attemptsAllowed
  createdAt
  curriculum
  downloadable
  gradeLevels
  id
  instructions
  pageBreaks
  parentTemplate {
    id
    title
    author {
      id
    }
  }
  questionNumbering
  resumable
  showResults
  shuffleOrder
  subjects
  tags
  timeLimit
  title
  type
}
    `;
export const QuizQuestionFragmentFragmentDoc = `
    fragment QuizQuestionFragment on QuizQuestion {
  id
  uid
  acceptPartialAnswers
  caseSensitive
  content
  createdAt
  displayNumber
  extraCredit
  sourceAttribution {
    id
  }
  points
  position
  published
  questionType
  requireOrder
  section
  shuffleAnswers
  tags
}
    `;
export const SubmissionFragmentFragmentDoc = `
    fragment SubmissionFragment on Submission {
  id
  isSubmitted
  isViewed
  submissionType
  createdAt
  submittedAt
  updatedAt
  grade
  gradedAt
  isDraft
  hasContent
  similarityReportResults
  attachments {
    ...FileEntryDefault
  }
  content {
    ... on QuizSubmission {
      answers
      bookmarks
      questionGrades
      timeElapsed
      timeLeft
    }
    ... on AssignmentSubmission {
      text
    }
  }
}
    `;
export const ConversationMessageFragmentFragmentDoc = `
    fragment ConversationMessageFragment on Message {
  id
  content
  subject
  author {
    id
    fullName
    initials
    calendarColor
    imageFileEntry {
      url
    }
  }
  createdAt
  fileEntry {
    ...FileEntryDefault
  }
}
    `;
export const CommentFragmentFragmentDoc = `
    fragment CommentFragment on Comment {
  id
  author {
    active
    id
    fullName
    initials
    calendarColor
    imageFileEntry {
      id
      url
      croppedUrl
      title
      fileType
    }
  }
  content
  fileEntry {
    ...FileEntryDefault
  }
  isViewed
  createdAt
}
    `;
export const EnrollmentFragmentFragmentDoc = `
    fragment EnrollmentFragment on Enrollment {
  id
  concluded
  dropped
  createdAt
  finalGrade
  activatedAt
  deactivatedAt
  lastActivityAt
  needsConfirmJoin
  user {
    active
    id
    fullName
    initials
    calendarColor
  }
  role {
    id
    fixed
    name
    type
  }
}
    `;
export const GradingSchemaFragmentFragmentDoc = `
    fragment GradingSchemaFragment on GradingScheme {
  id
  isDefault
  percentageGrade
  title
  ranges
  showLetterGrade
  showNumericGrade
  description
}
    `;
export const CreateAccountUserDocument = `
    mutation createAccountUser($email: String, $username: String, $firstName: String!, $lastName: String, $password: String!, $accountRoleId: ID!, $birthDate: ISO8601Date!, $calendarColor: String) {
  createAccountUser(
    email: $email
    username: $username
    firstName: $firstName
    lastName: $lastName
    password: $password
    accountRoleId: $accountRoleId
    birthDate: $birthDate
    calendarColor: $calendarColor
  ) {
    success
    errors
    user {
      id
      initials
      birthDate
      firstName
      lastName
      fullName
      username
      email
      calendarColor
      accountRole {
        id
        name
        roleType
      }
      unconfirmedEmail
      permissionLevel {
        id
        fixed
        name
        permissions
      }
    }
  }
}
    `;
export const useCreateAccountUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAccountUserMutation, TError, CreateAccountUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAccountUserMutation, TError, CreateAccountUserMutationVariables, TContext>(
      ['createAccountUser'],
      (variables?: CreateAccountUserMutationVariables) => fetcher<CreateAccountUserMutation, CreateAccountUserMutationVariables>(client, CreateAccountUserDocument, variables, headers)(),
      options
    );
useCreateAccountUserMutation.fetcher = (client: GraphQLClient, variables: CreateAccountUserMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateAccountUserMutation, CreateAccountUserMutationVariables>(client, CreateAccountUserDocument, variables, headers);
export const DeleteAccountUserDocument = `
    mutation deleteAccountUser($id: Int!) {
  deleteAccountUser(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteAccountUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAccountUserMutation, TError, DeleteAccountUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteAccountUserMutation, TError, DeleteAccountUserMutationVariables, TContext>(
      ['deleteAccountUser'],
      (variables?: DeleteAccountUserMutationVariables) => fetcher<DeleteAccountUserMutation, DeleteAccountUserMutationVariables>(client, DeleteAccountUserDocument, variables, headers)(),
      options
    );
useDeleteAccountUserMutation.fetcher = (client: GraphQLClient, variables: DeleteAccountUserMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteAccountUserMutation, DeleteAccountUserMutationVariables>(client, DeleteAccountUserDocument, variables, headers);
export const UpdateUserDocument = `
    mutation updateUser($id: Int!, $firstName: String, $lastName: String, $username: String, $calendarColor: String, $imageFileEntryId: ID, $email: String, $oldPassword: String, $newPassword: String, $active: Boolean, $notificationSettings: JSON, $minGradeNotificationThreshold: JSON, $permissionLevelId: ID, $birthDate: ISO8601Date, $turnItInEulaVersion: String) {
  updateAccountUser(
    id: $id
    firstName: $firstName
    lastName: $lastName
    username: $username
    calendarColor: $calendarColor
    imageFileEntryId: $imageFileEntryId
    email: $email
    oldPassword: $oldPassword
    newPassword: $newPassword
    active: $active
    notificationSettings: $notificationSettings
    minGradeNotificationThreshold: $minGradeNotificationThreshold
    permissionLevelId: $permissionLevelId
    birthDate: $birthDate
    turnitinEulaAcceptedVersion: $turnItInEulaVersion
  ) {
    errors
    success
    user {
      firstName
      lastName
      birthDate
      calendarColor
      email
      fullName
      id
      initials
      unconfirmedEmail
      notificationSettings
      minGradeNotificationThreshold
    }
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['updateUser'],
      (variables?: UpdateUserMutationVariables) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(client, UpdateUserDocument, variables, headers)(),
      options
    );
useUpdateUserMutation.fetcher = (client: GraphQLClient, variables: UpdateUserMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(client, UpdateUserDocument, variables, headers);
export const UpdateAccountDocument = `
    mutation updateAccount($name: String, $schoolAddress: String, $schoolCity: String, $schoolState: String, $schoolZip: String, $timeZone: String) {
  updateAccount(
    name: $name
    schoolAddress: $schoolAddress
    schoolCity: $schoolCity
    schoolState: $schoolState
    schoolZip: $schoolZip
    timeZone: $timeZone
  ) {
    account {
      name
      schoolAddress
      schoolCity
      schoolState
      schoolZip
      timeZone
    }
    success
    errors
  }
}
    `;
export const useUpdateAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAccountMutation, TError, UpdateAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAccountMutation, TError, UpdateAccountMutationVariables, TContext>(
      ['updateAccount'],
      (variables?: UpdateAccountMutationVariables) => fetcher<UpdateAccountMutation, UpdateAccountMutationVariables>(client, UpdateAccountDocument, variables, headers)(),
      options
    );
useUpdateAccountMutation.fetcher = (client: GraphQLClient, variables?: UpdateAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateAccountMutation, UpdateAccountMutationVariables>(client, UpdateAccountDocument, variables, headers);
export const ResetPasswordDocument = `
    mutation resetPassword($resetPasswordToken: String!, $password: String!) {
  resetPassword(resetPasswordToken: $resetPasswordToken, password: $password) {
    success
    errors {
      field
      message
    }
  }
}
    `;
export const useResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['resetPassword'],
      (variables?: ResetPasswordMutationVariables) => fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(client, ResetPasswordDocument, variables, headers)(),
      options
    );
useResetPasswordMutation.fetcher = (client: GraphQLClient, variables: ResetPasswordMutationVariables, headers?: RequestInit['headers']) => fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(client, ResetPasswordDocument, variables, headers);
export const ResendEmailChangeAccountUserDocument = `
    mutation resendEmailChangeAccountUser($id: Int!) {
  resendEmailChangeAccountUser(id: $id) {
    success
    errors
  }
}
    `;
export const useResendEmailChangeAccountUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResendEmailChangeAccountUserMutation, TError, ResendEmailChangeAccountUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResendEmailChangeAccountUserMutation, TError, ResendEmailChangeAccountUserMutationVariables, TContext>(
      ['resendEmailChangeAccountUser'],
      (variables?: ResendEmailChangeAccountUserMutationVariables) => fetcher<ResendEmailChangeAccountUserMutation, ResendEmailChangeAccountUserMutationVariables>(client, ResendEmailChangeAccountUserDocument, variables, headers)(),
      options
    );
useResendEmailChangeAccountUserMutation.fetcher = (client: GraphQLClient, variables: ResendEmailChangeAccountUserMutationVariables, headers?: RequestInit['headers']) => fetcher<ResendEmailChangeAccountUserMutation, ResendEmailChangeAccountUserMutationVariables>(client, ResendEmailChangeAccountUserDocument, variables, headers);
export const ResendEmailConfirmationAccountUserDocument = `
    mutation resendEmailConfirmationAccountUser($email: String!) {
  resendEmailConfirmationAccountUser(email: $email) {
    success
    errors
  }
}
    `;
export const useResendEmailConfirmationAccountUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResendEmailConfirmationAccountUserMutation, TError, ResendEmailConfirmationAccountUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResendEmailConfirmationAccountUserMutation, TError, ResendEmailConfirmationAccountUserMutationVariables, TContext>(
      ['resendEmailConfirmationAccountUser'],
      (variables?: ResendEmailConfirmationAccountUserMutationVariables) => fetcher<ResendEmailConfirmationAccountUserMutation, ResendEmailConfirmationAccountUserMutationVariables>(client, ResendEmailConfirmationAccountUserDocument, variables, headers)(),
      options
    );
useResendEmailConfirmationAccountUserMutation.fetcher = (client: GraphQLClient, variables: ResendEmailConfirmationAccountUserMutationVariables, headers?: RequestInit['headers']) => fetcher<ResendEmailConfirmationAccountUserMutation, ResendEmailConfirmationAccountUserMutationVariables>(client, ResendEmailConfirmationAccountUserDocument, variables, headers);
export const CancelEmailChangeAccountUserDocument = `
    mutation cancelEmailChangeAccountUser($id: Int!) {
  cancelEmailChangeAccountUser(id: $id) {
    success
    errors
  }
}
    `;
export const useCancelEmailChangeAccountUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelEmailChangeAccountUserMutation, TError, CancelEmailChangeAccountUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelEmailChangeAccountUserMutation, TError, CancelEmailChangeAccountUserMutationVariables, TContext>(
      ['cancelEmailChangeAccountUser'],
      (variables?: CancelEmailChangeAccountUserMutationVariables) => fetcher<CancelEmailChangeAccountUserMutation, CancelEmailChangeAccountUserMutationVariables>(client, CancelEmailChangeAccountUserDocument, variables, headers)(),
      options
    );
useCancelEmailChangeAccountUserMutation.fetcher = (client: GraphQLClient, variables: CancelEmailChangeAccountUserMutationVariables, headers?: RequestInit['headers']) => fetcher<CancelEmailChangeAccountUserMutation, CancelEmailChangeAccountUserMutationVariables>(client, CancelEmailChangeAccountUserDocument, variables, headers);
export const CreateAccountDocument = `
    mutation createAccount($email: String!, $password: String!, $firstName: String!, $lastName: String!) {
  createAccount(
    email: $email
    password: $password
    firstName: $firstName
    lastName: $lastName
  ) {
    success
    errors
    account {
      users {
        id
        email
      }
    }
  }
}
    `;
export const useCreateAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAccountMutation, TError, CreateAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAccountMutation, TError, CreateAccountMutationVariables, TContext>(
      ['createAccount'],
      (variables?: CreateAccountMutationVariables) => fetcher<CreateAccountMutation, CreateAccountMutationVariables>(client, CreateAccountDocument, variables, headers)(),
      options
    );
useCreateAccountMutation.fetcher = (client: GraphQLClient, variables: CreateAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateAccountMutation, CreateAccountMutationVariables>(client, CreateAccountDocument, variables, headers);
export const CreateSubscriptionDocument = `
    mutation createSubscription($subscriptionPlanId: ID!, $priceId: String, $forceUpdate: Boolean = false) {
  createSubscription(
    subscriptionPlanId: $subscriptionPlanId
    priceId: $priceId
    forceUpdate: $forceUpdate
  ) {
    success
    errors
    redirectUrl
    invoicePreview
    subscriptionPlan {
      title
      description
      features
      productId
      priceAnnual
      priceMonthly
    }
  }
}
    `;
export const useCreateSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateSubscriptionMutation, TError, CreateSubscriptionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateSubscriptionMutation, TError, CreateSubscriptionMutationVariables, TContext>(
      ['createSubscription'],
      (variables?: CreateSubscriptionMutationVariables) => fetcher<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(client, CreateSubscriptionDocument, variables, headers)(),
      options
    );
useCreateSubscriptionMutation.fetcher = (client: GraphQLClient, variables: CreateSubscriptionMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(client, CreateSubscriptionDocument, variables, headers);
export const CreateStripeDeepLinkDocument = `
    mutation createStripeDeepLink($type: String!) {
  createStripeDeepLink(type: $type) {
    success
    errors
    url
  }
}
    `;
export const useCreateStripeDeepLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateStripeDeepLinkMutation, TError, CreateStripeDeepLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateStripeDeepLinkMutation, TError, CreateStripeDeepLinkMutationVariables, TContext>(
      ['createStripeDeepLink'],
      (variables?: CreateStripeDeepLinkMutationVariables) => fetcher<CreateStripeDeepLinkMutation, CreateStripeDeepLinkMutationVariables>(client, CreateStripeDeepLinkDocument, variables, headers)(),
      options
    );
useCreateStripeDeepLinkMutation.fetcher = (client: GraphQLClient, variables: CreateStripeDeepLinkMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateStripeDeepLinkMutation, CreateStripeDeepLinkMutationVariables>(client, CreateStripeDeepLinkDocument, variables, headers);
export const CreateActivityDocument = `
    mutation createActivity($unitId: ID!, $activityBlockId: ID, $activityGroupId: ID, $assignmentItem: AssignmentAttributes, $quizItem: QuizAttributes, $assignDate: ISO8601DateTime, $dueDate: ISO8601DateTime, $dueTimeSignificant: Boolean, $optional: Boolean, $parentCanGrade: Boolean, $parentCanGradeOverride: Boolean, $markLate: Boolean, $published: Boolean, $visible: Boolean, $lockAfterDueDate: Boolean, $lockBeforeAssignDate: Boolean) {
  createActivity(
    unitId: $unitId
    activityBlockId: $activityBlockId
    activityGroupId: $activityGroupId
    assignmentItem: $assignmentItem
    quizItem: $quizItem
    assignDate: $assignDate
    dueDate: $dueDate
    dueTimeSignificant: $dueTimeSignificant
    optional: $optional
    parentCanGrade: $parentCanGrade
    parentCanGradeOverride: $parentCanGradeOverride
    markLate: $markLate
    published: $published
    visible: $visible
    lockAfterDueDate: $lockAfterDueDate
    lockBeforeAssignDate: $lockBeforeAssignDate
  ) {
    success
    errors
    activity {
      id
      lockAfterDueDate
      lockBeforeAssignDate
      lockedAfterDueDate
      lockedBeforeAssignDate
      markLate
      optional
      parentCanGrade
      parentCanGradeOverride
      points
      position
      published
      visible
      graded
      dueDate
      dueTimeSignificant
      createdAt
      assignDate
      activityGroup {
        id
        title
        description
        weight
      }
      item {
        id
        title
        type
        instructions
        attemptsAllowed
        createdAt
        ... on Assignment {
          submissionKind
          contentBlocks {
            uid
            backgroundColor
            blockType
            content
            itemId
            itemType
            position
            publish
            topLine
            sourceAttribution {
              author
              authorUrl
              byCompany
              id
              licenseOther
              licenseType
              notes
              title
              url
            }
          }
        }
        ... on Quiz {
          attemptsAllowed
          createdAt
          curriculum
          downloadable
          gradeLevels
          id
          instructions
          pageBreaks
          questionNumbering
          questions(includeHidden: true) {
            id
            acceptPartialAnswers
            caseSensitive
            content
            createdAt
            displayNumber
            extraCredit
            points
            position
            published
            questionType
            requireOrder
            section
            shuffleAnswers
            tags
          }
          resumable
          showResults
          shuffleOrder
          subjects
          tags
          timeLimit
          title
          type
        }
      }
    }
  }
}
    `;
export const useCreateActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateActivityMutation, TError, CreateActivityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateActivityMutation, TError, CreateActivityMutationVariables, TContext>(
      ['createActivity'],
      (variables?: CreateActivityMutationVariables) => fetcher<CreateActivityMutation, CreateActivityMutationVariables>(client, CreateActivityDocument, variables, headers)(),
      options
    );
useCreateActivityMutation.fetcher = (client: GraphQLClient, variables: CreateActivityMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateActivityMutation, CreateActivityMutationVariables>(client, CreateActivityDocument, variables, headers);
export const UpdateActivityDocument = `
    mutation updateActivity($id: ID!, $unitId: ID, $activityBlockId: ID, $activityGroupId: ID, $assignmentItem: AssignmentAttributes, $quizItem: QuizAttributes, $assignDate: ISO8601DateTime, $dueDate: ISO8601DateTime, $dueTimeSignificant: Boolean, $optional: Boolean, $parentCanGrade: Boolean, $parentCanGradeOverride: Boolean, $markLate: Boolean, $published: Boolean, $visible: Boolean, $lockAfterDueDate: Boolean, $lockBeforeAssignDate: Boolean) {
  updateActivity(
    id: $id
    unitId: $unitId
    activityBlockId: $activityBlockId
    activityGroupId: $activityGroupId
    assignmentItem: $assignmentItem
    quizItem: $quizItem
    assignDate: $assignDate
    dueDate: $dueDate
    dueTimeSignificant: $dueTimeSignificant
    optional: $optional
    parentCanGrade: $parentCanGrade
    parentCanGradeOverride: $parentCanGradeOverride
    markLate: $markLate
    published: $published
    visible: $visible
    lockAfterDueDate: $lockAfterDueDate
    lockBeforeAssignDate: $lockBeforeAssignDate
  ) {
    success
    errors
    activity {
      id
      lockAfterDueDate
      lockBeforeAssignDate
      lockedAfterDueDate
      lockedBeforeAssignDate
      markLate
      optional
      parentCanGrade
      parentCanGradeOverride
      points
      position
      published
      visible
      graded
      dueDate
      dueTimeSignificant
      createdAt
      assignDate
      activityGroup {
        id
        title
        description
        weight
      }
      item {
        id
        title
        type
        instructions
        attemptsAllowed
        createdAt
        ... on Assignment {
          contentBlocks {
            backgroundColor
            uid
            blockType
            content
            itemId
            itemType
            position
            publish
            topLine
            sourceAttribution {
              author
              authorUrl
              byCompany
              id
              licenseOther
              licenseType
              notes
              title
              url
            }
          }
        }
        ... on Quiz {
          attemptsAllowed
          createdAt
          curriculum
          downloadable
          gradeLevels
          id
          instructions
          pageBreaks
          questionNumbering
          questions(includeHidden: true) {
            id
            acceptPartialAnswers
            caseSensitive
            content
            createdAt
            displayNumber
            extraCredit
            points
            position
            published
            questionType
            requireOrder
            section
            shuffleAnswers
            tags
          }
          resumable
          showResults
          shuffleOrder
          subjects
          tags
          timeLimit
          title
          type
        }
      }
    }
  }
}
    `;
export const useUpdateActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateActivityMutation, TError, UpdateActivityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateActivityMutation, TError, UpdateActivityMutationVariables, TContext>(
      ['updateActivity'],
      (variables?: UpdateActivityMutationVariables) => fetcher<UpdateActivityMutation, UpdateActivityMutationVariables>(client, UpdateActivityDocument, variables, headers)(),
      options
    );
useUpdateActivityMutation.fetcher = (client: GraphQLClient, variables: UpdateActivityMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateActivityMutation, UpdateActivityMutationVariables>(client, UpdateActivityDocument, variables, headers);
export const CreateActivityBlockDocument = `
    mutation createActivityBlock($unitId: ID!, $title: String!, $assignDate: ISO8601Date, $dueDate: ISO8601Date, $visible: Boolean) {
  createActivityBlock(
    unitId: $unitId
    title: $title
    assignDate: $assignDate
    dueDate: $dueDate
    visible: $visible
  ) {
    success
    errors
  }
}
    `;
export const useCreateActivityBlockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateActivityBlockMutation, TError, CreateActivityBlockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateActivityBlockMutation, TError, CreateActivityBlockMutationVariables, TContext>(
      ['createActivityBlock'],
      (variables?: CreateActivityBlockMutationVariables) => fetcher<CreateActivityBlockMutation, CreateActivityBlockMutationVariables>(client, CreateActivityBlockDocument, variables, headers)(),
      options
    );
useCreateActivityBlockMutation.fetcher = (client: GraphQLClient, variables: CreateActivityBlockMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateActivityBlockMutation, CreateActivityBlockMutationVariables>(client, CreateActivityBlockDocument, variables, headers);
export const DeleteActivityDocument = `
    mutation deleteActivity($id: ID!, $force: Boolean) {
  deleteActivity(id: $id, force: $force) {
    success
    errors
  }
}
    `;
export const useDeleteActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteActivityMutation, TError, DeleteActivityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteActivityMutation, TError, DeleteActivityMutationVariables, TContext>(
      ['deleteActivity'],
      (variables?: DeleteActivityMutationVariables) => fetcher<DeleteActivityMutation, DeleteActivityMutationVariables>(client, DeleteActivityDocument, variables, headers)(),
      options
    );
useDeleteActivityMutation.fetcher = (client: GraphQLClient, variables: DeleteActivityMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteActivityMutation, DeleteActivityMutationVariables>(client, DeleteActivityDocument, variables, headers);
export const CreateActivityBatchDocument = `
    mutation createActivityBatch($courseId: ID!, $title: String!, $items: [JSON!], $baseItemType: String!, $baseItemId: ID) {
  createActivityBatch(
    courseId: $courseId
    title: $title
    items: $items
    baseItemType: $baseItemType
    baseItemId: $baseItemId
  ) {
    success
    errors
    activityBatch {
      ...ActivityBatchDefault
    }
  }
}
    ${ActivityBatchDefaultFragmentDoc}`;
export const useCreateActivityBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateActivityBatchMutation, TError, CreateActivityBatchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateActivityBatchMutation, TError, CreateActivityBatchMutationVariables, TContext>(
      ['createActivityBatch'],
      (variables?: CreateActivityBatchMutationVariables) => fetcher<CreateActivityBatchMutation, CreateActivityBatchMutationVariables>(client, CreateActivityBatchDocument, variables, headers)(),
      options
    );
useCreateActivityBatchMutation.fetcher = (client: GraphQLClient, variables: CreateActivityBatchMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateActivityBatchMutation, CreateActivityBatchMutationVariables>(client, CreateActivityBatchDocument, variables, headers);
export const DeleteActivityBatchDocument = `
    mutation deleteActivityBatch($id: ID!) {
  deleteActivityBatch(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteActivityBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteActivityBatchMutation, TError, DeleteActivityBatchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteActivityBatchMutation, TError, DeleteActivityBatchMutationVariables, TContext>(
      ['deleteActivityBatch'],
      (variables?: DeleteActivityBatchMutationVariables) => fetcher<DeleteActivityBatchMutation, DeleteActivityBatchMutationVariables>(client, DeleteActivityBatchDocument, variables, headers)(),
      options
    );
useDeleteActivityBatchMutation.fetcher = (client: GraphQLClient, variables: DeleteActivityBatchMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteActivityBatchMutation, DeleteActivityBatchMutationVariables>(client, DeleteActivityBatchDocument, variables, headers);
export const UpdateActivityBatchDocument = `
    mutation updateActivityBatch($id: ID!, $title: String, $items: [JSON!]) {
  updateActivityBatch(id: $id, title: $title, items: $items) {
    success
    errors
    activityBatch {
      ...ActivityBatchDefault
    }
  }
}
    ${ActivityBatchDefaultFragmentDoc}`;
export const useUpdateActivityBatchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateActivityBatchMutation, TError, UpdateActivityBatchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateActivityBatchMutation, TError, UpdateActivityBatchMutationVariables, TContext>(
      ['updateActivityBatch'],
      (variables?: UpdateActivityBatchMutationVariables) => fetcher<UpdateActivityBatchMutation, UpdateActivityBatchMutationVariables>(client, UpdateActivityBatchDocument, variables, headers)(),
      options
    );
useUpdateActivityBatchMutation.fetcher = (client: GraphQLClient, variables: UpdateActivityBatchMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateActivityBatchMutation, UpdateActivityBatchMutationVariables>(client, UpdateActivityBatchDocument, variables, headers);
export const BatchActivitiesDocument = `
    mutation batchActivities($batchItems: [ActivityAttributes!]!) {
  batchActivities(batchItems: $batchItems) {
    success
    errors
    activities {
      id
      lockAfterDueDate
      lockBeforeAssignDate
      lockedAfterDueDate
      lockedBeforeAssignDate
      markLate
      optional
      parentCanGrade
      parentCanGradeOverride
      points
      position
      published
      visible
      graded
      dueDate
      dueTimeSignificant
      createdAt
      assignDate
      activityGroup {
        id
        title
        description
        weight
      }
      item {
        id
        title
        type
        instructions
        attemptsAllowed
        createdAt
        ... on Assignment {
          contentBlocks {
            uid
            backgroundColor
            blockType
            content
            itemId
            itemType
            position
            publish
            topLine
            sourceAttribution {
              author
              authorUrl
              byCompany
              id
              licenseOther
              licenseType
              notes
              title
              url
            }
          }
        }
        ... on Quiz {
          attemptsAllowed
          createdAt
          curriculum
          downloadable
          gradeLevels
          id
          instructions
          pageBreaks
          questionNumbering
          questions(includeHidden: true) {
            id
            acceptPartialAnswers
            caseSensitive
            content
            createdAt
            displayNumber
            extraCredit
            points
            position
            published
            questionType
            requireOrder
            section
            shuffleAnswers
            tags
          }
          resumable
          showResults
          shuffleOrder
          subjects
          tags
          timeLimit
          title
          type
        }
      }
    }
  }
}
    `;
export const useBatchActivitiesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchActivitiesMutation, TError, BatchActivitiesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchActivitiesMutation, TError, BatchActivitiesMutationVariables, TContext>(
      ['batchActivities'],
      (variables?: BatchActivitiesMutationVariables) => fetcher<BatchActivitiesMutation, BatchActivitiesMutationVariables>(client, BatchActivitiesDocument, variables, headers)(),
      options
    );
useBatchActivitiesMutation.fetcher = (client: GraphQLClient, variables: BatchActivitiesMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchActivitiesMutation, BatchActivitiesMutationVariables>(client, BatchActivitiesDocument, variables, headers);
export const CreateActivityGroupDocument = `
    mutation createActivityGroup($courseId: ID!, $title: String!, $description: String, $weight: Int) {
  createActivityGroup(
    courseId: $courseId
    title: $title
    description: $description
    weight: $weight
  ) {
    success
    errors
    activityGroup {
      id
      title
      weight
      description
      createdAt
    }
  }
}
    `;
export const useCreateActivityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateActivityGroupMutation, TError, CreateActivityGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateActivityGroupMutation, TError, CreateActivityGroupMutationVariables, TContext>(
      ['createActivityGroup'],
      (variables?: CreateActivityGroupMutationVariables) => fetcher<CreateActivityGroupMutation, CreateActivityGroupMutationVariables>(client, CreateActivityGroupDocument, variables, headers)(),
      options
    );
useCreateActivityGroupMutation.fetcher = (client: GraphQLClient, variables: CreateActivityGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateActivityGroupMutation, CreateActivityGroupMutationVariables>(client, CreateActivityGroupDocument, variables, headers);
export const DeleteActivityGroupDocument = `
    mutation deleteActivityGroup($id: ID!) {
  deleteActivityGroup(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteActivityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteActivityGroupMutation, TError, DeleteActivityGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteActivityGroupMutation, TError, DeleteActivityGroupMutationVariables, TContext>(
      ['deleteActivityGroup'],
      (variables?: DeleteActivityGroupMutationVariables) => fetcher<DeleteActivityGroupMutation, DeleteActivityGroupMutationVariables>(client, DeleteActivityGroupDocument, variables, headers)(),
      options
    );
useDeleteActivityGroupMutation.fetcher = (client: GraphQLClient, variables: DeleteActivityGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteActivityGroupMutation, DeleteActivityGroupMutationVariables>(client, DeleteActivityGroupDocument, variables, headers);
export const UpdateActivityGroupDocument = `
    mutation updateActivityGroup($id: ID!, $title: String!, $description: String, $weight: Int) {
  updateActivityGroup(
    id: $id
    title: $title
    description: $description
    weight: $weight
  ) {
    success
    errors
    activityGroup {
      id
      title
      weight
      description
      createdAt
    }
  }
}
    `;
export const useUpdateActivityGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateActivityGroupMutation, TError, UpdateActivityGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateActivityGroupMutation, TError, UpdateActivityGroupMutationVariables, TContext>(
      ['updateActivityGroup'],
      (variables?: UpdateActivityGroupMutationVariables) => fetcher<UpdateActivityGroupMutation, UpdateActivityGroupMutationVariables>(client, UpdateActivityGroupDocument, variables, headers)(),
      options
    );
useUpdateActivityGroupMutation.fetcher = (client: GraphQLClient, variables: UpdateActivityGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateActivityGroupMutation, UpdateActivityGroupMutationVariables>(client, UpdateActivityGroupDocument, variables, headers);
export const BatchActivityGroupsDocument = `
    mutation batchActivityGroups($batchItems: [ActivityGroupArguments!]!) {
  batchActivityGroups(batchItems: $batchItems) {
    success
    errors
  }
}
    `;
export const useBatchActivityGroupsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchActivityGroupsMutation, TError, BatchActivityGroupsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchActivityGroupsMutation, TError, BatchActivityGroupsMutationVariables, TContext>(
      ['batchActivityGroups'],
      (variables?: BatchActivityGroupsMutationVariables) => fetcher<BatchActivityGroupsMutation, BatchActivityGroupsMutationVariables>(client, BatchActivityGroupsDocument, variables, headers)(),
      options
    );
useBatchActivityGroupsMutation.fetcher = (client: GraphQLClient, variables: BatchActivityGroupsMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchActivityGroupsMutation, BatchActivityGroupsMutationVariables>(client, BatchActivityGroupsDocument, variables, headers);
export const CreateAssignmentTemplateDocument = `
    mutation createAssignmentTemplate($originalAssignmentId: ID!, $title: String!, $visibleTo: Visibility, $copyableBy: Visibility, $maxPoints: Int) {
  createAssignmentTemplate(
    originalAssignmentId: $originalAssignmentId
    title: $title
    visibleTo: $visibleTo
    copyableBy: $copyableBy
    maxPoints: $maxPoints
  ) {
    assignmentTemplate {
      id
      title
    }
    errors
    success
  }
}
    `;
export const useCreateAssignmentTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAssignmentTemplateMutation, TError, CreateAssignmentTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAssignmentTemplateMutation, TError, CreateAssignmentTemplateMutationVariables, TContext>(
      ['createAssignmentTemplate'],
      (variables?: CreateAssignmentTemplateMutationVariables) => fetcher<CreateAssignmentTemplateMutation, CreateAssignmentTemplateMutationVariables>(client, CreateAssignmentTemplateDocument, variables, headers)(),
      options
    );
useCreateAssignmentTemplateMutation.fetcher = (client: GraphQLClient, variables: CreateAssignmentTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateAssignmentTemplateMutation, CreateAssignmentTemplateMutationVariables>(client, CreateAssignmentTemplateDocument, variables, headers);
export const CreateQuizTemplateDocument = `
    mutation createQuizTemplate($originalQuizId: ID, $title: String!, $visibleTo: Visibility, $copyableBy: Visibility) {
  createQuizTemplate(
    originalQuizId: $originalQuizId
    title: $title
    visibleTo: $visibleTo
    copyableBy: $copyableBy
  ) {
    quizTemplate {
      id
      title
    }
    errors
    success
  }
}
    `;
export const useCreateQuizTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateQuizTemplateMutation, TError, CreateQuizTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateQuizTemplateMutation, TError, CreateQuizTemplateMutationVariables, TContext>(
      ['createQuizTemplate'],
      (variables?: CreateQuizTemplateMutationVariables) => fetcher<CreateQuizTemplateMutation, CreateQuizTemplateMutationVariables>(client, CreateQuizTemplateDocument, variables, headers)(),
      options
    );
useCreateQuizTemplateMutation.fetcher = (client: GraphQLClient, variables: CreateQuizTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateQuizTemplateMutation, CreateQuizTemplateMutationVariables>(client, CreateQuizTemplateDocument, variables, headers);
export const UseAssignmentTemplateDocument = `
    mutation useAssignmentTemplate($id: Int!, $unitId: ID!) {
  useAssignmentTemplate(id: $id, unitId: $unitId) {
    activity {
      id
      item {
        title
        id
      }
    }
    errors
    success
  }
}
    `;
export const useUseAssignmentTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UseAssignmentTemplateMutation, TError, UseAssignmentTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UseAssignmentTemplateMutation, TError, UseAssignmentTemplateMutationVariables, TContext>(
      ['useAssignmentTemplate'],
      (variables?: UseAssignmentTemplateMutationVariables) => fetcher<UseAssignmentTemplateMutation, UseAssignmentTemplateMutationVariables>(client, UseAssignmentTemplateDocument, variables, headers)(),
      options
    );
useUseAssignmentTemplateMutation.fetcher = (client: GraphQLClient, variables: UseAssignmentTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<UseAssignmentTemplateMutation, UseAssignmentTemplateMutationVariables>(client, UseAssignmentTemplateDocument, variables, headers);
export const UseQuizTemplateDocument = `
    mutation useQuizTemplate($id: Int!, $unitId: ID!) {
  useQuizTemplate(id: $id, unitId: $unitId) {
    activity {
      id
      item {
        title
        id
      }
    }
    errors
    success
  }
}
    `;
export const useUseQuizTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UseQuizTemplateMutation, TError, UseQuizTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UseQuizTemplateMutation, TError, UseQuizTemplateMutationVariables, TContext>(
      ['useQuizTemplate'],
      (variables?: UseQuizTemplateMutationVariables) => fetcher<UseQuizTemplateMutation, UseQuizTemplateMutationVariables>(client, UseQuizTemplateDocument, variables, headers)(),
      options
    );
useUseQuizTemplateMutation.fetcher = (client: GraphQLClient, variables: UseQuizTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<UseQuizTemplateMutation, UseQuizTemplateMutationVariables>(client, UseQuizTemplateDocument, variables, headers);
export const DeleteAssignmentTemplateDocument = `
    mutation deleteAssignmentTemplate($id: Int!) {
  deleteAssignmentTemplate(id: $id) {
    errors
    success
  }
}
    `;
export const useDeleteAssignmentTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAssignmentTemplateMutation, TError, DeleteAssignmentTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteAssignmentTemplateMutation, TError, DeleteAssignmentTemplateMutationVariables, TContext>(
      ['deleteAssignmentTemplate'],
      (variables?: DeleteAssignmentTemplateMutationVariables) => fetcher<DeleteAssignmentTemplateMutation, DeleteAssignmentTemplateMutationVariables>(client, DeleteAssignmentTemplateDocument, variables, headers)(),
      options
    );
useDeleteAssignmentTemplateMutation.fetcher = (client: GraphQLClient, variables: DeleteAssignmentTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteAssignmentTemplateMutation, DeleteAssignmentTemplateMutationVariables>(client, DeleteAssignmentTemplateDocument, variables, headers);
export const DeleteQuizTemplateDocument = `
    mutation deleteQuizTemplate($id: Int!) {
  deleteQuizTemplate(id: $id) {
    errors
    success
  }
}
    `;
export const useDeleteQuizTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteQuizTemplateMutation, TError, DeleteQuizTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteQuizTemplateMutation, TError, DeleteQuizTemplateMutationVariables, TContext>(
      ['deleteQuizTemplate'],
      (variables?: DeleteQuizTemplateMutationVariables) => fetcher<DeleteQuizTemplateMutation, DeleteQuizTemplateMutationVariables>(client, DeleteQuizTemplateDocument, variables, headers)(),
      options
    );
useDeleteQuizTemplateMutation.fetcher = (client: GraphQLClient, variables: DeleteQuizTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteQuizTemplateMutation, DeleteQuizTemplateMutationVariables>(client, DeleteQuizTemplateDocument, variables, headers);
export const CreateEventDocument = `
    mutation createEvent($title: String!, $details: String, $url: String, $date: ISO8601Date!, $timeStart: ISO8601DateTime, $timeEnd: ISO8601DateTime, $courseId: ID, $calendarId: ID) {
  createEvent(
    title: $title
    details: $details
    url: $url
    date: $date
    timeStart: $timeStart
    timeEnd: $timeEnd
    courseId: $courseId
    calendarId: $calendarId
  ) {
    event {
      calendar {
        id
      }
      id
      title
      course {
        id
      }
      date
      timeStart
      timeEnd
      url
      details
      createdBy {
        id
        fullName
        initials
        calendarColor
      }
    }
    success
    errors
  }
}
    `;
export const useCreateEventMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateEventMutation, TError, CreateEventMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateEventMutation, TError, CreateEventMutationVariables, TContext>(
      ['createEvent'],
      (variables?: CreateEventMutationVariables) => fetcher<CreateEventMutation, CreateEventMutationVariables>(client, CreateEventDocument, variables, headers)(),
      options
    );
useCreateEventMutation.fetcher = (client: GraphQLClient, variables: CreateEventMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateEventMutation, CreateEventMutationVariables>(client, CreateEventDocument, variables, headers);
export const UpdateEventDocument = `
    mutation updateEvent($id: ID!, $title: String!, $details: String, $url: String, $date: ISO8601Date!, $timeStart: ISO8601DateTime, $timeEnd: ISO8601DateTime, $courseId: ID, $calendarId: ID) {
  updateEvent(
    id: $id
    title: $title
    details: $details
    url: $url
    date: $date
    timeStart: $timeStart
    timeEnd: $timeEnd
    courseId: $courseId
    calendarId: $calendarId
  ) {
    event {
      calendar {
        id
      }
      id
      title
      course {
        id
      }
      date
      timeStart
      timeEnd
      url
      details
      createdBy {
        id
        fullName
        initials
        calendarColor
      }
    }
    success
    errors
  }
}
    `;
export const useUpdateEventMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateEventMutation, TError, UpdateEventMutationVariables, TContext>(
      ['updateEvent'],
      (variables?: UpdateEventMutationVariables) => fetcher<UpdateEventMutation, UpdateEventMutationVariables>(client, UpdateEventDocument, variables, headers)(),
      options
    );
useUpdateEventMutation.fetcher = (client: GraphQLClient, variables: UpdateEventMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateEventMutation, UpdateEventMutationVariables>(client, UpdateEventDocument, variables, headers);
export const DeleteEventDocument = `
    mutation deleteEvent($id: ID!, $chain: Boolean) {
  deleteEvent(id: $id, chain: $chain) {
    success
    errors
  }
}
    `;
export const useDeleteEventMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteEventMutation, TError, DeleteEventMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteEventMutation, TError, DeleteEventMutationVariables, TContext>(
      ['deleteEvent'],
      (variables?: DeleteEventMutationVariables) => fetcher<DeleteEventMutation, DeleteEventMutationVariables>(client, DeleteEventDocument, variables, headers)(),
      options
    );
useDeleteEventMutation.fetcher = (client: GraphQLClient, variables: DeleteEventMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteEventMutation, DeleteEventMutationVariables>(client, DeleteEventDocument, variables, headers);
export const CreateCommentDocument = `
    mutation CreateComment($objectId: ID!, $objectType: CommentableObject!, $content: String!, $fileEntryId: ID) {
  createComment(
    objectId: $objectId
    objectType: $objectType
    content: $content
    fileEntryId: $fileEntryId
  ) {
    comment {
      ...CommentFragment
    }
  }
}
    ${CommentFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useCreateCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCommentMutation, TError, CreateCommentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCommentMutation, TError, CreateCommentMutationVariables, TContext>(
      ['CreateComment'],
      (variables?: CreateCommentMutationVariables) => fetcher<CreateCommentMutation, CreateCommentMutationVariables>(client, CreateCommentDocument, variables, headers)(),
      options
    );
useCreateCommentMutation.fetcher = (client: GraphQLClient, variables: CreateCommentMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateCommentMutation, CreateCommentMutationVariables>(client, CreateCommentDocument, variables, headers);
export const ToggleReadCommentDocument = `
    mutation ToggleReadComment($commentId: ID!) {
  toggleReadComment(id: $commentId) {
    success
    errors
  }
}
    `;
export const useToggleReadCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ToggleReadCommentMutation, TError, ToggleReadCommentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ToggleReadCommentMutation, TError, ToggleReadCommentMutationVariables, TContext>(
      ['ToggleReadComment'],
      (variables?: ToggleReadCommentMutationVariables) => fetcher<ToggleReadCommentMutation, ToggleReadCommentMutationVariables>(client, ToggleReadCommentDocument, variables, headers)(),
      options
    );
useToggleReadCommentMutation.fetcher = (client: GraphQLClient, variables: ToggleReadCommentMutationVariables, headers?: RequestInit['headers']) => fetcher<ToggleReadCommentMutation, ToggleReadCommentMutationVariables>(client, ToggleReadCommentDocument, variables, headers);
export const MarkReadAllCommentsDocument = `
    mutation MarkReadAllComments($ids: [ID!]!) {
  markReadAllComments(ids: $ids) {
    success
    errors
  }
}
    `;
export const useMarkReadAllCommentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkReadAllCommentsMutation, TError, MarkReadAllCommentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkReadAllCommentsMutation, TError, MarkReadAllCommentsMutationVariables, TContext>(
      ['MarkReadAllComments'],
      (variables?: MarkReadAllCommentsMutationVariables) => fetcher<MarkReadAllCommentsMutation, MarkReadAllCommentsMutationVariables>(client, MarkReadAllCommentsDocument, variables, headers)(),
      options
    );
useMarkReadAllCommentsMutation.fetcher = (client: GraphQLClient, variables: MarkReadAllCommentsMutationVariables, headers?: RequestInit['headers']) => fetcher<MarkReadAllCommentsMutation, MarkReadAllCommentsMutationVariables>(client, MarkReadAllCommentsDocument, variables, headers);
export const CreateConversationDocument = `
    mutation createConversation($participatingUserIds: [ID!], $participatingCourses: [ConversationParticipatingCourseAttributes!], $title: String, $iconFileEntryId: ID, $message: String, $messageSubject: String) {
  createConversation(
    participatingUserIds: $participatingUserIds
    participatingCourses: $participatingCourses
    title: $title
    iconFileEntryId: $iconFileEntryId
    message: $message
    messageSubject: $messageSubject
  ) {
    conversation {
      id
      title
      leftParticipants {
        id
        fullName
        calendarColor
        initials
        accountRole {
          id
          name
          roleType
        }
        imageFileEntry {
          url
        }
      }
      participatingCourseMemberGroups {
        course {
          id
          title
        }
      }
      owner {
        id
        fullName
        calendarColor
        initials
        accountRole {
          id
          name
          roleType
        }
        imageFileEntry {
          url
        }
      }
      createdAt
    }
  }
}
    `;
export const useCreateConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateConversationMutation, TError, CreateConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateConversationMutation, TError, CreateConversationMutationVariables, TContext>(
      ['createConversation'],
      (variables?: CreateConversationMutationVariables) => fetcher<CreateConversationMutation, CreateConversationMutationVariables>(client, CreateConversationDocument, variables, headers)(),
      options
    );
useCreateConversationMutation.fetcher = (client: GraphQLClient, variables?: CreateConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateConversationMutation, CreateConversationMutationVariables>(client, CreateConversationDocument, variables, headers);
export const HideConversationDocument = `
    mutation hideConversation($id: ID!) {
  hideConversation(id: $id) {
    success
    errors
  }
}
    `;
export const useHideConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<HideConversationMutation, TError, HideConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<HideConversationMutation, TError, HideConversationMutationVariables, TContext>(
      ['hideConversation'],
      (variables?: HideConversationMutationVariables) => fetcher<HideConversationMutation, HideConversationMutationVariables>(client, HideConversationDocument, variables, headers)(),
      options
    );
useHideConversationMutation.fetcher = (client: GraphQLClient, variables: HideConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<HideConversationMutation, HideConversationMutationVariables>(client, HideConversationDocument, variables, headers);
export const LeaveConversationDocument = `
    mutation leaveConversation($id: ID!) {
  leaveConversation(id: $id) {
    success
    errors
  }
}
    `;
export const useLeaveConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LeaveConversationMutation, TError, LeaveConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LeaveConversationMutation, TError, LeaveConversationMutationVariables, TContext>(
      ['leaveConversation'],
      (variables?: LeaveConversationMutationVariables) => fetcher<LeaveConversationMutation, LeaveConversationMutationVariables>(client, LeaveConversationDocument, variables, headers)(),
      options
    );
useLeaveConversationMutation.fetcher = (client: GraphQLClient, variables: LeaveConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<LeaveConversationMutation, LeaveConversationMutationVariables>(client, LeaveConversationDocument, variables, headers);
export const ToggleMuteConversationDocument = `
    mutation toggleMuteConversation($id: ID!) {
  toggleMuteConversation(id: $id) {
    success
    errors
    conversation {
      id
      isMuted
    }
  }
}
    `;
export const useToggleMuteConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ToggleMuteConversationMutation, TError, ToggleMuteConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ToggleMuteConversationMutation, TError, ToggleMuteConversationMutationVariables, TContext>(
      ['toggleMuteConversation'],
      (variables?: ToggleMuteConversationMutationVariables) => fetcher<ToggleMuteConversationMutation, ToggleMuteConversationMutationVariables>(client, ToggleMuteConversationDocument, variables, headers)(),
      options
    );
useToggleMuteConversationMutation.fetcher = (client: GraphQLClient, variables: ToggleMuteConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<ToggleMuteConversationMutation, ToggleMuteConversationMutationVariables>(client, ToggleMuteConversationDocument, variables, headers);
export const ToggleViewConversationDocument = `
    mutation toggleViewConversation($id: ID!) {
  toggleViewConversation(id: $id) {
    success
    errors
    conversation {
      id
      isMuted
    }
  }
}
    `;
export const useToggleViewConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ToggleViewConversationMutation, TError, ToggleViewConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ToggleViewConversationMutation, TError, ToggleViewConversationMutationVariables, TContext>(
      ['toggleViewConversation'],
      (variables?: ToggleViewConversationMutationVariables) => fetcher<ToggleViewConversationMutation, ToggleViewConversationMutationVariables>(client, ToggleViewConversationDocument, variables, headers)(),
      options
    );
useToggleViewConversationMutation.fetcher = (client: GraphQLClient, variables: ToggleViewConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<ToggleViewConversationMutation, ToggleViewConversationMutationVariables>(client, ToggleViewConversationDocument, variables, headers);
export const ReopenConversationDocument = `
    mutation reopenConversation($id: ID!) {
  reopenConversation(id: $id) {
    success
    errors
  }
}
    `;
export const useReopenConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReopenConversationMutation, TError, ReopenConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReopenConversationMutation, TError, ReopenConversationMutationVariables, TContext>(
      ['reopenConversation'],
      (variables?: ReopenConversationMutationVariables) => fetcher<ReopenConversationMutation, ReopenConversationMutationVariables>(client, ReopenConversationDocument, variables, headers)(),
      options
    );
useReopenConversationMutation.fetcher = (client: GraphQLClient, variables: ReopenConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<ReopenConversationMutation, ReopenConversationMutationVariables>(client, ReopenConversationDocument, variables, headers);
export const CreateConversationMessageDocument = `
    mutation createConversationMessage($conversationId: ID!, $content: String, $fileEntryId: ID, $subject: String) {
  createMessage(
    conversationId: $conversationId
    content: $content
    fileEntryId: $fileEntryId
    subject: $subject
  ) {
    success
    errors
    message {
      ...ConversationMessageFragment
    }
  }
}
    ${ConversationMessageFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useCreateConversationMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateConversationMessageMutation, TError, CreateConversationMessageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateConversationMessageMutation, TError, CreateConversationMessageMutationVariables, TContext>(
      ['createConversationMessage'],
      (variables?: CreateConversationMessageMutationVariables) => fetcher<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>(client, CreateConversationMessageDocument, variables, headers)(),
      options
    );
useCreateConversationMessageMutation.fetcher = (client: GraphQLClient, variables: CreateConversationMessageMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>(client, CreateConversationMessageDocument, variables, headers);
export const DeleteConversationMessageDocument = `
    mutation deleteConversationMessage($id: ID!) {
  deleteMessage(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteConversationMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteConversationMessageMutation, TError, DeleteConversationMessageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteConversationMessageMutation, TError, DeleteConversationMessageMutationVariables, TContext>(
      ['deleteConversationMessage'],
      (variables?: DeleteConversationMessageMutationVariables) => fetcher<DeleteConversationMessageMutation, DeleteConversationMessageMutationVariables>(client, DeleteConversationMessageDocument, variables, headers)(),
      options
    );
useDeleteConversationMessageMutation.fetcher = (client: GraphQLClient, variables: DeleteConversationMessageMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteConversationMessageMutation, DeleteConversationMessageMutationVariables>(client, DeleteConversationMessageDocument, variables, headers);
export const UpdateConversationDocument = `
    mutation updateConversation($id: ID!, $participatingUserIds: [ID!], $participatingCourses: [ConversationParticipatingCourseAttributes!], $title: String, $iconFileEntryId: ID) {
  updateConversation(
    id: $id
    participatingUserIds: $participatingUserIds
    participatingCourses: $participatingCourses
    title: $title
    iconFileEntryId: $iconFileEntryId
  ) {
    conversation {
      id
      title
      leftParticipants {
        id
        fullName
        calendarColor
        initials
        accountRole {
          id
          name
          roleType
        }
        imageFileEntry {
          url
        }
      }
      participatingCourseMemberGroups {
        course {
          id
          title
        }
      }
      participants {
        id
        fullName
        calendarColor
      }
      owner {
        id
        fullName
        calendarColor
        initials
        accountRole {
          id
          name
          roleType
        }
        imageFileEntry {
          url
        }
      }
      createdAt
    }
  }
}
    `;
export const useUpdateConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateConversationMutation, TError, UpdateConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateConversationMutation, TError, UpdateConversationMutationVariables, TContext>(
      ['updateConversation'],
      (variables?: UpdateConversationMutationVariables) => fetcher<UpdateConversationMutation, UpdateConversationMutationVariables>(client, UpdateConversationDocument, variables, headers)(),
      options
    );
useUpdateConversationMutation.fetcher = (client: GraphQLClient, variables: UpdateConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateConversationMutation, UpdateConversationMutationVariables>(client, UpdateConversationDocument, variables, headers);
export const CreateCourseDocument = `
    mutation createCourse($title: String!, $graded: Boolean, $iconColor: String) {
  createCourse(title: $title, graded: $graded, iconColor: $iconColor) {
    course {
      id
      description
      iconColor
      title
      uid
      welcome
      welcomeMediaType
      published
      graded
      courseCredits
    }
    success
    errors
  }
}
    `;
export const useCreateCourseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCourseMutation, TError, CreateCourseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCourseMutation, TError, CreateCourseMutationVariables, TContext>(
      ['createCourse'],
      (variables?: CreateCourseMutationVariables) => fetcher<CreateCourseMutation, CreateCourseMutationVariables>(client, CreateCourseDocument, variables, headers)(),
      options
    );
useCreateCourseMutation.fetcher = (client: GraphQLClient, variables: CreateCourseMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateCourseMutation, CreateCourseMutationVariables>(client, CreateCourseDocument, variables, headers);
export const UpdateCourseDocument = `
    mutation updateCourse($id: ID!, $title: String, $gradingSchemeId: ID, $iconColor: String, $description: String, $graded: Boolean, $timeZone: String, $published: Boolean, $courseCredits: Float, $scheduledDaysOff: [ISO8601Date!], $scheduledWeekdays: [DayOfWeek!], $startDate: ISO8601Date, $schedulingMode: CourseSchedulingMode, $gradeLevels: [String!], $subjects: [String!], $curriculum: [String!], $welcome: String, $thumbnailFileEntryId: ID, $videoFileEntryId: ID, $imageFileEntryId: ID, $inviteCode: String, $autoRegenerateInviteCode: Boolean, $inviteCodeExpiresAt: ISO8601DateTime, $requireJoinConfirmation: Boolean, $welcomeMediaType: CourseWelcomeMedia, $defaultCourseTermId: ID) {
  updateCourse(
    id: $id
    title: $title
    gradingSchemeId: $gradingSchemeId
    iconColor: $iconColor
    description: $description
    graded: $graded
    timeZone: $timeZone
    published: $published
    courseCredits: $courseCredits
    scheduledDaysOff: $scheduledDaysOff
    scheduledWeekdays: $scheduledWeekdays
    startDate: $startDate
    schedulingMode: $schedulingMode
    gradeLevels: $gradeLevels
    subjects: $subjects
    curriculum: $curriculum
    welcome: $welcome
    thumbnailFileEntryId: $thumbnailFileEntryId
    videoFileEntryId: $videoFileEntryId
    imageFileEntryId: $imageFileEntryId
    inviteCode: $inviteCode
    autoRegenerateInviteCode: $autoRegenerateInviteCode
    inviteCodeExpiresAt: $inviteCodeExpiresAt
    requireJoinConfirmation: $requireJoinConfirmation
    welcomeMediaType: $welcomeMediaType
    defaultCourseTermId: $defaultCourseTermId
  ) {
    course {
      id
      description
      iconColor
      title
      uid
      published
      welcome
      welcomeMediaType
      published
      graded
      timeZone
      courseCredits
      scheduledDaysOff
      scheduledWeekdays
      schedulingMode
      inviteCode
      autoRegenerateInviteCode
      inviteCodeExpiresAt
      requireJoinConfirmation
      startDate
      videoFileEntry {
        ...FileEntryDefault
      }
      imageFileEntry {
        ...FileEntryDefault
      }
      thumbnailFileEntry {
        ...FileEntryDefault
      }
    }
    success
    errors
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useUpdateCourseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCourseMutation, TError, UpdateCourseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCourseMutation, TError, UpdateCourseMutationVariables, TContext>(
      ['updateCourse'],
      (variables?: UpdateCourseMutationVariables) => fetcher<UpdateCourseMutation, UpdateCourseMutationVariables>(client, UpdateCourseDocument, variables, headers)(),
      options
    );
useUpdateCourseMutation.fetcher = (client: GraphQLClient, variables: UpdateCourseMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateCourseMutation, UpdateCourseMutationVariables>(client, UpdateCourseDocument, variables, headers);
export const DeleteCourseDocument = `
    mutation deleteCourse($id: ID!) {
  deleteCourse(id: $id) {
    errors
    success
  }
}
    `;
export const useDeleteCourseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCourseMutation, TError, DeleteCourseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCourseMutation, TError, DeleteCourseMutationVariables, TContext>(
      ['deleteCourse'],
      (variables?: DeleteCourseMutationVariables) => fetcher<DeleteCourseMutation, DeleteCourseMutationVariables>(client, DeleteCourseDocument, variables, headers)(),
      options
    );
useDeleteCourseMutation.fetcher = (client: GraphQLClient, variables: DeleteCourseMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteCourseMutation, DeleteCourseMutationVariables>(client, DeleteCourseDocument, variables, headers);
export const CreateCourseRoleDocument = `
    mutation createCourseRole($name: String!, $courseId: ID!) {
  createCourseRole(name: $name, courseId: $courseId) {
    courseRole {
      id
      name
      permissions
      fixed
      type
      enrollments {
        id
        user {
          id
          fullName
          calendarColor
          initials
        }
      }
    }
    success
    errors
  }
}
    `;
export const useCreateCourseRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCourseRoleMutation, TError, CreateCourseRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCourseRoleMutation, TError, CreateCourseRoleMutationVariables, TContext>(
      ['createCourseRole'],
      (variables?: CreateCourseRoleMutationVariables) => fetcher<CreateCourseRoleMutation, CreateCourseRoleMutationVariables>(client, CreateCourseRoleDocument, variables, headers)(),
      options
    );
useCreateCourseRoleMutation.fetcher = (client: GraphQLClient, variables: CreateCourseRoleMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateCourseRoleMutation, CreateCourseRoleMutationVariables>(client, CreateCourseRoleDocument, variables, headers);
export const UpdateCourseRoleDocument = `
    mutation updateCourseRole($id: ID!, $name: String, $permissions: [String!]) {
  updateCourseRole(id: $id, name: $name, permissions: $permissions) {
    courseRole {
      id
      name
      permissions
      fixed
      type
      enrollments {
        id
        user {
          id
          fullName
          calendarColor
          initials
        }
      }
    }
    success
    errors
  }
}
    `;
export const useUpdateCourseRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCourseRoleMutation, TError, UpdateCourseRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCourseRoleMutation, TError, UpdateCourseRoleMutationVariables, TContext>(
      ['updateCourseRole'],
      (variables?: UpdateCourseRoleMutationVariables) => fetcher<UpdateCourseRoleMutation, UpdateCourseRoleMutationVariables>(client, UpdateCourseRoleDocument, variables, headers)(),
      options
    );
useUpdateCourseRoleMutation.fetcher = (client: GraphQLClient, variables: UpdateCourseRoleMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateCourseRoleMutation, UpdateCourseRoleMutationVariables>(client, UpdateCourseRoleDocument, variables, headers);
export const DeleteCourseRoleDocument = `
    mutation deleteCourseRole($id: ID!) {
  deleteCourseRole(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteCourseRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCourseRoleMutation, TError, DeleteCourseRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCourseRoleMutation, TError, DeleteCourseRoleMutationVariables, TContext>(
      ['deleteCourseRole'],
      (variables?: DeleteCourseRoleMutationVariables) => fetcher<DeleteCourseRoleMutation, DeleteCourseRoleMutationVariables>(client, DeleteCourseRoleDocument, variables, headers)(),
      options
    );
useDeleteCourseRoleMutation.fetcher = (client: GraphQLClient, variables: DeleteCourseRoleMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteCourseRoleMutation, DeleteCourseRoleMutationVariables>(client, DeleteCourseRoleDocument, variables, headers);
export const CreateUnitDocument = `
    mutation createUnit($courseId: ID!, $title: String!, $courseTermId: ID) {
  createUnit(courseId: $courseId, title: $title, courseTermId: $courseTermId) {
    success
    errors
    unit {
      id
      title
    }
  }
}
    `;
export const useCreateUnitMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateUnitMutation, TError, CreateUnitMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateUnitMutation, TError, CreateUnitMutationVariables, TContext>(
      ['createUnit'],
      (variables?: CreateUnitMutationVariables) => fetcher<CreateUnitMutation, CreateUnitMutationVariables>(client, CreateUnitDocument, variables, headers)(),
      options
    );
useCreateUnitMutation.fetcher = (client: GraphQLClient, variables: CreateUnitMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateUnitMutation, CreateUnitMutationVariables>(client, CreateUnitDocument, variables, headers);
export const BatchCreateUnitsDocument = `
    mutation batchCreateUnits($batchItems: [UnitArguments!]!) {
  batchCreateUnits(batchItems: $batchItems) {
    success
    errors
  }
}
    `;
export const useBatchCreateUnitsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchCreateUnitsMutation, TError, BatchCreateUnitsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchCreateUnitsMutation, TError, BatchCreateUnitsMutationVariables, TContext>(
      ['batchCreateUnits'],
      (variables?: BatchCreateUnitsMutationVariables) => fetcher<BatchCreateUnitsMutation, BatchCreateUnitsMutationVariables>(client, BatchCreateUnitsDocument, variables, headers)(),
      options
    );
useBatchCreateUnitsMutation.fetcher = (client: GraphQLClient, variables: BatchCreateUnitsMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchCreateUnitsMutation, BatchCreateUnitsMutationVariables>(client, BatchCreateUnitsDocument, variables, headers);
export const DeleteUnitDocument = `
    mutation deleteUnit($id: ID!) {
  deleteUnit(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteUnitMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteUnitMutation, TError, DeleteUnitMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteUnitMutation, TError, DeleteUnitMutationVariables, TContext>(
      ['deleteUnit'],
      (variables?: DeleteUnitMutationVariables) => fetcher<DeleteUnitMutation, DeleteUnitMutationVariables>(client, DeleteUnitDocument, variables, headers)(),
      options
    );
useDeleteUnitMutation.fetcher = (client: GraphQLClient, variables: DeleteUnitMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteUnitMutation, DeleteUnitMutationVariables>(client, DeleteUnitDocument, variables, headers);
export const UpdateUnitDocument = `
    mutation updateUnit($id: ID!, $title: String!, $description: String, $courseTermId: ID, $visible: Boolean, $imageFileEntryId: ID, $backgroundFileEntryId: ID) {
  updateUnit(
    id: $id
    title: $title
    description: $description
    courseTermId: $courseTermId
    visible: $visible
    imageFileEntryId: $imageFileEntryId
    backgroundFileEntryId: $backgroundFileEntryId
  ) {
    success
    errors
    unit {
      id
      title
      visible
      description
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
    }
  }
}
    `;
export const useUpdateUnitMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUnitMutation, TError, UpdateUnitMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateUnitMutation, TError, UpdateUnitMutationVariables, TContext>(
      ['updateUnit'],
      (variables?: UpdateUnitMutationVariables) => fetcher<UpdateUnitMutation, UpdateUnitMutationVariables>(client, UpdateUnitDocument, variables, headers)(),
      options
    );
useUpdateUnitMutation.fetcher = (client: GraphQLClient, variables: UpdateUnitMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateUnitMutation, UpdateUnitMutationVariables>(client, UpdateUnitDocument, variables, headers);
export const BatchUnitsDocument = `
    mutation batchUnits($batchItems: [UnitArguments!]!) {
  batchUnits(batchItems: $batchItems) {
    success
    errors
  }
}
    `;
export const useBatchUnitsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchUnitsMutation, TError, BatchUnitsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchUnitsMutation, TError, BatchUnitsMutationVariables, TContext>(
      ['batchUnits'],
      (variables?: BatchUnitsMutationVariables) => fetcher<BatchUnitsMutation, BatchUnitsMutationVariables>(client, BatchUnitsDocument, variables, headers)(),
      options
    );
useBatchUnitsMutation.fetcher = (client: GraphQLClient, variables: BatchUnitsMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchUnitsMutation, BatchUnitsMutationVariables>(client, BatchUnitsDocument, variables, headers);
export const CreateCourseTermDocument = `
    mutation createCourseTerm($courseId: ID!, $title: String!, $weight: Int, $published: Boolean, $unitIds: [ID!]) {
  createCourseTerm(
    courseId: $courseId
    title: $title
    weight: $weight
    published: $published
    unitIds: $unitIds
  ) {
    success
    errors
    courseTerm {
      id
      title
      weight
      units {
        id
        title
      }
      published
      publishable
    }
  }
}
    `;
export const useCreateCourseTermMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCourseTermMutation, TError, CreateCourseTermMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCourseTermMutation, TError, CreateCourseTermMutationVariables, TContext>(
      ['createCourseTerm'],
      (variables?: CreateCourseTermMutationVariables) => fetcher<CreateCourseTermMutation, CreateCourseTermMutationVariables>(client, CreateCourseTermDocument, variables, headers)(),
      options
    );
useCreateCourseTermMutation.fetcher = (client: GraphQLClient, variables: CreateCourseTermMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateCourseTermMutation, CreateCourseTermMutationVariables>(client, CreateCourseTermDocument, variables, headers);
export const UpdateCourseTermDocument = `
    mutation updateCourseTerm($id: ID!, $title: String!, $weight: Int, $published: Boolean, $unitIds: [ID!]) {
  updateCourseTerm(
    id: $id
    title: $title
    weight: $weight
    published: $published
    unitIds: $unitIds
  ) {
    success
    errors
  }
}
    `;
export const useUpdateCourseTermMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCourseTermMutation, TError, UpdateCourseTermMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCourseTermMutation, TError, UpdateCourseTermMutationVariables, TContext>(
      ['updateCourseTerm'],
      (variables?: UpdateCourseTermMutationVariables) => fetcher<UpdateCourseTermMutation, UpdateCourseTermMutationVariables>(client, UpdateCourseTermDocument, variables, headers)(),
      options
    );
useUpdateCourseTermMutation.fetcher = (client: GraphQLClient, variables: UpdateCourseTermMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateCourseTermMutation, UpdateCourseTermMutationVariables>(client, UpdateCourseTermDocument, variables, headers);
export const BatchCourseTermsDocument = `
    mutation batchCourseTerms($batchItems: [CourseTermArguments!]!) {
  batchCourseTerms(batchItems: $batchItems) {
    success
    errors
    courseTerms {
      accessible
      id
      published
      title
      weight
      publishable
      forGradebook
      units {
        id
        title
      }
    }
  }
}
    `;
export const useBatchCourseTermsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchCourseTermsMutation, TError, BatchCourseTermsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchCourseTermsMutation, TError, BatchCourseTermsMutationVariables, TContext>(
      ['batchCourseTerms'],
      (variables?: BatchCourseTermsMutationVariables) => fetcher<BatchCourseTermsMutation, BatchCourseTermsMutationVariables>(client, BatchCourseTermsDocument, variables, headers)(),
      options
    );
useBatchCourseTermsMutation.fetcher = (client: GraphQLClient, variables: BatchCourseTermsMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchCourseTermsMutation, BatchCourseTermsMutationVariables>(client, BatchCourseTermsDocument, variables, headers);
export const DeleteCourseTermDocument = `
    mutation deleteCourseTerm($id: ID!) {
  deleteCourseTerm(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteCourseTermMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCourseTermMutation, TError, DeleteCourseTermMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCourseTermMutation, TError, DeleteCourseTermMutationVariables, TContext>(
      ['deleteCourseTerm'],
      (variables?: DeleteCourseTermMutationVariables) => fetcher<DeleteCourseTermMutation, DeleteCourseTermMutationVariables>(client, DeleteCourseTermDocument, variables, headers)(),
      options
    );
useDeleteCourseTermMutation.fetcher = (client: GraphQLClient, variables: DeleteCourseTermMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteCourseTermMutation, DeleteCourseTermMutationVariables>(client, DeleteCourseTermDocument, variables, headers);
export const BatchCourseMaterialsDocument = `
    mutation batchCourseMaterials($batchItems: [CourseMaterialArguments!]!) {
  batchCourseMaterials(batchItems: $batchItems) {
    success
    errors
    materials {
      id
      description
      title
      url
      published
      position
      fileEntry {
        ...FileEntryDefault
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useBatchCourseMaterialsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchCourseMaterialsMutation, TError, BatchCourseMaterialsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchCourseMaterialsMutation, TError, BatchCourseMaterialsMutationVariables, TContext>(
      ['batchCourseMaterials'],
      (variables?: BatchCourseMaterialsMutationVariables) => fetcher<BatchCourseMaterialsMutation, BatchCourseMaterialsMutationVariables>(client, BatchCourseMaterialsDocument, variables, headers)(),
      options
    );
useBatchCourseMaterialsMutation.fetcher = (client: GraphQLClient, variables: BatchCourseMaterialsMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchCourseMaterialsMutation, BatchCourseMaterialsMutationVariables>(client, BatchCourseMaterialsDocument, variables, headers);
export const ReorderUnitItemsDocument = `
    mutation reorderUnitItems($unitId: ID!, $activityIds: [PolymorphicItemId!]!) {
  reorderUnitItems(unitId: $unitId, activityIds: $activityIds) {
    success
    errors
  }
}
    `;
export const useReorderUnitItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReorderUnitItemsMutation, TError, ReorderUnitItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReorderUnitItemsMutation, TError, ReorderUnitItemsMutationVariables, TContext>(
      ['reorderUnitItems'],
      (variables?: ReorderUnitItemsMutationVariables) => fetcher<ReorderUnitItemsMutation, ReorderUnitItemsMutationVariables>(client, ReorderUnitItemsDocument, variables, headers)(),
      options
    );
useReorderUnitItemsMutation.fetcher = (client: GraphQLClient, variables: ReorderUnitItemsMutationVariables, headers?: RequestInit['headers']) => fetcher<ReorderUnitItemsMutation, ReorderUnitItemsMutationVariables>(client, ReorderUnitItemsDocument, variables, headers);
export const ReorderUnitsDocument = `
    mutation reorderUnits($ids: [ID!]!) {
  reorderUnits(ids: $ids) {
    success
    errors
  }
}
    `;
export const useReorderUnitsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReorderUnitsMutation, TError, ReorderUnitsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReorderUnitsMutation, TError, ReorderUnitsMutationVariables, TContext>(
      ['reorderUnits'],
      (variables?: ReorderUnitsMutationVariables) => fetcher<ReorderUnitsMutation, ReorderUnitsMutationVariables>(client, ReorderUnitsDocument, variables, headers)(),
      options
    );
useReorderUnitsMutation.fetcher = (client: GraphQLClient, variables: ReorderUnitsMutationVariables, headers?: RequestInit['headers']) => fetcher<ReorderUnitsMutation, ReorderUnitsMutationVariables>(client, ReorderUnitsDocument, variables, headers);
export const DuplicateActivityDocument = `
    mutation duplicateActivity($id: ID!) {
  duplicateActivity(id: $id) {
    success
    errors
    activity {
      id
    }
  }
}
    `;
export const useDuplicateActivityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DuplicateActivityMutation, TError, DuplicateActivityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DuplicateActivityMutation, TError, DuplicateActivityMutationVariables, TContext>(
      ['duplicateActivity'],
      (variables?: DuplicateActivityMutationVariables) => fetcher<DuplicateActivityMutation, DuplicateActivityMutationVariables>(client, DuplicateActivityDocument, variables, headers)(),
      options
    );
useDuplicateActivityMutation.fetcher = (client: GraphQLClient, variables: DuplicateActivityMutationVariables, headers?: RequestInit['headers']) => fetcher<DuplicateActivityMutation, DuplicateActivityMutationVariables>(client, DuplicateActivityDocument, variables, headers);
export const DuplicateUnitDocument = `
    mutation duplicateUnit($id: ID!, $title: String) {
  duplicateUnit(id: $id, title: $title) {
    success
    errors
    unit {
      id
    }
  }
}
    `;
export const useDuplicateUnitMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DuplicateUnitMutation, TError, DuplicateUnitMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DuplicateUnitMutation, TError, DuplicateUnitMutationVariables, TContext>(
      ['duplicateUnit'],
      (variables?: DuplicateUnitMutationVariables) => fetcher<DuplicateUnitMutation, DuplicateUnitMutationVariables>(client, DuplicateUnitDocument, variables, headers)(),
      options
    );
useDuplicateUnitMutation.fetcher = (client: GraphQLClient, variables: DuplicateUnitMutationVariables, headers?: RequestInit['headers']) => fetcher<DuplicateUnitMutation, DuplicateUnitMutationVariables>(client, DuplicateUnitDocument, variables, headers);
export const StartUploadSessionDocument = `
    mutation startUploadSession($authorizerItem: PolymorphicItemId!) {
  startUploadSession(authorizerItem: $authorizerItem) {
    errors
    success
    uploadSession {
      expiresAt
      id
      authorizerItem
    }
  }
}
    `;
export const useStartUploadSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartUploadSessionMutation, TError, StartUploadSessionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StartUploadSessionMutation, TError, StartUploadSessionMutationVariables, TContext>(
      ['startUploadSession'],
      (variables?: StartUploadSessionMutationVariables) => fetcher<StartUploadSessionMutation, StartUploadSessionMutationVariables>(client, StartUploadSessionDocument, variables, headers)(),
      options
    );
useStartUploadSessionMutation.fetcher = (client: GraphQLClient, variables: StartUploadSessionMutationVariables, headers?: RequestInit['headers']) => fetcher<StartUploadSessionMutation, StartUploadSessionMutationVariables>(client, StartUploadSessionDocument, variables, headers);
export const GetUploadSessionDocument = `
    query getUploadSession($uploadSessionId: String!) {
  getUploadSession(uploadSessionId: $uploadSessionId) {
    expiresAt
    id
    uploadedFiles {
      createdAt
      croppedUrl
      description
      fileType
      id
      originalFileName
      originalFileSize
      tags
      title
      updatedAt
      url
    }
    authorizerItem
    userId
  }
}
    `;
export const useGetUploadSessionQuery = <
      TData = GetUploadSessionQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUploadSessionQueryVariables,
      options?: UseQueryOptions<GetUploadSessionQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUploadSessionQuery, TError, TData>(
      ['getUploadSession', variables],
      fetcher<GetUploadSessionQuery, GetUploadSessionQueryVariables>(client, GetUploadSessionDocument, variables, headers),
      options
    );
useGetUploadSessionQuery.fetcher = (client: GraphQLClient, variables: GetUploadSessionQueryVariables, headers?: RequestInit['headers']) => fetcher<GetUploadSessionQuery, GetUploadSessionQueryVariables>(client, GetUploadSessionDocument, variables, headers);
export const GenerateCumulativeGradebookUrlDocument = `
    mutation generateCumulativeGradebookUrl($courseId: ID!, $enrollmentIds: [ID!], $courseTermId: ID) {
  generateCumulativeGradebookUrl(
    courseId: $courseId
    enrollmentIds: $enrollmentIds
    type: "cumulative"
    courseTermId: $courseTermId
  ) {
    success
    errors
    url
  }
}
    `;
export const useGenerateCumulativeGradebookUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GenerateCumulativeGradebookUrlMutation, TError, GenerateCumulativeGradebookUrlMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GenerateCumulativeGradebookUrlMutation, TError, GenerateCumulativeGradebookUrlMutationVariables, TContext>(
      ['generateCumulativeGradebookUrl'],
      (variables?: GenerateCumulativeGradebookUrlMutationVariables) => fetcher<GenerateCumulativeGradebookUrlMutation, GenerateCumulativeGradebookUrlMutationVariables>(client, GenerateCumulativeGradebookUrlDocument, variables, headers)(),
      options
    );
useGenerateCumulativeGradebookUrlMutation.fetcher = (client: GraphQLClient, variables: GenerateCumulativeGradebookUrlMutationVariables, headers?: RequestInit['headers']) => fetcher<GenerateCumulativeGradebookUrlMutation, GenerateCumulativeGradebookUrlMutationVariables>(client, GenerateCumulativeGradebookUrlDocument, variables, headers);
export const GenerateGridGradebookUrlDocument = `
    mutation generateGridGradebookUrl($courseId: ID!, $enrollmentIds: [ID!], $courseTermId: ID) {
  generateCumulativeGradebookUrl(
    courseId: $courseId
    enrollmentIds: $enrollmentIds
    type: "grid"
    courseTermId: $courseTermId
  ) {
    success
    errors
    url
  }
}
    `;
export const useGenerateGridGradebookUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GenerateGridGradebookUrlMutation, TError, GenerateGridGradebookUrlMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GenerateGridGradebookUrlMutation, TError, GenerateGridGradebookUrlMutationVariables, TContext>(
      ['generateGridGradebookUrl'],
      (variables?: GenerateGridGradebookUrlMutationVariables) => fetcher<GenerateGridGradebookUrlMutation, GenerateGridGradebookUrlMutationVariables>(client, GenerateGridGradebookUrlDocument, variables, headers)(),
      options
    );
useGenerateGridGradebookUrlMutation.fetcher = (client: GraphQLClient, variables: GenerateGridGradebookUrlMutationVariables, headers?: RequestInit['headers']) => fetcher<GenerateGridGradebookUrlMutation, GenerateGridGradebookUrlMutationVariables>(client, GenerateGridGradebookUrlDocument, variables, headers);
export const CreateCourseTemplateDocument = `
    mutation createCourseTemplate($courseId: ID!, $title: String!, $description: String, $visibleTo: Visibility, $copyableBy: Visibility, $keepDates: Boolean!, $keepRoles: Boolean!, $gradeLevels: [String!], $subjects: [String!], $curriculum: [String!], $courseCredits: Float, $thumbnailFileEntryId: ID) {
  createCourseTemplate(
    originalCourseId: $courseId
    title: $title
    description: $description
    visibleTo: $visibleTo
    copyableBy: $copyableBy
    keepDates: $keepDates
    keepRolesPermissions: $keepRoles
    gradeLevels: $gradeLevels
    subjects: $subjects
    curriculum: $curriculum
    courseCredits: $courseCredits
    thumbnailFileEntryId: $thumbnailFileEntryId
  ) {
    courseTemplate {
      id
      title
      description
      uid
      subjects
      curriculum
      gradeLevels
      tags
      courseCredits
      thumbnailFileEntry {
        id
      }
      imageFileEntry {
        id
      }
      iconColor
      visibleTo
      copyableBy
      originalCourse {
        id
      }
      parentTemplate {
        id
      }
      sourceAttribution {
        id
      }
    }
    errors
    success
  }
}
    `;
export const useCreateCourseTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCourseTemplateMutation, TError, CreateCourseTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCourseTemplateMutation, TError, CreateCourseTemplateMutationVariables, TContext>(
      ['createCourseTemplate'],
      (variables?: CreateCourseTemplateMutationVariables) => fetcher<CreateCourseTemplateMutation, CreateCourseTemplateMutationVariables>(client, CreateCourseTemplateDocument, variables, headers)(),
      options
    );
useCreateCourseTemplateMutation.fetcher = (client: GraphQLClient, variables: CreateCourseTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateCourseTemplateMutation, CreateCourseTemplateMutationVariables>(client, CreateCourseTemplateDocument, variables, headers);
export const DeleteCourseTemplateDocument = `
    mutation deleteCourseTemplate($id: Int!) {
  deleteCourseTemplate(id: $id) {
    errors
    success
  }
}
    `;
export const useDeleteCourseTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCourseTemplateMutation, TError, DeleteCourseTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCourseTemplateMutation, TError, DeleteCourseTemplateMutationVariables, TContext>(
      ['deleteCourseTemplate'],
      (variables?: DeleteCourseTemplateMutationVariables) => fetcher<DeleteCourseTemplateMutation, DeleteCourseTemplateMutationVariables>(client, DeleteCourseTemplateDocument, variables, headers)(),
      options
    );
useDeleteCourseTemplateMutation.fetcher = (client: GraphQLClient, variables: DeleteCourseTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteCourseTemplateMutation, DeleteCourseTemplateMutationVariables>(client, DeleteCourseTemplateDocument, variables, headers);
export const UpdateCourseTemplateDocument = `
    mutation updateCourseTemplate($id: Int!, $title: String!, $description: String) {
  updateCourseTemplate(id: $id, title: $title, description: $description) {
    courseTemplate {
      id
      title
      description
      uid
      subjects
      curriculum
      gradeLevels
      tags
      courseCredits
      thumbnailFileEntry {
        id
      }
      imageFileEntry {
        id
      }
      iconColor
      visibleTo
      copyableBy
      originalCourse {
        id
      }
      parentTemplate {
        id
      }
      sourceAttribution {
        id
      }
    }
    errors
    success
  }
}
    `;
export const useUpdateCourseTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCourseTemplateMutation, TError, UpdateCourseTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCourseTemplateMutation, TError, UpdateCourseTemplateMutationVariables, TContext>(
      ['updateCourseTemplate'],
      (variables?: UpdateCourseTemplateMutationVariables) => fetcher<UpdateCourseTemplateMutation, UpdateCourseTemplateMutationVariables>(client, UpdateCourseTemplateDocument, variables, headers)(),
      options
    );
useUpdateCourseTemplateMutation.fetcher = (client: GraphQLClient, variables: UpdateCourseTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateCourseTemplateMutation, UpdateCourseTemplateMutationVariables>(client, UpdateCourseTemplateDocument, variables, headers);
export const UseCourseTemplateDocument = `
    mutation useCourseTemplate($id: Int!, $keepDates: Boolean!, $title: String!, $graded: Boolean, $startDate: ISO8601Date, $iconColor: String) {
  useCourseTemplate(
    id: $id
    title: $title
    keepDates: $keepDates
    graded: $graded
    startDate: $startDate
    iconColor: $iconColor
  ) {
    course {
      id
      title
    }
    errors
    success
  }
}
    `;
export const useUseCourseTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UseCourseTemplateMutation, TError, UseCourseTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UseCourseTemplateMutation, TError, UseCourseTemplateMutationVariables, TContext>(
      ['useCourseTemplate'],
      (variables?: UseCourseTemplateMutationVariables) => fetcher<UseCourseTemplateMutation, UseCourseTemplateMutationVariables>(client, UseCourseTemplateDocument, variables, headers)(),
      options
    );
useUseCourseTemplateMutation.fetcher = (client: GraphQLClient, variables: UseCourseTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<UseCourseTemplateMutation, UseCourseTemplateMutationVariables>(client, UseCourseTemplateDocument, variables, headers);
export const CreateEnrollmentDocument = `
    mutation createEnrollment($courseId: ID, $inviteCode: ID, $userId: ID, $email: ID, $courseRoleId: ID, $favorite: Boolean) {
  createEnrollment(
    courseId: $courseId
    inviteCode: $inviteCode
    userId: $userId
    email: $email
    courseRoleId: $courseRoleId
    favorite: $favorite
  ) {
    enrollment {
      ...EnrollmentFragment
    }
    success
    errors
  }
}
    ${EnrollmentFragmentFragmentDoc}`;
export const useCreateEnrollmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateEnrollmentMutation, TError, CreateEnrollmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateEnrollmentMutation, TError, CreateEnrollmentMutationVariables, TContext>(
      ['createEnrollment'],
      (variables?: CreateEnrollmentMutationVariables) => fetcher<CreateEnrollmentMutation, CreateEnrollmentMutationVariables>(client, CreateEnrollmentDocument, variables, headers)(),
      options
    );
useCreateEnrollmentMutation.fetcher = (client: GraphQLClient, variables?: CreateEnrollmentMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateEnrollmentMutation, CreateEnrollmentMutationVariables>(client, CreateEnrollmentDocument, variables, headers);
export const SwitchEnrollmentDocument = `
    mutation switchEnrollment($enrollmentId: ID!) {
  switchEnrollment(enrollmentId: $enrollmentId) {
    enrollment {
      id
      user {
        id
        fullName
      }
    }
    success
    errors
  }
}
    `;
export const useSwitchEnrollmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SwitchEnrollmentMutation, TError, SwitchEnrollmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SwitchEnrollmentMutation, TError, SwitchEnrollmentMutationVariables, TContext>(
      ['switchEnrollment'],
      (variables?: SwitchEnrollmentMutationVariables) => fetcher<SwitchEnrollmentMutation, SwitchEnrollmentMutationVariables>(client, SwitchEnrollmentDocument, variables, headers)(),
      options
    );
useSwitchEnrollmentMutation.fetcher = (client: GraphQLClient, variables: SwitchEnrollmentMutationVariables, headers?: RequestInit['headers']) => fetcher<SwitchEnrollmentMutation, SwitchEnrollmentMutationVariables>(client, SwitchEnrollmentDocument, variables, headers);
export const ConcludeEnrollmentDocument = `
    mutation concludeEnrollment($id: ID!, $finalGrade: Int, $silent: Boolean) {
  concludeEnrollment(id: $id, finalGrade: $finalGrade, silent: $silent) {
    success
    errors
  }
}
    `;
export const useConcludeEnrollmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConcludeEnrollmentMutation, TError, ConcludeEnrollmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConcludeEnrollmentMutation, TError, ConcludeEnrollmentMutationVariables, TContext>(
      ['concludeEnrollment'],
      (variables?: ConcludeEnrollmentMutationVariables) => fetcher<ConcludeEnrollmentMutation, ConcludeEnrollmentMutationVariables>(client, ConcludeEnrollmentDocument, variables, headers)(),
      options
    );
useConcludeEnrollmentMutation.fetcher = (client: GraphQLClient, variables: ConcludeEnrollmentMutationVariables, headers?: RequestInit['headers']) => fetcher<ConcludeEnrollmentMutation, ConcludeEnrollmentMutationVariables>(client, ConcludeEnrollmentDocument, variables, headers);
export const ConcludeAllEnrollmentsDocument = `
    mutation concludeAllEnrollments($courseId: ID!, $silent: Boolean) {
  concludeAllEnrollments(courseId: $courseId, silent: $silent) {
    success
    errors
    enrollments {
      id
    }
  }
}
    `;
export const useConcludeAllEnrollmentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConcludeAllEnrollmentsMutation, TError, ConcludeAllEnrollmentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConcludeAllEnrollmentsMutation, TError, ConcludeAllEnrollmentsMutationVariables, TContext>(
      ['concludeAllEnrollments'],
      (variables?: ConcludeAllEnrollmentsMutationVariables) => fetcher<ConcludeAllEnrollmentsMutation, ConcludeAllEnrollmentsMutationVariables>(client, ConcludeAllEnrollmentsDocument, variables, headers)(),
      options
    );
useConcludeAllEnrollmentsMutation.fetcher = (client: GraphQLClient, variables: ConcludeAllEnrollmentsMutationVariables, headers?: RequestInit['headers']) => fetcher<ConcludeAllEnrollmentsMutation, ConcludeAllEnrollmentsMutationVariables>(client, ConcludeAllEnrollmentsDocument, variables, headers);
export const AcademicRecordsDownloadUrlDocument = `
    mutation academicRecordsDownloadUrl($scope: String!, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  academicRecordsDownloadUrl(
    startDate: $startDate
    endDate: $endDate
    scope: $scope
  ) {
    success
    errors
    url
  }
}
    `;
export const useAcademicRecordsDownloadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AcademicRecordsDownloadUrlMutation, TError, AcademicRecordsDownloadUrlMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AcademicRecordsDownloadUrlMutation, TError, AcademicRecordsDownloadUrlMutationVariables, TContext>(
      ['academicRecordsDownloadUrl'],
      (variables?: AcademicRecordsDownloadUrlMutationVariables) => fetcher<AcademicRecordsDownloadUrlMutation, AcademicRecordsDownloadUrlMutationVariables>(client, AcademicRecordsDownloadUrlDocument, variables, headers)(),
      options
    );
useAcademicRecordsDownloadUrlMutation.fetcher = (client: GraphQLClient, variables: AcademicRecordsDownloadUrlMutationVariables, headers?: RequestInit['headers']) => fetcher<AcademicRecordsDownloadUrlMutation, AcademicRecordsDownloadUrlMutationVariables>(client, AcademicRecordsDownloadUrlDocument, variables, headers);
export const DropEnrollmentDocument = `
    mutation dropEnrollment($id: ID!, $silent: Boolean) {
  dropEnrollment(id: $id, silent: $silent) {
    success
    errors
  }
}
    `;
export const useDropEnrollmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DropEnrollmentMutation, TError, DropEnrollmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DropEnrollmentMutation, TError, DropEnrollmentMutationVariables, TContext>(
      ['dropEnrollment'],
      (variables?: DropEnrollmentMutationVariables) => fetcher<DropEnrollmentMutation, DropEnrollmentMutationVariables>(client, DropEnrollmentDocument, variables, headers)(),
      options
    );
useDropEnrollmentMutation.fetcher = (client: GraphQLClient, variables: DropEnrollmentMutationVariables, headers?: RequestInit['headers']) => fetcher<DropEnrollmentMutation, DropEnrollmentMutationVariables>(client, DropEnrollmentDocument, variables, headers);
export const UpdateEnrollmentDocument = `
    mutation updateEnrollment($id: ID!, $courseRoleId: ID) {
  updateEnrollment(id: $id, courseRoleId: $courseRoleId) {
    success
    errors
  }
}
    `;
export const useUpdateEnrollmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateEnrollmentMutation, TError, UpdateEnrollmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateEnrollmentMutation, TError, UpdateEnrollmentMutationVariables, TContext>(
      ['updateEnrollment'],
      (variables?: UpdateEnrollmentMutationVariables) => fetcher<UpdateEnrollmentMutation, UpdateEnrollmentMutationVariables>(client, UpdateEnrollmentDocument, variables, headers)(),
      options
    );
useUpdateEnrollmentMutation.fetcher = (client: GraphQLClient, variables: UpdateEnrollmentMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateEnrollmentMutation, UpdateEnrollmentMutationVariables>(client, UpdateEnrollmentDocument, variables, headers);
export const AcceptEnrollmentDocument = `
    mutation acceptEnrollment($id: ID!) {
  acceptEnrollment(id: $id) {
    success
    errors
    enrollment {
      id
      course {
        id
      }
    }
  }
}
    `;
export const useAcceptEnrollmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AcceptEnrollmentMutation, TError, AcceptEnrollmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AcceptEnrollmentMutation, TError, AcceptEnrollmentMutationVariables, TContext>(
      ['acceptEnrollment'],
      (variables?: AcceptEnrollmentMutationVariables) => fetcher<AcceptEnrollmentMutation, AcceptEnrollmentMutationVariables>(client, AcceptEnrollmentDocument, variables, headers)(),
      options
    );
useAcceptEnrollmentMutation.fetcher = (client: GraphQLClient, variables: AcceptEnrollmentMutationVariables, headers?: RequestInit['headers']) => fetcher<AcceptEnrollmentMutation, AcceptEnrollmentMutationVariables>(client, AcceptEnrollmentDocument, variables, headers);
export const ResendEnrollmentInviteDocument = `
    mutation resendEnrollmentInvite($id: ID!) {
  resendEnrollmentInvite(id: $id) {
    success
    errors
  }
}
    `;
export const useResendEnrollmentInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResendEnrollmentInviteMutation, TError, ResendEnrollmentInviteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResendEnrollmentInviteMutation, TError, ResendEnrollmentInviteMutationVariables, TContext>(
      ['resendEnrollmentInvite'],
      (variables?: ResendEnrollmentInviteMutationVariables) => fetcher<ResendEnrollmentInviteMutation, ResendEnrollmentInviteMutationVariables>(client, ResendEnrollmentInviteDocument, variables, headers)(),
      options
    );
useResendEnrollmentInviteMutation.fetcher = (client: GraphQLClient, variables: ResendEnrollmentInviteMutationVariables, headers?: RequestInit['headers']) => fetcher<ResendEnrollmentInviteMutation, ResendEnrollmentInviteMutationVariables>(client, ResendEnrollmentInviteDocument, variables, headers);
export const CreateFileDocument = `
    mutation createFile($title: String!, $file: Upload, $srcUrl: String, $skipperPaperContent: String, $authorizerItem: PolymorphicItemId, $cropAttributes: CropAttributes, $uploadSessionId: String) {
  createFile(
    title: $title
    file: $file
    srcUrl: $srcUrl
    skipperPaperContent: $skipperPaperContent
    authorizerItem: $authorizerItem
    cropAttributes: $cropAttributes
    uploadSessionId: $uploadSessionId
  ) {
    success
    errors
    fileEntry {
      croppedUrl
      fileType
      id
      originalFileSize
      originalFileName
      originalFileContentType
      skipperPaperContent
      sourceAttribution {
        author
        authorUrl
        byCompany
        id
        licenseOther
        licenseType
        notes
        title
        url
      }
      title
      description
      url
      createdAt
      updatedAt
      uploadedBy {
        id
        fullName
        username
      }
    }
  }
}
    `;
export const useCreateFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFileMutation, TError, CreateFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateFileMutation, TError, CreateFileMutationVariables, TContext>(
      ['createFile'],
      (variables?: CreateFileMutationVariables) => fetcher<CreateFileMutation, CreateFileMutationVariables>(client, CreateFileDocument, variables, headers)(),
      options
    );
useCreateFileMutation.fetcher = (client: GraphQLClient, variables: CreateFileMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFileMutation, CreateFileMutationVariables>(client, CreateFileDocument, variables, headers);
export const PresignCreateFileDocument = `
    mutation presignCreateFile($title: String!, $contentType: String, $fileSize: Int, $authorizerItem: PolymorphicItemId, $uploadSessionId: String) {
  presignCreateFile(
    title: $title
    fileSize: $fileSize
    contentType: $contentType
    authorizerItem: $authorizerItem
    uploadSessionId: $uploadSessionId
  ) {
    success
    errors
    fileEntryId
    uploadId
    parts {
      partNumber
      offset
      size
      url
    }
  }
}
    `;
export const usePresignCreateFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PresignCreateFileMutation, TError, PresignCreateFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PresignCreateFileMutation, TError, PresignCreateFileMutationVariables, TContext>(
      ['presignCreateFile'],
      (variables?: PresignCreateFileMutationVariables) => fetcher<PresignCreateFileMutation, PresignCreateFileMutationVariables>(client, PresignCreateFileDocument, variables, headers)(),
      options
    );
usePresignCreateFileMutation.fetcher = (client: GraphQLClient, variables: PresignCreateFileMutationVariables, headers?: RequestInit['headers']) => fetcher<PresignCreateFileMutation, PresignCreateFileMutationVariables>(client, PresignCreateFileDocument, variables, headers);
export const FinishCreateFileDocument = `
    mutation finishCreateFile($fileEntryId: ID!, $uploadId: String, $etags: [String!]!, $cropAttributes: CropAttributes, $uploadSessionId: String, $skipperPaperContent: String) {
  finishCreateFile(
    fileEntryId: $fileEntryId
    uploadId: $uploadId
    etags: $etags
    cropAttributes: $cropAttributes
    uploadSessionId: $uploadSessionId
    skipperPaperContent: $skipperPaperContent
  ) {
    success
    errors
    fileEntry {
      croppedUrl
      fileType
      id
      originalFileSize
      originalFileName
      originalFileContentType
      skipperPaperContent
      sourceAttribution {
        author
        authorUrl
        byCompany
        id
        licenseOther
        licenseType
        notes
        title
        url
      }
      title
      description
      url
      createdAt
      updatedAt
      uploadedBy {
        id
        fullName
        username
      }
    }
  }
}
    `;
export const useFinishCreateFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FinishCreateFileMutation, TError, FinishCreateFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<FinishCreateFileMutation, TError, FinishCreateFileMutationVariables, TContext>(
      ['finishCreateFile'],
      (variables?: FinishCreateFileMutationVariables) => fetcher<FinishCreateFileMutation, FinishCreateFileMutationVariables>(client, FinishCreateFileDocument, variables, headers)(),
      options
    );
useFinishCreateFileMutation.fetcher = (client: GraphQLClient, variables: FinishCreateFileMutationVariables, headers?: RequestInit['headers']) => fetcher<FinishCreateFileMutation, FinishCreateFileMutationVariables>(client, FinishCreateFileDocument, variables, headers);
export const UpdateFileDocument = `
    mutation updateFile($id: ID!, $skipperPaperContent: String, $title: String, $description: String, $cropAttributes: CropAttributes, $sourceAttributionId: ID, $annotation: String) {
  updateFile(
    id: $id
    title: $title
    skipperPaperContent: $skipperPaperContent
    description: $description
    cropAttributes: $cropAttributes
    sourceAttributionId: $sourceAttributionId
    annotation: $annotation
  ) {
    success
    errors
    fileEntry {
      annotation
      croppedUrl
      fileType
      id
      originalFileSize
      title
      description
      url
      skipperPaperContent
      createdAt
      updatedAt
      sourceAttribution {
        author
        authorUrl
        byCompany
        id
        licenseOther
        licenseType
        notes
        title
        url
      }
    }
  }
}
    `;
export const useUpdateFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFileMutation, TError, UpdateFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFileMutation, TError, UpdateFileMutationVariables, TContext>(
      ['updateFile'],
      (variables?: UpdateFileMutationVariables) => fetcher<UpdateFileMutation, UpdateFileMutationVariables>(client, UpdateFileDocument, variables, headers)(),
      options
    );
useUpdateFileMutation.fetcher = (client: GraphQLClient, variables: UpdateFileMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFileMutation, UpdateFileMutationVariables>(client, UpdateFileDocument, variables, headers);
export const DeleteFileDocument = `
    mutation deleteFile($id: ID!) {
  deleteFile(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFileMutation, TError, DeleteFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFileMutation, TError, DeleteFileMutationVariables, TContext>(
      ['deleteFile'],
      (variables?: DeleteFileMutationVariables) => fetcher<DeleteFileMutation, DeleteFileMutationVariables>(client, DeleteFileDocument, variables, headers)(),
      options
    );
useDeleteFileMutation.fetcher = (client: GraphQLClient, variables: DeleteFileMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFileMutation, DeleteFileMutationVariables>(client, DeleteFileDocument, variables, headers);
export const ViewFileDocument = `
    mutation viewFile($id: ID!) {
  viewFile(id: $id) {
    success
    errors
  }
}
    `;
export const useViewFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ViewFileMutation, TError, ViewFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ViewFileMutation, TError, ViewFileMutationVariables, TContext>(
      ['viewFile'],
      (variables?: ViewFileMutationVariables) => fetcher<ViewFileMutation, ViewFileMutationVariables>(client, ViewFileDocument, variables, headers)(),
      options
    );
useViewFileMutation.fetcher = (client: GraphQLClient, variables: ViewFileMutationVariables, headers?: RequestInit['headers']) => fetcher<ViewFileMutation, ViewFileMutationVariables>(client, ViewFileDocument, variables, headers);
export const ForgotPasswordDocument = `
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email) {
    success
    errors {
      field
      message
    }
  }
}
    `;
export const useForgotPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>(
      ['forgotPassword'],
      (variables?: ForgotPasswordMutationVariables) => fetcher<ForgotPasswordMutation, ForgotPasswordMutationVariables>(client, ForgotPasswordDocument, variables, headers)(),
      options
    );
useForgotPasswordMutation.fetcher = (client: GraphQLClient, variables: ForgotPasswordMutationVariables, headers?: RequestInit['headers']) => fetcher<ForgotPasswordMutation, ForgotPasswordMutationVariables>(client, ForgotPasswordDocument, variables, headers);
export const CreateGradingSchemeDocument = `
    mutation createGradingScheme($title: String!, $description: String, $ranges: JSON!, $percentageGrade: Boolean, $showNumericGrade: Boolean, $showLetterGrade: Boolean) {
  createGradingScheme(
    title: $title
    description: $description
    ranges: $ranges
    percentageGrade: $percentageGrade
    showNumericGrade: $showNumericGrade
    showLetterGrade: $showLetterGrade
  ) {
    success
    errors
    gradingScheme {
      id
      isDefault
      percentageGrade
      ranges
      showLetterGrade
      showNumericGrade
      title
      description
    }
  }
}
    `;
export const useCreateGradingSchemeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateGradingSchemeMutation, TError, CreateGradingSchemeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateGradingSchemeMutation, TError, CreateGradingSchemeMutationVariables, TContext>(
      ['createGradingScheme'],
      (variables?: CreateGradingSchemeMutationVariables) => fetcher<CreateGradingSchemeMutation, CreateGradingSchemeMutationVariables>(client, CreateGradingSchemeDocument, variables, headers)(),
      options
    );
useCreateGradingSchemeMutation.fetcher = (client: GraphQLClient, variables: CreateGradingSchemeMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateGradingSchemeMutation, CreateGradingSchemeMutationVariables>(client, CreateGradingSchemeDocument, variables, headers);
export const DeleteGradingSchemeDocument = `
    mutation deleteGradingScheme($id: ID!) {
  deleteGradingScheme(id: $id) {
    success
    errors
  }
}
    `;
export const useDeleteGradingSchemeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteGradingSchemeMutation, TError, DeleteGradingSchemeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteGradingSchemeMutation, TError, DeleteGradingSchemeMutationVariables, TContext>(
      ['deleteGradingScheme'],
      (variables?: DeleteGradingSchemeMutationVariables) => fetcher<DeleteGradingSchemeMutation, DeleteGradingSchemeMutationVariables>(client, DeleteGradingSchemeDocument, variables, headers)(),
      options
    );
useDeleteGradingSchemeMutation.fetcher = (client: GraphQLClient, variables: DeleteGradingSchemeMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteGradingSchemeMutation, DeleteGradingSchemeMutationVariables>(client, DeleteGradingSchemeDocument, variables, headers);
export const UpdateGradingSchemeDocument = `
    mutation updateGradingScheme($id: ID!, $title: String, $description: String, $ranges: JSON, $percentageGrade: Boolean, $showNumericGrade: Boolean, $showLetterGrade: Boolean) {
  updateGradingScheme(
    id: $id
    title: $title
    description: $description
    ranges: $ranges
    percentageGrade: $percentageGrade
    showNumericGrade: $showNumericGrade
    showLetterGrade: $showLetterGrade
  ) {
    success
    errors
    gradingScheme {
      id
      isDefault
      percentageGrade
      ranges
      showLetterGrade
      showNumericGrade
      title
      description
    }
  }
}
    `;
export const useUpdateGradingSchemeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateGradingSchemeMutation, TError, UpdateGradingSchemeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateGradingSchemeMutation, TError, UpdateGradingSchemeMutationVariables, TContext>(
      ['updateGradingScheme'],
      (variables?: UpdateGradingSchemeMutationVariables) => fetcher<UpdateGradingSchemeMutation, UpdateGradingSchemeMutationVariables>(client, UpdateGradingSchemeDocument, variables, headers)(),
      options
    );
useUpdateGradingSchemeMutation.fetcher = (client: GraphQLClient, variables: UpdateGradingSchemeMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateGradingSchemeMutation, UpdateGradingSchemeMutationVariables>(client, UpdateGradingSchemeDocument, variables, headers);
export const ImpersonateDocument = `
    mutation impersonate($id: ID!) {
  impersonate(id: $id) {
    success
    errors {
      field
      message
    }
    user {
      id
      initials
      birthDate
      firstName
      lastName
    }
  }
}
    `;
export const useImpersonateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImpersonateMutation, TError, ImpersonateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImpersonateMutation, TError, ImpersonateMutationVariables, TContext>(
      ['impersonate'],
      (variables?: ImpersonateMutationVariables) => fetcher<ImpersonateMutation, ImpersonateMutationVariables>(client, ImpersonateDocument, variables, headers)(),
      options
    );
useImpersonateMutation.fetcher = (client: GraphQLClient, variables: ImpersonateMutationVariables, headers?: RequestInit['headers']) => fetcher<ImpersonateMutation, ImpersonateMutationVariables>(client, ImpersonateDocument, variables, headers);
export const BatchMaterialBooksDocument = `
    mutation batchMaterialBooks($batchItems: [MaterialBookArguments!]!) {
  batchMaterialBooks(batchItems: $batchItems) {
    success
    errors
    materialBooks {
      author
      createdAt
      description
      id
      imageUrl
      isbn
      libraryButton
      title
      url
      websiteButton
    }
  }
}
    `;
export const useBatchMaterialBooksMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchMaterialBooksMutation, TError, BatchMaterialBooksMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchMaterialBooksMutation, TError, BatchMaterialBooksMutationVariables, TContext>(
      ['batchMaterialBooks'],
      (variables?: BatchMaterialBooksMutationVariables) => fetcher<BatchMaterialBooksMutation, BatchMaterialBooksMutationVariables>(client, BatchMaterialBooksDocument, variables, headers)(),
      options
    );
useBatchMaterialBooksMutation.fetcher = (client: GraphQLClient, variables: BatchMaterialBooksMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchMaterialBooksMutation, BatchMaterialBooksMutationVariables>(client, BatchMaterialBooksDocument, variables, headers);
export const BatchMaterialCodesDocument = `
    mutation batchMaterialCodes($batchItems: [MaterialCodeArguments!]!) {
  batchMaterialCodes(batchItems: $batchItems) {
    success
    errors
    materialCodes {
      code
      createdAt
      description
      id
      title
    }
  }
}
    `;
export const useBatchMaterialCodesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchMaterialCodesMutation, TError, BatchMaterialCodesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchMaterialCodesMutation, TError, BatchMaterialCodesMutationVariables, TContext>(
      ['batchMaterialCodes'],
      (variables?: BatchMaterialCodesMutationVariables) => fetcher<BatchMaterialCodesMutation, BatchMaterialCodesMutationVariables>(client, BatchMaterialCodesDocument, variables, headers)(),
      options
    );
useBatchMaterialCodesMutation.fetcher = (client: GraphQLClient, variables: BatchMaterialCodesMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchMaterialCodesMutation, BatchMaterialCodesMutationVariables>(client, BatchMaterialCodesDocument, variables, headers);
export const BatchMaterialLinksDocument = `
    mutation batchMaterialLinks($batchItems: [MaterialLinkArguments!]!) {
  batchMaterialLinks(batchItems: $batchItems) {
    success
    errors
    materialLinks {
      id
      createdAt
      description
      image
      title
      otherImages
      showImage
      imageMaxWidth
      url
    }
  }
}
    `;
export const useBatchMaterialLinksMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchMaterialLinksMutation, TError, BatchMaterialLinksMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchMaterialLinksMutation, TError, BatchMaterialLinksMutationVariables, TContext>(
      ['batchMaterialLinks'],
      (variables?: BatchMaterialLinksMutationVariables) => fetcher<BatchMaterialLinksMutation, BatchMaterialLinksMutationVariables>(client, BatchMaterialLinksDocument, variables, headers)(),
      options
    );
useBatchMaterialLinksMutation.fetcher = (client: GraphQLClient, variables: BatchMaterialLinksMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchMaterialLinksMutation, BatchMaterialLinksMutationVariables>(client, BatchMaterialLinksDocument, variables, headers);
export const BatchSourceAttributionsDocument = `
    mutation batchSourceAttributions($batchItems: [SourceAttributionArguments!]!) {
  batchSourceAttributions(batchItems: $batchItems) {
    success
    errors
    sourceAttributions {
      author
      authorUrl
      byCompany
      id
      licenseOther
      licenseType
      notes
      title
      url
    }
  }
}
    `;
export const useBatchSourceAttributionsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchSourceAttributionsMutation, TError, BatchSourceAttributionsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchSourceAttributionsMutation, TError, BatchSourceAttributionsMutationVariables, TContext>(
      ['batchSourceAttributions'],
      (variables?: BatchSourceAttributionsMutationVariables) => fetcher<BatchSourceAttributionsMutation, BatchSourceAttributionsMutationVariables>(client, BatchSourceAttributionsDocument, variables, headers)(),
      options
    );
useBatchSourceAttributionsMutation.fetcher = (client: GraphQLClient, variables: BatchSourceAttributionsMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchSourceAttributionsMutation, BatchSourceAttributionsMutationVariables>(client, BatchSourceAttributionsDocument, variables, headers);
export const ToggleReadNotificationDocument = `
    mutation ToggleReadNotification($id: ID!) {
  toggleReadNotification(id: $id) {
    success
    errors
    notification {
      id
      isViewed
    }
  }
}
    `;
export const useToggleReadNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ToggleReadNotificationMutation, TError, ToggleReadNotificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ToggleReadNotificationMutation, TError, ToggleReadNotificationMutationVariables, TContext>(
      ['ToggleReadNotification'],
      (variables?: ToggleReadNotificationMutationVariables) => fetcher<ToggleReadNotificationMutation, ToggleReadNotificationMutationVariables>(client, ToggleReadNotificationDocument, variables, headers)(),
      options
    );
useToggleReadNotificationMutation.fetcher = (client: GraphQLClient, variables: ToggleReadNotificationMutationVariables, headers?: RequestInit['headers']) => fetcher<ToggleReadNotificationMutation, ToggleReadNotificationMutationVariables>(client, ToggleReadNotificationDocument, variables, headers);
export const MarkReadAllNotificationsDocument = `
    mutation MarkReadAllNotifications($types: [NotificationType!]) {
  markReadAllNotifications(types: $types) {
    success
    errors
  }
}
    `;
export const useMarkReadAllNotificationsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkReadAllNotificationsMutation, TError, MarkReadAllNotificationsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkReadAllNotificationsMutation, TError, MarkReadAllNotificationsMutationVariables, TContext>(
      ['MarkReadAllNotifications'],
      (variables?: MarkReadAllNotificationsMutationVariables) => fetcher<MarkReadAllNotificationsMutation, MarkReadAllNotificationsMutationVariables>(client, MarkReadAllNotificationsDocument, variables, headers)(),
      options
    );
useMarkReadAllNotificationsMutation.fetcher = (client: GraphQLClient, variables?: MarkReadAllNotificationsMutationVariables, headers?: RequestInit['headers']) => fetcher<MarkReadAllNotificationsMutation, MarkReadAllNotificationsMutationVariables>(client, MarkReadAllNotificationsDocument, variables, headers);
export const UpdatePermissionLevelDocument = `
    mutation updatePermissionLevel($id: Int!, $name: String, $permissions: [String!]) {
  updatePermissionLevel(id: $id, name: $name, permissions: $permissions) {
    success
    errors
  }
}
    `;
export const useUpdatePermissionLevelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePermissionLevelMutation, TError, UpdatePermissionLevelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePermissionLevelMutation, TError, UpdatePermissionLevelMutationVariables, TContext>(
      ['updatePermissionLevel'],
      (variables?: UpdatePermissionLevelMutationVariables) => fetcher<UpdatePermissionLevelMutation, UpdatePermissionLevelMutationVariables>(client, UpdatePermissionLevelDocument, variables, headers)(),
      options
    );
useUpdatePermissionLevelMutation.fetcher = (client: GraphQLClient, variables: UpdatePermissionLevelMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdatePermissionLevelMutation, UpdatePermissionLevelMutationVariables>(client, UpdatePermissionLevelDocument, variables, headers);
export const CreatePermissionLevelDocument = `
    mutation createPermissionLevel($name: String) {
  createPermissionLevel(name: $name) {
    success
    errors
  }
}
    `;
export const useCreatePermissionLevelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePermissionLevelMutation, TError, CreatePermissionLevelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePermissionLevelMutation, TError, CreatePermissionLevelMutationVariables, TContext>(
      ['createPermissionLevel'],
      (variables?: CreatePermissionLevelMutationVariables) => fetcher<CreatePermissionLevelMutation, CreatePermissionLevelMutationVariables>(client, CreatePermissionLevelDocument, variables, headers)(),
      options
    );
useCreatePermissionLevelMutation.fetcher = (client: GraphQLClient, variables?: CreatePermissionLevelMutationVariables, headers?: RequestInit['headers']) => fetcher<CreatePermissionLevelMutation, CreatePermissionLevelMutationVariables>(client, CreatePermissionLevelDocument, variables, headers);
export const DeletePermissionLevelDocument = `
    mutation deletePermissionLevel($id: Int!) {
  deletePermissionLevel(id: $id) {
    success
    errors
  }
}
    `;
export const useDeletePermissionLevelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePermissionLevelMutation, TError, DeletePermissionLevelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePermissionLevelMutation, TError, DeletePermissionLevelMutationVariables, TContext>(
      ['deletePermissionLevel'],
      (variables?: DeletePermissionLevelMutationVariables) => fetcher<DeletePermissionLevelMutation, DeletePermissionLevelMutationVariables>(client, DeletePermissionLevelDocument, variables, headers)(),
      options
    );
useDeletePermissionLevelMutation.fetcher = (client: GraphQLClient, variables: DeletePermissionLevelMutationVariables, headers?: RequestInit['headers']) => fetcher<DeletePermissionLevelMutation, DeletePermissionLevelMutationVariables>(client, DeletePermissionLevelDocument, variables, headers);
export const SigninUserDocument = `
    mutation signinUser($email: String!, $password: String!) {
  signIn(email: $email, password: $password, rememberMe: false) {
    success
    user {
      id
      email
      initials
    }
    errors {
      field
      message
    }
  }
}
    `;
export const useSigninUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SigninUserMutation, TError, SigninUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SigninUserMutation, TError, SigninUserMutationVariables, TContext>(
      ['signinUser'],
      (variables?: SigninUserMutationVariables) => fetcher<SigninUserMutation, SigninUserMutationVariables>(client, SigninUserDocument, variables, headers)(),
      options
    );
useSigninUserMutation.fetcher = (client: GraphQLClient, variables: SigninUserMutationVariables, headers?: RequestInit['headers']) => fetcher<SigninUserMutation, SigninUserMutationVariables>(client, SigninUserDocument, variables, headers);
export const SignInOauthDocument = `
    mutation signInOauth($provider: OauthProvider!, $uid: String!, $verifier: String!, $idToken: String) {
  signInOauth(
    provider: $provider
    uid: $uid
    verifier: $verifier
    idToken: $idToken
  ) {
    success
    user {
      id
    }
    errors
  }
}
    `;
export const useSignInOauthMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SignInOauthMutation, TError, SignInOauthMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SignInOauthMutation, TError, SignInOauthMutationVariables, TContext>(
      ['signInOauth'],
      (variables?: SignInOauthMutationVariables) => fetcher<SignInOauthMutation, SignInOauthMutationVariables>(client, SignInOauthDocument, variables, headers)(),
      options
    );
useSignInOauthMutation.fetcher = (client: GraphQLClient, variables: SignInOauthMutationVariables, headers?: RequestInit['headers']) => fetcher<SignInOauthMutation, SignInOauthMutationVariables>(client, SignInOauthDocument, variables, headers);
export const ClearOauthAccountUserDocument = `
    mutation clearOauthAccountUser($id: Int, $provider: OauthProvider!) {
  clearOauthAccountUser(id: $id, provider: $provider) {
    success
    user {
      id
    }
    errors
  }
}
    `;
export const useClearOauthAccountUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ClearOauthAccountUserMutation, TError, ClearOauthAccountUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ClearOauthAccountUserMutation, TError, ClearOauthAccountUserMutationVariables, TContext>(
      ['clearOauthAccountUser'],
      (variables?: ClearOauthAccountUserMutationVariables) => fetcher<ClearOauthAccountUserMutation, ClearOauthAccountUserMutationVariables>(client, ClearOauthAccountUserDocument, variables, headers)(),
      options
    );
useClearOauthAccountUserMutation.fetcher = (client: GraphQLClient, variables: ClearOauthAccountUserMutationVariables, headers?: RequestInit['headers']) => fetcher<ClearOauthAccountUserMutation, ClearOauthAccountUserMutationVariables>(client, ClearOauthAccountUserDocument, variables, headers);
export const StartQuizSubmissionDocument = `
    mutation startQuizSubmission($activityId: ID!) {
  startQuizSubmission(activityId: $activityId) {
    success
    submission {
      id
    }
    sessionId
    errors
  }
}
    `;
export const useStartQuizSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartQuizSubmissionMutation, TError, StartQuizSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StartQuizSubmissionMutation, TError, StartQuizSubmissionMutationVariables, TContext>(
      ['startQuizSubmission'],
      (variables?: StartQuizSubmissionMutationVariables) => fetcher<StartQuizSubmissionMutation, StartQuizSubmissionMutationVariables>(client, StartQuizSubmissionDocument, variables, headers)(),
      options
    );
useStartQuizSubmissionMutation.fetcher = (client: GraphQLClient, variables: StartQuizSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<StartQuizSubmissionMutation, StartQuizSubmissionMutationVariables>(client, StartQuizSubmissionDocument, variables, headers);
export const UpdateQuizSubmissionDocument = `
    mutation updateQuizSubmission($submissionId: ID!, $answers: [JSON!], $bookmarks: [ID!], $sessionId: String!, $saveForLater: Boolean) {
  updateQuizSubmission(
    submissionId: $submissionId
    answers: $answers
    bookmarks: $bookmarks
    sessionId: $sessionId
    saveForLater: $saveForLater
  ) {
    success
    submission {
      id
      isSubmitted
      isViewed
      submissionType
      createdAt
      submittedAt
      updatedAt
      grade
      gradedAt
      hasContent
      content {
        ... on QuizSubmission {
          answers
          bookmarks
          questionGrades
          timeElapsed
          timeLeft
        }
        ... on AssignmentSubmission {
          text
        }
      }
    }
    errors
  }
}
    `;
export const useUpdateQuizSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateQuizSubmissionMutation, TError, UpdateQuizSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateQuizSubmissionMutation, TError, UpdateQuizSubmissionMutationVariables, TContext>(
      ['updateQuizSubmission'],
      (variables?: UpdateQuizSubmissionMutationVariables) => fetcher<UpdateQuizSubmissionMutation, UpdateQuizSubmissionMutationVariables>(client, UpdateQuizSubmissionDocument, variables, headers)(),
      options
    );
useUpdateQuizSubmissionMutation.fetcher = (client: GraphQLClient, variables: UpdateQuizSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateQuizSubmissionMutation, UpdateQuizSubmissionMutationVariables>(client, UpdateQuizSubmissionDocument, variables, headers);
export const SubmitQuizSubmissionDocument = `
    mutation submitQuizSubmission($submissionId: ID!, $answers: [JSON!], $bookmarks: [ID!], $sessionId: String!) {
  submitQuizSubmission(
    submissionId: $submissionId
    answers: $answers
    bookmarks: $bookmarks
    sessionId: $sessionId
  ) {
    success
    submission {
      id
      isSubmitted
      isViewed
      submissionType
      createdAt
      submittedAt
      updatedAt
      grade
      gradedAt
      hasContent
      content {
        ... on QuizSubmission {
          answers
          bookmarks
          questionGrades
          timeElapsed
          timeLeft
        }
        ... on AssignmentSubmission {
          text
        }
      }
    }
    errors
  }
}
    `;
export const useSubmitQuizSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubmitQuizSubmissionMutation, TError, SubmitQuizSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SubmitQuizSubmissionMutation, TError, SubmitQuizSubmissionMutationVariables, TContext>(
      ['submitQuizSubmission'],
      (variables?: SubmitQuizSubmissionMutationVariables) => fetcher<SubmitQuizSubmissionMutation, SubmitQuizSubmissionMutationVariables>(client, SubmitQuizSubmissionDocument, variables, headers)(),
      options
    );
useSubmitQuizSubmissionMutation.fetcher = (client: GraphQLClient, variables: SubmitQuizSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<SubmitQuizSubmissionMutation, SubmitQuizSubmissionMutationVariables>(client, SubmitQuizSubmissionDocument, variables, headers);
export const GradeSubmissionDocument = `
    mutation gradeSubmission($submissionId: ID!, $points: Float, $quizQuestionId: ID, $bonus: Boolean) {
  gradeSubmission(
    submissionId: $submissionId
    points: $points
    quizQuestionId: $quizQuestionId
    bonus: $bonus
  ) {
    success
    submission {
      id
      isSubmitted
      isViewed
      submissionType
      createdAt
      submittedAt
      updatedAt
      grade
      gradedAt
      percentageGrade
      hasContent
      enrollment {
        id
      }
      attachments {
        ...FileEntryDefault
      }
      content {
        ... on QuizSubmission {
          answers
          bookmarks
          questionGrades
          timeElapsed
          timeLeft
        }
        ... on AssignmentSubmission {
          text
        }
      }
    }
    errors
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useGradeSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GradeSubmissionMutation, TError, GradeSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GradeSubmissionMutation, TError, GradeSubmissionMutationVariables, TContext>(
      ['gradeSubmission'],
      (variables?: GradeSubmissionMutationVariables) => fetcher<GradeSubmissionMutation, GradeSubmissionMutationVariables>(client, GradeSubmissionDocument, variables, headers)(),
      options
    );
useGradeSubmissionMutation.fetcher = (client: GraphQLClient, variables: GradeSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<GradeSubmissionMutation, GradeSubmissionMutationVariables>(client, GradeSubmissionDocument, variables, headers);
export const StartAssignmentSubmissionDocument = `
    mutation startAssignmentSubmission($activityId: ID!, $attachmentIds: [ID!], $studentEnrollmentId: ID) {
  startAssignmentSubmission(
    activityId: $activityId
    attachmentIds: $attachmentIds
    studentEnrollmentId: $studentEnrollmentId
  ) {
    success
    submission {
      ...SubmissionFragment
    }
    errors
  }
}
    ${SubmissionFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useStartAssignmentSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartAssignmentSubmissionMutation, TError, StartAssignmentSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StartAssignmentSubmissionMutation, TError, StartAssignmentSubmissionMutationVariables, TContext>(
      ['startAssignmentSubmission'],
      (variables?: StartAssignmentSubmissionMutationVariables) => fetcher<StartAssignmentSubmissionMutation, StartAssignmentSubmissionMutationVariables>(client, StartAssignmentSubmissionDocument, variables, headers)(),
      options
    );
useStartAssignmentSubmissionMutation.fetcher = (client: GraphQLClient, variables: StartAssignmentSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<StartAssignmentSubmissionMutation, StartAssignmentSubmissionMutationVariables>(client, StartAssignmentSubmissionDocument, variables, headers);
export const SubmitAssignmentSubmissionDocument = `
    mutation submitAssignmentSubmission($submissionId: ID!, $addAttachmentIds: [ID!], $removeAttachmentIds: [ID!]) {
  submitAssignmentSubmission(
    submissionId: $submissionId
    addAttachmentIds: $addAttachmentIds
    removeAttachmentIds: $removeAttachmentIds
  ) {
    success
    submission {
      ...SubmissionFragment
    }
    errors
  }
}
    ${SubmissionFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useSubmitAssignmentSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubmitAssignmentSubmissionMutation, TError, SubmitAssignmentSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SubmitAssignmentSubmissionMutation, TError, SubmitAssignmentSubmissionMutationVariables, TContext>(
      ['submitAssignmentSubmission'],
      (variables?: SubmitAssignmentSubmissionMutationVariables) => fetcher<SubmitAssignmentSubmissionMutation, SubmitAssignmentSubmissionMutationVariables>(client, SubmitAssignmentSubmissionDocument, variables, headers)(),
      options
    );
useSubmitAssignmentSubmissionMutation.fetcher = (client: GraphQLClient, variables: SubmitAssignmentSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<SubmitAssignmentSubmissionMutation, SubmitAssignmentSubmissionMutationVariables>(client, SubmitAssignmentSubmissionDocument, variables, headers);
export const UpdateAssignmentSubmissionDocument = `
    mutation updateAssignmentSubmission($submissionId: ID!, $addAttachmentIds: [ID!], $removeAttachmentIds: [ID!]) {
  updateAssignmentSubmission(
    submissionId: $submissionId
    addAttachmentIds: $addAttachmentIds
    removeAttachmentIds: $removeAttachmentIds
  ) {
    success
    submission {
      ...SubmissionFragment
    }
    errors
  }
}
    ${SubmissionFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useUpdateAssignmentSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAssignmentSubmissionMutation, TError, UpdateAssignmentSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAssignmentSubmissionMutation, TError, UpdateAssignmentSubmissionMutationVariables, TContext>(
      ['updateAssignmentSubmission'],
      (variables?: UpdateAssignmentSubmissionMutationVariables) => fetcher<UpdateAssignmentSubmissionMutation, UpdateAssignmentSubmissionMutationVariables>(client, UpdateAssignmentSubmissionDocument, variables, headers)(),
      options
    );
useUpdateAssignmentSubmissionMutation.fetcher = (client: GraphQLClient, variables: UpdateAssignmentSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateAssignmentSubmissionMutation, UpdateAssignmentSubmissionMutationVariables>(client, UpdateAssignmentSubmissionDocument, variables, headers);
export const DeleteSubmissionDocument = `
    mutation deleteSubmission($submissionId: ID!) {
  deleteSubmission(submissionId: $submissionId) {
    success
    errors
  }
}
    `;
export const useDeleteSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteSubmissionMutation, TError, DeleteSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteSubmissionMutation, TError, DeleteSubmissionMutationVariables, TContext>(
      ['deleteSubmission'],
      (variables?: DeleteSubmissionMutationVariables) => fetcher<DeleteSubmissionMutation, DeleteSubmissionMutationVariables>(client, DeleteSubmissionDocument, variables, headers)(),
      options
    );
useDeleteSubmissionMutation.fetcher = (client: GraphQLClient, variables: DeleteSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteSubmissionMutation, DeleteSubmissionMutationVariables>(client, DeleteSubmissionDocument, variables, headers);
export const OverrideActivityStatusDocument = `
    mutation overrideActivityStatus($id: ID!, $enrollmentId: ID!, $status: ActivityStatusOverride) {
  overrideActivityStatus(id: $id, enrollmentId: $enrollmentId, status: $status) {
    success
    errors
  }
}
    `;
export const useOverrideActivityStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<OverrideActivityStatusMutation, TError, OverrideActivityStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<OverrideActivityStatusMutation, TError, OverrideActivityStatusMutationVariables, TContext>(
      ['overrideActivityStatus'],
      (variables?: OverrideActivityStatusMutationVariables) => fetcher<OverrideActivityStatusMutation, OverrideActivityStatusMutationVariables>(client, OverrideActivityStatusDocument, variables, headers)(),
      options
    );
useOverrideActivityStatusMutation.fetcher = (client: GraphQLClient, variables: OverrideActivityStatusMutationVariables, headers?: RequestInit['headers']) => fetcher<OverrideActivityStatusMutation, OverrideActivityStatusMutationVariables>(client, OverrideActivityStatusDocument, variables, headers);
export const OverrideActivityGradeDocument = `
    mutation overrideActivityGrade($id: ID!, $enrollmentId: ID!, $points: Float) {
  overrideActivityGrade(id: $id, enrollmentId: $enrollmentId, points: $points) {
    success
    errors
  }
}
    `;
export const useOverrideActivityGradeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<OverrideActivityGradeMutation, TError, OverrideActivityGradeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<OverrideActivityGradeMutation, TError, OverrideActivityGradeMutationVariables, TContext>(
      ['overrideActivityGrade'],
      (variables?: OverrideActivityGradeMutationVariables) => fetcher<OverrideActivityGradeMutation, OverrideActivityGradeMutationVariables>(client, OverrideActivityGradeDocument, variables, headers)(),
      options
    );
useOverrideActivityGradeMutation.fetcher = (client: GraphQLClient, variables: OverrideActivityGradeMutationVariables, headers?: RequestInit['headers']) => fetcher<OverrideActivityGradeMutation, OverrideActivityGradeMutationVariables>(client, OverrideActivityGradeDocument, variables, headers);
export const BatchActivityOverridesDocument = `
    mutation batchActivityOverrides($overrides: [ActivityBatchOverrideAttributes!]!) {
  batchActivityOverrides(overrides: $overrides) {
    success
    errors
  }
}
    `;
export const useBatchActivityOverridesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BatchActivityOverridesMutation, TError, BatchActivityOverridesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BatchActivityOverridesMutation, TError, BatchActivityOverridesMutationVariables, TContext>(
      ['batchActivityOverrides'],
      (variables?: BatchActivityOverridesMutationVariables) => fetcher<BatchActivityOverridesMutation, BatchActivityOverridesMutationVariables>(client, BatchActivityOverridesDocument, variables, headers)(),
      options
    );
useBatchActivityOverridesMutation.fetcher = (client: GraphQLClient, variables: BatchActivityOverridesMutationVariables, headers?: RequestInit['headers']) => fetcher<BatchActivityOverridesMutation, BatchActivityOverridesMutationVariables>(client, BatchActivityOverridesDocument, variables, headers);
export const AnnotateSubmissionDocument = `
    mutation annotateSubmission($submissionId: ID!, $annotation: String) {
  annotateSubmission(submissionId: $submissionId, annotation: $annotation) {
    success
    errors
  }
}
    `;
export const useAnnotateSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AnnotateSubmissionMutation, TError, AnnotateSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AnnotateSubmissionMutation, TError, AnnotateSubmissionMutationVariables, TContext>(
      ['annotateSubmission'],
      (variables?: AnnotateSubmissionMutationVariables) => fetcher<AnnotateSubmissionMutation, AnnotateSubmissionMutationVariables>(client, AnnotateSubmissionDocument, variables, headers)(),
      options
    );
useAnnotateSubmissionMutation.fetcher = (client: GraphQLClient, variables: AnnotateSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<AnnotateSubmissionMutation, AnnotateSubmissionMutationVariables>(client, AnnotateSubmissionDocument, variables, headers);
export const OverrideEnrollmentGradeDocument = `
    mutation overrideEnrollmentGrade($id: ID!, $courseTermId: ID, $percentageGrade: Float) {
  overrideEnrollmentGrade(
    id: $id
    courseTermId: $courseTermId
    percentageGrade: $percentageGrade
  ) {
    success
    errors
  }
}
    `;
export const useOverrideEnrollmentGradeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<OverrideEnrollmentGradeMutation, TError, OverrideEnrollmentGradeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<OverrideEnrollmentGradeMutation, TError, OverrideEnrollmentGradeMutationVariables, TContext>(
      ['overrideEnrollmentGrade'],
      (variables?: OverrideEnrollmentGradeMutationVariables) => fetcher<OverrideEnrollmentGradeMutation, OverrideEnrollmentGradeMutationVariables>(client, OverrideEnrollmentGradeDocument, variables, headers)(),
      options
    );
useOverrideEnrollmentGradeMutation.fetcher = (client: GraphQLClient, variables: OverrideEnrollmentGradeMutationVariables, headers?: RequestInit['headers']) => fetcher<OverrideEnrollmentGradeMutation, OverrideEnrollmentGradeMutationVariables>(client, OverrideEnrollmentGradeDocument, variables, headers);
export const GenerateSubmissionSimilarityReportUrlDocument = `
    mutation generateSubmissionSimilarityReportUrl($submissionId: ID!) {
  generateSubmissionSimilarityReportUrl(submissionId: $submissionId) {
    success
    url
    errors
  }
}
    `;
export const useGenerateSubmissionSimilarityReportUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GenerateSubmissionSimilarityReportUrlMutation, TError, GenerateSubmissionSimilarityReportUrlMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GenerateSubmissionSimilarityReportUrlMutation, TError, GenerateSubmissionSimilarityReportUrlMutationVariables, TContext>(
      ['generateSubmissionSimilarityReportUrl'],
      (variables?: GenerateSubmissionSimilarityReportUrlMutationVariables) => fetcher<GenerateSubmissionSimilarityReportUrlMutation, GenerateSubmissionSimilarityReportUrlMutationVariables>(client, GenerateSubmissionSimilarityReportUrlDocument, variables, headers)(),
      options
    );
useGenerateSubmissionSimilarityReportUrlMutation.fetcher = (client: GraphQLClient, variables: GenerateSubmissionSimilarityReportUrlMutationVariables, headers?: RequestInit['headers']) => fetcher<GenerateSubmissionSimilarityReportUrlMutation, GenerateSubmissionSimilarityReportUrlMutationVariables>(client, GenerateSubmissionSimilarityReportUrlDocument, variables, headers);
export const CreateUnitTemplateDocument = `
    mutation createUnitTemplate($originalUnitId: ID!, $title: String!, $description: String, $subjects: [String!], $curriculum: [String!], $gradeLevels: [String!], $tags: [String!], $visibleTo: Visibility, $copyableBy: Visibility, $sourceAttributionId: ID) {
  createUnitTemplate(
    originalUnitId: $originalUnitId
    title: $title
    description: $description
    subjects: $subjects
    curriculum: $curriculum
    gradeLevels: $gradeLevels
    tags: $tags
    visibleTo: $visibleTo
    copyableBy: $copyableBy
    sourceAttributionId: $sourceAttributionId
  ) {
    unitTemplate {
      id
      title
    }
    errors
    success
  }
}
    `;
export const useCreateUnitTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateUnitTemplateMutation, TError, CreateUnitTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateUnitTemplateMutation, TError, CreateUnitTemplateMutationVariables, TContext>(
      ['createUnitTemplate'],
      (variables?: CreateUnitTemplateMutationVariables) => fetcher<CreateUnitTemplateMutation, CreateUnitTemplateMutationVariables>(client, CreateUnitTemplateDocument, variables, headers)(),
      options
    );
useCreateUnitTemplateMutation.fetcher = (client: GraphQLClient, variables: CreateUnitTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateUnitTemplateMutation, CreateUnitTemplateMutationVariables>(client, CreateUnitTemplateDocument, variables, headers);
export const UseUnitTemplateDocument = `
    mutation useUnitTemplate($id: Int!, $title: String!, $courseId: ID!, $keepDates: Boolean!, $startDate: ISO8601Date, $addAfterUnitId: Int) {
  useUnitTemplate(
    id: $id
    title: $title
    courseId: $courseId
    keepDates: $keepDates
    startDate: $startDate
    addAfterUnitId: $addAfterUnitId
  ) {
    unit {
      id
      course {
        id
      }
    }
    errors
    success
  }
}
    `;
export const useUseUnitTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UseUnitTemplateMutation, TError, UseUnitTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UseUnitTemplateMutation, TError, UseUnitTemplateMutationVariables, TContext>(
      ['useUnitTemplate'],
      (variables?: UseUnitTemplateMutationVariables) => fetcher<UseUnitTemplateMutation, UseUnitTemplateMutationVariables>(client, UseUnitTemplateDocument, variables, headers)(),
      options
    );
useUseUnitTemplateMutation.fetcher = (client: GraphQLClient, variables: UseUnitTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<UseUnitTemplateMutation, UseUnitTemplateMutationVariables>(client, UseUnitTemplateDocument, variables, headers);
export const DeleteUnitTemplateDocument = `
    mutation deleteUnitTemplate($id: Int!) {
  deleteUnitTemplate(id: $id) {
    errors
    success
  }
}
    `;
export const useDeleteUnitTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteUnitTemplateMutation, TError, DeleteUnitTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteUnitTemplateMutation, TError, DeleteUnitTemplateMutationVariables, TContext>(
      ['deleteUnitTemplate'],
      (variables?: DeleteUnitTemplateMutationVariables) => fetcher<DeleteUnitTemplateMutation, DeleteUnitTemplateMutationVariables>(client, DeleteUnitTemplateDocument, variables, headers)(),
      options
    );
useDeleteUnitTemplateMutation.fetcher = (client: GraphQLClient, variables: DeleteUnitTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteUnitTemplateMutation, DeleteUnitTemplateMutationVariables>(client, DeleteUnitTemplateDocument, variables, headers);
export const ValidateTokenDocument = `
    mutation validateToken {
  validateToken {
    errors {
      field
      message
    }
    success
    valid
  }
}
    `;
export const useValidateTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ValidateTokenMutation, TError, ValidateTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ValidateTokenMutation, TError, ValidateTokenMutationVariables, TContext>(
      ['validateToken'],
      (variables?: ValidateTokenMutationVariables) => fetcher<ValidateTokenMutation, ValidateTokenMutationVariables>(client, ValidateTokenDocument, variables, headers)(),
      options
    );
useValidateTokenMutation.fetcher = (client: GraphQLClient, variables?: ValidateTokenMutationVariables, headers?: RequestInit['headers']) => fetcher<ValidateTokenMutation, ValidateTokenMutationVariables>(client, ValidateTokenDocument, variables, headers);
export const AccountDetailsDocument = `
    query accountDetails {
  account {
    name
    schoolAddress
    schoolCity
    schoolState
    schoolZip
    timeZone
    subscriptionActive
    subscriptionPastDue
    subscriptionCancelled
    subscriptionCustomPrice
    subscriptionCustomInterval
    subscriptionEndDate
    subscriptionTrialEndDate
    subscriptionMaxActivities
    subscriptionMaxCourses
    subscriptionMaxInstructors
    subscriptionMaxStudents
    subscriptionTotalActivities
    subscriptionTotalCourses
    subscriptionTotalInstructors
    subscriptionTotalStudents
    subscriptionPlan {
      title
      description
      features
      productId
      priceAnnual
      priceMonthly
    }
  }
}
    `;
export const useAccountDetailsQuery = <
      TData = AccountDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AccountDetailsQueryVariables,
      options?: UseQueryOptions<AccountDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountDetailsQuery, TError, TData>(
      variables === undefined ? ['accountDetails'] : ['accountDetails', variables],
      fetcher<AccountDetailsQuery, AccountDetailsQueryVariables>(client, AccountDetailsDocument, variables, headers),
      options
    );
useAccountDetailsQuery.fetcher = (client: GraphQLClient, variables?: AccountDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<AccountDetailsQuery, AccountDetailsQueryVariables>(client, AccountDetailsDocument, variables, headers);
export const AccountRolesDocument = `
    query accountRoles {
  accountRoles {
    id
    name
    roleType
  }
}
    `;
export const useAccountRolesQuery = <
      TData = AccountRolesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AccountRolesQueryVariables,
      options?: UseQueryOptions<AccountRolesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountRolesQuery, TError, TData>(
      variables === undefined ? ['accountRoles'] : ['accountRoles', variables],
      fetcher<AccountRolesQuery, AccountRolesQueryVariables>(client, AccountRolesDocument, variables, headers),
      options
    );
useAccountRolesQuery.fetcher = (client: GraphQLClient, variables?: AccountRolesQueryVariables, headers?: RequestInit['headers']) => fetcher<AccountRolesQuery, AccountRolesQueryVariables>(client, AccountRolesDocument, variables, headers);
export const AccountUsersDocument = `
    query AccountUsers($includeInactive: Boolean) {
  accountUsers(includeInactive: $includeInactive) {
    id
    active
    initials
    birthDate
    firstName
    lastName
    fullName
    username
    calendarColor
    email
    oauthConnections
    systemAdmin
    imageFileEntry {
      ...FileEntryDefault
    }
    accountRole {
      id
      name
      roleType
    }
    unconfirmedEmail
    confirmedAt
    permissionLevel {
      id
      fixed
      name
      permissions
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useAccountUsersQuery = <
      TData = AccountUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AccountUsersQueryVariables,
      options?: UseQueryOptions<AccountUsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountUsersQuery, TError, TData>(
      variables === undefined ? ['AccountUsers'] : ['AccountUsers', variables],
      fetcher<AccountUsersQuery, AccountUsersQueryVariables>(client, AccountUsersDocument, variables, headers),
      options
    );
useAccountUsersQuery.fetcher = (client: GraphQLClient, variables?: AccountUsersQueryVariables, headers?: RequestInit['headers']) => fetcher<AccountUsersQuery, AccountUsersQueryVariables>(client, AccountUsersDocument, variables, headers);
export const AccountUsersNotificationsDocument = `
    query AccountUsersNotifications {
  accountUsers {
    id
    fullName
    firstName
    lastName
    initials
    minGradeNotificationThreshold
    notificationSettings
    pauseNotifications
    imageFileEntry {
      ...FileEntryDefault
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useAccountUsersNotificationsQuery = <
      TData = AccountUsersNotificationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AccountUsersNotificationsQueryVariables,
      options?: UseQueryOptions<AccountUsersNotificationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountUsersNotificationsQuery, TError, TData>(
      variables === undefined ? ['AccountUsersNotifications'] : ['AccountUsersNotifications', variables],
      fetcher<AccountUsersNotificationsQuery, AccountUsersNotificationsQueryVariables>(client, AccountUsersNotificationsDocument, variables, headers),
      options
    );
useAccountUsersNotificationsQuery.fetcher = (client: GraphQLClient, variables?: AccountUsersNotificationsQueryVariables, headers?: RequestInit['headers']) => fetcher<AccountUsersNotificationsQuery, AccountUsersNotificationsQueryVariables>(client, AccountUsersNotificationsDocument, variables, headers);
export const SubscriptionPlansDocument = `
    query subscriptionPlans {
  subscriptionPlans {
    id
    title
    description
    features
    productId
    priceAnnual
    priceMonthly
    annualPriceId
    monthlyPriceId
    maxCourses
    maxActivities
    maxInstructors
    maxStudents
  }
}
    `;
export const useSubscriptionPlansQuery = <
      TData = SubscriptionPlansQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SubscriptionPlansQueryVariables,
      options?: UseQueryOptions<SubscriptionPlansQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SubscriptionPlansQuery, TError, TData>(
      variables === undefined ? ['subscriptionPlans'] : ['subscriptionPlans', variables],
      fetcher<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(client, SubscriptionPlansDocument, variables, headers),
      options
    );
useSubscriptionPlansQuery.fetcher = (client: GraphQLClient, variables?: SubscriptionPlansQueryVariables, headers?: RequestInit['headers']) => fetcher<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(client, SubscriptionPlansDocument, variables, headers);
export const StripeUpcomingInvoiceDocument = `
    query stripeUpcomingInvoice {
  stripeUpcomingInvoice
}
    `;
export const useStripeUpcomingInvoiceQuery = <
      TData = StripeUpcomingInvoiceQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: StripeUpcomingInvoiceQueryVariables,
      options?: UseQueryOptions<StripeUpcomingInvoiceQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<StripeUpcomingInvoiceQuery, TError, TData>(
      variables === undefined ? ['stripeUpcomingInvoice'] : ['stripeUpcomingInvoice', variables],
      fetcher<StripeUpcomingInvoiceQuery, StripeUpcomingInvoiceQueryVariables>(client, StripeUpcomingInvoiceDocument, variables, headers),
      options
    );
useStripeUpcomingInvoiceQuery.fetcher = (client: GraphQLClient, variables?: StripeUpcomingInvoiceQueryVariables, headers?: RequestInit['headers']) => fetcher<StripeUpcomingInvoiceQuery, StripeUpcomingInvoiceQueryVariables>(client, StripeUpcomingInvoiceDocument, variables, headers);
export const UsersDocument = `
    query users {
  users {
    id
    fullName
    email
    initials
    username
    calendarColor
    imageFileEntry {
      id
      url
    }
    accountRole {
      id
      name
      roleType
    }
    primaryAccount {
      name
    }
  }
}
    `;
export const useUsersQuery = <
      TData = UsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: UsersQueryVariables,
      options?: UseQueryOptions<UsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UsersQuery, TError, TData>(
      variables === undefined ? ['users'] : ['users', variables],
      fetcher<UsersQuery, UsersQueryVariables>(client, UsersDocument, variables, headers),
      options
    );
useUsersQuery.fetcher = (client: GraphQLClient, variables?: UsersQueryVariables, headers?: RequestInit['headers']) => fetcher<UsersQuery, UsersQueryVariables>(client, UsersDocument, variables, headers);
export const CourseActivitiesCalendarDataDocument = `
    query CourseActivitiesCalendarData($startDate: ISO8601Date!, $endDate: ISO8601Date) {
  courseActivities(startDate: $startDate, endDate: $endDate) {
    id
    assignDate
    dueDate
    dueTimeSignificant
    item {
      id
      title
      type
    }
    unit {
      id
      title
      course {
        id
        iconColor
        title
      }
    }
  }
}
    `;
export const useCourseActivitiesCalendarDataQuery = <
      TData = CourseActivitiesCalendarDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CourseActivitiesCalendarDataQueryVariables,
      options?: UseQueryOptions<CourseActivitiesCalendarDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseActivitiesCalendarDataQuery, TError, TData>(
      ['CourseActivitiesCalendarData', variables],
      fetcher<CourseActivitiesCalendarDataQuery, CourseActivitiesCalendarDataQueryVariables>(client, CourseActivitiesCalendarDataDocument, variables, headers),
      options
    );
useCourseActivitiesCalendarDataQuery.fetcher = (client: GraphQLClient, variables: CourseActivitiesCalendarDataQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseActivitiesCalendarDataQuery, CourseActivitiesCalendarDataQueryVariables>(client, CourseActivitiesCalendarDataDocument, variables, headers);
export const CalendarPrintedScheduleDocument = `
    query CalendarPrintedSchedule($userIds: [ID!], $startDate: ISO8601Date!, $endDate: ISO8601Date!, $courseIds: [ID!], $scheduleType: PrintSchedule!, $viewOptions: [PrintShowOption!]) {
  printedSchedule(
    userIds: $userIds
    startDate: $startDate
    endDate: $endDate
    courseIds: $courseIds
    scheduleType: $scheduleType
    viewOptions: $viewOptions
  )
}
    `;
export const useCalendarPrintedScheduleQuery = <
      TData = CalendarPrintedScheduleQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CalendarPrintedScheduleQueryVariables,
      options?: UseQueryOptions<CalendarPrintedScheduleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CalendarPrintedScheduleQuery, TError, TData>(
      ['CalendarPrintedSchedule', variables],
      fetcher<CalendarPrintedScheduleQuery, CalendarPrintedScheduleQueryVariables>(client, CalendarPrintedScheduleDocument, variables, headers),
      options
    );
useCalendarPrintedScheduleQuery.fetcher = (client: GraphQLClient, variables: CalendarPrintedScheduleQueryVariables, headers?: RequestInit['headers']) => fetcher<CalendarPrintedScheduleQuery, CalendarPrintedScheduleQueryVariables>(client, CalendarPrintedScheduleDocument, variables, headers);
export const CalendarEventsDocument = `
    query CalendarEvents($startDate: ISO8601Date!, $endDate: ISO8601Date, $calendarIds: [ID!], $keyword: String) {
  calendarEvents(
    startDate: $startDate
    endDate: $endDate
    calendarIds: $calendarIds
    keyword: $keyword
  ) {
    id
    title
    details
    url
    date
    timeStart
    timeEnd
    calendar {
      id
      title
      color
    }
    course {
      id
      title
      iconColor
      currentEnrollment {
        id
        role {
          id
          type
          name
          permissions
        }
      }
    }
    createdBy {
      id
      fullName
      initials
      calendarColor
    }
  }
}
    `;
export const useCalendarEventsQuery = <
      TData = CalendarEventsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CalendarEventsQueryVariables,
      options?: UseQueryOptions<CalendarEventsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CalendarEventsQuery, TError, TData>(
      ['CalendarEvents', variables],
      fetcher<CalendarEventsQuery, CalendarEventsQueryVariables>(client, CalendarEventsDocument, variables, headers),
      options
    );
useCalendarEventsQuery.fetcher = (client: GraphQLClient, variables: CalendarEventsQueryVariables, headers?: RequestInit['headers']) => fetcher<CalendarEventsQuery, CalendarEventsQueryVariables>(client, CalendarEventsDocument, variables, headers);
export const CalendarsDocument = `
    query Calendars {
  calendars {
    id
    title
    color
    familyAccount {
      name
    }
    owner {
      id
      fullName
      initials
      calendarColor
    }
    readOnly
    users {
      id
      fullName
      initials
      calendarColor
    }
  }
}
    `;
export const useCalendarsQuery = <
      TData = CalendarsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CalendarsQueryVariables,
      options?: UseQueryOptions<CalendarsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CalendarsQuery, TError, TData>(
      variables === undefined ? ['Calendars'] : ['Calendars', variables],
      fetcher<CalendarsQuery, CalendarsQueryVariables>(client, CalendarsDocument, variables, headers),
      options
    );
useCalendarsQuery.fetcher = (client: GraphQLClient, variables?: CalendarsQueryVariables, headers?: RequestInit['headers']) => fetcher<CalendarsQuery, CalendarsQueryVariables>(client, CalendarsDocument, variables, headers);
export const IcalFeedUrlDocument = `
    query icalFeedUrl($calendarIds: [ID!], $startDate: ISO8601Date, $endDate: ISO8601Date, $userIds: [ID!], $courseIds: [ID!]) {
  icalFeedUrl(
    calendarIds: $calendarIds
    startDate: $startDate
    endDate: $endDate
    userIds: $userIds
    courseIds: $courseIds
  )
}
    `;
export const useIcalFeedUrlQuery = <
      TData = IcalFeedUrlQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: IcalFeedUrlQueryVariables,
      options?: UseQueryOptions<IcalFeedUrlQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<IcalFeedUrlQuery, TError, TData>(
      variables === undefined ? ['icalFeedUrl'] : ['icalFeedUrl', variables],
      fetcher<IcalFeedUrlQuery, IcalFeedUrlQueryVariables>(client, IcalFeedUrlDocument, variables, headers),
      options
    );
useIcalFeedUrlQuery.fetcher = (client: GraphQLClient, variables?: IcalFeedUrlQueryVariables, headers?: RequestInit['headers']) => fetcher<IcalFeedUrlQuery, IcalFeedUrlQueryVariables>(client, IcalFeedUrlDocument, variables, headers);
export const CommentsDocument = `
    query Comments($objectId: ID!, $objectType: CommentableObject!, $markRead: Boolean) {
  comments(objectId: $objectId, objectType: $objectType, markRead: $markRead) {
    ...CommentFragment
  }
}
    ${CommentFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useCommentsQuery = <
      TData = CommentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CommentsQueryVariables,
      options?: UseQueryOptions<CommentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CommentsQuery, TError, TData>(
      ['Comments', variables],
      fetcher<CommentsQuery, CommentsQueryVariables>(client, CommentsDocument, variables, headers),
      options
    );
useCommentsQuery.fetcher = (client: GraphQLClient, variables: CommentsQueryVariables, headers?: RequestInit['headers']) => fetcher<CommentsQuery, CommentsQueryVariables>(client, CommentsDocument, variables, headers);
export const CommentedItemsDocument = `
    query CommentedItems {
  commentedItems {
    id
    type
    comments {
      ...CommentFragment
    }
    ... on PrivateDiscussion {
      users {
        id
      }
      enrollments {
        id
        user {
          id
          fullName
        }
        role {
          id
          type
          name
        }
      }
      targetItem {
        id
        type
        ... on Activity {
          item {
            id
            title
            type
          }
          unit {
            id
            title
            course {
              id
              title
              iconColor
            }
          }
        }
      }
    }
    ... on Activity {
      item {
        id
        title
      }
      unit {
        id
        title
        course {
          id
          title
        }
      }
    }
  }
}
    ${CommentFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useCommentedItemsQuery = <
      TData = CommentedItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CommentedItemsQueryVariables,
      options?: UseQueryOptions<CommentedItemsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CommentedItemsQuery, TError, TData>(
      variables === undefined ? ['CommentedItems'] : ['CommentedItems', variables],
      fetcher<CommentedItemsQuery, CommentedItemsQueryVariables>(client, CommentedItemsDocument, variables, headers),
      options
    );
useCommentedItemsQuery.fetcher = (client: GraphQLClient, variables?: CommentedItemsQueryVariables, headers?: RequestInit['headers']) => fetcher<CommentedItemsQuery, CommentedItemsQueryVariables>(client, CommentedItemsDocument, variables, headers);
export const ContactableUsersDocument = `
    query contactableUsers($conversationId: ID) {
  contactableUsers(conversationId: $conversationId) {
    id
    fullName
    calendarColor
    initials
    accountRole {
      id
      name
      roleType
    }
    imageFileEntry {
      url
    }
  }
}
    `;
export const useContactableUsersQuery = <
      TData = ContactableUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ContactableUsersQueryVariables,
      options?: UseQueryOptions<ContactableUsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ContactableUsersQuery, TError, TData>(
      variables === undefined ? ['contactableUsers'] : ['contactableUsers', variables],
      fetcher<ContactableUsersQuery, ContactableUsersQueryVariables>(client, ContactableUsersDocument, variables, headers),
      options
    );
useContactableUsersQuery.fetcher = (client: GraphQLClient, variables?: ContactableUsersQueryVariables, headers?: RequestInit['headers']) => fetcher<ContactableUsersQuery, ContactableUsersQueryVariables>(client, ContactableUsersDocument, variables, headers);
export const ContactableCourseMemberGroupTypesDocument = `
    query contactableCourseMemberGroupTypes {
  contactableCourseMemberGroupTypes {
    course {
      id
      title
      iconColor
    }
    memberGroupTypes
  }
}
    `;
export const useContactableCourseMemberGroupTypesQuery = <
      TData = ContactableCourseMemberGroupTypesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ContactableCourseMemberGroupTypesQueryVariables,
      options?: UseQueryOptions<ContactableCourseMemberGroupTypesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ContactableCourseMemberGroupTypesQuery, TError, TData>(
      variables === undefined ? ['contactableCourseMemberGroupTypes'] : ['contactableCourseMemberGroupTypes', variables],
      fetcher<ContactableCourseMemberGroupTypesQuery, ContactableCourseMemberGroupTypesQueryVariables>(client, ContactableCourseMemberGroupTypesDocument, variables, headers),
      options
    );
useContactableCourseMemberGroupTypesQuery.fetcher = (client: GraphQLClient, variables?: ContactableCourseMemberGroupTypesQueryVariables, headers?: RequestInit['headers']) => fetcher<ContactableCourseMemberGroupTypesQuery, ContactableCourseMemberGroupTypesQueryVariables>(client, ContactableCourseMemberGroupTypesDocument, variables, headers);
export const ConversationsListDocument = `
    query conversationsList {
  conversations {
    id
    title
    isMuted
    isClosed
    isViewed
    permissions
    iconFileEntry {
      id
      title
      url
      croppedUrl
    }
    moderators {
      id
      fullName
      initials
      calendarColor
      imageFileEntry {
        url
      }
    }
    participants {
      id
      fullName
      initials
      calendarColor
      imageFileEntry {
        url
      }
    }
    courseParticipantEnrollments {
      id
      course {
        id
        title
      }
      user {
        id
        fullName
        initials
        calendarColor
        imageFileEntry {
          url
        }
      }
      role {
        id
        type
        name
      }
    }
    owner {
      id
      fullName
      initials
      calendarColor
      imageFileEntry {
        url
      }
    }
    lastMessage {
      ...ConversationMessageFragment
    }
    createdAt
    updatedAt
    participatingCourseMemberGroups {
      course {
        id
        title
        iconColor
      }
      memberGroupTypes
    }
    participatingUsers {
      id
      fullName
      initials
      calendarColor
      imageFileEntry {
        url
      }
    }
  }
}
    ${ConversationMessageFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useConversationsListQuery = <
      TData = ConversationsListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ConversationsListQueryVariables,
      options?: UseQueryOptions<ConversationsListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ConversationsListQuery, TError, TData>(
      variables === undefined ? ['conversationsList'] : ['conversationsList', variables],
      fetcher<ConversationsListQuery, ConversationsListQueryVariables>(client, ConversationsListDocument, variables, headers),
      options
    );
useConversationsListQuery.fetcher = (client: GraphQLClient, variables?: ConversationsListQueryVariables, headers?: RequestInit['headers']) => fetcher<ConversationsListQuery, ConversationsListQueryVariables>(client, ConversationsListDocument, variables, headers);
export const ConversationMessagesDocument = `
    query conversationMessages($id: ID!) {
  conversationMessages(conversationId: $id) {
    ...ConversationMessageFragment
  }
}
    ${ConversationMessageFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useConversationMessagesQuery = <
      TData = ConversationMessagesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ConversationMessagesQueryVariables,
      options?: UseQueryOptions<ConversationMessagesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ConversationMessagesQuery, TError, TData>(
      ['conversationMessages', variables],
      fetcher<ConversationMessagesQuery, ConversationMessagesQueryVariables>(client, ConversationMessagesDocument, variables, headers),
      options
    );
useConversationMessagesQuery.fetcher = (client: GraphQLClient, variables: ConversationMessagesQueryVariables, headers?: RequestInit['headers']) => fetcher<ConversationMessagesQuery, ConversationMessagesQueryVariables>(client, ConversationMessagesDocument, variables, headers);
export const CoursesDocument = `
    query Courses($ids: [ID!], $userId: ID, $unitIds: [ID!], $includeGrading: Boolean!, $includeActivityGroups: Boolean!, $courseTermId: ID, $includeHiddenUnits: Boolean) {
  courses(ids: $ids, userId: $userId) {
    ...CourseFragment
    activityGroups @include(if: $includeActivityGroups) {
      ...CourseActivityGroups
    }
    gradingScheme @include(if: $includeGrading) {
      ...CourseGradingSchema
    }
    units(
      ids: $unitIds
      includeHidden: $includeHiddenUnits
      courseTermId: $courseTermId
    ) {
      ...UnitDetails
    }
  }
}
    ${CourseFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}
${CourseActivityGroupsFragmentDoc}
${CourseGradingSchemaFragmentDoc}
${UnitDetailsFragmentDoc}`;
export const useCoursesQuery = <
      TData = CoursesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CoursesQueryVariables,
      options?: UseQueryOptions<CoursesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesQuery, TError, TData>(
      ['Courses', variables],
      fetcher<CoursesQuery, CoursesQueryVariables>(client, CoursesDocument, variables, headers),
      options
    );
useCoursesQuery.fetcher = (client: GraphQLClient, variables: CoursesQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesQuery, CoursesQueryVariables>(client, CoursesDocument, variables, headers);
export const CoursesWithActivitiesDocument = `
    query CoursesWithActivities($ids: [ID!], $userId: ID!, $unitIds: [ID!], $activityIds: [ID!], $includeDrafts: Boolean, $courseTermId: ID, $includeHiddenUnits: Boolean) {
  courses(ids: $ids, userId: $userId) {
    ...CourseFragment
    currentEnrollment {
      id
      status
      role {
        id
        fixed
        name
        type
        permissions
      }
    }
    enrollments(userIds: [$userId], includePast: false) {
      id
      role {
        id
        fixed
        name
        type
      }
    }
    units(
      ids: $unitIds
      includeHidden: $includeHiddenUnits
      courseTermId: $courseTermId
    ) {
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      ...UnitDetails
      activities(ids: $activityIds, includeDrafts: $includeDrafts) {
        ...ActivitiesDetails
        item {
          id
          title
          type
        }
      }
    }
  }
}
    ${CourseFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}
${UnitDetailsFragmentDoc}
${ActivitiesDetailsFragmentDoc}`;
export const useCoursesWithActivitiesQuery = <
      TData = CoursesWithActivitiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CoursesWithActivitiesQueryVariables,
      options?: UseQueryOptions<CoursesWithActivitiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesWithActivitiesQuery, TError, TData>(
      ['CoursesWithActivities', variables],
      fetcher<CoursesWithActivitiesQuery, CoursesWithActivitiesQueryVariables>(client, CoursesWithActivitiesDocument, variables, headers),
      options
    );
useCoursesWithActivitiesQuery.fetcher = (client: GraphQLClient, variables: CoursesWithActivitiesQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesWithActivitiesQuery, CoursesWithActivitiesQueryVariables>(client, CoursesWithActivitiesDocument, variables, headers);
export const CoursesWithActivitiyItemsDocument = `
    query CoursesWithActivitiyItems($ids: [ID!], $userId: ID, $unitIds: [ID!], $activityIds: [ID!], $includeDrafts: Boolean, $courseTermId: ID, $includeHiddenUnits: Boolean, $includeHiddenQuestions: Boolean) {
  courses(ids: $ids, userId: $userId) {
    ...CourseFragment
    gradingScheme {
      ...CourseGradingSchema
    }
    activityGroups {
      ...CourseActivityGroups
    }
    units(
      ids: $unitIds
      includeHidden: $includeHiddenUnits
      courseTermId: $courseTermId
    ) {
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      ...UnitDetails
      activities(ids: $activityIds, includeDrafts: $includeDrafts) {
        ...ActivitiesDetails
        item {
          ...ActivityItemFragment
          ... on Assignment {
            ...AssignmentFragment
          }
          ... on Quiz {
            ...QuizFragment
            questions(includeHidden: $includeHiddenQuestions) {
              ...QuizQuestionFragment
            }
          }
        }
      }
    }
  }
}
    ${CourseFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}
${CourseGradingSchemaFragmentDoc}
${CourseActivityGroupsFragmentDoc}
${UnitDetailsFragmentDoc}
${ActivitiesDetailsFragmentDoc}
${ActivityItemFragmentFragmentDoc}
${AssignmentFragmentFragmentDoc}
${QuizFragmentFragmentDoc}
${QuizQuestionFragmentFragmentDoc}`;
export const useCoursesWithActivitiyItemsQuery = <
      TData = CoursesWithActivitiyItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CoursesWithActivitiyItemsQueryVariables,
      options?: UseQueryOptions<CoursesWithActivitiyItemsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesWithActivitiyItemsQuery, TError, TData>(
      variables === undefined ? ['CoursesWithActivitiyItems'] : ['CoursesWithActivitiyItems', variables],
      fetcher<CoursesWithActivitiyItemsQuery, CoursesWithActivitiyItemsQueryVariables>(client, CoursesWithActivitiyItemsDocument, variables, headers),
      options
    );
useCoursesWithActivitiyItemsQuery.fetcher = (client: GraphQLClient, variables?: CoursesWithActivitiyItemsQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesWithActivitiyItemsQuery, CoursesWithActivitiyItemsQueryVariables>(client, CoursesWithActivitiyItemsDocument, variables, headers);
export const CoursesRolesDocument = `
    query CoursesRoles($ids: [ID!], $userId: ID) {
  courses(ids: $ids, userId: $userId) {
    id
    schedulingMode
    graded
    roles {
      id
      name
      permissions
      fixed
      type
      enrollments {
        id
        user {
          id
          fullName
          calendarColor
          initials
          imageFileEntry {
            ...FileEntryDefault
          }
        }
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useCoursesRolesQuery = <
      TData = CoursesRolesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CoursesRolesQueryVariables,
      options?: UseQueryOptions<CoursesRolesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesRolesQuery, TError, TData>(
      variables === undefined ? ['CoursesRoles'] : ['CoursesRoles', variables],
      fetcher<CoursesRolesQuery, CoursesRolesQueryVariables>(client, CoursesRolesDocument, variables, headers),
      options
    );
useCoursesRolesQuery.fetcher = (client: GraphQLClient, variables?: CoursesRolesQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesRolesQuery, CoursesRolesQueryVariables>(client, CoursesRolesDocument, variables, headers);
export const CoursesInviteCodesDocument = `
    query CoursesInviteCodes($ids: [ID!]) {
  courses(ids: $ids) {
    id
    title
    inviteCode
    inviteCodeExpiresAt
    timeZone
    requireJoinConfirmation
    autoRegenerateInviteCode
  }
}
    `;
export const useCoursesInviteCodesQuery = <
      TData = CoursesInviteCodesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CoursesInviteCodesQueryVariables,
      options?: UseQueryOptions<CoursesInviteCodesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesInviteCodesQuery, TError, TData>(
      variables === undefined ? ['CoursesInviteCodes'] : ['CoursesInviteCodes', variables],
      fetcher<CoursesInviteCodesQuery, CoursesInviteCodesQueryVariables>(client, CoursesInviteCodesDocument, variables, headers),
      options
    );
useCoursesInviteCodesQuery.fetcher = (client: GraphQLClient, variables?: CoursesInviteCodesQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesInviteCodesQuery, CoursesInviteCodesQueryVariables>(client, CoursesInviteCodesDocument, variables, headers);
export const CourseNotificationsDocument = `
    query CourseNotifications($ids: [ID!], $userId: ID) {
  courses(ids: $ids, userId: $userId) {
    id
    title
  }
}
    `;
export const useCourseNotificationsQuery = <
      TData = CourseNotificationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CourseNotificationsQueryVariables,
      options?: UseQueryOptions<CourseNotificationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseNotificationsQuery, TError, TData>(
      variables === undefined ? ['CourseNotifications'] : ['CourseNotifications', variables],
      fetcher<CourseNotificationsQuery, CourseNotificationsQueryVariables>(client, CourseNotificationsDocument, variables, headers),
      options
    );
useCourseNotificationsQuery.fetcher = (client: GraphQLClient, variables?: CourseNotificationsQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseNotificationsQuery, CourseNotificationsQueryVariables>(client, CourseNotificationsDocument, variables, headers);
export const CourseTermsDocument = `
    query CourseTerms($ids: [ID!], $userId: ID) {
  courses(ids: $ids, userId: $userId) {
    id
    title
    terms {
      id
      title
      weight
      accessible
      published
      publishable
      forGradebook
      units {
        id
        title
      }
    }
  }
}
    `;
export const useCourseTermsQuery = <
      TData = CourseTermsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CourseTermsQueryVariables,
      options?: UseQueryOptions<CourseTermsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseTermsQuery, TError, TData>(
      variables === undefined ? ['CourseTerms'] : ['CourseTerms', variables],
      fetcher<CourseTermsQuery, CourseTermsQueryVariables>(client, CourseTermsDocument, variables, headers),
      options
    );
useCourseTermsQuery.fetcher = (client: GraphQLClient, variables?: CourseTermsQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseTermsQuery, CourseTermsQueryVariables>(client, CourseTermsDocument, variables, headers);
export const CourseByInviteDocument = `
    query CourseByInvite($inviteCode: String!, $userIds: [ID!]) {
  courseByInvite(inviteCode: $inviteCode) {
    id
    title
    enrollments(userIds: $userIds) {
      id
      needsConfirmJoin
      user {
        id
      }
    }
  }
}
    `;
export const useCourseByInviteQuery = <
      TData = CourseByInviteQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CourseByInviteQueryVariables,
      options?: UseQueryOptions<CourseByInviteQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseByInviteQuery, TError, TData>(
      ['CourseByInvite', variables],
      fetcher<CourseByInviteQuery, CourseByInviteQueryVariables>(client, CourseByInviteDocument, variables, headers),
      options
    );
useCourseByInviteQuery.fetcher = (client: GraphQLClient, variables: CourseByInviteQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseByInviteQuery, CourseByInviteQueryVariables>(client, CourseByInviteDocument, variables, headers);
export const CourseActivityBatchesDocument = `
    query CourseActivityBatches($ids: [ID!], $userId: ID, $unitIds: [ID!], $courseTermId: ID) {
  courses(ids: $ids, userId: $userId) {
    id
    title
    scheduledDaysOff
    scheduledWeekdays
    schedulingMode
    graded
    activityGroups {
      ...CourseActivityGroups
    }
    units(ids: $unitIds, includeHidden: true, courseTermId: $courseTermId) {
      id
      title
      visible
      description
      courseTerm {
        id
        published
        title
        accessible
        weight
      }
    }
    activityBatches {
      ...ActivityBatchDefault
    }
  }
}
    ${CourseActivityGroupsFragmentDoc}
${ActivityBatchDefaultFragmentDoc}`;
export const useCourseActivityBatchesQuery = <
      TData = CourseActivityBatchesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CourseActivityBatchesQueryVariables,
      options?: UseQueryOptions<CourseActivityBatchesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseActivityBatchesQuery, TError, TData>(
      variables === undefined ? ['CourseActivityBatches'] : ['CourseActivityBatches', variables],
      fetcher<CourseActivityBatchesQuery, CourseActivityBatchesQueryVariables>(client, CourseActivityBatchesDocument, variables, headers),
      options
    );
useCourseActivityBatchesQuery.fetcher = (client: GraphQLClient, variables?: CourseActivityBatchesQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseActivityBatchesQuery, CourseActivityBatchesQueryVariables>(client, CourseActivityBatchesDocument, variables, headers);
export const CourseMetaDataDocument = `
    query CourseMetaData($ids: [ID!], $userId: ID!) {
  courses(ids: $ids, userId: $userId) {
    ...CourseFragment
    activityGroups {
      ...CourseActivityGroups
    }
    gradingScheme {
      ...CourseGradingSchema
    }
    currentEnrollment {
      id
      status
      role {
        id
        fixed
        name
        type
        permissions
      }
    }
    enrollments(userIds: [$userId], includePast: false) {
      id
      role {
        id
        fixed
        name
        type
      }
    }
  }
}
    ${CourseFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}
${CourseActivityGroupsFragmentDoc}
${CourseGradingSchemaFragmentDoc}`;
export const useCourseMetaDataQuery = <
      TData = CourseMetaDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CourseMetaDataQueryVariables,
      options?: UseQueryOptions<CourseMetaDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseMetaDataQuery, TError, TData>(
      ['CourseMetaData', variables],
      fetcher<CourseMetaDataQuery, CourseMetaDataQueryVariables>(client, CourseMetaDataDocument, variables, headers),
      options
    );
useCourseMetaDataQuery.fetcher = (client: GraphQLClient, variables: CourseMetaDataQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseMetaDataQuery, CourseMetaDataQueryVariables>(client, CourseMetaDataDocument, variables, headers);
export const CourseUnitsDataDocument = `
    query CourseUnitsData($ids: [ID!], $userId: ID!, $unitIds: [ID!], $includeHidden: Boolean, $courseTermId: ID, $activityIds: [ID!], $includeDraft: Boolean, $includeActivities: Boolean!, $onlyVisible: Boolean) {
  courses(ids: $ids, userId: $userId) {
    title
    id
    units(ids: $unitIds, includeHidden: $includeHidden, courseTermId: $courseTermId) {
      ...UnitDetails
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      activities(
        ids: $activityIds
        includeDrafts: $includeDraft
        onlyVisible: $onlyVisible
      ) @include(if: $includeActivities) {
        id
        visible
        published
        item {
          id
          title
          type
        }
      }
    }
  }
}
    ${UnitDetailsFragmentDoc}`;
export const useCourseUnitsDataQuery = <
      TData = CourseUnitsDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CourseUnitsDataQueryVariables,
      options?: UseQueryOptions<CourseUnitsDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseUnitsDataQuery, TError, TData>(
      ['CourseUnitsData', variables],
      fetcher<CourseUnitsDataQuery, CourseUnitsDataQueryVariables>(client, CourseUnitsDataDocument, variables, headers),
      options
    );
useCourseUnitsDataQuery.fetcher = (client: GraphQLClient, variables: CourseUnitsDataQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseUnitsDataQuery, CourseUnitsDataQueryVariables>(client, CourseUnitsDataDocument, variables, headers);
export const CourseUnitsDataStudentsDataDocument = `
    query CourseUnitsDataStudentsData($ids: [ID!], $userId: ID!, $unitIds: [ID!], $includeHidden: Boolean, $courseTermId: ID, $activityIds: [ID!], $includeDraft: Boolean, $includeActivities: Boolean!, $onlyVisible: Boolean) {
  courses(ids: $ids, userId: $userId) {
    title
    id
    units(ids: $unitIds, includeHidden: $includeHidden, courseTermId: $courseTermId) {
      ...UnitDetails
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      activities(
        ids: $activityIds
        includeDrafts: $includeDraft
        onlyVisible: $onlyVisible
      ) @include(if: $includeActivities) {
        id
        visible
        published
        item {
          id
          title
          type
        }
        studentSubmissions {
          mainStatus
          subStatus
          dueStatus
        }
      }
    }
  }
}
    ${UnitDetailsFragmentDoc}`;
export const useCourseUnitsDataStudentsDataQuery = <
      TData = CourseUnitsDataStudentsDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CourseUnitsDataStudentsDataQueryVariables,
      options?: UseQueryOptions<CourseUnitsDataStudentsDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseUnitsDataStudentsDataQuery, TError, TData>(
      ['CourseUnitsDataStudentsData', variables],
      fetcher<CourseUnitsDataStudentsDataQuery, CourseUnitsDataStudentsDataQueryVariables>(client, CourseUnitsDataStudentsDataDocument, variables, headers),
      options
    );
useCourseUnitsDataStudentsDataQuery.fetcher = (client: GraphQLClient, variables: CourseUnitsDataStudentsDataQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseUnitsDataStudentsDataQuery, CourseUnitsDataStudentsDataQueryVariables>(client, CourseUnitsDataStudentsDataDocument, variables, headers);
export const CourseUnitActivitiesDataDocument = `
    query CourseUnitActivitiesData($ids: [ID!], $userId: ID!, $unitIds: [ID!], $includeHidden: Boolean, $courseTermId: ID, $activityIds: [ID!], $includeDraft: Boolean, $includeHiddenQuestions: Boolean, $onlyVisible: Boolean) {
  courses(ids: $ids, userId: $userId) {
    id
    units(ids: $unitIds, includeHidden: $includeHidden, courseTermId: $courseTermId) {
      ...UnitDetails
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      activities(
        ids: $activityIds
        includeDrafts: $includeDraft
        onlyVisible: $onlyVisible
      ) {
        ...ActivitiesDetails
        item {
          ...ActivityItemFragment
          ... on Assignment {
            ...AssignmentFragment
          }
          ... on Quiz {
            ...QuizFragment
            questions(includeHidden: $includeHiddenQuestions) {
              ...QuizQuestionFragment
            }
          }
        }
        studentSubmissions {
          mainStatus
          subStatus
          dueStatus
          status
        }
      }
    }
  }
}
    ${UnitDetailsFragmentDoc}
${ActivitiesDetailsFragmentDoc}
${ActivityItemFragmentFragmentDoc}
${AssignmentFragmentFragmentDoc}
${QuizFragmentFragmentDoc}
${QuizQuestionFragmentFragmentDoc}`;
export const useCourseUnitActivitiesDataQuery = <
      TData = CourseUnitActivitiesDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CourseUnitActivitiesDataQueryVariables,
      options?: UseQueryOptions<CourseUnitActivitiesDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseUnitActivitiesDataQuery, TError, TData>(
      ['CourseUnitActivitiesData', variables],
      fetcher<CourseUnitActivitiesDataQuery, CourseUnitActivitiesDataQueryVariables>(client, CourseUnitActivitiesDataDocument, variables, headers),
      options
    );
useCourseUnitActivitiesDataQuery.fetcher = (client: GraphQLClient, variables: CourseUnitActivitiesDataQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseUnitActivitiesDataQuery, CourseUnitActivitiesDataQueryVariables>(client, CourseUnitActivitiesDataDocument, variables, headers);
export const CourseTermsDataDocument = `
    query CourseTermsData($ids: [ID!], $userId: ID) {
  courses(ids: $ids, userId: $userId) {
    id
    title
    terms {
      id
      title
      weight
      accessible
      published
      publishable
      units {
        id
        title
      }
    }
  }
}
    `;
export const useCourseTermsDataQuery = <
      TData = CourseTermsDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CourseTermsDataQueryVariables,
      options?: UseQueryOptions<CourseTermsDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseTermsDataQuery, TError, TData>(
      variables === undefined ? ['CourseTermsData'] : ['CourseTermsData', variables],
      fetcher<CourseTermsDataQuery, CourseTermsDataQueryVariables>(client, CourseTermsDataDocument, variables, headers),
      options
    );
useCourseTermsDataQuery.fetcher = (client: GraphQLClient, variables?: CourseTermsDataQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseTermsDataQuery, CourseTermsDataQueryVariables>(client, CourseTermsDataDocument, variables, headers);
export const CoursesRolesDataDocument = `
    query CoursesRolesData($ids: [ID!], $userId: ID) {
  courses(ids: $ids, userId: $userId) {
    id
    currentEnrollment {
      id
      status
      role {
        id
        type
        permissions
      }
    }
    roles {
      id
      name
      permissions
      fixed
      type
      enrollments {
        id
        user {
          id
          fullName
          calendarColor
          initials
          imageFileEntry {
            ...FileEntryDefault
          }
        }
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useCoursesRolesDataQuery = <
      TData = CoursesRolesDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CoursesRolesDataQueryVariables,
      options?: UseQueryOptions<CoursesRolesDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesRolesDataQuery, TError, TData>(
      variables === undefined ? ['CoursesRolesData'] : ['CoursesRolesData', variables],
      fetcher<CoursesRolesDataQuery, CoursesRolesDataQueryVariables>(client, CoursesRolesDataDocument, variables, headers),
      options
    );
useCoursesRolesDataQuery.fetcher = (client: GraphQLClient, variables?: CoursesRolesDataQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesRolesDataQuery, CoursesRolesDataQueryVariables>(client, CoursesRolesDataDocument, variables, headers);
export const StudentCurrentAverageDocument = `
    query StudentCurrentAverage($ids: [ID!], $userId: ID!) {
  courses(ids: $ids, userId: $userId) {
    id
    graded
    gradingScheme {
      ...CourseGradingSchema
    }
    currentTerm {
      title
    }
    enrollments(userIds: [$userId]) {
      id
      averageGrade
      role {
        name
        type
      }
    }
  }
}
    ${CourseGradingSchemaFragmentDoc}`;
export const useStudentCurrentAverageQuery = <
      TData = StudentCurrentAverageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: StudentCurrentAverageQueryVariables,
      options?: UseQueryOptions<StudentCurrentAverageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<StudentCurrentAverageQuery, TError, TData>(
      ['StudentCurrentAverage', variables],
      fetcher<StudentCurrentAverageQuery, StudentCurrentAverageQueryVariables>(client, StudentCurrentAverageDocument, variables, headers),
      options
    );
useStudentCurrentAverageQuery.fetcher = (client: GraphQLClient, variables: StudentCurrentAverageQueryVariables, headers?: RequestInit['headers']) => fetcher<StudentCurrentAverageQuery, StudentCurrentAverageQueryVariables>(client, StudentCurrentAverageDocument, variables, headers);
export const AccountCoursesDocument = `
    query AccountCourses($includeArchived: Boolean, $page: Int, $perPage: Int, $userIds: [ID!], $searchKey: String) {
  accountCourses(
    includeArchived: $includeArchived
    page: $page
    perPage: $perPage
    searchKey: $searchKey
  ) {
    items {
      id
      title
      iconColor
      createdAt
      enrollments(userIds: $userIds) {
        id
        user {
          id
          fullName
          initials
          calendarColor
          imageFileEntry {
            url
          }
        }
        role {
          id
          name
          type
        }
      }
    }
    totalCount
    totalPages
  }
}
    `;
export const useAccountCoursesQuery = <
      TData = AccountCoursesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AccountCoursesQueryVariables,
      options?: UseQueryOptions<AccountCoursesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountCoursesQuery, TError, TData>(
      variables === undefined ? ['AccountCourses'] : ['AccountCourses', variables],
      fetcher<AccountCoursesQuery, AccountCoursesQueryVariables>(client, AccountCoursesDocument, variables, headers),
      options
    );
useAccountCoursesQuery.fetcher = (client: GraphQLClient, variables?: AccountCoursesQueryVariables, headers?: RequestInit['headers']) => fetcher<AccountCoursesQuery, AccountCoursesQueryVariables>(client, AccountCoursesDocument, variables, headers);
export const AccountEnrollmentsDocument = `
    query AccountEnrollments($includePast: Boolean, $includePending: Boolean, $page: Int, $perPage: Int, $searchKey: String, $rolePrefix: String) {
  accountEnrollments(
    includePast: $includePast
    includePending: $includePending
    page: $page
    perPage: $perPage
    searchKey: $searchKey
    rolePrefix: $rolePrefix
  ) {
    items {
      averageGrade
      children {
        user {
          id
          birthDate
          email
          fullName
          initials
          calendarColor
          imageFileEntry {
            url
          }
        }
      }
      course {
        id
        title
        iconColor
        gradingScheme {
          ...CourseGradingSchema
        }
        currentTerm {
          title
        }
      }
      createdAt
      id
      lastActivityAt
      user {
        birthDate
        id
        initials
        calendarColor
        email
        createdAt
        fullName
        imageFileEntry {
          url
        }
        parent {
          id
          initials
          calendarColor
          email
          createdAt
          fullName
          imageFileEntry {
            url
          }
        }
      }
      parent {
        user {
          id
          fullName
          initials
          calendarColor
          imageFileEntry {
            url
          }
        }
      }
      role {
        id
        name
        type
      }
    }
    totalCount
    totalPages
  }
}
    ${CourseGradingSchemaFragmentDoc}`;
export const useAccountEnrollmentsQuery = <
      TData = AccountEnrollmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AccountEnrollmentsQueryVariables,
      options?: UseQueryOptions<AccountEnrollmentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountEnrollmentsQuery, TError, TData>(
      variables === undefined ? ['AccountEnrollments'] : ['AccountEnrollments', variables],
      fetcher<AccountEnrollmentsQuery, AccountEnrollmentsQueryVariables>(client, AccountEnrollmentsDocument, variables, headers),
      options
    );
useAccountEnrollmentsQuery.fetcher = (client: GraphQLClient, variables?: AccountEnrollmentsQueryVariables, headers?: RequestInit['headers']) => fetcher<AccountEnrollmentsQuery, AccountEnrollmentsQueryVariables>(client, AccountEnrollmentsDocument, variables, headers);
export const CourseEnrollmentsDocument = `
    query courseEnrollments($ids: [ID!], $includePast: Boolean, $userIds: [ID!], $calculateFinalGrade: Boolean) {
  courses(ids: $ids) {
    id
    title
    graded
    roles {
      id
      fixed
      name
      permissions
      type
    }
    enrollments(includePast: $includePast, userIds: $userIds) {
      id
      concluded
      dropped
      createdAt
      createdBy {
        id
        fullName
      }
      finalGrade(includeCalculated: $calculateFinalGrade)
      activatedAt
      deactivatedAt
      lastActivityAt
      needsConfirmJoin
      status
      user {
        active
        id
        fullName
        email
        birthDate
        createdAt
        initials
        calendarColor
        oauthConnections
        imageFileEntry {
          ...FileEntryDefault
        }
        children {
          id
          fullName
          birthDate
          email
          initials
          active
          calendarColor
          imageFileEntry {
            ...FileEntryDefault
          }
        }
        parent {
          id
          initials
          calendarColor
          email
          createdAt
          fullName
          imageFileEntry {
            url
          }
        }
      }
      parent {
        id
        lastActivityAt
        user {
          id
          fullName
          createdAt
          birthDate
          email
          initials
          active
          calendarColor
          imageFileEntry {
            ...FileEntryDefault
          }
          children {
            id
            fullName
            birthDate
            email
            initials
            active
            calendarColor
            imageFileEntry {
              ...FileEntryDefault
            }
          }
        }
      }
      role {
        id
        fixed
        name
        type
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useCourseEnrollmentsQuery = <
      TData = CourseEnrollmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CourseEnrollmentsQueryVariables,
      options?: UseQueryOptions<CourseEnrollmentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseEnrollmentsQuery, TError, TData>(
      variables === undefined ? ['courseEnrollments'] : ['courseEnrollments', variables],
      fetcher<CourseEnrollmentsQuery, CourseEnrollmentsQueryVariables>(client, CourseEnrollmentsDocument, variables, headers),
      options
    );
useCourseEnrollmentsQuery.fetcher = (client: GraphQLClient, variables?: CourseEnrollmentsQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseEnrollmentsQuery, CourseEnrollmentsQueryVariables>(client, CourseEnrollmentsDocument, variables, headers);
export const EnrollmentsOnlyDocument = `
    query enrollmentsOnly($ids: [ID!], $courseId: ID, $userId: ID, $includePast: Boolean, $includePending: Boolean, $includeChildren: Boolean!, $calculateFinalGrade: Boolean) {
  enrollments(
    ids: $ids
    courseId: $courseId
    userId: $userId
    includePast: $includePast
    includePending: $includePending
  ) {
    id
    concluded
    dropped
    createdAt
    createdBy {
      id
      fullName
    }
    finalGrade(includeCalculated: $calculateFinalGrade)
    activatedAt
    deactivatedAt
    lastActivityAt
    needsConfirmJoin
    status
    children @include(if: $includeChildren) {
      id
      user {
        id
        fullName
        initials
        active
        calendarColor
        imageFileEntry {
          ...FileEntryDefault
        }
      }
    }
    role {
      id
      fixed
      name
      type
      permissions
    }
    course {
      id
      title
      welcome
      welcomeMediaType
      published
      iconColor
      gradingScheme {
        ...CourseGradingSchema
      }
      schedulingMode
      imageFileEntry {
        ...FileEntryDefault
      }
      thumbnailFileEntry {
        ...FileEntryDefault
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}
${CourseGradingSchemaFragmentDoc}`;
export const useEnrollmentsOnlyQuery = <
      TData = EnrollmentsOnlyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: EnrollmentsOnlyQueryVariables,
      options?: UseQueryOptions<EnrollmentsOnlyQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EnrollmentsOnlyQuery, TError, TData>(
      ['enrollmentsOnly', variables],
      fetcher<EnrollmentsOnlyQuery, EnrollmentsOnlyQueryVariables>(client, EnrollmentsOnlyDocument, variables, headers),
      options
    );
useEnrollmentsOnlyQuery.fetcher = (client: GraphQLClient, variables: EnrollmentsOnlyQueryVariables, headers?: RequestInit['headers']) => fetcher<EnrollmentsOnlyQuery, EnrollmentsOnlyQueryVariables>(client, EnrollmentsOnlyDocument, variables, headers);
export const ExternalImagesDocument = `
    query externalImages($provider: ExternalImageProvider!, $query: String) {
  externalImages(provider: $provider, query: $query) {
    author
    authorUrl
    description
    thumbnailUrl
    title
    url
    originalHeight
    originalWidth
  }
}
    `;
export const useExternalImagesQuery = <
      TData = ExternalImagesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ExternalImagesQueryVariables,
      options?: UseQueryOptions<ExternalImagesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ExternalImagesQuery, TError, TData>(
      ['externalImages', variables],
      fetcher<ExternalImagesQuery, ExternalImagesQueryVariables>(client, ExternalImagesDocument, variables, headers),
      options
    );
useExternalImagesQuery.fetcher = (client: GraphQLClient, variables: ExternalImagesQueryVariables, headers?: RequestInit['headers']) => fetcher<ExternalImagesQuery, ExternalImagesQueryVariables>(client, ExternalImagesDocument, variables, headers);
export const FileEntriesDocument = `
    query fileEntries($ids: [ID!]!) {
  fileEntries(ids: $ids) {
    fileType
    id
    originalFileSize
    title
    description
    url
    skipperPaperContent
    annotation
    createdAt
    updatedAt
  }
}
    `;
export const useFileEntriesQuery = <
      TData = FileEntriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FileEntriesQueryVariables,
      options?: UseQueryOptions<FileEntriesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FileEntriesQuery, TError, TData>(
      ['fileEntries', variables],
      fetcher<FileEntriesQuery, FileEntriesQueryVariables>(client, FileEntriesDocument, variables, headers),
      options
    );
useFileEntriesQuery.fetcher = (client: GraphQLClient, variables: FileEntriesQueryVariables, headers?: RequestInit['headers']) => fetcher<FileEntriesQuery, FileEntriesQueryVariables>(client, FileEntriesDocument, variables, headers);
export const GradingSchemesDocument = `
    query GradingSchemes {
  gradingSchemes {
    ...GradingSchemaFragment
  }
}
    ${GradingSchemaFragmentFragmentDoc}`;
export const useGradingSchemesQuery = <
      TData = GradingSchemesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GradingSchemesQueryVariables,
      options?: UseQueryOptions<GradingSchemesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradingSchemesQuery, TError, TData>(
      variables === undefined ? ['GradingSchemes'] : ['GradingSchemes', variables],
      fetcher<GradingSchemesQuery, GradingSchemesQueryVariables>(client, GradingSchemesDocument, variables, headers),
      options
    );
useGradingSchemesQuery.fetcher = (client: GraphQLClient, variables?: GradingSchemesQueryVariables, headers?: RequestInit['headers']) => fetcher<GradingSchemesQuery, GradingSchemesQueryVariables>(client, GradingSchemesDocument, variables, headers);
export const SearchBooksDocument = `
    query searchBooks($query: String!) {
  searchBooks(query: $query) {
    author
    id
    image
    isbn
    title
  }
}
    `;
export const useSearchBooksQuery = <
      TData = SearchBooksQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchBooksQueryVariables,
      options?: UseQueryOptions<SearchBooksQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SearchBooksQuery, TError, TData>(
      ['searchBooks', variables],
      fetcher<SearchBooksQuery, SearchBooksQueryVariables>(client, SearchBooksDocument, variables, headers),
      options
    );
useSearchBooksQuery.fetcher = (client: GraphQLClient, variables: SearchBooksQueryVariables, headers?: RequestInit['headers']) => fetcher<SearchBooksQuery, SearchBooksQueryVariables>(client, SearchBooksDocument, variables, headers);
export const MaterialBooksDocument = `
    query materialBooks($ids: [ID!]) {
  materialBooks(ids: $ids) {
    author
    createdAt
    description
    id
    imageUrl
    isbn
    libraryButton
    title
    url
    websiteButton
  }
}
    `;
export const useMaterialBooksQuery = <
      TData = MaterialBooksQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MaterialBooksQueryVariables,
      options?: UseQueryOptions<MaterialBooksQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MaterialBooksQuery, TError, TData>(
      variables === undefined ? ['materialBooks'] : ['materialBooks', variables],
      fetcher<MaterialBooksQuery, MaterialBooksQueryVariables>(client, MaterialBooksDocument, variables, headers),
      options
    );
useMaterialBooksQuery.fetcher = (client: GraphQLClient, variables?: MaterialBooksQueryVariables, headers?: RequestInit['headers']) => fetcher<MaterialBooksQuery, MaterialBooksQueryVariables>(client, MaterialBooksDocument, variables, headers);
export const MaterialCodesDocument = `
    query materialCodes($ids: [ID!]) {
  materialCodes(ids: $ids) {
    code
    createdAt
    description
    id
    title
  }
}
    `;
export const useMaterialCodesQuery = <
      TData = MaterialCodesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MaterialCodesQueryVariables,
      options?: UseQueryOptions<MaterialCodesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MaterialCodesQuery, TError, TData>(
      variables === undefined ? ['materialCodes'] : ['materialCodes', variables],
      fetcher<MaterialCodesQuery, MaterialCodesQueryVariables>(client, MaterialCodesDocument, variables, headers),
      options
    );
useMaterialCodesQuery.fetcher = (client: GraphQLClient, variables?: MaterialCodesQueryVariables, headers?: RequestInit['headers']) => fetcher<MaterialCodesQuery, MaterialCodesQueryVariables>(client, MaterialCodesDocument, variables, headers);
export const MaterialLinksDocument = `
    query materialLinks($ids: [ID!]) {
  materialLinks(ids: $ids) {
    id
    createdAt
    description
    image
    title
    otherImages
    showImage
    imageMaxWidth
    url
  }
}
    `;
export const useMaterialLinksQuery = <
      TData = MaterialLinksQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MaterialLinksQueryVariables,
      options?: UseQueryOptions<MaterialLinksQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MaterialLinksQuery, TError, TData>(
      variables === undefined ? ['materialLinks'] : ['materialLinks', variables],
      fetcher<MaterialLinksQuery, MaterialLinksQueryVariables>(client, MaterialLinksDocument, variables, headers),
      options
    );
useMaterialLinksQuery.fetcher = (client: GraphQLClient, variables?: MaterialLinksQueryVariables, headers?: RequestInit['headers']) => fetcher<MaterialLinksQuery, MaterialLinksQueryVariables>(client, MaterialLinksDocument, variables, headers);
export const SourceAttributionsDocument = `
    query sourceAttributions($ids: [ID!]) {
  sourceAttributions(ids: $ids) {
    author
    authorUrl
    byCompany
    id
    licenseOther
    licenseType
    notes
    title
    url
  }
}
    `;
export const useSourceAttributionsQuery = <
      TData = SourceAttributionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SourceAttributionsQueryVariables,
      options?: UseQueryOptions<SourceAttributionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SourceAttributionsQuery, TError, TData>(
      variables === undefined ? ['sourceAttributions'] : ['sourceAttributions', variables],
      fetcher<SourceAttributionsQuery, SourceAttributionsQueryVariables>(client, SourceAttributionsDocument, variables, headers),
      options
    );
useSourceAttributionsQuery.fetcher = (client: GraphQLClient, variables?: SourceAttributionsQueryVariables, headers?: RequestInit['headers']) => fetcher<SourceAttributionsQuery, SourceAttributionsQueryVariables>(client, SourceAttributionsDocument, variables, headers);
export const NotificationsDocument = `
    query Notifications {
  notifications {
    createdAt
    id
    isViewed
    message
    notificationType
    originUser {
      ...UserFragment
    }
    targetUser {
      ...UserFragment
    }
    updatedAt
    url
    dotColor
    dotTitle
    iconType
    title
  }
}
    ${UserFragmentFragmentDoc}`;
export const useNotificationsQuery = <
      TData = NotificationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: NotificationsQueryVariables,
      options?: UseQueryOptions<NotificationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<NotificationsQuery, TError, TData>(
      variables === undefined ? ['Notifications'] : ['Notifications', variables],
      fetcher<NotificationsQuery, NotificationsQueryVariables>(client, NotificationsDocument, variables, headers),
      options
    );
useNotificationsQuery.fetcher = (client: GraphQLClient, variables?: NotificationsQueryVariables, headers?: RequestInit['headers']) => fetcher<NotificationsQuery, NotificationsQueryVariables>(client, NotificationsDocument, variables, headers);
export const PermissionLevelsDocument = `
    query permissionLevels {
  permissionLevels {
    fixed
    id
    name
    permissions
  }
}
    `;
export const usePermissionLevelsQuery = <
      TData = PermissionLevelsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PermissionLevelsQueryVariables,
      options?: UseQueryOptions<PermissionLevelsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PermissionLevelsQuery, TError, TData>(
      variables === undefined ? ['permissionLevels'] : ['permissionLevels', variables],
      fetcher<PermissionLevelsQuery, PermissionLevelsQueryVariables>(client, PermissionLevelsDocument, variables, headers),
      options
    );
usePermissionLevelsQuery.fetcher = (client: GraphQLClient, variables?: PermissionLevelsQueryVariables, headers?: RequestInit['headers']) => fetcher<PermissionLevelsQuery, PermissionLevelsQueryVariables>(client, PermissionLevelsDocument, variables, headers);
export const PermissionsWithUsersDocument = `
    query permissionsWithUsers {
  permissionLevels {
    fixed
    id
    name
    permissions
    users {
      id
      fullName
      initials
      calendarColor
      accountRole {
        id
        name
        roleType
      }
      imageFileEntry {
        ...FileEntryDefault
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const usePermissionsWithUsersQuery = <
      TData = PermissionsWithUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PermissionsWithUsersQueryVariables,
      options?: UseQueryOptions<PermissionsWithUsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PermissionsWithUsersQuery, TError, TData>(
      variables === undefined ? ['permissionsWithUsers'] : ['permissionsWithUsers', variables],
      fetcher<PermissionsWithUsersQuery, PermissionsWithUsersQueryVariables>(client, PermissionsWithUsersDocument, variables, headers),
      options
    );
usePermissionsWithUsersQuery.fetcher = (client: GraphQLClient, variables?: PermissionsWithUsersQueryVariables, headers?: RequestInit['headers']) => fetcher<PermissionsWithUsersQuery, PermissionsWithUsersQueryVariables>(client, PermissionsWithUsersDocument, variables, headers);
export const CurrentUserDocument = `
    query CurrentUser {
  me {
    id
    uid
    fullName
    firstName
    birthDate
    lastName
    initials
    email
    calendarColor
    unconfirmedEmail
    confirmedAt
    username
    active
    oauthConnections
    turnitinEulaAcceptedAt
    turnitinEulaAcceptedVersion
    turnitinEulaLatestVersion
    imageFileEntry {
      ...FileEntryDefault
    }
    accountRole {
      id
      name
      roleType
    }
    permissionLevel {
      id
      name
      permissions
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CurrentUserQueryVariables,
      options?: UseQueryOptions<CurrentUserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CurrentUserQuery, TError, TData>(
      variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables],
      fetcher<CurrentUserQuery, CurrentUserQueryVariables>(client, CurrentUserDocument, variables, headers),
      options
    );
useCurrentUserQuery.fetcher = (client: GraphQLClient, variables?: CurrentUserQueryVariables, headers?: RequestInit['headers']) => fetcher<CurrentUserQuery, CurrentUserQueryVariables>(client, CurrentUserDocument, variables, headers);
export const RealUserDocument = `
    query RealUser {
  realMe {
    id
    uid
    intercomHash
    fullName
    firstName
    birthDate
    lastName
    initials
    email
    calendarColor
    unconfirmedEmail
    confirmedAt
    username
    active
    systemAdmin
    oauthConnections
    imageFileEntry {
      ...FileEntryDefault
    }
    accountRole {
      id
      name
      roleType
    }
    permissionLevel {
      id
      name
      permissions
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useRealUserQuery = <
      TData = RealUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: RealUserQueryVariables,
      options?: UseQueryOptions<RealUserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RealUserQuery, TError, TData>(
      variables === undefined ? ['RealUser'] : ['RealUser', variables],
      fetcher<RealUserQuery, RealUserQueryVariables>(client, RealUserDocument, variables, headers),
      options
    );
useRealUserQuery.fetcher = (client: GraphQLClient, variables?: RealUserQueryVariables, headers?: RequestInit['headers']) => fetcher<RealUserQuery, RealUserQueryVariables>(client, RealUserDocument, variables, headers);
export const SubmissionsDocument = `
    query submissions($ids: [ID!]!) {
  submissions(ids: $ids) {
    id
    isSubmitted
    isViewed
    submissionType
    createdAt
    submittedAt
    updatedAt
    grade
    gradedAt
    isFinal
    percentageGrade
    hasContent
    activity {
      id
      dueDate
      dueTimeSignificant
      graded
      points
      optional
      item {
        id
        title
        type
      }
      activityGroup {
        id
        title
        weight
        course {
          id
          title
        }
      }
      unit {
        id
        title
      }
    }
    annotatedPdf {
      id
      annotation
      fileType
      url
      title
    }
    annotationStatus
    enrollment {
      id
      user {
        id
        initials
        fullName
        imageFileEntry {
          id
          url
        }
      }
    }
    attachments {
      ...FileEntryDefault
    }
    content {
      ... on QuizSubmission {
        answers
        bookmarks
        questionGrades
        timeElapsed
        timeLeft
      }
      ... on AssignmentSubmission {
        text
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useSubmissionsQuery = <
      TData = SubmissionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SubmissionsQueryVariables,
      options?: UseQueryOptions<SubmissionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SubmissionsQuery, TError, TData>(
      ['submissions', variables],
      fetcher<SubmissionsQuery, SubmissionsQueryVariables>(client, SubmissionsDocument, variables, headers),
      options
    );
useSubmissionsQuery.fetcher = (client: GraphQLClient, variables: SubmissionsQueryVariables, headers?: RequestInit['headers']) => fetcher<SubmissionsQuery, SubmissionsQueryVariables>(client, SubmissionsDocument, variables, headers);
export const CoursesWithActivitiesAndSubmissionsDocument = `
    query CoursesWithActivitiesAndSubmissions($ids: [ID!], $userId: ID, $unitIds: [ID!], $activityIds: [ID!], $includeDrafts: Boolean, $courseTermId: ID, $enrollmentIds: [ID!], $includePastSubmissions: Boolean, $includeDraftSubmissions: Boolean, $includeHiddenQuestions: Boolean, $limit: Int) {
  courses(ids: $ids, userId: $userId) {
    ...CourseFragment
    gradingScheme {
      ...CourseGradingSchema
    }
    activityGroups {
      ...CourseActivityGroups
    }
    units(ids: $unitIds, includeHidden: true, courseTermId: $courseTermId) {
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      ...UnitDetails
      activities(ids: $activityIds, includeDrafts: $includeDrafts) {
        ...ActivitiesDetails
        item {
          ...ActivityItemFragment
          ... on Assignment {
            ...AssignmentFragment
          }
          ... on Quiz {
            ...QuizFragment
            questions(includeHidden: $includeHiddenQuestions) {
              ...QuizQuestionFragment
            }
          }
        }
        submissions(
          enrollmentIds: $enrollmentIds
          includePast: $includePastSubmissions
          includeDrafts: $includeDraftSubmissions
          limit: $limit
        ) {
          id
          isSubmitted
          isViewed
          submissionType
          createdAt
          submittedAt
          updatedAt
          grade
          gradedAt
          isDraft
          isFinal
          percentageGrade
          hasContent
          annotatedPdf {
            id
            annotation
            fileType
            url
            title
          }
          annotationStatus
          enrollment {
            id
            user {
              active
              id
              fullName
              initials
              calendarColor
              oauthConnections
              imageFileEntry {
                id
                url
                croppedUrl
                title
                fileType
              }
            }
          }
          attachments {
            ...FileEntryDefault
          }
          content {
            ... on QuizSubmission {
              answers
              bookmarks
              questionGrades
              timeElapsed
              timeLeft
            }
            ... on AssignmentSubmission {
              text
            }
          }
        }
      }
    }
  }
}
    ${CourseFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}
${CourseGradingSchemaFragmentDoc}
${CourseActivityGroupsFragmentDoc}
${UnitDetailsFragmentDoc}
${ActivitiesDetailsFragmentDoc}
${ActivityItemFragmentFragmentDoc}
${AssignmentFragmentFragmentDoc}
${QuizFragmentFragmentDoc}
${QuizQuestionFragmentFragmentDoc}`;
export const useCoursesWithActivitiesAndSubmissionsQuery = <
      TData = CoursesWithActivitiesAndSubmissionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CoursesWithActivitiesAndSubmissionsQueryVariables,
      options?: UseQueryOptions<CoursesWithActivitiesAndSubmissionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesWithActivitiesAndSubmissionsQuery, TError, TData>(
      variables === undefined ? ['CoursesWithActivitiesAndSubmissions'] : ['CoursesWithActivitiesAndSubmissions', variables],
      fetcher<CoursesWithActivitiesAndSubmissionsQuery, CoursesWithActivitiesAndSubmissionsQueryVariables>(client, CoursesWithActivitiesAndSubmissionsDocument, variables, headers),
      options
    );
useCoursesWithActivitiesAndSubmissionsQuery.fetcher = (client: GraphQLClient, variables?: CoursesWithActivitiesAndSubmissionsQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesWithActivitiesAndSubmissionsQuery, CoursesWithActivitiesAndSubmissionsQueryVariables>(client, CoursesWithActivitiesAndSubmissionsDocument, variables, headers);
export const CoursesActivitySubmissionsByEnrollmentsDocument = `
    query CoursesActivitySubmissionsByEnrollments($ids: [ID!], $userId: ID, $unitIds: [ID!], $activityIds: [ID!], $includeDrafts: Boolean, $courseTermId: ID, $includePastSubmissions: Boolean, $includeDraftSubmissions: Boolean, $includeHiddenQuestions: Boolean) {
  courses(ids: $ids, userId: $userId) {
    ...CourseFragment
    gradingScheme {
      ...CourseGradingSchema
    }
    activityGroups {
      ...CourseActivityGroups
    }
    units(ids: $unitIds, includeHidden: true, courseTermId: $courseTermId) {
      imageFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      backgroundFileEntry {
        id
        url
        croppedUrl
        title
        fileType
      }
      ...UnitDetails
      activities(ids: $activityIds, includeDrafts: $includeDrafts) {
        ...ActivitiesDetails
        item {
          ...ActivityItemFragment
          ... on Assignment {
            ...AssignmentFragment
          }
          ... on Quiz {
            ...QuizFragment
            questions(includeHidden: $includeHiddenQuestions) {
              ...QuizQuestionFragment
            }
          }
        }
        unit {
          id
          title
        }
        studentSubmissions {
          __typename
          dueStatus
          grade
          gradedAt
          status
          mainStatus
          statusOverriddenAt
          privateDiscussionId
          enrollment {
            id
            user {
              active
              id
              fullName
              initials
              calendarColor
              oauthConnections
              imageFileEntry {
                id
                url
                croppedUrl
                title
                fileType
              }
            }
          }
          ... on MultiSubmission {
            submissions(
              includePast: $includePastSubmissions
              includeDrafts: $includeDraftSubmissions
            ) {
              id
              isSubmitted
              isViewed
              submissionType
              createdAt
              submittedAt
              updatedAt
              grade
              gradedAt
              percentageGrade
              hasContent
              isDraft
              isFinal
              attachments {
                annotatable
                croppedUrl
                fileType
                id
                originalFileSize
                originalFileName
                originalFileContentType
                sourceAttribution {
                  id
                }
                title
                description
                url
                createdAt
                updatedAt
                uploadedBy {
                  id
                  fullName
                  username
                }
              }
              deletableAttachments {
                id
              }
              content {
                ... on QuizSubmission {
                  answers
                  bookmarks
                  questionGrades
                  timeElapsed
                  timeLeft
                }
                ... on AssignmentSubmission {
                  text
                }
              }
            }
          }
          ... on SingleSubmission {
            submission(includeDraft: $includeDraftSubmissions) {
              id
              isSubmitted
              isViewed
              submissionType
              createdAt
              submittedAt
              updatedAt
              grade
              gradedAt
              isDraft
              percentageGrade
              hasContent
              annotatedPdf {
                id
                annotation
                fileType
                url
                title
              }
              annotationStatus
              attachments {
                ...FileEntryDefault
              }
              deletableAttachments {
                id
              }
              content {
                ... on QuizSubmission {
                  answers
                  bookmarks
                  questionGrades
                  timeElapsed
                  timeLeft
                }
                ... on AssignmentSubmission {
                  text
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CourseFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}
${CourseGradingSchemaFragmentDoc}
${CourseActivityGroupsFragmentDoc}
${UnitDetailsFragmentDoc}
${ActivitiesDetailsFragmentDoc}
${ActivityItemFragmentFragmentDoc}
${AssignmentFragmentFragmentDoc}
${QuizFragmentFragmentDoc}
${QuizQuestionFragmentFragmentDoc}`;
export const useCoursesActivitySubmissionsByEnrollmentsQuery = <
      TData = CoursesActivitySubmissionsByEnrollmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CoursesActivitySubmissionsByEnrollmentsQueryVariables,
      options?: UseQueryOptions<CoursesActivitySubmissionsByEnrollmentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CoursesActivitySubmissionsByEnrollmentsQuery, TError, TData>(
      variables === undefined ? ['CoursesActivitySubmissionsByEnrollments'] : ['CoursesActivitySubmissionsByEnrollments', variables],
      fetcher<CoursesActivitySubmissionsByEnrollmentsQuery, CoursesActivitySubmissionsByEnrollmentsQueryVariables>(client, CoursesActivitySubmissionsByEnrollmentsDocument, variables, headers),
      options
    );
useCoursesActivitySubmissionsByEnrollmentsQuery.fetcher = (client: GraphQLClient, variables?: CoursesActivitySubmissionsByEnrollmentsQueryVariables, headers?: RequestInit['headers']) => fetcher<CoursesActivitySubmissionsByEnrollmentsQuery, CoursesActivitySubmissionsByEnrollmentsQueryVariables>(client, CoursesActivitySubmissionsByEnrollmentsDocument, variables, headers);
export const GradebookActivitiesDataDocument = `
    query gradebookActivitiesData($courseId: ID!, $studentEnrollmentIds: [ID!], $activityIds: [ID!], $activitiesLimit: Int, $activitiesOffset: Int, $activityGroupIds: [ID!], $courseTermId: ID, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime, $keyword: String) {
  gradebookData(
    courseId: $courseId
    studentEnrollmentIds: $studentEnrollmentIds
    activityIds: $activityIds
    activitiesLimit: $activitiesLimit
    activitiesOffset: $activitiesOffset
    activityGroupIds: $activityGroupIds
    courseTermId: $courseTermId
    startDate: $startDate
    endDate: $endDate
    keyword: $keyword
  ) {
    activitiesTotal
    activities {
      id
      dueDate
      dueTimeSignificant
      lockedBeforeAssignDate
      graded
      points
      optional
      item {
        id
        title
        type
        ... on Quiz {
          attemptsAllowed
          attemptsRemaining
          questions {
            id
          }
          resumable
        }
        ... on Assignment {
          submissionKind
          onlineSubmissionRequired
          onlineSubmissionAccepted
        }
      }
      activityGroup {
        id
        title
        weight
      }
      unit {
        id
        title
      }
      studentSubmissions(enrollmentIds: $studentEnrollmentIds) {
        activity {
          id
        }
        __typename
        dueStatus
        grade
        gradedAt
        status
        enrollment {
          id
        }
        mainStatus
        subStatus
        ... on MultiSubmission {
          submissions(includeDrafts: true, includePast: true) {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            percentageGrade
            hasContent
            isDraft
            isFinal
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
          }
        }
        ... on SingleSubmission {
          submission {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            isDraft
            percentageGrade
            hasContent
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
          }
        }
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useGradebookActivitiesDataQuery = <
      TData = GradebookActivitiesDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GradebookActivitiesDataQueryVariables,
      options?: UseQueryOptions<GradebookActivitiesDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradebookActivitiesDataQuery, TError, TData>(
      ['gradebookActivitiesData', variables],
      fetcher<GradebookActivitiesDataQuery, GradebookActivitiesDataQueryVariables>(client, GradebookActivitiesDataDocument, variables, headers),
      options
    );
useGradebookActivitiesDataQuery.fetcher = (client: GraphQLClient, variables: GradebookActivitiesDataQueryVariables, headers?: RequestInit['headers']) => fetcher<GradebookActivitiesDataQuery, GradebookActivitiesDataQueryVariables>(client, GradebookActivitiesDataDocument, variables, headers);
export const GradebookActivitiesUpdatedDataDocument = `
    query gradebookActivitiesUpdatedData($courseId: ID!, $studentEnrollmentIds: [ID!], $activityIds: [ID!], $activitiesLimit: Int, $activitiesOffset: Int, $activityGroupIds: [ID!], $courseTermId: ID, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime) {
  gradebookData(
    courseId: $courseId
    studentEnrollmentIds: $studentEnrollmentIds
    activityIds: $activityIds
    activitiesLimit: $activitiesLimit
    activitiesOffset: $activitiesOffset
    activityGroupIds: $activityGroupIds
    courseTermId: $courseTermId
    startDate: $startDate
    endDate: $endDate
  ) {
    activitiesTotal
    activities {
      id
      dueDate
      dueTimeSignificant
      graded
      points
      optional
      item {
        id
        title
        type
      }
      activityGroup {
        id
        title
        weight
      }
      unit {
        id
        title
      }
      studentSubmissions(enrollmentIds: $studentEnrollmentIds) {
        activity {
          id
        }
        __typename
        dueStatus
        grade
        gradedAt
        status
        enrollment {
          id
        }
        mainStatus
        subStatus
        ... on MultiSubmission {
          submissions {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            percentageGrade
            hasContent
            isDraft
            isFinal
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
            content {
              ... on QuizSubmission {
                answers
                bookmarks
                questionGrades
                timeElapsed
                timeLeft
              }
              ... on AssignmentSubmission {
                text
              }
            }
          }
        }
        ... on SingleSubmission {
          submission {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            isDraft
            percentageGrade
            hasContent
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
            content {
              ... on QuizSubmission {
                answers
                bookmarks
                questionGrades
                timeElapsed
                timeLeft
              }
              ... on AssignmentSubmission {
                text
              }
            }
          }
        }
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useGradebookActivitiesUpdatedDataQuery = <
      TData = GradebookActivitiesUpdatedDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GradebookActivitiesUpdatedDataQueryVariables,
      options?: UseQueryOptions<GradebookActivitiesUpdatedDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradebookActivitiesUpdatedDataQuery, TError, TData>(
      ['gradebookActivitiesUpdatedData', variables],
      fetcher<GradebookActivitiesUpdatedDataQuery, GradebookActivitiesUpdatedDataQueryVariables>(client, GradebookActivitiesUpdatedDataDocument, variables, headers),
      options
    );
useGradebookActivitiesUpdatedDataQuery.fetcher = (client: GraphQLClient, variables: GradebookActivitiesUpdatedDataQueryVariables, headers?: RequestInit['headers']) => fetcher<GradebookActivitiesUpdatedDataQuery, GradebookActivitiesUpdatedDataQueryVariables>(client, GradebookActivitiesUpdatedDataDocument, variables, headers);
export const GradebookStudentsDataDocument = `
    query gradebookStudentsData($courseId: ID!, $studentEnrollmentIds: [ID!], $activityIds: [ID!], $studentsLimit: Int, $studentsOffset: Int, $studentsSort: EnrollmentsSortOrder, $activitiesLimit: Int, $activitiesOffset: Int, $activityGroupIds: [ID!], $courseTermId: ID, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime) {
  gradebookData(
    courseId: $courseId
    studentEnrollmentIds: $studentEnrollmentIds
    activityIds: $activityIds
    studentsLimit: $studentsLimit
    studentsOffset: $studentsOffset
    studentsSort: $studentsSort
    activitiesLimit: $activitiesLimit
    activitiesOffset: $activitiesOffset
    activityGroupIds: $activityGroupIds
    courseTermId: $courseTermId
    startDate: $startDate
    endDate: $endDate
  ) {
    students {
      enrollment {
        id
        user {
          active
          id
          fullName
          initials
          calendarColor
          oauthConnections
          imageFileEntry {
            id
            url
            croppedUrl
            title
            fileType
          }
        }
      }
    }
  }
}
    `;
export const useGradebookStudentsDataQuery = <
      TData = GradebookStudentsDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GradebookStudentsDataQueryVariables,
      options?: UseQueryOptions<GradebookStudentsDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradebookStudentsDataQuery, TError, TData>(
      ['gradebookStudentsData', variables],
      fetcher<GradebookStudentsDataQuery, GradebookStudentsDataQueryVariables>(client, GradebookStudentsDataDocument, variables, headers),
      options
    );
useGradebookStudentsDataQuery.fetcher = (client: GraphQLClient, variables: GradebookStudentsDataQueryVariables, headers?: RequestInit['headers']) => fetcher<GradebookStudentsDataQuery, GradebookStudentsDataQueryVariables>(client, GradebookStudentsDataDocument, variables, headers);
export const GradebookStudentsAvgDataDocument = `
    query gradebookStudentsAvgData($courseId: ID!, $studentEnrollmentIds: [ID!], $activityIds: [ID!], $studentsLimit: Int, $studentsOffset: Int, $studentsSort: EnrollmentsSortOrder, $activitiesLimit: Int, $activitiesOffset: Int, $activityGroupIds: [ID!], $courseTermId: ID, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime) {
  gradebookData(
    courseId: $courseId
    studentEnrollmentIds: $studentEnrollmentIds
    activityIds: $activityIds
    studentsLimit: $studentsLimit
    studentsOffset: $studentsOffset
    studentsSort: $studentsSort
    activitiesLimit: $activitiesLimit
    activitiesOffset: $activitiesOffset
    activityGroupIds: $activityGroupIds
    courseTermId: $courseTermId
    startDate: $startDate
    endDate: $endDate
  ) {
    students {
      activityGroupGrades {
        grade
        activityGroup {
          id
          title
          weight
        }
      }
      courseGrade
      courseGradeOverridden
      courseOriginalGrade
      courseTermGrades {
        grade
        gradeOverridden
        originalGrade
        courseTerm {
          id
          title
        }
      }
      enrollment {
        id
      }
    }
  }
}
    `;
export const useGradebookStudentsAvgDataQuery = <
      TData = GradebookStudentsAvgDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GradebookStudentsAvgDataQueryVariables,
      options?: UseQueryOptions<GradebookStudentsAvgDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradebookStudentsAvgDataQuery, TError, TData>(
      ['gradebookStudentsAvgData', variables],
      fetcher<GradebookStudentsAvgDataQuery, GradebookStudentsAvgDataQueryVariables>(client, GradebookStudentsAvgDataDocument, variables, headers),
      options
    );
useGradebookStudentsAvgDataQuery.fetcher = (client: GraphQLClient, variables: GradebookStudentsAvgDataQueryVariables, headers?: RequestInit['headers']) => fetcher<GradebookStudentsAvgDataQuery, GradebookStudentsAvgDataQueryVariables>(client, GradebookStudentsAvgDataDocument, variables, headers);
export const GradebookDataDocument = `
    query gradebookData($courseId: ID!, $studentEnrollmentIds: [ID!], $activityIds: [ID!], $studentsLimit: Int, $studentsOffset: Int, $studentsSort: EnrollmentsSortOrder, $activitiesLimit: Int, $activitiesOffset: Int, $activityGroupIds: [ID!], $courseTermId: ID, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime, $keyword: String) {
  gradebookData(
    courseId: $courseId
    studentEnrollmentIds: $studentEnrollmentIds
    activityIds: $activityIds
    studentsLimit: $studentsLimit
    studentsOffset: $studentsOffset
    studentsSort: $studentsSort
    activitiesLimit: $activitiesLimit
    activitiesOffset: $activitiesOffset
    activityGroupIds: $activityGroupIds
    courseTermId: $courseTermId
    startDate: $startDate
    endDate: $endDate
    keyword: $keyword
  ) {
    activities {
      id
      dueDate
      dueTimeSignificant
      graded
      points
      optional
      item {
        id
        title
        type
      }
      activityGroup {
        id
        title
        weight
      }
      unit {
        id
        title
      }
    }
    students {
      submissions {
        __typename
        activity {
          id
          points
          assignDate
          dueDate
          dueTimeSignificant
          optional
          lockedBeforeAssignDate
          lockedAfterDueDate
          item {
            id
            title
            type
            ...ActivityItemFragment
            ... on Assignment {
              ...AssignmentFragment
            }
          }
          activityGroup {
            id
            title
            weight
          }
          unit {
            id
            title
          }
        }
        dueStatus
        grade
        gradedAt
        status
        statusOverriddenAt
        enrollment {
          id
        }
        ... on MultiSubmission {
          submissions {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            percentageGrade
            hasContent
            isDraft
            isFinal
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
            content {
              ... on QuizSubmission {
                answers
                bookmarks
                questionGrades
                timeElapsed
                timeLeft
              }
              ... on AssignmentSubmission {
                text
              }
            }
          }
        }
        ... on SingleSubmission {
          submission {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            isDraft
            percentageGrade
            hasContent
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
            content {
              ... on QuizSubmission {
                answers
                bookmarks
                questionGrades
                timeElapsed
                timeLeft
              }
              ... on AssignmentSubmission {
                text
              }
            }
          }
        }
      }
      activityGroupGrades {
        grade
        activityGroup {
          id
          title
          weight
        }
      }
      courseGrade
      courseGradeOverridden
      courseOriginalGrade
      courseTermGrades {
        grade
        gradeOverridden
        originalGrade
        courseTerm {
          id
          title
        }
      }
      needsGradingCounter
      enrollment {
        id
        user {
          active
          id
          fullName
          initials
          calendarColor
          oauthConnections
          imageFileEntry {
            id
            url
            croppedUrl
            title
            fileType
          }
        }
      }
    }
  }
}
    ${ActivityItemFragmentFragmentDoc}
${AssignmentFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useGradebookDataQuery = <
      TData = GradebookDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GradebookDataQueryVariables,
      options?: UseQueryOptions<GradebookDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradebookDataQuery, TError, TData>(
      ['gradebookData', variables],
      fetcher<GradebookDataQuery, GradebookDataQueryVariables>(client, GradebookDataDocument, variables, headers),
      options
    );
useGradebookDataQuery.fetcher = (client: GraphQLClient, variables: GradebookDataQueryVariables, headers?: RequestInit['headers']) => fetcher<GradebookDataQuery, GradebookDataQueryVariables>(client, GradebookDataDocument, variables, headers);
export const GetStudentEnrollmentsDocument = `
    query getStudentEnrollments($courseIds: [ID!], $roleIds: [ID!]) {
  courses(ids: $courseIds) {
    id
    enrollments(roleIds: $roleIds) {
      id
      user {
        id
        fullName
      }
    }
  }
}
    `;
export const useGetStudentEnrollmentsQuery = <
      TData = GetStudentEnrollmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetStudentEnrollmentsQueryVariables,
      options?: UseQueryOptions<GetStudentEnrollmentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStudentEnrollmentsQuery, TError, TData>(
      variables === undefined ? ['getStudentEnrollments'] : ['getStudentEnrollments', variables],
      fetcher<GetStudentEnrollmentsQuery, GetStudentEnrollmentsQueryVariables>(client, GetStudentEnrollmentsDocument, variables, headers),
      options
    );
useGetStudentEnrollmentsQuery.fetcher = (client: GraphQLClient, variables?: GetStudentEnrollmentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetStudentEnrollmentsQuery, GetStudentEnrollmentsQueryVariables>(client, GetStudentEnrollmentsDocument, variables, headers);
export const GradebookStudentsDocument = `
    query gradebookStudents($courseId: ID!, $studentEnrollmentIds: [ID!], $studentsLimit: Int, $studentsOffset: Int, $studentsSort: EnrollmentsSortOrder, $activityIds: [ID!], $activitiesLimit: Int, $activitiesOffset: Int, $activityGroupIds: [ID!], $courseTermId: ID, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime) {
  gradebookData(
    courseId: $courseId
    studentEnrollmentIds: $studentEnrollmentIds
    studentsLimit: $studentsLimit
    studentsOffset: $studentsOffset
    studentsSort: $studentsSort
    activityIds: $activityIds
    activitiesLimit: $activitiesLimit
    activitiesOffset: $activitiesOffset
    activityGroupIds: $activityGroupIds
    courseTermId: $courseTermId
    startDate: $startDate
    endDate: $endDate
  ) {
    students {
      submissions {
        __typename
        activity {
          id
          points
          optional
          item {
            id
            title
            type
          }
          activityGroup {
            id
            title
            weight
          }
          unit {
            id
            title
          }
        }
        dueStatus
        grade
        gradedAt
        status
        statusOverriddenAt
        enrollment {
          id
          course {
            id
            gradingScheme {
              id
              percentageGrade
              ranges
              showLetterGrade
              showNumericGrade
            }
          }
        }
        ... on MultiSubmission {
          submissions {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            percentageGrade
            hasContent
            isDraft
            isFinal
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
            content {
              ... on QuizSubmission {
                answers
                bookmarks
                questionGrades
                timeElapsed
                timeLeft
              }
              ... on AssignmentSubmission {
                text
              }
            }
          }
        }
        ... on SingleSubmission {
          submission {
            id
            isSubmitted
            isViewed
            submissionType
            createdAt
            submittedAt
            updatedAt
            grade
            gradedAt
            isDraft
            percentageGrade
            hasContent
            annotatedPdf {
              id
              annotation
              fileType
              url
              title
            }
            annotationStatus
            attachments {
              ...FileEntryDefault
            }
            content {
              ... on QuizSubmission {
                answers
                bookmarks
                questionGrades
                timeElapsed
                timeLeft
              }
              ... on AssignmentSubmission {
                text
              }
            }
          }
        }
      }
      needsGradingCounter
      enrollment {
        id
        course {
          id
          gradingScheme {
            id
            percentageGrade
            ranges
            showLetterGrade
            showNumericGrade
          }
        }
        user {
          active
          id
          fullName
          initials
          calendarColor
          oauthConnections
          imageFileEntry {
            id
            url
            croppedUrl
            title
            fileType
          }
        }
      }
    }
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useGradebookStudentsQuery = <
      TData = GradebookStudentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GradebookStudentsQueryVariables,
      options?: UseQueryOptions<GradebookStudentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradebookStudentsQuery, TError, TData>(
      ['gradebookStudents', variables],
      fetcher<GradebookStudentsQuery, GradebookStudentsQueryVariables>(client, GradebookStudentsDocument, variables, headers),
      options
    );
useGradebookStudentsQuery.fetcher = (client: GraphQLClient, variables: GradebookStudentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GradebookStudentsQuery, GradebookStudentsQueryVariables>(client, GradebookStudentsDocument, variables, headers);
export const StudentSubmissionsDocument = `
    query studentSubmissions($enrollmentIds: [ID!]!, $activityIds: [ID!]!) {
  studentSubmissions(enrollmentIds: $enrollmentIds, activityIds: $activityIds) {
    __typename
    activity {
      id
      points
      optional
      graded
      similarityReportsEnabled
      item {
        ...ActivityItemFragment
        ... on Assignment {
          ...AssignmentFragment
        }
        ... on Quiz {
          ...QuizFragment
          questions {
            ...QuizQuestionFragment
          }
        }
      }
      activityGroup {
        id
        title
        weight
      }
      unit {
        id
        title
      }
    }
    dueStatus
    grade
    gradedAt
    status
    statusOverriddenAt
    privateDiscussionId
    enrollment {
      id
      course {
        id
        graded
        gradingScheme {
          id
          percentageGrade
          ranges
          showLetterGrade
          showNumericGrade
        }
      }
      user {
        active
        id
        fullName
        initials
        calendarColor
        oauthConnections
        imageFileEntry {
          id
          url
          croppedUrl
          title
          fileType
        }
      }
    }
    ... on MultiSubmission {
      submissions(includePast: true) {
        id
        isSubmitted
        isViewed
        submissionType
        createdAt
        submittedAt
        updatedAt
        grade
        gradedAt
        percentageGrade
        hasContent
        isDraft
        isFinal
        annotatedPdf {
          id
          annotation
          fileType
          url
          title
        }
        annotationStatus
        similarityReportResults
        attachments {
          ...FileEntryDefault
        }
        content {
          ... on QuizSubmission {
            answers
            bookmarks
            questionGrades
            timeElapsed
            timeLeft
          }
          ... on AssignmentSubmission {
            text
          }
        }
      }
    }
    ... on SingleSubmission {
      submission {
        id
        isSubmitted
        isViewed
        submissionType
        createdAt
        submittedAt
        updatedAt
        grade
        gradedAt
        isDraft
        percentageGrade
        hasContent
        annotatedPdf {
          id
          annotation
          fileType
          url
          title
        }
        annotationStatus
        similarityReportResults
        attachments {
          ...FileEntryDefault
        }
        content {
          ... on QuizSubmission {
            answers
            bookmarks
            questionGrades
            timeElapsed
            timeLeft
          }
          ... on AssignmentSubmission {
            text
          }
        }
      }
    }
  }
}
    ${ActivityItemFragmentFragmentDoc}
${AssignmentFragmentFragmentDoc}
${QuizFragmentFragmentDoc}
${QuizQuestionFragmentFragmentDoc}
${FileEntryDefaultFragmentDoc}`;
export const useStudentSubmissionsQuery = <
      TData = StudentSubmissionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: StudentSubmissionsQueryVariables,
      options?: UseQueryOptions<StudentSubmissionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<StudentSubmissionsQuery, TError, TData>(
      ['studentSubmissions', variables],
      fetcher<StudentSubmissionsQuery, StudentSubmissionsQueryVariables>(client, StudentSubmissionsDocument, variables, headers),
      options
    );
useStudentSubmissionsQuery.fetcher = (client: GraphQLClient, variables: StudentSubmissionsQueryVariables, headers?: RequestInit['headers']) => fetcher<StudentSubmissionsQuery, StudentSubmissionsQueryVariables>(client, StudentSubmissionsDocument, variables, headers);
export const GradebookActivitiesDocument = `
    query gradebookActivities($courseId: ID!, $studentEnrollmentIds: [ID!], $studentsLimit: Int, $studentsOffset: Int, $studentsSort: EnrollmentsSortOrder, $activityIds: [ID!], $activitiesLimit: Int, $activitiesOffset: Int, $activityGroupIds: [ID!], $courseTermId: ID, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime) {
  gradebookData(
    courseId: $courseId
    studentEnrollmentIds: $studentEnrollmentIds
    studentsLimit: $studentsLimit
    studentsOffset: $studentsOffset
    studentsSort: $studentsSort
    activityIds: $activityIds
    activitiesLimit: $activitiesLimit
    activitiesOffset: $activitiesOffset
    activityGroupIds: $activityGroupIds
    courseTermId: $courseTermId
    startDate: $startDate
    endDate: $endDate
  ) {
    activities {
      id
      points
      optional
      dueDate
      dueTimeSignificant
      item {
        id
        title
        type
      }
      activityGroup {
        id
        title
        weight
      }
      unit {
        id
        title
      }
    }
  }
}
    `;
export const useGradebookActivitiesQuery = <
      TData = GradebookActivitiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GradebookActivitiesQueryVariables,
      options?: UseQueryOptions<GradebookActivitiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GradebookActivitiesQuery, TError, TData>(
      ['gradebookActivities', variables],
      fetcher<GradebookActivitiesQuery, GradebookActivitiesQueryVariables>(client, GradebookActivitiesDocument, variables, headers),
      options
    );
useGradebookActivitiesQuery.fetcher = (client: GraphQLClient, variables: GradebookActivitiesQueryVariables, headers?: RequestInit['headers']) => fetcher<GradebookActivitiesQuery, GradebookActivitiesQueryVariables>(client, GradebookActivitiesDocument, variables, headers);
export const MakeFinalSubmissionDocument = `
    mutation makeFinalSubmission($submissionId: ID!) {
  makeFinalSubmission(submissionId: $submissionId) {
    errors
    success
  }
}
    `;
export const useMakeFinalSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MakeFinalSubmissionMutation, TError, MakeFinalSubmissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MakeFinalSubmissionMutation, TError, MakeFinalSubmissionMutationVariables, TContext>(
      ['makeFinalSubmission'],
      (variables?: MakeFinalSubmissionMutationVariables) => fetcher<MakeFinalSubmissionMutation, MakeFinalSubmissionMutationVariables>(client, MakeFinalSubmissionDocument, variables, headers)(),
      options
    );
useMakeFinalSubmissionMutation.fetcher = (client: GraphQLClient, variables: MakeFinalSubmissionMutationVariables, headers?: RequestInit['headers']) => fetcher<MakeFinalSubmissionMutation, MakeFinalSubmissionMutationVariables>(client, MakeFinalSubmissionDocument, variables, headers);
export const AutocompleteDataDocument = `
    query autocompleteData($key: String!) {
  autocompleteData(key: $key) {
    data
  }
}
    `;
export const useAutocompleteDataQuery = <
      TData = AutocompleteDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AutocompleteDataQueryVariables,
      options?: UseQueryOptions<AutocompleteDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AutocompleteDataQuery, TError, TData>(
      ['autocompleteData', variables],
      fetcher<AutocompleteDataQuery, AutocompleteDataQueryVariables>(client, AutocompleteDataDocument, variables, headers),
      options
    );
useAutocompleteDataQuery.fetcher = (client: GraphQLClient, variables: AutocompleteDataQueryVariables, headers?: RequestInit['headers']) => fetcher<AutocompleteDataQuery, AutocompleteDataQueryVariables>(client, AutocompleteDataDocument, variables, headers);
export const CourseTemplatesDocument = `
    query CourseTemplates($ids: [ID!]) {
  courseTemplates(ids: $ids) {
    __typename
    activitiesCount
    author {
      fullName
      initials
      id
      username
      calendarColor
      imageFileEntry {
        url
      }
    }
    content
    copyableBy
    createdAt
    courseCredits
    curriculum
    description
    gradeLevels
    iconColor
    id
    imageFileEntry {
      croppedUrl
      fileType
      id
      url
    }
    originalCourse {
      id
      title
      iconColor
      graded
    }
    parentTemplate {
      id
      title
    }
    subjects
    tags
    thumbnailFileEntry {
      id
      url
      title
    }
    title
    tags
    uid
    visibleTo
  }
}
    `;
export const useCourseTemplatesQuery = <
      TData = CourseTemplatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: CourseTemplatesQueryVariables,
      options?: UseQueryOptions<CourseTemplatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CourseTemplatesQuery, TError, TData>(
      variables === undefined ? ['CourseTemplates'] : ['CourseTemplates', variables],
      fetcher<CourseTemplatesQuery, CourseTemplatesQueryVariables>(client, CourseTemplatesDocument, variables, headers),
      options
    );
useCourseTemplatesQuery.fetcher = (client: GraphQLClient, variables?: CourseTemplatesQueryVariables, headers?: RequestInit['headers']) => fetcher<CourseTemplatesQuery, CourseTemplatesQueryVariables>(client, CourseTemplatesDocument, variables, headers);
export const AssignmentTemplatesDocument = `
    query AssignmentTemplates($ids: [ID!]) {
  assignmentTemplates(ids: $ids) {
    __typename
    author {
      fullName
      id
      username
      initials
      calendarColor
      imageFileEntry {
        url
      }
    }
    contentBlocks {
      attachments {
        ...FileEntryDefault
      }
      backgroundColor
      blockType
      content
      itemId
      itemType
      position
      publish
      sourceAttribution {
        author
        licenseType
        title
        url
      }
      topLine
    }
    gradeLevels
    curriculum
    subjects
    copyableBy
    createdAt
    instructions
    sourceAttribution {
      author
      licenseType
      title
      url
    }
    templateInCourse {
      id
      title
    }
    templateOptions
    parentTemplate {
      id
      title
    }
    title
    id
    tags
    visibleTo
  }
}
    ${FileEntryDefaultFragmentDoc}`;
export const useAssignmentTemplatesQuery = <
      TData = AssignmentTemplatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AssignmentTemplatesQueryVariables,
      options?: UseQueryOptions<AssignmentTemplatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AssignmentTemplatesQuery, TError, TData>(
      variables === undefined ? ['AssignmentTemplates'] : ['AssignmentTemplates', variables],
      fetcher<AssignmentTemplatesQuery, AssignmentTemplatesQueryVariables>(client, AssignmentTemplatesDocument, variables, headers),
      options
    );
useAssignmentTemplatesQuery.fetcher = (client: GraphQLClient, variables?: AssignmentTemplatesQueryVariables, headers?: RequestInit['headers']) => fetcher<AssignmentTemplatesQuery, AssignmentTemplatesQueryVariables>(client, AssignmentTemplatesDocument, variables, headers);
export const QuizTemplatesDocument = `
    query QuizTemplates($ids: [ID!]) {
  quizTemplates(ids: $ids) {
    __typename
    author {
      fullName
      id
      username
      initials
      calendarColor
      imageFileEntry {
        url
      }
    }
    copyableBy
    createdAt
    instructions
    templateInCourse {
      id
      title
    }
    templateOptions
    parentTemplate {
      id
      title
    }
    title
    id
    tags
    questions {
      id
      questionType
      content
      uid
    }
    visibleTo
  }
}
    `;
export const useQuizTemplatesQuery = <
      TData = QuizTemplatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: QuizTemplatesQueryVariables,
      options?: UseQueryOptions<QuizTemplatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<QuizTemplatesQuery, TError, TData>(
      variables === undefined ? ['QuizTemplates'] : ['QuizTemplates', variables],
      fetcher<QuizTemplatesQuery, QuizTemplatesQueryVariables>(client, QuizTemplatesDocument, variables, headers),
      options
    );
useQuizTemplatesQuery.fetcher = (client: GraphQLClient, variables?: QuizTemplatesQueryVariables, headers?: RequestInit['headers']) => fetcher<QuizTemplatesQuery, QuizTemplatesQueryVariables>(client, QuizTemplatesDocument, variables, headers);
export const UnitTemplatesDocument = `
    query UnitTemplates($ids: [ID!]) {
  unitTemplates(ids: $ids) {
    activitiesCount
    author {
      fullName
      id
      username
      initials
      calendarColor
      imageFileEntry {
        url
      }
    }
    __typename
    content
    copyableBy
    createdAt
    description
    parentTemplate {
      id
      title
    }
    originalCourse {
      id
      title
    }
    title
    id
    subjects
    curriculum
    gradeLevels
    tags
    visibleTo
  }
}
    `;
export const useUnitTemplatesQuery = <
      TData = UnitTemplatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: UnitTemplatesQueryVariables,
      options?: UseQueryOptions<UnitTemplatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UnitTemplatesQuery, TError, TData>(
      variables === undefined ? ['UnitTemplates'] : ['UnitTemplates', variables],
      fetcher<UnitTemplatesQuery, UnitTemplatesQueryVariables>(client, UnitTemplatesDocument, variables, headers),
      options
    );
useUnitTemplatesQuery.fetcher = (client: GraphQLClient, variables?: UnitTemplatesQueryVariables, headers?: RequestInit['headers']) => fetcher<UnitTemplatesQuery, UnitTemplatesQueryVariables>(client, UnitTemplatesDocument, variables, headers);